export const icon = {
  "icon-clock-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5ZM11.1 6.6H12.9V11.1H15.6V12.9H11.1V6.6Z"
        fill="#767A7F"
      />
    </svg>
  ),
  "icon-medal-check-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0912 5.78198L7.35789 9.51532L4.90923 7.06665C4.80464 6.95255 4.74815 6.80247 4.75151 6.64773C4.75488 6.49298 4.81786 6.34551 4.9273 6.23606C5.03675 6.12661 5.18422 6.06364 5.33897 6.06027C5.49371 6.0569 5.64379 6.1134 5.75789 6.21798L7.35789 7.81798L10.2426 4.93332C10.2983 4.87759 10.3644 4.83339 10.4372 4.80323C10.5101 4.77308 10.5881 4.75755 10.6669 4.75755C10.7457 4.75755 10.8237 4.77308 10.8965 4.80323C10.9693 4.83339 11.0355 4.87759 11.0912 4.93332C11.147 4.98904 11.1912 5.0552 11.2213 5.128C11.2515 5.20081 11.267 5.27885 11.267 5.35765C11.267 5.43646 11.2515 5.51449 11.2213 5.5873C11.1912 5.66011 11.147 5.72626 11.0912 5.78198ZM14.0979 7.04665C14.1604 6.98414 14.1955 6.89937 14.1955 6.81098C14.1955 6.7226 14.1604 6.63783 14.0979 6.57532L13.1312 5.60865C13.0898 5.56732 13.06 5.51577 13.0449 5.45922C13.0298 5.40268 13.0299 5.34314 13.0452 5.28665L13.3986 3.96665C13.4214 3.88125 13.4093 3.7903 13.365 3.71378C13.3208 3.63727 13.248 3.58147 13.1626 3.55865L11.8426 3.20532C11.7859 3.19014 11.7342 3.16026 11.6928 3.1187C11.6513 3.07714 11.6216 3.02538 11.6066 2.96865L11.2532 1.64865C11.2303 1.56321 11.1743 1.49037 11.0977 1.44612C11.0211 1.40188 10.93 1.38984 10.8446 1.41265L9.52389 1.76665C9.46744 1.78176 9.408 1.78171 9.35158 1.76649C9.29516 1.75127 9.24376 1.72143 9.20256 1.67998L8.23589 0.713318C8.17338 0.650828 8.08861 0.615723 8.00023 0.615723C7.91184 0.615723 7.82707 0.650828 7.76456 0.713318L6.79789 1.68065C6.75652 1.72204 6.705 1.75183 6.64848 1.76704C6.59197 1.78225 6.53245 1.78235 6.47589 1.76732L5.15589 1.41265C5.11356 1.40126 5.0694 1.39834 5.02594 1.40404C4.98248 1.40974 4.94057 1.42396 4.90261 1.44588C4.86465 1.46781 4.83138 1.497 4.80472 1.53179C4.77806 1.56659 4.75852 1.6063 4.74723 1.64865L4.39323 2.96865C4.37816 3.02518 4.34848 3.07675 4.30717 3.11817C4.26586 3.1596 4.21438 3.18942 4.15789 3.20465L2.83723 3.55865C2.75196 3.58161 2.67928 3.63748 2.63516 3.71397C2.59104 3.79047 2.57907 3.88134 2.60189 3.96665L2.95523 5.28665C2.97055 5.34314 2.97066 5.40268 2.95556 5.45922C2.94046 5.51577 2.91067 5.56732 2.86923 5.60865L1.90256 6.57532C1.87154 6.60622 1.84692 6.64295 1.83013 6.68339C1.81333 6.72383 1.80469 6.76719 1.80469 6.81098C1.80469 6.85477 1.81333 6.89813 1.83013 6.93858C1.84692 6.97902 1.87154 7.01574 1.90256 7.04665L2.86923 8.01332C2.91067 8.05479 2.94045 8.10645 2.95555 8.16311C2.97064 8.21976 2.97053 8.27939 2.95523 8.33598L2.60189 9.65598C2.57907 9.74129 2.59104 9.83217 2.63516 9.90866C2.67928 9.98516 2.75196 10.041 2.83723 10.064L4.15789 10.418C4.21438 10.4332 4.26586 10.463 4.30717 10.5045C4.34848 10.5459 4.37816 10.5975 4.39323 10.654L4.74656 11.974C4.75825 12.0168 4.77837 12.0568 4.80573 12.0917C4.83309 12.1266 4.86714 12.1557 4.90589 12.1773L3.66523 15.522H7.12056L7.99989 13.15L8.88056 15.522H12.3352L11.0946 12.1773C11.1333 12.1558 11.1673 12.1267 11.1946 12.0918C11.2218 12.0569 11.2418 12.0168 11.2532 11.974L11.6066 10.654C11.6216 10.5973 11.6514 10.5457 11.6928 10.5042C11.7343 10.4628 11.7859 10.433 11.8426 10.418L13.1626 10.0647C13.2049 10.0534 13.2446 10.0338 13.2794 10.0072C13.3142 9.98049 13.3434 9.94723 13.3653 9.90927C13.3872 9.87131 13.4015 9.8294 13.4072 9.78594C13.4129 9.74247 13.4099 9.69831 13.3986 9.65598L13.0452 8.33598C13.0299 8.27949 13.0298 8.21996 13.0449 8.16341C13.06 8.10686 13.0898 8.05531 13.1312 8.01398L14.0979 7.04732V7.04665Z"
        fill="#FFBD14"
      />
    </svg>
  ),

  icon_pencil_mono: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1305_7879)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.22333 3.63585L2.182 9.67718L1.358 12.7505L0.816 14.7752C0.800945 14.8317 0.80102 14.8913 0.816217 14.9478C0.831415 15.0043 0.8612 15.0559 0.90259 15.0973C0.94398 15.1386 0.99552 15.1684 1.05205 15.1836C1.10857 15.1988 1.1681 15.1989 1.22467 15.1838L3.248 14.6412L6.322 13.8172H6.32267L12.364 7.77585L8.224 3.63585H8.22333ZM14.862 4.33585L11.6647 1.13785C11.6028 1.07589 11.5293 1.02673 11.4485 0.993187C11.3676 0.959647 11.2809 0.942383 11.1933 0.942383C11.1058 0.942383 11.0191 0.959647 10.9382 0.993187C10.8573 1.02673 10.7839 1.07589 10.722 1.13785L9.072 2.78718L13.2127 6.92785L14.862 5.27785C14.924 5.21599 14.9731 5.14252 15.0067 5.06165C15.0402 4.98077 15.0575 4.89407 15.0575 4.80652C15.0575 4.71896 15.0402 4.63226 15.0067 4.55139C14.9731 4.47051 14.924 4.39704 14.862 4.33518"
          fill="#B9B9B9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1305_7879">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  add: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 9H15V0.75C15 0.551088 14.921 0.360322 14.7803 0.21967C14.6397 0.0790176 14.4489 0 14.25 0L9.75 0C9.55109 0 9.36032 0.0790176 9.21967 0.21967C9.07902 0.360322 9 0.551088 9 0.75V9H0.75C0.551088 9 0.360322 9.07902 0.21967 9.21967C0.0790176 9.36032 0 9.55109 0 9.75L0 14.25C0 14.4489 0.0790176 14.6397 0.21967 14.7803C0.360322 14.921 0.551088 15 0.75 15H9V23.25C9 23.4489 9.07902 23.6397 9.21967 23.7803C9.36032 23.921 9.55109 24 9.75 24H14.25C14.4489 24 14.6397 23.921 14.7803 23.7803C14.921 23.6397 15 23.4489 15 23.25V15H23.25C23.4489 15 23.6397 14.921 23.7803 14.7803C23.921 14.6397 24 14.4489 24 14.25V9.75C24 9.55109 23.921 9.36032 23.7803 9.21967C23.6397 9.07902 23.4489 9 23.25 9Z"
        fill="#E9E9E9"
      />
    </svg>
  ),
  "icon-store-mono": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 3.3335H4.00002C3.6464 3.3335 3.30726 3.47397 3.05721 3.72402C2.80716 3.97407 2.66669 4.31321 2.66669 4.66683V6.8895H29.3334V4.66683C29.3334 4.31321 29.1929 3.97407 28.9428 3.72402C28.6928 3.47397 28.3536 3.3335 28 3.3335M4.23469 25.5842C4.23469 26.4326 4.57165 27.2464 5.17147 27.8464C5.7713 28.4465 6.58489 28.7838 7.43335 28.7842H13.3334V23.7788C13.3334 23.4252 13.4738 23.0861 13.7239 22.836C13.9739 22.586 14.3131 22.4455 14.6667 22.4455H17.3334C17.687 22.4455 18.0261 22.586 18.2762 22.836C18.5262 23.0861 18.6667 23.4252 18.6667 23.7788V28.7828H24.5667C25.4151 28.7825 26.2287 28.4452 26.8286 27.8451C27.4284 27.245 27.7654 26.4313 27.7654 25.5828V14.6668H4.23469V25.5842V25.5842ZM2.66669 11.3335C2.66669 11.6871 2.80716 12.0263 3.05721 12.2763C3.30726 12.5264 3.6464 12.6668 4.00002 12.6668H28C28.3536 12.6668 28.6928 12.5264 28.9428 12.2763C29.1929 12.0263 29.3334 11.6871 29.3334 11.3335V9.11083H2.66669V11.3335Z"
        fill="#B9B9B9"
      />
    </svg>
  ),
  "icon-building-mono": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46532 19.2013H11.8653V16.8013H9.46532V19.2013V19.2013ZM9.46532 14.2H11.8653V11.8H9.46532V14.2V14.2ZM9.46532 9.2H11.8653V6.8H9.46532V9.2V9.2ZM14.8 19.2013H17.2V16.8013H14.8V19.2013ZM14.8 14.2H17.2V11.8H14.8V14.2ZM14.8 9.2H17.2V6.8H14.8V9.2V9.2ZM20.136 19.2013H22.536V16.8013H20.136V19.2013ZM20.136 14.2H22.536V11.8H20.136V14.2ZM20.136 9.2H22.536V6.8H20.136V9.2V9.2ZM26.004 2H5.99598C5.82077 1.99983 5.64725 2.03418 5.48533 2.10111C5.32341 2.16804 5.17626 2.26622 5.05231 2.39005C4.92836 2.51388 4.83003 2.66093 4.76294 2.82278C4.69585 2.98464 4.66132 3.15813 4.66132 3.33333V28.5173C4.66132 28.9417 4.82989 29.3486 5.12995 29.6487C5.43 29.9488 5.83697 30.1173 6.26132 30.1173H13.3333V25.1133C13.3333 24.7597 13.4738 24.4206 13.7238 24.1705C13.9739 23.9205 14.313 23.78 14.6666 23.78H17.3333C17.6869 23.78 18.0261 23.9205 18.2761 24.1705C18.5262 24.4206 18.6666 24.7597 18.6666 25.1133V30.1173H25.7373C26.1617 30.1173 26.5686 29.9488 26.8687 29.6487C27.1687 29.3486 27.3373 28.9417 27.3373 28.5173V3.33333C27.3373 2.97971 27.1968 2.64057 26.9468 2.39052C26.6967 2.14048 26.3576 2 26.004 2Z"
        fill="#B9B9B9"
      />
    </svg>
  ),
  "content-copy-outline": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 14.6666C2.96667 14.6666 2.65267 14.5359 2.39133 14.2746C2.13 14.0133 1.99956 13.6995 2 13.3333V3.99992H3.33333V13.3333H10.6667V14.6666H3.33333ZM6 11.9999C5.63333 11.9999 5.31933 11.8693 5.058 11.6079C4.79667 11.3466 4.66622 11.0328 4.66667 10.6666V2.66659C4.66667 2.29992 4.79733 1.98592 5.05867 1.72459C5.32 1.46325 5.63378 1.33281 6 1.33325H12C12.3667 1.33325 12.6807 1.46392 12.942 1.72525C13.2033 1.98659 13.3338 2.30036 13.3333 2.66659V10.6666C13.3333 11.0333 13.2027 11.3473 12.9413 11.6086C12.68 11.8699 12.3662 12.0004 12 11.9999H6ZM6 10.6666H12V2.66659H6V10.6666Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  arrow_fat_down_fill: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1479 9.96047L9.39792 16.7105C9.34568 16.7628 9.28365 16.8043 9.21536 16.8326C9.14707 16.8609 9.07388 16.8754 8.99995 16.8754C8.92603 16.8754 8.85284 16.8609 8.78455 16.8326C8.71626 16.8043 8.65423 16.7628 8.60199 16.7105L1.85199 9.96047C1.77323 9.8818 1.71959 9.78153 1.69784 9.67236C1.6761 9.56319 1.68724 9.45002 1.72985 9.34718C1.77247 9.24434 1.84463 9.15646 1.93721 9.09466C2.0298 9.03286 2.13864 8.99991 2.24995 9H4.07808V3.375C4.07808 3.07663 4.19661 2.79048 4.40759 2.5795C4.61857 2.36853 4.90471 2.25 5.20308 2.25H12.8099C13.1083 2.25 13.3944 2.36853 13.6054 2.5795C13.8164 2.79048 13.9349 3.07663 13.9349 3.375V9H15.75C15.8613 8.99991 15.9701 9.03286 16.0627 9.09466C16.1553 9.15646 16.2274 9.24434 16.2701 9.34718C16.3127 9.45002 16.3238 9.56319 16.3021 9.67236C16.2803 9.78153 16.2267 9.8818 16.1479 9.96047Z"
        fill="#3B6EBF"
      />
      <path
        d="M7.14189 8.00115C7.91515 8.00492 8.34515 7.43535 8.34893 6.59043C8.34515 5.7606 7.93024 5.18726 7.14189 5.18726C6.38373 5.18726 5.93864 5.7606 5.94241 6.59043C5.93864 7.42781 6.36487 8.00492 7.14189 8.00115ZM6.63645 6.59043C6.64022 6.11893 6.80996 5.79077 7.14189 5.79077C7.49646 5.787 7.64734 6.11516 7.64734 6.59043C7.64734 7.08079 7.48514 7.39763 7.14189 7.39763C6.80996 7.39763 6.64022 7.08079 6.63645 6.59043ZM6.64399 10.8H7.40593L11.1628 5.33813H10.4009L6.64399 10.8ZM9.51069 9.54011C9.50692 10.3699 9.93315 10.9471 10.7102 10.9433C11.4834 10.9471 11.9134 10.3775 11.9172 9.54011C11.9134 8.70651 11.4948 8.12939 10.7102 8.12939C9.95201 8.12939 9.50692 8.70651 9.51069 9.54011ZM10.2047 9.54011C10.2085 9.06107 10.3782 8.73668 10.7102 8.73291C11.0647 8.72914 11.2156 9.0573 11.2156 9.54011C11.2156 10.0229 11.0534 10.3435 10.7102 10.3398C10.3782 10.3435 10.2085 10.0229 10.2047 9.54011Z"
        style={{ fill: "white" }}
      />
    </svg>
  ),
  arrow_fat_up_fill: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.60208 1.28953L1.85208 8.03953C1.77332 8.1182 1.71968 8.21847 1.69794 8.32764C1.67619 8.43681 1.68733 8.54998 1.72995 8.65282C1.77256 8.75566 1.84472 8.84354 1.93731 8.90534C2.02989 8.96714 2.13873 9.00009 2.25005 9L4.06507 9L4.06507 14.625C4.06507 14.9234 4.18359 15.2095 4.39457 15.4205C4.60555 15.6315 4.8917 15.75 5.19007 15.75L12.7969 15.75C13.0953 15.75 13.3814 15.6315 13.5924 15.4205C13.8034 15.2095 13.9219 14.9234 13.9219 14.625L13.9219 9L15.75 9C15.8614 9.00009 15.9702 8.96714 16.0628 8.90534C16.1554 8.84354 16.2275 8.75566 16.2701 8.65282C16.3128 8.54998 16.3239 8.43681 16.3022 8.32764C16.2804 8.21847 16.2268 8.1182 16.148 8.03953L9.39802 1.28953C9.34577 1.23723 9.28374 1.19574 9.21545 1.16743C9.14716 1.13913 9.07397 1.12456 9.00005 1.12456C8.92613 1.12456 8.85293 1.13913 8.78464 1.16743C8.71636 1.19574 8.65432 1.23723 8.60208 1.28953ZM9.65107 11.4096C9.65485 10.5646 10.0849 9.99508 10.8581 9.99885C11.6351 9.99508 12.0614 10.5722 12.0576 11.4096C12.0614 12.2394 11.6163 12.8127 10.8581 12.8127C10.0698 12.8127 9.65485 12.2394 9.65107 11.4096ZM10.8581 12.2092C11.19 12.2092 11.3598 11.8811 11.3635 11.4096C11.3598 10.9192 11.19 10.6024 10.8581 10.6024C10.5149 10.6024 10.3527 10.9192 10.3527 11.4096C10.3527 11.8848 10.5035 12.213 10.8581 12.2092ZM10.5941 7.20005L11.356 7.20005L7.59912 12.6619L6.83718 12.6619L10.5941 7.20005ZM7.28982 7.05671C8.06685 7.05294 8.49308 7.63005 8.48931 8.45989C8.49308 9.29349 8.04799 9.8706 7.28982 9.8706C6.50525 9.8706 6.08656 9.29349 6.08279 8.45989C6.08656 7.62251 6.51656 7.05294 7.28982 7.05671ZM7.28982 9.26709C7.62175 9.26332 7.79149 8.93893 7.79526 8.45989C7.79149 7.97707 7.62175 7.65646 7.28982 7.66023C6.94657 7.65646 6.78437 7.97707 6.78437 8.45989C6.78437 8.9427 6.93525 9.27086 7.28982 9.26709Z"
        fill="#EA7810"
      />
    </svg>
  ),
  arrow_right_small: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3124 10.05C4.1399 10.05 3.9674 9.98247 3.8324 9.85497C3.70645 9.72847 3.63574 9.55723 3.63574 9.37872C3.63574 9.20021 3.70645 9.02897 3.8324 8.90247L6.7349 5.99997L3.8324 3.10497C3.70645 2.97847 3.63574 2.80723 3.63574 2.62872C3.63574 2.45021 3.70645 2.27897 3.8324 2.15247C3.9589 2.02652 4.13014 1.95581 4.30865 1.95581C4.48716 1.95581 4.6584 2.02652 4.7849 2.15247L8.1599 5.52747C8.28585 5.65397 8.35656 5.82521 8.35656 6.00372C8.35656 6.18223 8.28585 6.35347 8.1599 6.47997L4.7849 9.85497C4.6574 9.98247 4.4849 10.05 4.3124 10.05Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  icon_tightarrow_forward: (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.05025 1.05025L5.29289 5.29289C5.68342 5.68342 5.68342 6.31658 5.29289 6.70711L1.05025 10.9497"
        stroke="#686868"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  "icon-circle-check-fill-mono": (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0003 2.91675C20.1253 2.91675 25.0837 7.87508 25.0837 14.0001C25.0837 20.1251 20.1253 25.0834 14.0003 25.0834C7.87533 25.0834 2.91699 20.1251 2.91699 14.0001C2.91699 7.87508 7.87533 2.91675 14.0003 2.91675Z"
        fill="#CBCDCF"
      />
      <path
        d="M17.9788 10.4533C18.3288 10.0683 18.9121 10.045 19.2971 10.395C19.6821 10.745 19.7054 11.3283 19.3554 11.7133L13.5221 18.13C13.3471 18.3167 13.1138 18.4333 12.8571 18.4333C12.6004 18.4333 12.3554 18.34 12.1804 18.165L8.68043 14.665C8.31876 14.3033 8.31876 13.7083 8.68043 13.3467C9.0421 12.985 9.6371 12.985 9.99876 13.3467L12.8104 16.1583L17.9904 10.465L17.9788 10.4533Z"
        fill="white"
      />
    </svg>
  ),

  "icon-circle-check-active-mono": (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0003 2.91675C20.1253 2.91675 25.0837 7.87508 25.0837 14.0001C25.0837 20.1251 20.1253 25.0834 14.0003 25.0834C7.87533 25.0834 2.91699 20.1251 2.91699 14.0001C2.91699 7.87508 7.87533 2.91675 14.0003 2.91675Z"
        fill="#171819"
      />
      <path
        d="M17.9788 10.4533C18.3288 10.0683 18.9121 10.045 19.2971 10.395C19.6821 10.745 19.7054 11.3283 19.3554 11.7133L13.5221 18.13C13.3471 18.3167 13.1138 18.4333 12.8571 18.4333C12.6004 18.4333 12.3554 18.34 12.1804 18.165L8.68043 14.665C8.31876 14.3033 8.31876 13.7083 8.68043 13.3467C9.0421 12.985 9.6371 12.985 9.99876 13.3467L12.8104 16.1583L17.9904 10.465L17.9788 10.4533Z"
        fill="white"
      />
    </svg>
  ),

  /** Figma Icon/Normal/CircleCheck 선 버전. 단색이라 color 로 칠한다 */
  "icon-circle-check-line-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.5C17.25 2.5 21.5 6.75 21.5 12C21.5 17.25 17.25 21.5 12 21.5C6.75 21.5 2.5 17.25 2.5 12C2.5 6.75 6.75 2.5 12 2.5ZM12 4.1C7.64 4.1 4.1 7.64 4.1 12C4.1 16.36 7.64 19.9 12 19.9C16.36 19.9 19.9 16.36 19.9 12C19.9 7.64 16.36 4.1 12 4.1ZM15.41 8.96C15.71 8.63 16.21 8.61 16.54 8.91C16.87 9.21 16.89 9.71 16.59 10.04L11.59 15.54C11.44 15.7 11.24 15.8 11.02 15.8C10.8 15.8 10.59 15.72 10.44 15.57L7.44 12.57C7.13 12.26 7.13 11.75 7.44 11.44C7.75 11.13 8.26 11.13 8.57 11.44L10.98 13.85L15.42 8.97L15.41 8.96Z"
        fill="#FFAC7E"
      />
    </svg>
  ),

  /**
   * Figma Icon/Normal/CircleCheck 채움 버전 (주황 원 + 흰 체크).
   * 두 색이라 color 를 주면 체크까지 칠해진다 — color 없이 쓴다.
   */
  "icon-circle-check-orange-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma 는 24px 박스 안에 19px 아트를 10.42% 인셋으로 둔다 */}
      <g transform="translate(2.5 2.5)">
        <path
          d="M9.5 0C14.75 0 19 4.25 19 9.5C19 14.75 14.75 19 9.5 19C4.25 19 0 14.75 0 9.5C0 4.25 4.25 0 9.5 0Z"
          fill="#FF7225"
        />
        <path
          d="M12.91 6.46C13.21 6.13 13.71 6.11 14.04 6.41C14.37 6.71 14.39 7.21 14.09 7.54L9.09 13.04C8.94 13.2 8.74 13.3 8.52 13.3C8.3 13.3 8.09 13.22 7.94 13.07L4.94 10.07C4.63 9.76 4.63 9.25 4.94 8.94C5.25 8.63 5.76 8.63 6.07 8.94L8.48 11.35L12.92 6.47L12.91 6.46Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  // 그라디언트/클립 id 는 다른 아이콘과 충돌하지 않도록 goi- 접두어 사용
  "icon-graphic-search-doc": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#goi-search-doc-clip)">
        <path
          d="M28.1397 34.1535C36.086 33.0588 41.6404 25.7295 40.5456 17.7832C39.4509 9.8368 32.1216 4.28246 24.1753 5.37719C16.2289 6.47192 10.6746 13.8012 11.7693 21.7475C12.864 29.6939 20.1933 35.2483 28.1397 34.1535Z"
          fill="#F7FAFD"
        />
        <path
          d="M18.2712 16.8701C18.0734 15.4346 18.2032 13.5456 20.0335 13.2934L22.4081 12.9663C24.705 12.6498 25.5693 15.5173 25.058 16.8493L23.6363 20.5985L23.8456 22.1178L21.8897 22.3872L21.6524 20.6646L23.0245 17.2636C23.3237 16.5153 23.0503 14.8404 22.0992 14.9714L20.9987 15.123C20.2091 15.2318 20.109 15.788 20.2211 16.6015L18.2652 16.8709L18.2712 16.8701ZM24.3176 25.2342L22.3199 25.5095L22.0471 23.5296L24.0449 23.2544L24.3176 25.2342Z"
          fill="#909399"
        />
        <path
          d="M26.2057 15.7822C26.008 14.3467 26.1378 12.4577 27.9681 12.2055L30.3427 11.8784C32.6395 11.562 33.5039 14.4294 32.9926 15.7614L31.5709 19.5106L31.7802 21.0299L29.8243 21.2993L29.587 19.5767L30.9591 16.1757C31.2583 15.4275 30.9849 13.7525 30.0338 13.8835L28.9333 14.0351C28.1437 14.1439 28.0436 14.7001 28.1557 15.5136L26.1998 15.783L26.2057 15.7822ZM32.2522 24.1464L30.2544 24.4216L29.9817 22.4418L31.9795 22.1665L32.2522 24.1464Z"
          fill="#909399"
        />
        <path
          opacity="0.5"
          d="M14.0917 26.3406C18.2448 33.0205 27.0266 35.0688 33.7065 30.9157C40.3863 26.7626 42.4346 17.9808 38.2816 11.301C34.1285 4.62113 25.3466 2.5728 18.6668 6.72589C11.987 10.879 9.93863 19.6608 14.0917 26.3406Z"
          fill="url(#goi-search-doc-grad)"
        />
        <path
          d="M18.0307 30.7155L15.9297 28.9746L11.2629 34.6067L13.364 36.3477L18.0307 30.7155Z"
          fill="#72706E"
        />
        <path
          d="M16.2821 32.8325L18.0313 30.722C17.6562 30.4712 17.2891 30.1994 16.9369 29.9069C16.5847 29.6144 16.2488 29.3041 15.9317 28.9817L14.1825 31.0922C14.504 31.4091 14.8387 31.7165 15.1922 32.0119C15.5457 32.3073 15.9115 32.5762 16.2834 32.8354L16.2821 32.8325Z"
          fill="#545251"
        />
        <path
          d="M14.8969 36.1187C15.7479 35.0918 15.6052 33.5694 14.5782 32.7185C13.5513 31.8676 12.0289 32.0102 11.178 33.0372L4.41979 41.2065C3.56885 42.2335 3.71154 43.7558 4.7385 44.6067C5.76546 45.4577 7.2878 45.315 8.13873 44.288L14.8969 36.1187Z"
          fill="#2D2826"
        />
        <path
          d="M16.063 30.9587C9.34614 25.3918 8.40745 15.3965 13.9743 8.67965C19.5412 1.96281 29.5365 1.02413 36.2547 6.59389C42.9715 12.1608 43.9102 22.1561 38.3433 28.8729C32.7764 35.5898 22.7811 36.5284 16.0643 30.9616L16.063 30.9587ZM34.5144 8.69341C28.9545 4.08718 20.6872 4.86038 16.0809 10.4202C11.4747 15.98 12.2492 24.2503 17.8077 28.8537C23.3676 33.4599 31.6378 32.6854 36.2412 27.1269C40.8474 21.567 40.0742 13.2996 34.5144 8.69341Z"
          fill="#72706E"
        />
      </g>
      <defs>
        <linearGradient
          id="goi-search-doc-grad"
          x1="19.3549"
          y1="12.5847"
          x2="37.5263"
          y2="29.0459"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.504808" stopColor="#E7EDF4" />
          <stop offset="1" stopColor="#A6C1DB" />
        </linearGradient>
        <clipPath id="goi-search-doc-clip">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-graphic-write": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.58301 4.99992C4.58301 4.07944 5.3292 3.33325 6.24967 3.33325H27.9164C28.8369 3.33325 29.583 4.07944 29.583 4.99992V34.9999C29.583 35.9204 28.8369 36.6666 27.9164 36.6666H6.24967C5.3292 36.6666 4.58301 35.9204 4.58301 34.9999V4.99992Z"
        fill="#D1E6FF"
      />
      <rect
        x="9.16602"
        y="9.1665"
        width="15.8333"
        height="1.66667"
        rx="0.833333"
        fill="#A0C9FF"
      />
      <rect
        x="9.16602"
        y="15.8333"
        width="15.8333"
        height="1.66667"
        rx="0.833333"
        fill="#A0C9FF"
      />
      <rect
        x="9.16602"
        y="22.5"
        width="15.8333"
        height="1.66667"
        rx="0.833333"
        fill="#A0C9FF"
      />
      <path
        d="M32.499 15.1745C32.7823 14.9412 33.251 14.9299 33.4844 15.2132L36.9571 19.2628C37.1905 19.5461 37.1177 19.9966 36.8344 20.2299L21.9844 32.6966C21.801 32.8466 21.5806 32.945 21.3473 32.945C21.3473 32.945 17.8389 32.9737 17.4222 32.9737C17.0056 32.9737 16.6067 32.5171 16.6733 32.1004L17.2991 28.2245C17.3324 27.9911 17.4574 27.7816 17.6408 27.6316L32.499 15.1745Z"
        fill="#76A1DE"
      />
    </svg>
  ),

  arrow_left_small: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6876 1.95003C7.8601 1.95003 8.0326 2.01753 8.1676 2.14503C8.29355 2.27153 8.36426 2.44277 8.36426 2.62128C8.36426 2.79979 8.29355 2.97103 8.1676 3.09753L5.2651 6.00003L8.1676 8.89503C8.29355 9.02153 8.36426 9.19277 8.36426 9.37128C8.36426 9.54979 8.29355 9.72103 8.1676 9.84753C8.0411 9.97348 7.86986 10.0442 7.69135 10.0442C7.51284 10.0442 7.3416 9.97348 7.2151 9.84753L3.8401 6.47253C3.71415 6.34603 3.64344 6.17479 3.64344 5.99628C3.64344 5.81777 3.71415 5.64653 3.8401 5.52003L7.2151 2.14503C7.3426 2.01753 7.5151 1.95003 7.6876 1.95003Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  icon_outline_message: (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M3.33366 3.33317H16.667V13.3332H4.30866L3.33366 14.3082V3.33317ZM3.33366 1.6665C2.41699 1.6665 1.67533 2.4165 1.67533 3.33317L1.66699 18.3332L5.00033 14.9998H16.667C17.5837 14.9998 18.3337 14.2498 18.3337 13.3332V3.33317C18.3337 2.4165 17.5837 1.6665 16.667 1.6665H3.33366ZM5.00033 9.99984H15.0003V11.6665H5.00033V9.99984ZM5.00033 7.49984H15.0003V9.1665H5.00033V7.49984ZM5.00033 4.99984H15.0003V6.6665H5.00033V4.99984Z"
        fill="#686868"
      />
    </svg>
  ),
  keyboard_double_arrow_down: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 38L12 26L14.1 23.9L24 33.8L33.9 23.9L36 26L24 38ZM24 25.35L12 13.35L14.1 11.25L24 21.15L33.9 11.25L36 13.35L24 25.35Z"
        fill="black"
      />
    </svg>
  ),
  check_circle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill="#2CBA00"
      />
    </svg>
  ),
  arrow_forward_rounded: (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.34315 1.34315L6.29289 6.29289C6.68342 6.68342 6.68342 7.31658 6.29289 7.70711L1.34315 12.6569"
        stroke="#252525"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  arrow_forward_ios: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_765_12181)">
        <path
          d="M11.0784 14.0067C10.7517 14.3334 10.225 14.3334 9.89838 14.0067L4.35838 8.4667C4.09838 8.2067 4.09838 7.7867 4.35838 7.5267L9.89838 1.9867C10.225 1.66003 10.7517 1.66003 11.0784 1.9867C11.405 2.31337 11.405 2.84003 11.0784 3.1667L6.25171 8.00003L11.085 12.8334C11.405 13.1534 11.405 13.6867 11.0784 14.0067Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_765_12181">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16 0)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  check_empty: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="1.25"
        stroke="#B9B9B9"
        strokeWidth="1.5"
      />
      <path
        d="M9.33095 14.9159L6.41168 11.8543C6.08639 11.5131 5.56926 11.5131 5.24397 11.8543C4.91868 12.1954 4.91868 12.7378 5.24397 13.0789L8.73875 16.7441C9.06405 17.0853 9.58951 17.0853 9.9148 16.7441L18.756 7.48052C19.0813 7.13936 19.0813 6.59702 18.756 6.25586C18.4307 5.91471 17.9136 5.91471 17.5883 6.25586L9.33095 14.9159Z"
        fill="#B9B9B9"
      />
    </svg>
  ),
  check_fill: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill="#F18334" />
      <path d="M9.33095 14.9159L6.41168 11.8543C6.08639 11.5131 5.56926 11.5131 5.24397 11.8543C4.91868 12.1954 4.91868 12.7378 5.24397 13.0789L8.73875 16.7441C9.06405 17.0853 9.58951 17.0853 9.9148 16.7441L18.756 7.48052C19.0813 7.13936 19.0813 6.59702 18.756 6.25586C18.4307 5.91471 17.9136 5.91471 17.5883 6.25586L9.33095 14.9159Z" />
    </svg>
  ),
  "icon-chat-bubble-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.04346C4.134 1.04346 1 3.87879 1 7.37679C1 9.06146 1.732 10.5881 2.91733 11.7235L2.33867 14.5561C2.32634 14.6167 2.33111 14.6795 2.35245 14.7376C2.37378 14.7956 2.41083 14.8465 2.45945 14.8847C2.50808 14.9229 2.56637 14.9468 2.62781 14.9538C2.68924 14.9607 2.7514 14.9505 2.80733 14.9241L5.96133 13.4355C6.62551 13.6179 7.31121 13.7103 8 13.7101C11.866 13.7101 15 10.8748 15 7.37679C15 3.87879 11.866 1.04346 8 1.04346"
        fill="#B9B9B9"
      />
    </svg>
  ),
  arrow_circle_up: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#FBDDC3" />
      <path
        d="M9 16L16 9M16 9L23 16M16 9V23"
        stroke="#252525"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  arrow_circle_down: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="white" />
      <path
        d="M8 10.5L12 14.5L16 10.5"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrow_circle_right: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4378 12.6045L12.6045 10.4378C12.7295 10.3128 12.792 10.167 12.792 10.0003C12.792 9.83366 12.7295 9.68783 12.6045 9.56283L10.417 7.37533C10.3059 7.26421 10.1635 7.21213 9.98991 7.21908C9.8163 7.22602 9.67394 7.28505 9.56283 7.39616C9.43783 7.52116 9.37533 7.66699 9.37533 7.83366C9.37533 8.00033 9.43783 8.14616 9.56283 8.27116L10.667 9.37533H7.47949C7.31283 9.37533 7.17046 9.43783 7.05241 9.56283C6.93435 9.68783 6.87533 9.83366 6.87533 10.0003C6.87533 10.1809 6.93435 10.3302 7.05241 10.4482C7.17046 10.5663 7.31977 10.6253 7.50033 10.6253H10.667L9.54199 11.7503C9.43088 11.8614 9.3788 12.0038 9.38574 12.1774C9.39269 12.351 9.45171 12.4934 9.56283 12.6045C9.68783 12.7295 9.83366 12.792 10.0003 12.792C10.167 12.792 10.3128 12.7295 10.4378 12.6045ZM10.0003 18.3337C8.81977 18.3337 7.72255 18.1219 6.70866 17.6982C5.69477 17.2746 4.81283 16.6878 4.06283 15.9378C3.31283 15.1878 2.72602 14.3059 2.30241 13.292C1.8788 12.2781 1.66699 11.1809 1.66699 10.0003C1.66699 8.83366 1.8788 7.74338 2.30241 6.72949C2.72602 5.7156 3.31283 4.83366 4.06283 4.08366C4.81283 3.33366 5.69477 2.74338 6.70866 2.31283C7.72255 1.88227 8.81977 1.66699 10.0003 1.66699C11.167 1.66699 12.2573 1.88227 13.2712 2.31283C14.285 2.74338 15.167 3.33366 15.917 4.08366C16.667 4.83366 17.2573 5.7156 17.6878 6.72949C18.1184 7.74338 18.3337 8.83366 18.3337 10.0003C18.3337 11.1809 18.1184 12.2781 17.6878 13.292C17.2573 14.3059 16.667 15.1878 15.917 15.9378C15.167 16.6878 14.285 17.2746 13.2712 17.6982C12.2573 18.1219 11.167 18.3337 10.0003 18.3337ZM10.0003 17.0837C12.0142 17.0837 13.6982 16.4066 15.0524 15.0524C16.4066 13.6982 17.0837 12.0142 17.0837 10.0003C17.0837 7.98644 16.4066 6.30241 15.0524 4.94824C13.6982 3.59408 12.0142 2.91699 10.0003 2.91699C7.98644 2.91699 6.30241 3.59408 4.94824 4.94824C3.59408 6.30241 2.91699 7.98644 2.91699 10.0003C2.91699 12.0142 3.59408 13.6982 4.94824 15.0524C6.30241 16.4066 7.98644 17.0837 10.0003 17.0837Z"
        fill="black"
      />
    </svg>
  ),
  refresh: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 16.6663C8.15245 16.6663 6.57954 16.017 5.28092 14.7184C3.98231 13.4198 3.33301 11.8469 3.33301 9.99967C3.33301 8.15245 3.98231 6.57954 5.28092 5.28092C6.57954 3.98231 8.15245 3.33301 9.99967 3.33301C11.1802 3.33301 12.215 3.57259 13.1038 4.05176C13.9927 4.53092 14.7636 5.18717 15.4163 6.02051V3.95801C15.4163 3.77745 15.4754 3.62815 15.5934 3.51009C15.7115 3.39204 15.8608 3.33301 16.0413 3.33301C16.2219 3.33301 16.3712 3.39204 16.4893 3.51009C16.6073 3.62815 16.6663 3.77745 16.6663 3.95801V7.99967C16.6663 8.18023 16.6073 8.32954 16.4893 8.44759C16.3712 8.56565 16.2219 8.62467 16.0413 8.62467H11.9997C11.8191 8.62467 11.6698 8.56565 11.5518 8.44759C11.4337 8.32954 11.3747 8.18023 11.3747 7.99967C11.3747 7.81912 11.4337 7.66981 11.5518 7.55176C11.6698 7.4337 11.8191 7.37467 11.9997 7.37467H14.8747C14.3469 6.54134 13.6733 5.86773 12.8538 5.35384C12.0344 4.83995 11.083 4.58301 9.99967 4.58301C8.48579 4.58301 7.20454 5.10731 6.15592 6.15592C5.10731 7.20454 4.58301 8.48579 4.58301 9.99967C4.58301 11.5136 5.10731 12.7948 6.15592 13.8434C7.20454 14.892 8.48579 15.4163 9.99967 15.4163C11.083 15.4163 12.0761 15.1281 12.9788 14.5518C13.8816 13.9754 14.5552 13.2011 14.9997 12.2288C15.0552 12.1177 15.1455 12.0205 15.2705 11.9372C15.3955 11.8538 15.5205 11.8122 15.6455 11.8122C15.8816 11.8122 16.0518 11.8886 16.1559 12.0413C16.2601 12.1941 16.2705 12.3747 16.1872 12.583C15.6733 13.8191 14.8573 14.8087 13.7393 15.5518C12.6212 16.2948 11.3747 16.6663 9.99967 16.6663Z"
        fill="black"
      />
    </svg>
  ),
  tab_triangle: (
    <svg
      width="50"
      height="47"
      viewBox="0 0 50 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_666_10589)">
        <path d="M25 12L37.9904 34.5H12.0096L25 12Z" fill="#F5F5F5" />
      </g>
      <defs>
        <filter
          id="filter0_d_666_10589"
          x="0.00976562"
          y="0"
          width="49.9805"
          height="46.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_666_10589"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_666_10589"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  icon_coin_mono: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13.247H15.989L15.269 15.866C15.2062 16.1002 15.0674 16.307 14.8746 16.4539C14.6817 16.6008 14.4455 16.6796 14.203 16.678H14.202C13.698 16.678 13.27 16.351 13.137 15.866L12 11.738L10.864 15.866C10.8012 16.1002 10.6624 16.307 10.4696 16.4539C10.2767 16.6008 10.0405 16.6796 9.798 16.678C9.294 16.678 8.866 16.352 8.732 15.867L8.011 13.247H6C5.76131 13.247 5.53239 13.1522 5.3636 12.9834C5.19482 12.8146 5.1 12.5857 5.1 12.347C5.1 12.1083 5.19482 11.8794 5.3636 11.7106C5.53239 11.5418 5.76131 11.447 6 11.447H7.516L6.885 9.155C6.8501 9.03999 6.83859 8.91916 6.85114 8.79964C6.8637 8.68011 6.90006 8.56431 6.9581 8.45907C7.01613 8.35382 7.09466 8.26127 7.18904 8.18686C7.28342 8.11246 7.39175 8.05771 7.50764 8.02585C7.62352 7.99399 7.74461 7.98566 7.86377 8.00136C7.98292 8.01706 8.09772 8.05646 8.2014 8.11725C8.30508 8.17803 8.39554 8.25897 8.46743 8.35527C8.53933 8.45158 8.5912 8.56132 8.62 8.678L9.798 12.956L10.934 8.829C10.9965 8.59452 11.1351 8.38745 11.328 8.24029C11.521 8.09314 11.7573 8.01424 12 8.016C12.504 8.016 12.933 8.343 13.066 8.829L14.203 12.956L15.38 8.678C15.4113 8.56401 15.4648 8.45731 15.5373 8.36399C15.6099 8.27066 15.7001 8.19254 15.8029 8.13409C15.9056 8.07563 16.0189 8.03799 16.1362 8.0233C16.2535 8.00862 16.3725 8.01718 16.4865 8.0485C16.6005 8.07982 16.7072 8.13329 16.8005 8.20584C16.8938 8.2784 16.972 8.36863 17.0304 8.47138C17.0889 8.57412 17.1265 8.68738 17.1412 8.80468C17.1559 8.92197 17.1473 9.04101 17.116 9.155L16.484 11.447H18C18.2387 11.447 18.4676 11.5418 18.6364 11.7106C18.8052 11.8794 18.9 12.1083 18.9 12.347C18.9 12.5857 18.8052 12.8146 18.6364 12.9834C18.4676 13.1522 18.2387 13.247 18 13.247ZM12 1C5.925 1 1 5.925 1 12C1 18.076 5.925 23 12 23C18.075 23 23 18.076 23 12C23 5.925 18.075 1 12 1Z"
        fill="#F6B982"
      />
    </svg>
  ),
  chat_bubble_rounded: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 19.575V4C2 3.45 2.196 2.979 2.588 2.587C2.97933 2.19567 3.45 2 4 2H20C20.55 2 21.021 2.19567 21.413 2.587C21.8043 2.979 22 3.45 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.021 17.8043 20.55 18 20 18H6L3.7 20.3C3.38333 20.6167 3.02067 20.6873 2.612 20.512C2.204 20.3373 2 20.025 2 19.575Z"
        fill="#F6B982"
      />
    </svg>
  ),
  icon_call_mono: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_493_6660)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8936 11.2753L12.2409 9.222C12.1128 9.12313 11.9531 9.07435 11.7916 9.08478C11.6301 9.09521 11.4779 9.16414 11.3636 9.27866L9.95559 10.6873C9.85072 10.7933 9.71316 10.8607 9.56519 10.8787C9.41722 10.8968 9.26749 10.8643 9.14025 10.7867C8.68692 10.5087 7.92826 9.97 6.97892 9.02C6.02959 8.07133 5.49092 7.312 5.21292 6.85933C5.13516 6.73219 5.10273 6.58248 5.12088 6.43456C5.13904 6.28664 5.20672 6.14922 5.31292 6.04467L6.72092 4.636C6.83561 4.52173 6.90459 4.36949 6.91491 4.20793C6.92522 4.04636 6.87615 3.88659 6.77692 3.75867L4.72426 1.10533C4.25759 0.503332 3.37759 0.407999 2.80426 0.911332C2.04892 1.574 1.14159 2.56667 0.877589 3.68067C0.399588 5.68733 1.15492 8.20533 4.47492 11.5253C7.79492 14.8447 10.3129 15.6007 12.3189 15.1233C13.4329 14.858 14.4263 13.95 15.0889 13.1953C15.5916 12.622 15.4963 11.742 14.8936 11.2753Z"
          fill="#BEB4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_493_6660">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  search: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7917 15.1667H15.9358L15.6325 14.8742C16.6942 13.6392 17.3333 12.0358 17.3333 10.2917C17.3333 6.4025 14.1808 3.25 10.2917 3.25C6.4025 3.25 3.25 6.4025 3.25 10.2917C3.25 14.1808 6.4025 17.3333 10.2917 17.3333C12.0358 17.3333 13.6392 16.6942 14.8742 15.6325L15.1667 15.9358V16.7917L20.5833 22.1975L22.1975 20.5833L16.7917 15.1667ZM10.2917 15.1667C7.59417 15.1667 5.41667 12.9892 5.41667 10.2917C5.41667 7.59417 7.59417 5.41667 10.2917 5.41667C12.9892 5.41667 15.1667 7.59417 15.1667 10.2917C15.1667 12.9892 12.9892 15.1667 10.2917 15.1667Z"
        fill="#B9B9B9"
      />
    </svg>
  ),
  logout: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4971 6H6V19H12.5M15.75 15.75L19 12.5L15.75 9.25M10.5397 12.4971H19"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "icon-home-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.069 8.20395L12.622 1.48695C12.4453 1.3461 12.226 1.26941 12 1.26941C11.774 1.26941 11.5547 1.3461 11.378 1.48695L2.92999 8.20395C2.69454 8.39123 2.50437 8.62921 2.37365 8.90017C2.24293 9.17114 2.17502 9.4681 2.17499 9.76895V19.1869C2.17499 19.8235 2.42784 20.4339 2.87793 20.884C3.32802 21.3341 3.93847 21.5869 4.57499 21.5869H9.99999V16.8349C9.99999 16.5697 10.1053 16.3154 10.2929 16.1278C10.4804 15.9403 10.7348 15.8349 11 15.8349H13C13.2652 15.8349 13.5196 15.9403 13.7071 16.1278C13.8946 16.3154 14 16.5697 14 16.8349V21.5869H19.424C20.0605 21.5869 20.671 21.3341 21.121 20.884C21.5711 20.4339 21.824 19.8235 21.824 19.1869V9.76995C21.824 9.4691 21.756 9.17214 21.6253 8.90117C21.4946 8.63021 21.3044 8.39223 21.069 8.20495"
        fill="#252525"
      />
    </svg>
  ),
  "icon-calendar-check-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.207 10.415L11.623 15.999C11.4355 16.1865 11.1812 16.2918 10.916 16.2918C10.6508 16.2918 10.3965 16.1865 10.209 15.999L6.79299 12.582C6.70014 12.4892 6.6265 12.379 6.57625 12.2577C6.526 12.1364 6.50014 12.0064 6.50014 11.875C6.50014 11.7437 6.526 11.6137 6.57625 11.4924C6.6265 11.3711 6.70014 11.2609 6.79299 11.168C6.88583 11.0752 6.99605 11.0016 7.11736 10.9513C7.23867 10.9011 7.36869 10.8752 7.49999 10.8752C7.63129 10.8752 7.76131 10.9011 7.88261 10.9513C8.00392 11.0016 8.11414 11.0752 8.20699 11.168L10.916 13.877L15.793 9.00105C15.8858 8.9082 15.9961 8.83456 16.1174 8.78431C16.2387 8.73406 16.3687 8.7082 16.5 8.7082C16.6313 8.7082 16.7613 8.73406 16.8826 8.78431C17.0039 8.83456 17.1141 8.9082 17.207 9.00105C17.2998 9.09389 17.3735 9.20412 17.4237 9.32542C17.474 9.44673 17.4998 9.57675 17.4998 9.70805C17.4998 9.83935 17.474 9.96937 17.4237 10.0907C17.3735 10.212 17.2998 10.3222 17.207 10.415ZM19.7 2.80005H18.07V1.80005C18.07 1.53483 17.9646 1.28048 17.7771 1.09294C17.5896 0.905406 17.3352 0.800049 17.07 0.800049C16.8048 0.800049 16.5504 0.905406 16.3629 1.09294C16.1753 1.28048 16.07 1.53483 16.07 1.80005V2.80005H7.92999V1.80005C7.92999 1.53483 7.82463 1.28048 7.63709 1.09294C7.44956 0.905406 7.1952 0.800049 6.92999 0.800049C6.66477 0.800049 6.41042 0.905406 6.22288 1.09294C6.03534 1.28048 5.92999 1.53483 5.92999 1.80005V2.80005H4.29999C3.76956 2.80005 3.26085 3.01076 2.88577 3.38584C2.5107 3.76091 2.29999 4.26962 2.29999 4.80005V20.2001C2.29999 20.7305 2.5107 21.2392 2.88577 21.6143C3.26085 21.9893 3.76956 22.2001 4.29999 22.2001H19.7C20.2304 22.2001 20.7391 21.9893 21.1142 21.6143C21.4893 21.2392 21.7 20.7305 21.7 20.2001V4.80005C21.7 4.26962 21.4893 3.76091 21.1142 3.38584C20.7391 3.01076 20.2304 2.80005 19.7 2.80005Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-stack-up-square-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.21 16.105L19.677 15.338L13.565 18.394C13.0789 18.6361 12.5431 18.7618 12 18.761C11.4569 18.7617 10.9212 18.636 10.435 18.394L4.32301 15.338L2.78901 16.105C2.6226 16.1879 2.48261 16.3156 2.38476 16.4737C2.28691 16.6318 2.23508 16.8141 2.23508 17C2.23508 17.1859 2.28691 17.3682 2.38476 17.5263C2.48261 17.6844 2.6226 17.8121 2.78901 17.895L11.106 22.052C11.3837 22.1911 11.69 22.2635 12.0005 22.2635C12.3111 22.2635 12.6173 22.1911 12.895 22.052L21.211 17.894C21.3772 17.811 21.5169 17.6833 21.6146 17.5253C21.7122 17.3673 21.7639 17.1853 21.7639 16.9995C21.7639 16.8138 21.7122 16.6317 21.6146 16.4737C21.5169 16.3157 21.3772 16.1881 21.211 16.105"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.21 11.105L19.677 10.338L13.565 13.394C13.0789 13.6361 12.5431 13.7618 12 13.761C11.4569 13.7617 10.9212 13.636 10.435 13.394L4.32301 10.338L2.78901 11.105C2.6226 11.1879 2.48261 11.3156 2.38476 11.4737C2.28691 11.6318 2.23508 11.8141 2.23508 12C2.23508 12.1859 2.28691 12.3682 2.38476 12.5263C2.48261 12.6844 2.6226 12.8121 2.78901 12.895L11.106 17.052C11.3837 17.1911 11.69 17.2635 12.0005 17.2635C12.3111 17.2635 12.6173 17.1911 12.895 17.052L21.211 12.894C21.3772 12.811 21.5169 12.6833 21.6146 12.5253C21.7122 12.3673 21.7639 12.1853 21.7639 11.9995C21.7639 11.8138 21.7122 11.6317 21.6146 11.4737C21.5169 11.3157 21.3772 11.1881 21.211 11.105"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.106 12.053L2.79 7.89399C2.62412 7.81085 2.48464 7.6832 2.38717 7.52531C2.28969 7.36743 2.23807 7.18554 2.23807 6.99999C2.23807 6.81444 2.28969 6.63255 2.38717 6.47466C2.48464 6.31678 2.62412 6.18913 2.79 6.10599L11.106 1.94799C11.3837 1.80888 11.6899 1.73645 12.0005 1.73645C12.3111 1.73645 12.6173 1.80888 12.895 1.94799L21.211 6.10599C21.3771 6.18903 21.5169 6.3167 21.6145 6.47469C21.7122 6.63268 21.7639 6.81475 21.7639 7.00049C21.7639 7.18623 21.7122 7.3683 21.6145 7.52629C21.5169 7.68428 21.3771 7.81195 21.211 7.89499L12.895 12.053C12.6171 12.1917 12.3107 12.2639 12 12.2639C11.6893 12.2639 11.3829 12.1917 11.105 12.053"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-user-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.887 6.64401C16.8871 7.28683 16.7605 7.92337 16.5146 8.51729C16.2686 9.1112 15.9081 9.65086 15.4536 10.1054C14.9991 10.56 14.4595 10.9207 13.8657 11.1667C13.2718 11.4128 12.6353 11.5394 11.9925 11.5395C10.6943 11.5396 9.44914 11.024 8.53105 10.1062C7.61297 9.18826 7.09712 7.94325 7.09699 6.64501C7.09692 6.00219 7.22347 5.36565 7.46941 4.77174C7.71534 4.17782 8.07585 3.63817 8.53035 3.18358C9.44824 2.26549 10.6933 1.74964 11.9915 1.74951C13.2897 1.74938 14.5348 2.26497 15.4529 3.18287C16.371 4.10077 16.8869 5.34578 16.887 6.64401ZM11.992 13.037C4.94299 13.037 2.20099 17.523 2.20099 19.61C2.20099 21.696 8.03799 22.252 11.992 22.252C15.946 22.252 21.783 21.696 21.783 19.61C21.783 17.523 19.041 13.037 11.992 13.037Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  rating_star: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3659 6.67102L11.6444 5.95246L9.53374 1.47163C9.4761 1.34895 9.38126 1.24964 9.2641 1.18927C8.97028 1.03738 8.61324 1.16395 8.46633 1.47163L6.35568 5.95246L1.63413 6.67102C1.50396 6.6905 1.38494 6.75476 1.29382 6.85213C1.18366 6.97069 1.12296 7.13021 1.12505 7.29562C1.12714 7.46103 1.19186 7.6188 1.30498 7.73427L4.72108 11.2219L3.91401 16.1468C3.89508 16.2613 3.90719 16.3792 3.94896 16.4869C3.99072 16.5946 4.06048 16.6879 4.15031 16.7562C4.24014 16.8246 4.34646 16.8652 4.4572 16.8734C4.56795 16.8817 4.67869 16.8573 4.77687 16.803L9.00004 14.4779L13.2232 16.803C13.3385 16.8673 13.4724 16.8887 13.6007 16.8653C13.9243 16.8069 14.1419 16.4856 14.0861 16.1468L13.279 11.2219L16.6951 7.73427C16.7881 7.63885 16.8494 7.51422 16.868 7.37791C16.9182 7.03712 16.6914 6.72165 16.3659 6.67102Z"
        fill="#E9E9E9"
      />
    </svg>
  ),
  "icon-check-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6 17.2C10.3 17.2 9.99995 17.1 9.79995 16.8L5.19995 12.2C4.69995 11.7 4.69995 11 5.19995 10.5C5.69995 10 6.39995 10 6.89995 10.5L10.6 14.2L17.2 7.60001C17.7 7.10001 18.4 7.10001 18.9 7.60001C19.4 8.10001 19.4 8.80001 18.9 9.30001L11.5 16.7C11.2 17.1 10.9 17.2 10.6 17.2V17.2Z"
        fill="#F5F5F5"
      />
    </svg>
  ),
  "icon-unchecked-circle-line-mono-v2": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#CCCCCC" />
      <path
        d="M17.5869 8.02764C17.9571 8.39782 17.9571 8.99801 17.5869 9.36819L11.0244 15.9307C10.6543 16.3009 10.0541 16.3009 9.68389 15.9307L6.40264 12.6494C6.03245 12.2793 6.03245 11.6791 6.40264 11.3089C6.77282 10.9387 7.37301 10.9387 7.74319 11.3089L10.3542 13.9199L16.2464 8.02764C16.6166 7.65745 17.2168 7.65745 17.5869 8.02764Z"
        fill="white"
      />
    </svg>
  ),

  "icon-checked-circle-line-mono-v2": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#252525" />
      <path
        d="M17.5869 8.02764C17.9571 8.39782 17.9571 8.99801 17.5869 9.36819L11.0244 15.9307C10.6543 16.3009 10.0541 16.3009 9.68389 15.9307L6.40264 12.6494C6.03245 12.2793 6.03245 11.6791 6.40264 11.3089C6.77282 10.9387 7.37301 10.9387 7.74319 11.3089L10.3542 13.9199L16.2464 8.02764C16.6166 7.65745 17.2168 7.65745 17.5869 8.02764Z"
        fill="white"
      />
    </svg>
  ),

  "icon-check-circle-line-mono": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2 10.2L11.6 15.8C11.4 16 11.2 16.1 10.9 16.1C10.6 16.1 10.4 16 10.2 15.8L6.8 12.4C6.4 12 6.4 11.4 6.8 11C7.2 10.6 7.8 10.6 8.2 11L10.9 13.7L15.8 8.8C16.2 8.4 16.8 8.4 17.2 8.8C17.6 9.2 17.6 9.8 17.2 10.2Z"
        fill="#F18334"
      />
      <path
        d="M12 3C17 3 21 7 21 12C21 17 17 21 12 21C7 21 3 17 3 12C3 7 7 3 12 3ZM12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1Z"
        fill="#F18334"
      />
    </svg>
  ),
  "품목별 가격": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0913 5.78198L7.35801 9.51532L4.90935 7.06665C4.80477 6.95255 4.74827 6.80247 4.75164 6.64773C4.755 6.49298 4.81798 6.34551 4.92742 6.23606C5.03687 6.12661 5.18434 6.06364 5.33909 6.06027C5.49384 6.0569 5.64391 6.1134 5.75802 6.21798L7.35801 7.81798L10.2427 4.93332C10.2984 4.87759 10.3646 4.83339 10.4374 4.80323C10.5102 4.77308 10.5882 4.75755 10.667 4.75755C10.7458 4.75755 10.8239 4.77308 10.8967 4.80323C10.9695 4.83339 11.0356 4.87759 11.0913 4.93332C11.1471 4.98904 11.1913 5.0552 11.2214 5.128C11.2516 5.20081 11.2671 5.27885 11.2671 5.35765C11.2671 5.43646 11.2516 5.51449 11.2214 5.5873C11.1913 5.66011 11.1471 5.72626 11.0913 5.78198V5.78198ZM14.098 7.04665C14.1605 6.98414 14.1956 6.89937 14.1956 6.81098C14.1956 6.7226 14.1605 6.63783 14.098 6.57532L13.1313 5.60865C13.0899 5.56732 13.0601 5.51577 13.045 5.45922C13.0299 5.40268 13.03 5.34314 13.0453 5.28665L13.3987 3.96665C13.4215 3.88125 13.4094 3.7903 13.3652 3.71378C13.3209 3.63727 13.2481 3.58147 13.1627 3.55865L11.8427 3.20532C11.786 3.19014 11.7343 3.16026 11.6929 3.1187C11.6514 3.07714 11.6217 3.02538 11.6067 2.96865L11.2533 1.64865C11.2304 1.56321 11.1744 1.49037 11.0978 1.44612C11.0212 1.40188 10.9302 1.38984 10.8447 1.41265L9.52401 1.76665C9.46756 1.78176 9.40813 1.78171 9.3517 1.76649C9.29528 1.75127 9.24388 1.72143 9.20268 1.67998L8.23601 0.713318C8.17351 0.650828 8.08874 0.615723 8.00035 0.615723C7.91196 0.615723 7.82719 0.650828 7.76468 0.713318L6.79801 1.68065C6.75664 1.72204 6.70512 1.75183 6.6486 1.76704C6.59209 1.78225 6.53258 1.78235 6.47601 1.76732L5.15602 1.41265C5.11369 1.40126 5.06952 1.39834 5.02606 1.40404C4.9826 1.40974 4.94069 1.42396 4.90273 1.44588C4.86477 1.46781 4.83151 1.497 4.80484 1.53179C4.77818 1.56659 4.75864 1.6063 4.74735 1.64865L4.39335 2.96865C4.37828 3.02518 4.3486 3.07675 4.30729 3.11817C4.26599 3.1596 4.2145 3.18943 4.15802 3.20465L2.83735 3.55865C2.75208 3.58161 2.67941 3.63748 2.63528 3.71397C2.59116 3.79047 2.5792 3.88134 2.60202 3.96665L2.95535 5.28665C2.97067 5.34314 2.97078 5.40268 2.95568 5.45922C2.94058 5.51577 2.91079 5.56732 2.86935 5.60865L1.90268 6.57532C1.87166 6.60622 1.84705 6.64295 1.83025 6.68339C1.81346 6.72384 1.80481 6.76719 1.80481 6.81098C1.80481 6.85477 1.81346 6.89813 1.83025 6.93858C1.84705 6.97902 1.87166 7.01574 1.90268 7.04665L2.86935 8.01332C2.91079 8.05479 2.94057 8.10645 2.95567 8.16311C2.97077 8.21976 2.97066 8.27939 2.95535 8.33598L2.60202 9.65598C2.5792 9.74129 2.59116 9.83217 2.63528 9.90866C2.67941 9.98516 2.75208 10.041 2.83735 10.064L4.15802 10.418C4.2145 10.4332 4.26599 10.463 4.30729 10.5045C4.3486 10.5459 4.37828 10.5975 4.39335 10.654L4.74668 11.974C4.75837 12.0168 4.77849 12.0568 4.80585 12.0917C4.83321 12.1266 4.86726 12.1557 4.90602 12.1773L3.66535 15.522H7.12068L8.00001 13.15L8.88068 15.522H12.3353L11.0947 12.1773C11.1334 12.1558 11.1674 12.1267 11.1947 12.0918C11.222 12.0569 11.2419 12.0168 11.2533 11.974L11.6067 10.654C11.6217 10.5973 11.6515 10.5457 11.6929 10.5042C11.7344 10.4628 11.786 10.433 11.8427 10.418L13.1627 10.0647C13.205 10.0534 13.2447 10.0338 13.2795 10.0072C13.3143 9.98049 13.3435 9.94723 13.3654 9.90927C13.3874 9.87131 13.4016 9.8294 13.4073 9.78594C13.413 9.74247 13.4101 9.69831 13.3987 9.65598L13.0453 8.33598C13.03 8.27949 13.0299 8.21996 13.045 8.16341C13.0601 8.10686 13.0899 8.05531 13.1313 8.01398L14.098 7.04732V7.04665Z"
        fill="#857471"
      />
    </svg>
  ),

  "실제 결제 내역": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13.2998H15.913L15.172 15.9918C15.1149 16.205 14.9887 16.3932 14.8131 16.5269C14.6376 16.6606 14.4226 16.7323 14.202 16.7308C13.9814 16.7325 13.7665 16.6608 13.5911 16.527C13.4157 16.3932 13.2897 16.205 13.233 15.9918L12 11.5138L10.768 15.9918C10.7111 16.2049 10.5851 16.393 10.4097 16.5268C10.2343 16.6605 10.0195 16.7323 9.79898 16.7308H9.79798C9.57744 16.7324 9.36259 16.6608 9.18707 16.5273C9.01155 16.3937 8.88526 16.2058 8.82798 15.9928L8.08698 13.2998H5.99998C5.7878 13.2998 5.58432 13.2155 5.43429 13.0655C5.28426 12.9155 5.19998 12.712 5.19998 12.4998C5.19998 12.2876 5.28426 12.0841 5.43429 11.9341C5.58432 11.7841 5.7878 11.6998 5.99998 11.6998H7.64598L6.98098 9.2808C6.94938 9.17842 6.93867 9.07074 6.94949 8.96414C6.9603 8.85754 6.99242 8.7542 7.04393 8.66025C7.09545 8.56631 7.16531 8.48366 7.24937 8.41723C7.33344 8.3508 7.42999 8.30193 7.5333 8.27352C7.63661 8.24511 7.74457 8.23775 7.85078 8.25186C7.957 8.26597 8.05929 8.30128 8.1516 8.35568C8.2439 8.41008 8.32434 8.48247 8.38814 8.56856C8.45193 8.65464 8.49778 8.75266 8.52298 8.8568L9.79798 13.4858L11.03 9.0078C11.0871 8.79464 11.2133 8.60645 11.3888 8.47271C11.5644 8.33898 11.7793 8.26726 12 8.2688C12.458 8.2688 12.848 8.5658 12.97 9.0078L14.202 13.4858L15.477 8.8568C15.5332 8.65219 15.6684 8.47829 15.8528 8.37336C15.9442 8.32141 16.0448 8.28795 16.1491 8.2749C16.2534 8.26185 16.3592 8.26946 16.4605 8.2973C16.5618 8.32514 16.6566 8.37266 16.7396 8.43716C16.8225 8.50165 16.892 8.58185 16.9439 8.67317C16.9959 8.7645 17.0293 8.86517 17.0424 8.96942C17.0554 9.07368 17.0478 9.17949 17.02 9.2808L16.354 11.6998H18C18.105 11.6998 18.2091 11.7205 18.3061 11.7607C18.4032 11.8009 18.4914 11.8598 18.5657 11.9341C18.6399 12.0084 18.6989 12.0966 18.7391 12.1937C18.7793 12.2907 18.8 12.3947 18.8 12.4998C18.8 12.6049 18.7793 12.7089 18.7391 12.8059C18.6989 12.903 18.6399 12.9912 18.5657 13.0655C18.4914 13.1398 18.4032 13.1987 18.3061 13.2389C18.2091 13.2791 18.105 13.2998 18 13.2998ZM21 1.9458H2.99998C2.76128 1.9458 2.53236 2.04062 2.36358 2.2094C2.1948 2.37819 2.09998 2.60711 2.09998 2.8458C2.09998 3.0845 2.1948 3.31341 2.36358 3.4822C2.53236 3.65098 2.76128 3.7458 2.99998 3.7458V20.8458C2.99998 21.111 3.10533 21.3654 3.29287 21.5529C3.48041 21.7404 3.73476 21.8458 3.99998 21.8458H20C20.2652 21.8458 20.5195 21.7404 20.7071 21.5529C20.8946 21.3654 21 21.111 21 20.8458V3.7458C21.2387 3.7458 21.4676 3.65098 21.6364 3.4822C21.8052 3.31341 21.9 3.0845 21.9 2.8458C21.9 2.60711 21.8052 2.37819 21.6364 2.2094C21.4676 2.04062 21.2387 1.9458 21 1.9458Z"
        fill="#F18334"
      />
    </svg>
  ),
  "미사용 품목": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 12.3333C5.25265 12.3333 2.93131 11.5967 1.58465 10.436C1.42531 10.722 1.33331 11.022 1.33331 11.3333C1.33331 13.1747 4.31865 14.6667 7.99998 14.6667C11.6813 14.6667 14.6666 13.1747 14.6666 11.3333C14.6666 11.022 14.5746 10.722 14.4153 10.436C13.0693 11.5967 10.7473 12.3333 7.99998 12.3333Z"
        fill="#857471"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 9.00002C5.25265 9.00002 2.93131 8.26336 1.58465 7.10269C1.42531 7.38869 1.33331 7.68869 1.33331 8.00002C1.33331 9.84136 4.31865 11.3334 7.99998 11.3334C11.6813 11.3334 14.6666 9.84136 14.6666 8.00002C14.6666 7.68869 14.5746 7.38869 14.4153 7.10269C13.0693 8.26336 10.7473 9.00002 7.99998 9.00002Z"
        fill="#857471"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 8.00001C11.6813 8.00001 14.6666 6.50801 14.6666 4.66668C14.6666 2.82601 11.6813 1.33334 7.99998 1.33334C4.31865 1.33334 1.33331 2.82601 1.33331 4.66668C1.33331 6.50801 4.31865 8.00001 7.99998 8.00001Z"
        fill="#857471"
      />
    </svg>
  ),
  metaball: (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99999 15.77C3.99993 16.0327 3.94812 16.2929 3.84752 16.5355C3.74693 16.7782 3.59952 16.9987 3.41371 17.1844C3.2279 17.3702 3.00733 17.5175 2.76459 17.6179C2.52185 17.7184 2.2617 17.7701 1.99899 17.77C1.73628 17.77 1.47616 17.7181 1.23347 17.6175C0.990786 17.517 0.77029 17.3695 0.584573 17.1837C0.398856 16.9979 0.251555 16.7774 0.151081 16.5346C0.0506073 16.2919 -0.00107268 16.0317 -0.00100702 15.769C-0.000874401 15.2385 0.210019 14.7297 0.58528 14.3546C0.96054 13.9795 1.46943 13.7689 1.99999 13.769C2.53056 13.7692 3.03934 13.98 3.41441 14.3553C3.78949 14.7306 4.00013 15.2395 3.99999 15.77ZM3.99999 8.99902C3.99999 9.52945 3.78928 10.0382 3.41421 10.4132C3.03913 10.7883 2.53043 10.999 1.99999 10.999C1.46956 10.999 0.960853 10.7883 0.58578 10.4132C0.210707 10.0382 -6.61321e-06 9.52945 -6.61321e-06 8.99902C-6.61321e-06 8.46859 0.210707 7.95988 0.58578 7.58481C0.960853 7.20973 1.46956 6.99902 1.99999 6.99902C2.53043 6.99902 3.03913 7.20973 3.41421 7.58481C3.78928 7.95988 3.99999 8.46859 3.99999 8.99902ZM3.99999 2.22902C3.99993 2.49173 3.94812 2.75185 3.84752 2.99454C3.74693 3.23723 3.59952 3.45772 3.41371 3.64344C3.2279 3.82916 3.00733 3.97646 2.76459 4.07693C2.52185 4.1774 2.2617 4.22908 1.99899 4.22902C1.73628 4.22895 1.47616 4.17715 1.23347 4.07655C0.990786 3.97595 0.77029 3.82854 0.584573 3.64273C0.398856 3.45692 0.251555 3.23635 0.151081 2.99362C0.0506073 2.75088 -0.00107268 2.49073 -0.00100702 2.22802C-0.000874401 1.69745 0.210019 1.18867 0.58528 0.813599C0.96054 0.438526 1.46943 0.227886 1.99999 0.22802C2.53056 0.228153 3.03934 0.439047 3.41441 0.814306C3.78949 1.18957 4.00013 1.69845 3.99999 2.22902Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  edit: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.97264 2.2111L2.71873 9.46501C2.61029 9.57318 2.53919 9.71312 2.51576 9.86449L2.00831 13.1711C1.99119 13.2828 2.0006 13.397 2.03578 13.5043C2.07096 13.6117 2.13092 13.7093 2.21082 13.7892C2.29071 13.8691 2.38829 13.929 2.49566 13.9642C2.60303 13.9994 2.71718 14.0088 2.82886 13.9917L6.13623 13.4842C6.28751 13.461 6.42744 13.3902 6.53571 13.282L13.7896 6.02808C13.9246 5.8931 14.0004 5.71005 14.0004 5.51919C14.0004 5.32834 13.9246 5.14529 13.7896 5.01031L10.9897 2.21038C10.8547 2.07566 10.6718 2 10.4812 2C10.2905 2 10.1076 2.07566 9.97264 2.21038V2.2111ZM3.58031 12.4204L3.90277 10.3158L10.4815 3.73703L12.263 5.51919L5.68421 12.098L3.58031 12.4204V12.4204Z"
        fill="#686868"
      />
      <path
        d="M8.70898 5.10963L9.47195 4.34595L11.8055 6.67802L11.0418 7.44171L8.70898 5.10963Z"
        fill="#686868"
      />
    </svg>
  ),
  delete: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 6.88889V10.5556M9.25 6.88889V10.5556M3 4.44444H13M12.375 4.44444L11.8331 11.8646C11.8107 12.1729 11.6696 12.4615 11.4382 12.6722C11.2068 12.8829 10.9024 13 10.5863 13H5.41375C5.09759 13 4.79317 12.8829 4.5618 12.6722C4.33044 12.4615 4.18932 12.1729 4.16688 11.8646L3.625 4.44444H12.375ZM9.875 4.44444V2.61111C9.875 2.44903 9.80915 2.2936 9.69194 2.17899C9.57473 2.06438 9.41576 2 9.25 2H6.75C6.58424 2 6.42527 2.06438 6.30806 2.17899C6.19085 2.2936 6.125 2.44903 6.125 2.61111V4.44444H9.875Z"
        stroke="#686868"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "arrow-drop-down": (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.47517 4.47499L0.300173 1.29999C0.0668395 1.06666 0.0126725 0.795828 0.137672 0.487494C0.262672 0.179161 0.491839 0.0249939 0.825172 0.0249939H7.17517C7.50851 0.0249939 7.73767 0.179161 7.86267 0.487494C7.98767 0.795828 7.93351 1.06666 7.70017 1.29999L4.52517 4.47499C4.44184 4.55833 4.35851 4.61666 4.27517 4.64999C4.19184 4.68333 4.10017 4.69999 4.00017 4.69999C3.90017 4.69999 3.80851 4.68333 3.72517 4.64999C3.64184 4.61666 3.55851 4.55833 3.47517 4.47499Z"
        fill="black"
      />
    </svg>
  ),
  clear: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_463_5802)">
        <circle cx="15" cy="15" r="7.5" fill="#8F8F8F" />
        <path
          d="M12.0061 12.0061C12.0476 11.9646 12.0968 11.9316 12.1511 11.9091C12.2053 11.8866 12.2634 11.875 12.3221 11.875C12.3808 11.875 12.439 11.8866 12.4932 11.9091C12.5474 11.9316 12.5967 11.9646 12.6381 12.0061L15.0001 14.369L17.3621 12.0061C17.4036 11.9646 17.4529 11.9317 17.5071 11.9093C17.5613 11.8868 17.6194 11.8752 17.6781 11.8752C17.7368 11.8752 17.7949 11.8868 17.8491 11.9093C17.9033 11.9317 17.9526 11.9646 17.9941 12.0061C18.0356 12.0476 18.0685 12.0969 18.091 12.1511C18.1134 12.2053 18.125 12.2634 18.125 12.3221C18.125 12.3808 18.1134 12.4389 18.091 12.4931C18.0685 12.5474 18.0356 12.5966 17.9941 12.6381L15.6312 15.0001L17.9941 17.3621C18.0356 17.4036 18.0685 17.4529 18.091 17.5071C18.1134 17.5613 18.125 17.6194 18.125 17.6781C18.125 17.7368 18.1134 17.7949 18.091 17.8491C18.0685 17.9033 18.0356 17.9526 17.9941 17.9941C17.9526 18.0356 17.9033 18.0685 17.8491 18.091C17.7949 18.1134 17.7368 18.125 17.6781 18.125C17.6194 18.125 17.5613 18.1134 17.5071 18.091C17.4529 18.0685 17.4036 18.0356 17.3621 17.9941L15.0001 15.6312L12.6381 17.9941C12.5966 18.0356 12.5474 18.0685 12.4931 18.091C12.4389 18.1134 12.3808 18.125 12.3221 18.125C12.2634 18.125 12.2053 18.1134 12.1511 18.091C12.0969 18.0685 12.0476 18.0356 12.0061 17.9941C11.9646 17.9526 11.9317 17.9033 11.9093 17.8491C11.8868 17.7949 11.8752 17.7368 11.8752 17.6781C11.8752 17.6194 11.8868 17.5613 11.9093 17.5071C11.9317 17.4529 11.9646 17.4036 12.0061 17.3621L14.369 15.0001L12.0061 12.6381C11.9646 12.5967 11.9316 12.5474 11.9091 12.4932C11.8866 12.439 11.875 12.3808 11.875 12.3221C11.875 12.2634 11.8866 12.2053 11.9091 12.1511C11.9316 12.0968 11.9646 12.0476 12.0061 12.0061Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_463_5802">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(7.5 7.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-coin-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_354_6584)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8.83133H10.6593L10.1793 10.5773C10.1374 10.7335 10.0449 10.8713 9.91633 10.9693C9.78773 11.0672 9.63028 11.1198 9.46863 11.1187H9.46796C9.13196 11.1187 8.84663 10.9007 8.75796 10.5773L7.99996 7.82533L7.24263 10.5773C7.20074 10.7335 7.10826 10.8713 6.97966 10.9693C6.85106 11.0672 6.69361 11.1198 6.53196 11.1187C6.19596 11.1187 5.91063 10.9013 5.82129 10.578L5.34063 8.83133H3.99996C3.84083 8.83133 3.68822 8.76812 3.5757 8.6556C3.46317 8.54308 3.39996 8.39046 3.39996 8.23133C3.39996 8.0722 3.46317 7.91959 3.5757 7.80707C3.68822 7.69455 3.84083 7.63133 3.99996 7.63133H5.01063L4.58996 6.10333C4.56669 6.02666 4.55902 5.94611 4.56739 5.86643C4.57576 5.78674 4.6 5.70954 4.63869 5.63938C4.67738 5.56922 4.72973 5.50751 4.79265 5.45791C4.85557 5.40831 4.92779 5.37181 5.00505 5.35057C5.08231 5.32933 5.16303 5.32378 5.24247 5.33424C5.32191 5.34471 5.39844 5.37098 5.46756 5.4115C5.53668 5.45202 5.59698 5.50598 5.64491 5.57018C5.69284 5.63439 5.72743 5.70755 5.74663 5.78533L6.53196 8.63733L7.28929 5.886C7.33095 5.72968 7.42335 5.59163 7.55198 5.49353C7.68062 5.39543 7.83819 5.34283 7.99996 5.344C8.33596 5.344 8.62196 5.562 8.71063 5.886L9.46863 8.63733L10.2533 5.78533C10.2742 5.70934 10.3098 5.63821 10.3582 5.57599C10.4066 5.51377 10.4667 5.4617 10.5352 5.42273C10.6037 5.38376 10.6792 5.35866 10.7574 5.34887C10.8356 5.33908 10.915 5.34479 10.991 5.36567C11.067 5.38655 11.1381 5.42219 11.2003 5.47056C11.2625 5.51893 11.3146 5.57909 11.3536 5.64759C11.3925 5.71608 11.4176 5.79159 11.4274 5.86978C11.4372 5.94798 11.4315 6.02734 11.4106 6.10333L10.9893 7.63133H12C12.1591 7.63133 12.3117 7.69455 12.4242 7.80707C12.5367 7.91959 12.6 8.0722 12.6 8.23133C12.6 8.39046 12.5367 8.54308 12.4242 8.6556C12.3117 8.76812 12.1591 8.83133 12 8.83133M7.99996 0.666668C3.94996 0.666668 0.666626 3.95 0.666626 8C0.666626 12.0507 3.94996 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.0507 15.3333 8C15.3333 3.95 12.05 0.666668 7.99996 0.666668Z"
          fill="#E8E5E4"
        />
      </g>
      <defs>
        <clipPath id="clip0_354_6584">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-user-two-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00004 7.76467C5.32835 7.76467 5.65344 7.7 5.95675 7.57437C6.26006 7.44873 6.53566 7.26458 6.76781 7.03243C6.99995 6.80029 7.1841 6.52469 7.30974 6.22138C7.43538 5.91806 7.50004 5.59297 7.50004 5.26467C7.50004 4.93636 7.43538 4.61127 7.30974 4.30796C7.1841 4.00464 6.99995 3.72905 6.76781 3.4969C6.53566 3.26475 6.26006 3.08061 5.95675 2.95497C5.65344 2.82933 5.32835 2.76467 5.00004 2.76467C4.337 2.76467 3.70111 3.02806 3.23227 3.4969C2.76343 3.96574 2.50004 4.60163 2.50004 5.26467C2.50004 5.92771 2.76343 6.56359 3.23227 7.03243C3.70111 7.50128 4.337 7.76467 5.00004 7.76467M5.33337 11.8853C5.33337 11.0427 5.84737 9.79533 6.98671 8.85067C6.42471 8.65267 5.76804 8.52867 5.00004 8.52867C1.64004 8.52867 0.333374 10.8207 0.333374 11.8853C0.333374 12.952 3.11537 13.2347 5.00004 13.2347C5.31404 13.2347 5.65337 13.226 6.00071 13.208C5.56004 12.8567 5.33337 12.4167 5.33337 11.8853Z"
        fill="#E8E5E4"
        fillOpacity="0.72"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8.52933C7.64004 8.52933 6.33337 10.8207 6.33337 11.886C6.33337 12.9513 9.11537 13.2353 11 13.2353C12.8847 13.2353 15.6667 12.9513 15.6667 11.886C15.6667 10.8207 14.36 8.52933 11 8.52933ZM11 7.76467C11.3283 7.76467 11.6534 7.7 11.9567 7.57437C12.2601 7.44873 12.5357 7.26458 12.7678 7.03243C13 6.80029 13.1841 6.52469 13.3097 6.22138C13.4354 5.91806 13.5 5.59297 13.5 5.26467C13.5 4.93636 13.4354 4.61127 13.3097 4.30796C13.1841 4.00464 13 3.72905 12.7678 3.4969C12.5357 3.26475 12.2601 3.08061 11.9567 2.95497C11.6534 2.82933 11.3283 2.76467 11 2.76467C10.337 2.76467 9.70111 3.02806 9.23227 3.4969C8.76343 3.96574 8.50004 4.60163 8.50004 5.26467C8.50004 5.92771 8.76343 6.56359 9.23227 7.03243C9.70111 7.50128 10.337 7.76467 11 7.76467"
        fill="#E8E5E4"
      />
    </svg>
  ),
  "icon-call-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_582_6317)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6166 14.0942L15.3008 11.5275C15.1406 11.4039 14.9409 11.3429 14.7391 11.356C14.5372 11.369 14.347 11.4552 14.2041 11.5983L12.4441 13.3592C12.313 13.4916 12.1411 13.5759 11.9561 13.5984C11.7712 13.621 11.584 13.5804 11.425 13.4833C10.8583 13.1358 9.90995 12.4625 8.72329 11.275C7.53662 10.0892 6.86329 9.14001 6.51579 8.57418C6.41859 8.41526 6.37804 8.22812 6.40074 8.04322C6.42343 7.85832 6.50804 7.68654 6.64079 7.55584L8.40079 5.79501C8.54414 5.65217 8.63037 5.46188 8.64327 5.25992C8.65616 5.05796 8.59482 4.85825 8.47079 4.69834L5.90495 1.38168C5.32162 0.629178 4.22162 0.510011 3.50495 1.13918C2.56079 1.96751 1.42662 3.20834 1.09662 4.60084C0.499119 7.10918 1.44329 10.2567 5.59329 14.4067C9.74329 18.5558 12.8908 19.5008 15.3983 18.9042C16.7908 18.5725 18.0325 17.4375 18.8608 16.4942C19.4891 15.7775 19.37 14.6775 18.6166 14.0942Z"
          fill="#FEFAF6"
        />
      </g>
      <defs>
        <clipPath id="clip0_582_6317">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-arrow-left": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3306 4.94181C15.0206 4.62704 14.5136 4.62307 14.1988 4.93303L7.5992 11.433C7.44652 11.5834 7.35994 11.789 7.35994 12.0033C7.35994 12.2176 7.44652 12.4233 7.5992 12.5737L14.1988 19.0737C14.5136 19.3836 15.0206 19.3796 15.3306 19.0649C15.6406 18.7501 15.6366 18.243 15.3219 17.933L9.30135 12.0033L15.3219 6.07365C15.6366 5.76365 15.6406 5.25661 15.3306 4.94181Z"
        fill="#252525"
      />
    </svg>
  ),
  "icon-arrow-right-circle-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2800_20445)">
        <path
          d="M0.666687 7.99935C0.666687 12.066 3.93335 15.3327 8.00002 15.3327C12.0667 15.3327 15.3334 12.066 15.3334 7.99935C15.3334 3.93268 12.0667 0.666016 8.00002 0.666016C3.93335 0.666016 0.666687 3.93268 0.666687 7.99935ZM4.33335 7.99935C4.33335 7.59935 4.60002 7.33268 5.00002 7.33268H9.40002L7.86669 5.79935C7.60002 5.53268 7.60002 5.13268 7.86669 4.86602C8.13335 4.59935 8.53335 4.59935 8.80002 4.86602L11.4667 7.53268C11.7334 7.79935 11.7334 8.19935 11.4667 8.46602L8.80002 11.1327C8.66669 11.266 8.53335 11.3327 8.33335 11.3327C8.13335 11.3327 8.00002 11.266 7.86669 11.1327C7.60002 10.866 7.60002 10.466 7.86669 10.1993L9.40002 8.66602H5.00002C4.66669 8.66602 4.33335 8.39935 4.33335 7.99935Z"
          fill="#857471"
        />
      </g>
      <defs>
        <clipPath id="clip0_2800_20445">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-arrow-right-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64668 2.955C9.45335 2.74833 9.14668 2.74833 8.96002 2.955C8.77335 3.16167 8.77335 3.50167 8.96002 3.70833L12.4333 7.46833H2.43335C2.14002 7.46833 1.90002 7.70833 1.90002 8.00167C1.90002 8.295 2.14002 8.535 2.43335 8.535H12.4333L8.96668 12.2883C8.77335 12.495 8.77335 12.835 8.96668 13.0417C9.15335 13.2483 9.46002 13.255 9.65335 13.0417L13.9533 8.38167C14.0467 8.28167 14.1 8.14167 14.1 8.00167C14.1 7.86167 14.0467 7.72167 13.9533 7.62167L9.64668 2.955Z"
        fill="white"
      />
    </svg>
  ),
  "icon-arrow-right-small-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62498 20.0999C8.27998 20.0999 7.93498 19.9649 7.66498 19.7099C7.41309 19.4569 7.27167 19.1145 7.27167 18.7574C7.27167 18.4004 7.41309 18.0579 7.66498 17.8049L13.47 11.9999L7.66498 6.20994C7.41309 5.95694 7.27167 5.61445 7.27167 5.25744C7.27167 4.90042 7.41309 4.55794 7.66498 4.30494C7.91799 4.05304 8.26047 3.91162 8.61748 3.91162C8.9745 3.91162 9.31698 4.05304 9.56998 4.30494L16.32 11.0549C16.5719 11.3079 16.7133 11.6504 16.7133 12.0074C16.7133 12.3645 16.5719 12.7069 16.32 12.9599L9.56998 19.7099C9.31498 19.9649 8.96998 20.0999 8.62498 20.0999Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  "icon-chevron-up-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0617 15.3707C19.3765 15.0607 19.3805 14.5537 19.0705 14.2389L12.5705 7.63926C12.4201 7.48658 12.2145 7.4 12.0002 7.4C11.7859 7.4 11.5803 7.48658 11.4299 7.63926L4.92989 14.2389C4.61994 14.5537 4.62391 15.0607 4.93868 15.3707C5.25348 15.6807 5.76051 15.6767 6.07051 15.3619L12.0002 9.34141L17.9299 15.3619C18.2399 15.6767 18.7469 15.6807 19.0617 15.3707Z"
        fill="#767A7F"
      />
    </svg>
  ),
  "icon-warning-triangle-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 15.9926C9.86872 15.9926 9.73869 15.9667 9.61736 15.9165C9.49604 15.8662 9.3858 15.7926 9.29294 15.6997C9.20008 15.6068 9.12642 15.4966 9.07616 15.3753C9.02591 15.2539 9.00004 15.1239 9.00004 14.9926C9.00004 14.8613 9.02591 14.7312 9.07616 14.6099C9.12642 14.4886 9.20008 14.3783 9.29294 14.2855C9.3858 14.1926 9.49604 14.119 9.61736 14.0687C9.73869 14.0185 9.86872 13.9926 10 13.9926C10.2653 13.9926 10.5196 14.0979 10.7072 14.2855C10.8947 14.473 11 14.7274 11 14.9926C11 15.2578 10.8947 15.5122 10.7072 15.6997C10.5196 15.8872 10.2653 15.9926 10 15.9926ZM9.16671 7.67342C9.16671 7.45241 9.25451 7.24045 9.41079 7.08417C9.56707 6.92789 9.77903 6.84009 10 6.84009C10.2211 6.84009 10.433 6.92789 10.5893 7.08417C10.7456 7.24045 10.8334 7.45241 10.8334 7.67342V11.8401C10.8334 12.0611 10.7456 12.2731 10.5893 12.4293C10.433 12.5856 10.2211 12.6734 10 12.6734C9.77903 12.6734 9.56707 12.5856 9.41079 12.4293C9.25451 12.2731 9.16671 12.0611 9.16671 11.8401V7.67342ZM19.095 15.6793L11.7325 2.92676C10.9625 1.59342 9.03754 1.59342 8.26754 2.92676L0.905044 15.6793C0.135877 17.0126 1.09671 18.6793 2.63754 18.6793H17.3625C18.9025 18.6793 19.8642 17.0126 19.095 15.6793Z"
        fill="#E2452B"
      />
    </svg>
  ),
  "icon-x-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5124 9.99994L16.2215 5.29077C16.3145 5.19791 16.3882 5.08767 16.4385 4.96632C16.4888 4.84498 16.5147 4.71492 16.5147 4.58356C16.5148 4.45221 16.4889 4.32213 16.4387 4.20076C16.3885 4.07939 16.3148 3.9691 16.222 3.87619C16.1291 3.78328 16.0189 3.70956 15.8975 3.65926C15.7762 3.60896 15.6461 3.58305 15.5148 3.58301C15.3834 3.58297 15.2533 3.6088 15.132 3.65904C15.0106 3.70927 14.9003 3.78291 14.8074 3.87577L10.0982 8.58577L5.38822 3.87577C5.19851 3.69858 4.94739 3.60203 4.68785 3.6065C4.42831 3.61096 4.18065 3.71609 3.99715 3.89969C3.81366 4.0833 3.70867 4.33102 3.70436 4.59056C3.70005 4.8501 3.79675 5.10117 3.97405 5.29077L8.68405 9.99994L3.97405 14.7091C3.83485 14.8493 3.7402 15.0275 3.70201 15.2213C3.66381 15.4151 3.68378 15.6159 3.7594 15.7984C3.83501 15.9809 3.96291 16.1369 4.12699 16.2469C4.29106 16.3569 4.48401 16.416 4.68155 16.4166C4.93738 16.4166 5.19322 16.3191 5.38822 16.1241L10.0982 11.4141L14.8074 16.1241C14.9001 16.2172 15.0103 16.291 15.1317 16.3414C15.253 16.3917 15.3831 16.4177 15.5145 16.4177C15.6458 16.4177 15.7759 16.3917 15.8973 16.3414C16.0186 16.291 16.1288 16.2172 16.2215 16.1241C16.3145 16.0312 16.3883 15.9209 16.4386 15.7995C16.4889 15.6781 16.5148 15.548 16.5148 15.4166C16.5148 15.2852 16.4889 15.1551 16.4386 15.0337C16.3883 14.9123 16.3145 14.802 16.2215 14.7091L11.5124 9.99994Z"
        fill="#252525"
      />
    </svg>
  ),
  "icon-circle-check-mono": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2 29.2L31.3 15.1L28.5 12.3L17.2 23.6L11.5 17.9L8.7 20.7L17.2 29.2ZM20 40C17.2333 40 14.6333 39.4747 12.2 38.424C9.76667 37.3747 7.65 35.95 5.85 34.15C4.05 32.35 2.62533 30.2333 1.576 27.8C0.525334 25.3667 0 22.7667 0 20C0 17.2333 0.525334 14.6333 1.576 12.2C2.62533 9.76667 4.05 7.65 5.85 5.85C7.65 4.05 9.76667 2.62467 12.2 1.574C14.6333 0.524667 17.2333 0 20 0C22.7667 0 25.3667 0.524667 27.8 1.574C30.2333 2.62467 32.35 4.05 34.15 5.85C35.95 7.65 37.3747 9.76667 38.424 12.2C39.4747 14.6333 40 17.2333 40 20C40 22.7667 39.4747 25.3667 38.424 27.8C37.3747 30.2333 35.95 32.35 34.15 34.15C32.35 35.95 30.2333 37.3747 27.8 38.424C25.3667 39.4747 22.7667 40 20 40Z"
        fill="#2CBA00"
      />
    </svg>
  ),
  "icon-circle-empty-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C17 3 21 7 21 12C21 17 17 21 12 21C7 21 3 17 3 12C3 7 7 3 12 3ZM12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "home-fill": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.259 13.2763H9.75895V13.7763V18.1294C9.75895 18.3327 9.59094 18.5 9.38939 18.5H6.78072C6.57917 18.5 6.41116 18.3327 6.41116 18.1294V12.0351V11.5351H5.91116H4.60709L11.7491 5.09443C11.7492 5.09428 11.7494 5.09414 11.7496 5.094C11.8899 4.96868 12.1061 4.96867 12.2465 5.09396C12.2467 5.09411 12.2469 5.09427 12.2471 5.09443L19.389 11.5351H18.085H17.585V12.0351V18.1294C17.585 18.3327 17.417 18.5 17.2154 18.5H14.6067C14.4052 18.5 14.2372 18.3327 14.2372 18.1294V13.7763V13.2763H13.7372H10.259Z"
        fill="#F18334"
        stroke="#F18334"
      />
    </svg>
  ),
  exclamation_point: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C4.928 0 0 4.928 0 11C0 17.072 4.928 22 11 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 11 0ZM11 12.1C10.395 12.1 9.9 11.605 9.9 11V6.6C9.9 5.995 10.395 5.5 11 5.5C11.605 5.5 12.1 5.995 12.1 6.6V11C12.1 11.605 11.605 12.1 11 12.1ZM12.1 16.5H9.9V14.3H12.1V16.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  exclamation_inner_point: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 배경 원: fill 어트리뷰트 제거 → inline style 로 고정색 */}
      <circle cx="10" cy="10" r="10" style={{ fill: "#E9E9E9" }} />

      {/* 느낌표: fill 어트리뷰트를 유지 → ColorIcon 의 color 로 변경 가능 */}
      <path
        d="M11.1516 4.5L10.9884 12.0826H9.31161L9.13355 4.5H11.1516ZM10.1574 15.3619C9.51935 15.3619 9 14.8426 9 14.2045C9 13.5813 9.51935 13.0619 10.1574 13.0619C10.7658 13.0619 11.3 13.5813 11.3 14.2045C11.3 14.8426 10.7658 15.3619 10.1574 15.3619Z"
        fill="#686868"
      />
    </svg>
  ),
  headphone: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="15.4173"
        cy="24.75"
        rx="0.583333"
        ry="0.583334"
        stroke="#535353"
        strokeWidth="1.3"
      />
      <path
        d="M23.3306 13.948C24.0031 14.3326 24.5483 14.9033 24.8998 15.5905C25.2514 16.2776 25.394 17.0515 25.3104 17.8178C25.2267 18.5842 24.9204 19.3097 24.4288 19.9061C23.9371 20.5024 23.2815 20.9438 22.5416 21.1763C22.2802 22.355 21.6213 23.4096 20.6742 24.1656C19.727 24.9215 18.5483 25.3335 17.3333 25.3333H15.3342C15.1575 25.3333 14.988 25.2636 14.863 25.1394C14.7381 25.0153 14.6679 24.8469 14.6679 24.6714C14.6679 24.4958 14.7381 24.3274 14.863 24.2033C14.988 24.0792 15.1575 24.0094 15.3342 24.0094H17.3333C18.1604 24.0097 18.9673 23.7552 19.6428 23.281C20.3182 22.8068 20.8291 22.1362 21.105 21.3617H20.6652C20.4884 21.3617 20.3189 21.2919 20.194 21.1678C20.069 21.0436 19.9988 20.8753 19.9988 20.6997V14.0803C19.9988 13.9048 20.069 13.7364 20.194 13.6123C20.3189 13.4881 20.4884 13.4184 20.6652 13.4184H21.3315C21.5474 13.4184 21.7593 13.4356 21.9672 13.4687C21.8172 12.0004 21.1239 10.6396 20.0215 9.65014C18.9192 8.66064 17.4863 8.11282 16.0006 8.11282C14.5148 8.11282 13.082 8.66064 11.9797 9.65014C10.8773 10.6396 10.184 12.0004 10.0339 13.4687C10.2442 13.4353 10.4567 13.4184 10.6696 13.4184H11.336C11.5127 13.4184 11.6822 13.4881 11.8072 13.6123C11.9322 13.7364 12.0024 13.9048 12.0024 14.0803V20.6997C12.0024 20.8753 11.9322 21.0436 11.8072 21.1678C11.6822 21.2919 11.5127 21.3617 11.336 21.3617H10.6696C9.78869 21.3626 8.93207 21.0746 8.23287 20.5422C7.53369 20.0098 7.03108 19.2629 6.80314 18.4176C6.5752 17.5723 6.6347 16.6759 6.97239 15.8676C7.31008 15.0594 7.90705 14.3845 8.67055 13.948C8.67055 12.0168 9.44282 10.1648 10.8175 8.79928C12.1921 7.43376 14.0565 6.66663 16.0006 6.66663C17.9446 6.66663 19.8091 7.43376 21.1837 8.79928C22.5584 10.1648 23.3306 12.0168 23.3306 13.948ZM10.6696 14.7423C9.96272 14.7423 9.28475 15.0212 8.78488 15.5178C8.28501 16.0143 8.00418 16.6878 8.00418 17.39C8.00418 18.0923 8.28501 18.7657 8.78488 19.2623C9.28475 19.7588 9.96272 20.0378 10.6696 20.0378V14.7423ZM23.997 17.39C23.997 16.6878 23.7162 16.0143 23.2163 15.5178C22.7164 15.0212 22.0385 14.7423 21.3315 14.7423V20.0378C22.0385 20.0378 22.7164 19.7588 23.2163 19.2623C23.7162 18.7657 23.997 18.0923 23.997 17.39Z"
        fill="#535353"
      />
    </svg>
  ),
  share: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3872 26.3087C15.9089 26.7883 15.2604 27.0581 14.584 27.0588C14.0795 27.0588 13.5863 26.9088 13.1668 26.6277C12.7472 26.3466 12.4201 25.9471 12.227 25.4795C12.0339 25.012 11.9833 24.4975 12.0818 24.0012C12.1803 23.5048 12.4233 23.049 12.7801 22.6912C13.137 22.3334 13.5916 22.0898 14.0864 21.9911C14.5813 21.8924 15.0942 21.943 15.5604 22.1366C16.0265 22.3302 16.425 22.6581 16.7054 23.0789C16.9858 23.4996 17.1354 23.9942 17.1354 24.5003C17.1347 25.1787 16.8656 25.8291 16.3872 26.3087ZM32.4204 29.7173C31.7035 29.7174 30.9963 29.8829 30.3534 30.2008C29.7367 30.5059 29.195 30.9435 28.7667 31.4821L19.0356 25.9443C19.3397 25.0059 19.3397 23.9949 19.0356 23.0565L28.7669 17.5186C29.4689 18.3975 30.4639 18.9946 31.5704 19.1988C32.7056 19.4082 33.8778 19.1893 34.8616 18.5842C35.8454 17.9791 36.5711 17.0306 36.8993 15.9213C37.2275 14.812 37.135 13.6202 36.6395 12.5752C36.144 11.5302 35.2805 10.7058 34.2152 10.2607C33.1498 9.81558 31.9579 9.78124 30.8688 10.1643C29.7797 10.5474 28.8705 11.3207 28.3159 12.3355C27.7734 13.3283 27.6079 14.4836 27.8484 15.588L17.9348 21.2297C17.3002 20.5753 16.4884 20.1201 15.5987 19.9211C14.6833 19.7163 13.7277 19.792 12.8557 20.1384C11.9838 20.4849 11.2358 21.086 10.7088 21.8637C10.1818 22.6415 9.9 23.5601 9.9 24.5004C9.9 25.4406 10.1818 26.3592 10.7088 27.137C11.2358 27.9148 11.9838 28.5159 12.8557 28.8623C13.7277 29.2087 14.6833 29.2844 15.5987 29.0797C16.4884 28.8806 17.3002 28.4255 17.9348 27.771L27.8485 33.4128C27.6479 34.3389 27.7316 35.3049 28.0896 36.1832C28.4569 37.0847 29.095 37.8492 29.9154 38.3707C30.7357 38.8922 31.6976 39.1448 32.6676 39.0935C33.6376 39.0421 34.5676 38.6894 35.3286 38.0842C36.0896 37.479 36.6439 36.6514 36.9146 35.7162C37.1853 34.781 37.159 33.7845 36.8394 32.8649C36.5198 31.9453 35.9227 31.1482 35.1309 30.5842C34.339 30.0202 33.3917 29.7172 32.4204 29.7173ZM32.4205 12.0331C32.925 12.0331 33.4182 12.1831 33.8377 12.4642C34.2573 12.7453 34.5844 13.1449 34.7775 13.6124C34.9706 14.0799 35.0212 14.5944 34.9227 15.0907C34.8242 15.5871 34.5812 16.043 34.2244 16.4008C33.8675 16.7585 33.4129 17.0022 32.9181 17.1009C32.4232 17.1996 31.9103 17.1489 31.4441 16.9553C30.978 16.7617 30.5795 16.4338 30.2991 16.0131C30.0187 15.5923 29.8691 15.0977 29.8691 14.5917C29.8698 13.9132 30.1389 13.2629 30.6173 12.7832C31.0956 12.3036 31.7441 12.0338 32.4205 12.0331ZM32.4203 36.9677C31.9158 36.9676 31.4226 36.8176 31.003 36.5365C30.5835 36.2555 30.2564 35.8559 30.0633 35.3884C29.8702 34.9208 29.8196 34.4064 29.9181 33.91C30.0166 33.4137 30.2596 32.9578 30.6164 32.6C30.9732 32.2422 31.4278 31.9986 31.9227 31.8999C32.4176 31.8012 32.9305 31.8518 33.3967 32.0454C33.8628 32.2391 34.2613 32.5669 34.5417 32.9877C34.822 33.4084 34.9717 33.903 34.9717 34.4091C34.971 35.0875 34.7019 35.7379 34.2235 36.2175C33.7452 36.6972 33.0967 36.9669 32.4203 36.9677Z"
        fill="#252525"
        stroke="#252525"
        strokeWidth="0.2"
      />
    </svg>
  ),
  ["share-circle-fill"]: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <path d="M21 9L10 16L21 23" stroke="#252525" stroke-width="1.5" />
      <circle cx="10.5" cy="15.75" r="2.75" fill="#252525" />
      <circle cx="19.5" cy="9.75" r="2.75" fill="#252525" />
      <circle cx="19.5" cy="21.75" r="2.75" fill="#252525" />
    </svg>
  ),
  "heart-fill": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 15.4167C9.91951 15.4164 9.8413 15.3898 9.77765 15.3409C7.75024 13.7818 6.35366 12.4393 5.37642 11.1148C4.12935 9.42217 3.84492 7.85949 4.53045 6.47004C5.01907 5.47757 6.42294 4.66556 8.06383 5.13833C8.84619 5.36199 9.52878 5.84164 10.0001 6.49891C10.4714 5.84164 11.154 5.36199 11.9363 5.13833C13.5736 4.67277 14.9811 5.47757 15.4697 6.47004C16.1552 7.85949 15.8708 9.42217 14.6237 11.1148C13.6465 12.4393 12.2499 13.7818 10.2225 15.3409C10.1589 15.3898 10.0806 15.4164 10.0001 15.4167Z"
        fill="#2F9E44"
      />
    </svg>
  ),
  heart: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 48 48"
    >
      <g>
        <g>
          <path
            fill="#535353"
            d="M24.2,37.3c-0.2,0-0.4-0.1-0.6-0.2c-4.9-3.7-8.2-7-10.6-10.2c-3-4.1-3.7-7.9-2-11.3c0.9-1.8,3.2-3.6,6.3-3.6
     c0.8,0,1.6,0.1,2.3,0.3c1.9,0.5,3.5,1.7,4.6,3.2c1.1-1.5,2.8-2.7,4.6-3.2c0.8-0.2,1.5-0.3,2.3-0.3c3.1,0,5.4,1.8,6.3,3.6
     c1.7,3.4,1,7.2-2,11.3c-2.4,3.2-5.7,6.4-10.6,10.2C24.6,37.2,24.4,37.3,24.2,37.3L24.2,37.3z M17.1,14c-0.9,0-1.7,0.2-2.4,0.6
     c-0.8,0.4-1.5,1.1-1.9,1.9c-1.3,2.7-0.7,5.7,1.9,9.2c2.8,3.5,6,6.7,9.6,9.3c3.6-2.7,6.8-5.8,9.6-9.3c2.6-3.5,3.2-6.5,1.9-9.3
     c-0.7-1.5-2.6-2.5-4.6-2.5c-0.6,0-1.1,0.1-1.7,0.2c-0.9,0.3-1.8,0.7-2.5,1.4c-0.7,0.6-1.3,1.4-1.8,2.2c-0.1,0.2-0.2,0.3-0.4,0.4
     c-0.2,0.1-0.4,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.2-0.1-0.3-0.3-0.4-0.4c-0.4-0.9-1-1.6-1.7-2.2S20,14.6,19,14.3
     c-0.6-0.2-1.1-0.2-1.7-0.2H17.1L17.1,14z"
          />
          <path
            fill="#535353"
            d="M17.3,12.2c0.7,0,1.5,0.1,2.3,0.3c1.9,0.5,3.5,1.7,4.6,3.3c1.1-1.6,2.8-2.7,4.6-3.3c0.8-0.2,1.6-0.3,2.3-0.3
     c2.9,0,5.3,1.6,6.2,3.5c1.6,3.3,1,7.1-2,11.2C33,30,29.6,33.3,24.7,37c-0.2,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2
     c-4.9-3.7-8.2-7-10.6-10.1c-3-4.1-3.7-7.8-2.1-11.1C12,13.8,14.3,12.2,17.3,12.2z M24.2,35.2c3.6-2.7,6.9-5.8,9.7-9.4
     c2.6-3.6,3.2-6.6,1.9-9.4c-0.7-1.4-2.5-2.5-4.7-2.5c-0.6,0-1.1,0.1-1.7,0.2c-0.9,0.3-1.8,0.7-2.6,1.4S25.4,17,25,17.8
     c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2c-0.1-0.1-0.3-0.2-0.3-0.4c-0.4-0.9-1-1.6-1.8-2.3
     s-1.6-1.1-2.5-1.4c-0.6-0.2-1.2-0.2-1.8-0.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7,0.2-2.5,0.6c-0.8,0.5-1.5,1.1-2,1.9
     c-1.4,2.8-0.7,5.8,1.9,9.4C17.3,29.4,20.6,32.5,24.2,35.2L24.2,35.2z M17.3,12c-3.2,0-5.5,1.8-6.4,3.6c-1.7,3.4-1,7.2,2,11.3
     c2.4,3.2,5.7,6.4,10.6,10.2c0.2,0.1,0.4,0.2,0.7,0.2s0.5-0.1,0.7-0.2c4.9-3.8,8.2-7,10.6-10.2c3-4.1,3.7-7.9,2-11.3
     c-0.9-1.8-3.2-3.6-6.4-3.6c-0.8,0-1.6,0.1-2.3,0.3c-1.8,0.5-3.5,1.6-4.6,3.1c-1.1-1.5-2.8-2.6-4.6-3.1C18.8,12.1,18,12,17.3,12
     L17.3,12z M24.2,35c-3.6-2.7-6.8-5.8-9.5-9.3c-2.6-3.5-3.2-6.5-1.9-9.1c0.4-0.8,1.1-1.4,1.9-1.8c0.7-0.4,1.6-0.6,2.4-0.6
     c0.1,0,0.1,0,0.2,0c0.6,0,1.1,0.1,1.7,0.2c0.9,0.3,1.8,0.7,2.5,1.3s1.3,1.4,1.7,2.2c0.1,0.2,0.2,0.4,0.4,0.5
     c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5c0.4-0.8,1-1.6,1.7-2.2c0.7-0.6,1.6-1.1,2.5-1.3
     c0.5-0.2,1.1-0.2,1.7-0.2c1.9,0,3.8,1,4.5,2.4c1.3,2.7,0.7,5.7-1.9,9.1C31,29.2,27.8,32.3,24.2,35L24.2,35z"
          />
        </g>
      </g>
    </svg>
  ),
  guidebook: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19.5V7.86001C12 7.07108 11.6316 5.5 9.78947 5.5H5V18.1373H10.2198C11.0259 18.1373 11.7447 18.6824 12.0067 19.5H12Z"
        fill="#2F9E44"
        stroke="#2F9E44"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 19.5V7.86001C12.0001 6.68001 12.737 5.5 14.2106 5.5H19.0001V18.1373H13.7804C12.9742 18.1373 12.2554 18.6824 11.9934 19.5H12.0001Z"
        fill="#2F9E44"
        stroke="#2F9E44"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="12.0986"
        y1="9.80859"
        x2="12.0986"
        y2="14.5733"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  ),
  inquiry: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1 16.8415C6.41044 16.8415 5.74912 16.5712 5.26152 16.09C4.77393 15.6089 4.5 14.9563 4.5 14.2758V7.56566C4.5 6.8852 4.77393 6.23262 5.26152 5.75146C5.74912 5.27031 6.41044 5 7.1 5H17.9C18.2414 5 18.5795 5.06636 18.895 5.1953C19.2104 5.32424 19.497 5.51322 19.7385 5.75146C19.9799 5.98971 20.1714 6.27254 20.3021 6.58382C20.4327 6.8951 20.5 7.22873 20.5 7.56566V14.2758C20.5 14.6128 20.4327 14.9464 20.3021 15.2577C20.1714 15.569 19.9799 15.8518 19.7385 16.09C19.497 16.3283 19.2104 16.5173 18.895 16.6462C18.5795 16.7751 18.2414 16.8415 17.9 16.8415H13.272L8.9624 19.8548C8.84273 19.9384 8.70206 19.988 8.55577 19.9981C8.40948 20.0082 8.26319 19.9784 8.13289 19.912C8.00259 19.8456 7.8933 19.7451 7.81696 19.6215C7.74061 19.498 7.70015 19.3561 7.7 19.2114V16.8415H7.1Z"
        fill="#535353"
      />
      <circle
        r="0.464556"
        transform="matrix(1 0 0 -1 10.2978 10.7981)"
        fill="white"
      />
      <circle
        r="0.464556"
        transform="matrix(1 0 0 -1 12.4419 10.7981)"
        fill="white"
      />
      <circle
        r="0.464556"
        transform="matrix(1 0 0 -1 14.5861 10.7981)"
        fill="white"
      />
    </svg>
  ),
  icon_Graphic_BlackRibbon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95128 9.69823C7.95128 9.69823 7.53365 11.0466 10.9343 15.8433C8.82233 18.2298 6.82965 20.1508 6.05406 20.8787C5.86314 21.0577 5.83928 21.356 5.9944 21.5708L8.59562 24.9953C8.78654 25.2459 9.15643 25.2698 9.37121 25.0311C11.2088 23.0504 12.7361 21.3202 14.0009 19.8048C15.2657 21.3202 16.7811 23.0623 18.6306 25.0311C18.8454 25.2578 19.2153 25.2459 19.4062 24.9953L22.0074 21.5708C22.1625 21.356 22.1387 21.0577 21.9478 20.8787C21.1722 20.1508 19.1795 18.2417 17.0675 15.8433C20.4562 11.0585 20.0505 9.69823 20.0505 9.69823L17.5328 3.52927C13.7026 1.89456 10.4928 3.52927 10.4928 3.52927L7.93935 9.69823H7.95128ZM11.161 7.1328C13.273 6.72711 15.4089 6.94189 16.8288 7.19246C16.1964 8.75558 15.1703 10.4142 14.0128 12.025C12.2111 9.6863 11.173 7.1328 11.173 7.1328H11.161Z"
        fill="currentColor"
      />
    </svg>
  ),
  /**
   * 문서 + 돋보기. 검토, 비교, 살펴보기.
   *
   * 다색 그래픽 아이콘이라 ColorIcon 에 color="" 를 넘겨 원본 색을 유지한다.
   * 두 조각(Paper, Magnifying Glass)의 위치는 피그마 렌더를 픽셀로 재서 맞췄다.
   */
  icon_Graphic_Examine: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6 4)">
        <path
          d="M16.3333 0H32.6667C33.9553 0 35 1.04467 35 2.33333V44.3333C35 45.622 33.9553 46.6667 32.6667 46.6667H2.33333C1.04467 46.6667 0 45.622 0 44.3333V16.3333L16.3333 0Z"
          fill="#D1E6FF"
        />
        <path
          d="M16.3333 14V0L0 16.3333H14C15.2887 16.3333 16.3333 15.2887 16.3333 14Z"
          fill="#A0C9FF"
        />
      </g>
      <g transform="translate(23 21)">
        <rect
          width="23.3333"
          height="3.73333"
          rx="1.86667"
          transform="matrix(0.735415 0.677617 -0.677607 0.735424 9.38724 6.59454)"
          fill="#4982D3"
        />
        <path
          d="M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5Z"
          fill="white"
        />
        <path
          d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C3.86554e-07 4.70101 4.70101 3.86566e-07 10.5 0ZM10.5 3.73242C6.76287 3.73242 3.73242 6.76287 3.73242 10.5C3.73242 14.2371 6.76287 17.2676 10.5 17.2676C14.2371 17.2676 17.2676 14.2371 17.2676 10.5C17.2676 6.76287 14.2371 3.73242 10.5 3.73242Z"
          fill="#4982D3"
        />
      </g>
    </svg>
  ),
  icon_Graphic_Hourglass: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91388 23.4927V20.3326C7.91388 19.5472 8.14473 18.7992 8.55218 18.1633C8.94275 17.5232 9.51112 16.9928 10.2121 16.6523H17.3171C18.0181 16.9928 18.5865 17.5232 18.977 18.1633C19.3845 18.7992 19.6153 19.5478 19.6153 20.3326V23.4927H20.5767V20.2391C20.5767 18.4448 19.5521 16.8084 17.9379 16.0254L14.9888 14.5939C14.7615 14.4836 14.6169 14.2528 14.6169 14.0003C14.6169 13.7477 14.7615 13.5169 14.9888 13.4066L17.9379 11.9751C19.5521 11.1915 20.5767 9.5551 20.5767 7.76136V4.50781H6.95312V7.76136C6.95312 9.5557 7.97777 11.1921 9.59189 11.9751L12.5411 13.4066C12.7683 13.5169 12.9129 13.7477 12.9129 14.0003C12.9129 14.2528 12.7683 14.4836 12.5411 14.5939L9.59189 16.0254C7.97777 16.809 6.95312 18.4454 6.95312 20.2391V23.4927H7.91388Z"
        fill="#D0D6DE"
      />
      <path
        d="M18.9792 18.1644C18.5886 17.5243 18.0202 16.9939 17.3193 16.6533H10.2142C9.51326 16.9939 8.94488 17.5243 8.55431 18.1644C8.14686 18.8003 7.91602 19.5489 7.91602 20.3336V23.4937H19.6169V20.3336C19.6169 19.5482 19.3866 18.8003 18.9792 18.1644Z"
        fill="#FF9E00"
      />
      <path
        d="M20.5756 4.50683C20.9915 4.50683 21.329 4.1693 21.329 3.75342C21.329 3.33753 20.9915 3 20.5756 3H6.95264C6.53675 3 6.19922 3.33753 6.19922 3.75342C6.19922 4.1693 6.53675 4.50683 6.95264 4.50683H20.5756Z"
        fill="#6E4944"
      />
      <path
        d="M20.5756 23.4932H6.95264C6.53675 23.4932 6.19922 23.8307 6.19922 24.2466C6.19922 24.6625 6.53675 25 6.95264 25H20.5762C20.9921 25 21.3296 24.6625 21.3296 24.2466C21.3296 23.8307 20.9915 23.4932 20.5756 23.4932Z"
        fill="#6E4944"
      />
    </svg>
  ),
  timer: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 0.75H6.75V2.25H11.25V0.75ZM8.25 10.5H9.75V6H8.25V10.5ZM14.2725 5.5425L15.3375 4.4775C15.015 4.095 14.6625 3.735 14.28 3.42L13.215 4.485C12.0525 3.555 10.59 3 9 3C5.2725 3 2.25 6.0225 2.25 9.75C2.25 13.4775 5.265 16.5 9 16.5C12.735 16.5 15.75 13.4775 15.75 9.75C15.75 8.16 15.195 6.6975 14.2725 5.5425ZM9 15C6.0975 15 3.75 12.6525 3.75 9.75C3.75 6.8475 6.0975 4.5 9 4.5C11.9025 4.5 14.25 6.8475 14.25 9.75C14.25 12.6525 11.9025 15 9 15Z"
        fill="#2B8A3E"
      />
    </svg>
  ),
  thinArrow: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70673 17.0477C7.75234 17.092 7.80651 17.1272 7.86616 17.1512C7.92581 17.1752 7.98975 17.1875 8.05432 17.1875C8.1189 17.1875 8.18284 17.1752 8.24249 17.1512C8.30213 17.1272 8.35631 17.092 8.40191 17.0477L14.2933 11.3368C14.339 11.2926 14.3753 11.2401 14.4 11.1823C14.4248 11.1245 14.4375 11.0625 14.4375 10.9999C14.4375 10.9373 14.4248 10.8753 14.4 10.8175C14.3753 10.7597 14.339 10.7071 14.2933 10.6629L8.40191 4.95206C8.30973 4.8627 8.18469 4.8125 8.05432 4.8125C7.92395 4.8125 7.79892 4.8627 7.70673 4.95206C7.61455 5.04143 7.56276 5.16263 7.56276 5.28901C7.56276 5.41538 7.61455 5.53658 7.70673 5.62595L13.2515 10.9999L7.70673 16.3738C7.66101 16.418 7.62474 16.4705 7.59999 16.5283C7.57524 16.5862 7.5625 16.6481 7.5625 16.7107C7.5625 16.7733 7.57524 16.8353 7.59999 16.8931C7.62474 16.951 7.66101 17.0035 7.70673 17.0477Z"
        fill="currentColor"
      />
    </svg>
  ),
  pencil: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8688 2.86834C11.0164 2.71553 11.193 2.59364 11.3882 2.50978C11.5834 2.42593 11.7933 2.38179 12.0058 2.37994C12.2182 2.3781 12.4289 2.41858 12.6256 2.49903C12.8222 2.57948 13.0008 2.69828 13.1511 2.84851C13.3013 2.99874 13.4201 3.17738 13.5005 3.37402C13.581 3.57065 13.6215 3.78134 13.6196 3.99379C13.6178 4.20623 13.5736 4.41619 13.4898 4.61139C13.4059 4.8066 13.284 4.98315 13.1312 5.13074L12.4968 5.76514L10.2344 3.50274L10.8688 2.86834ZM9.10322 4.63394L2.40002 11.3371V13.5995H4.66242L11.3664 6.89634L9.10242 4.63394H9.10322Z"
        fill="#535353"
      />
    </svg>
  ),
  "icon-pencil-check-v2": (
    <svg
      width="122"
      height="108"
      viewBox="0 0 122 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M87.0738 5.74264L101.805 24.4601C103.227 26.2676 102.914 28.8728 101.103 30.2926L33.1912 83.5355L13.3185 58.2849L81.2301 5.042C83.0411 3.62219 85.6512 3.93514 87.0738 5.74264Z"
        fill="#FF9F55"
      />
      <path
        d="M10.6144 83.5762L33.1854 83.5208L13.3196 58.2793L7.92305 80.1424C7.49299 81.887 8.82478 83.5762 10.6282 83.5762H10.6144Z"
        fill="#FFECC2"
      />
      <path
        d="M9.13017 75.2544L7.49318 81.859C7.27122 82.7313 7.93711 83.5759 8.83884 83.5759H15.6642L9.13017 75.2544Z"
        fill="#8F8F8F"
      />
      <path
        d="M67.1465 93.2397H5.70398C4.25592 93.2397 3.08203 94.4114 3.08203 95.8567V95.8705C3.08203 97.3158 4.25592 98.4874 5.70398 98.4874H67.1465C68.5945 98.4874 69.7684 97.3158 69.7684 95.8705V95.8567C69.7684 94.4114 68.5945 93.2397 67.1465 93.2397Z"
        fill="#8F8F8F"
      />
      <path
        d="M98.8723 105.438C109.61 105.438 118.308 96.7568 118.308 86.0261C118.308 75.2953 109.61 66.6138 98.8723 66.6138C88.1348 66.6138 79.4365 75.2953 79.4365 86.0261C79.4365 96.7568 88.1348 105.438 98.8723 105.438Z"
        fill="#69A5FF"
      />
      <path
        d="M110.358 79.4495C109.373 78.4665 107.639 78.4526 106.654 79.4495L95.6392 90.4434L91.0612 85.8742C90.0763 84.8911 88.3422 84.8911 87.3572 85.8742C86.3445 86.8988 86.3445 88.5465 87.3572 89.5849L93.7803 96.0095C94.2797 96.508 94.9317 96.7849 95.6392 96.7849C96.3467 96.7849 96.9988 96.5218 97.4982 96.0095L110.358 83.1603C110.844 82.6618 111.135 81.9972 111.135 81.3049C111.135 80.6126 110.872 79.948 110.358 79.4495Z"
        fill="white"
      />
    </svg>
  ),
  "icon-shield-check-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0668 2.86669L8.26678 0.466687C8.13345 0.40002 7.93345 0.40002 7.73345 0.466687L1.93345 2.86669C1.66678 2.93335 1.53345 3.20002 1.53345 3.46669V9.00002C1.53345 11.5334 4.73345 14 7.73345 15.5334C7.93345 15.6 8.13345 15.6 8.33345 15.5334C11.3334 14 14.5334 11.5334 14.5334 9.00002V3.46669C14.4668 3.20002 14.3334 2.93335 14.0668 2.86669V2.86669ZM11.6001 6.53335L7.73345 10.4C7.60011 10.5334 7.40011 10.6 7.26678 10.6C7.13345 10.6 6.93345 10.5334 6.80011 10.4L4.40011 8.00002C4.13345 7.73335 4.13345 7.26669 4.40011 7.00002C4.66678 6.73335 5.13345 6.73335 5.40011 7.00002L7.26678 8.86669L10.6668 5.53335C10.9334 5.26669 11.4001 5.26669 11.6668 5.53335C11.9334 5.80002 11.9334 6.26669 11.6001 6.53335V6.53335Z"
        fill="#857471"
      />
    </svg>
  ),
  scrapped: (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 3C4.7912 3 3 4.73964 3 6.88594C3 8.61852 3.7 12.7305 10.5904 16.8873C10.7138 16.961 10.8555 17 11 17C11.1445 17 11.2862 16.961 11.4096 16.8873C18.3 12.7305 19 8.61852 19 6.88594C19 4.73964 17.2088 3 15 3C12.7912 3 11 5.35511 11 5.35511C11 5.35511 9.2088 3 7 3Z"
        fill="#E2452B"
        stroke="#E2452B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  menu_dots: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.90625 4.51172C8.90625 4.8018 9.02148 5.08 9.2266 5.28512C9.43172 5.49023 9.70992 5.60547 10 5.60547C10.2901 5.60547 10.5683 5.49023 10.7734 5.28512C10.9785 5.08 11.0938 4.8018 11.0938 4.51172C11.0938 4.22164 10.9785 3.94344 10.7734 3.73832C10.5683 3.5332 10.2901 3.41797 10 3.41797C9.70992 3.41797 9.43172 3.5332 9.2266 3.73832C9.02148 3.94344 8.90625 4.22164 8.90625 4.51172ZM8.90625 9.98047C8.90625 10.2705 9.02148 10.5487 9.2266 10.7539C9.43172 10.959 9.70992 11.0742 10 11.0742C10.2901 11.0742 10.5683 10.959 10.7734 10.7539C10.9785 10.5487 11.0938 10.2705 11.0938 9.98047C11.0938 9.69039 10.9785 9.41219 10.7734 9.20707C10.5683 9.00195 10.2901 8.88672 10 8.88672C9.70992 8.88672 9.43172 9.00195 9.2266 9.20707C9.02148 9.41219 8.90625 9.69039 8.90625 9.98047ZM8.90625 15.4492C8.90625 15.7393 9.02148 16.0175 9.2266 16.2226C9.43172 16.4277 9.70992 16.543 10 16.543C10.2901 16.543 10.5683 16.4277 10.7734 16.2226C10.9785 16.0175 11.0938 15.7393 11.0938 15.4492C11.0938 15.1591 10.9785 14.8809 10.7734 14.6758C10.5683 14.4707 10.2901 14.3555 10 14.3555C9.70992 14.3555 9.43172 14.4707 9.2266 14.6758C9.02148 14.8809 8.90625 15.1591 8.90625 15.4492Z"
        fill="#535353"
      />
    </svg>
  ),

  post: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 14.55V17.0833C2.5 17.3167 2.68333 17.5 2.91667 17.5H5.45C5.55833 17.5 5.66667 17.4583 5.74167 17.375L14.8417 8.28334L11.7167 5.15834L2.625 14.25C2.54167 14.3333 2.5 14.4333 2.5 14.55ZM17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C14.9833 2.41667 14.4583 2.41667 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667Z"
        fill="#B9B9B9"
      />
    </svg>
  ),
  infoquestion: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM5.496 6.033H6.321C6.459 6.033 6.569 5.92 6.587 5.783C6.677 5.127 7.127 4.649 7.929 4.649C8.615 4.649 9.243 4.992 9.243 5.817C9.243 6.452 8.869 6.744 8.278 7.188C7.605 7.677 7.072 8.248 7.11 9.175L7.113 9.392C7.11405 9.45761 7.14085 9.52017 7.18762 9.5662C7.23439 9.61222 7.29738 9.63801 7.363 9.638H8.174C8.2403 9.638 8.30389 9.61166 8.35078 9.56478C8.39766 9.51789 8.424 9.4543 8.424 9.388V9.283C8.424 8.565 8.697 8.356 9.434 7.797C10.043 7.334 10.678 6.82 10.678 5.741C10.678 4.23 9.402 3.5 8.005 3.5C6.738 3.5 5.35 4.09 5.255 5.786C5.25363 5.81829 5.25888 5.85053 5.27043 5.88072C5.28198 5.91091 5.29958 5.93841 5.32216 5.96155C5.34473 5.98468 5.3718 6.00296 5.40169 6.01524C5.43159 6.02753 5.46368 6.03357 5.496 6.033ZM7.821 12.476C8.431 12.476 8.85 12.082 8.85 11.549C8.85 10.997 8.43 10.609 7.821 10.609C7.237 10.609 6.812 10.997 6.812 11.549C6.812 12.082 7.237 12.476 7.822 12.476H7.821Z"
        fill="#DFDAD9"
      />
    </svg>
  ),
  arrow: (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L7 7L1 13" stroke="currentColor" strokeWidth="2.2" />
    </svg>
  ),
  funeral_store: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.999 8C21.9991 7.81852 21.9497 7.64045 21.856 7.485L19.147 2.97C18.9686 2.67484 18.7171 2.43057 18.417 2.26069C18.1168 2.09081 17.7779 2.00104 17.433 2H6.56502C5.86702 2 5.21002 2.372 4.85102 2.971L2.14202 7.485C2.04837 7.64045 1.99893 7.81852 1.99902 8C1.99902 9.005 2.38502 9.914 2.99902 10.618V20C2.99902 20.2652 3.10438 20.5196 3.29192 20.7071C3.47945 20.8946 3.73381 21 3.99902 21H11.999C12.2642 21 12.5186 20.8946 12.7061 20.7071C12.8937 20.5196 12.999 20.2652 12.999 20V15H16.999V20C16.999 20.2652 17.1044 20.5196 17.2919 20.7071C17.4795 20.8946 17.7338 21 17.999 21H19.999C20.2642 21 20.5186 20.8946 20.7061 20.7071C20.8937 20.5196 20.999 20.2652 20.999 20V10.618C21.613 9.914 21.999 9.005 21.999 8V8ZM19.983 8.251C19.9215 8.73391 19.6861 9.17785 19.321 9.49977C18.9558 9.82169 18.4858 9.99953 17.999 10C16.896 10 15.999 9.103 15.999 8C15.999 7.932 15.974 7.872 15.96 7.808L15.98 7.804L15.219 4H17.433L19.983 8.251V8.251ZM10.006 8.065L10.818 4H13.179L13.992 8.065C13.957 9.138 13.079 10 11.999 10C10.919 10 10.041 9.138 10.006 8.065V8.065ZM6.56502 4H8.77902L8.01902 7.804L8.03902 7.808C8.02402 7.872 7.99902 7.932 7.99902 8C7.99902 9.103 7.10202 10 5.99902 10C5.51221 9.99953 5.04226 9.82169 4.67708 9.49977C4.31191 9.17785 4.07654 8.73391 4.01502 8.251L6.56502 4ZM9.99902 16H5.99902V13H9.99902V16Z"
        fill="#857471"
      />
    </svg>
  ),
  funeral_disabled_facility: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7522 6.37546C12.9604 6.37546 13.9399 5.39598 13.9399 4.18773C13.9399 2.97948 12.9604 2 11.7522 2C10.5439 2 9.56445 2.97948 9.56445 4.18773C9.56445 5.39598 10.5439 6.37546 11.7522 6.37546Z"
        stroke="#857471"
        strokeWidth="2.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7521 6.37537V15.1263H16.1276L20.5031 20.5956M11.7521 10.7508H17.2215M7.37668 11.2978C6.59292 11.6223 5.8954 12.1248 5.33927 12.7654C4.78314 13.4059 4.38364 14.1671 4.17236 14.9887C3.96107 15.8103 3.94379 16.6697 4.12189 17.4991C4.29998 18.3285 4.66856 19.1051 5.1985 19.7676C5.72844 20.43 6.40519 20.9601 7.17528 21.3159C7.94536 21.6717 8.78765 21.8435 9.63557 21.8177C10.4835 21.7919 11.3138 21.5693 12.0608 21.1673C12.8079 20.7654 13.4512 20.1951 13.9399 19.5017"
        stroke="#857471"
        strokeWidth="2.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  funeral_waiting_room: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0169 16.4125C19.1584 15.2822 17.9326 14.4727 16.5418 14.1175L16.4984 14.1083L15.5 16C15.5 16 15.406 16.199 15.2468 16.3552C15.0875 16.5113 14.8718 16.5993 14.6466 16.6C14.1791 16.6 13.7967 16.225 13.3505 15.1216V15.095C13.3505 14.8187 13.2386 14.5537 13.0394 14.3584C12.8401 14.163 12.5699 14.0533 12.2882 14.0533C12.0064 14.0533 11.7362 14.163 11.537 14.3584C11.3378 14.5537 11.2258 14.8187 11.2258 15.095V15.1225V15.1208C10.7499 16.225 10.3641 16.5991 9.8975 16.5991C9.6723 16.5985 9.45653 16.5105 9.29729 16.3543C9.13806 16.1982 9.10054 16.194 9 16C8.65827 15.3407 8.07708 14.1041 8.07708 14.1041C6.6767 14.4534 5.43972 15.2606 4.57052 16.3925L4.55862 16.4083C4.21408 16.9608 4.02223 17.5918 4.00195 18.2391V18.245C4.0062 18.37 4.00195 18.5158 4.00195 18.6616V20.3283C4.00195 20.7703 4.18103 21.1942 4.4998 21.5068C4.81856 21.8194 5.25089 21.995 5.70169 21.995H18.8747C19.3255 21.995 19.7578 21.8194 20.0766 21.5068C20.3953 21.1942 20.5744 20.7703 20.5744 20.3283V18.6616C20.5744 18.5166 20.5702 18.37 20.5744 18.245C20.553 17.5903 20.3579 16.9524 20.0084 16.3941L20.0177 16.4108L20.0169 16.4125ZM7.82552 6.40829C7.82552 8.84163 9.37228 12.4166 12.2873 12.4166C15.1514 12.4166 16.7491 8.84163 16.7491 6.40829V6.35413C16.7491 5.77959 16.6337 5.21069 16.4095 4.67989C16.1853 4.14909 15.8566 3.66679 15.4423 3.26053C15.028 2.85428 14.5361 2.53202 13.9948 2.31215C13.4535 2.09229 12.8733 1.97913 12.2873 1.97913C11.7014 1.97913 11.1212 2.09229 10.5799 2.31215C10.0385 2.53202 9.54667 2.85428 9.13235 3.26053C8.71803 3.66679 8.38938 4.14909 8.16515 4.67989C7.94092 5.21069 7.82552 5.77959 7.82552 6.35413V6.41079V6.40829Z"
        fill="#988987"
      />
    </svg>
  ),
  funeral_parking_slot: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0697 10.5667L20.5566 9.32268L19.6467 7.11667C18.8656 5.2232 17.0026 4 14.8994 4H9.10155C6.99881 4 5.13529 5.2232 4.35418 7.11667L3.44434 9.32268L2.93121 10.5667C1.83008 10.9727 1.04395 11.998 1.04395 13.2083V15.3333C1.04395 16.047 1.32516 16.6911 1.77438 17.1896V19.5833C1.77438 20.3656 2.42858 21 3.23525 21H4.69612C5.50279 21 6.15699 20.3656 6.15699 19.5833V18.1667H17.8439V19.5833C17.8439 20.3656 18.4981 21 19.3048 21H20.7657C21.5724 21 22.2266 20.3656 22.2266 19.5833V17.1896C22.6758 16.6916 22.957 16.0474 22.957 15.3333V13.2083C22.957 11.998 22.1709 10.9727 21.0697 10.5667V10.5667ZM7.06684 8.16898C7.39964 7.36237 8.2054 6.83333 9.10155 6.83333H14.8994C15.7955 6.83333 16.6013 7.36237 16.9341 8.16898L17.8439 10.375H6.15699L7.06684 8.16898ZM4.69612 15.3245C3.8196 15.3245 3.23525 14.7596 3.23525 13.9122C3.23525 13.0649 3.8196 12.5 4.69612 12.5C5.57264 12.5 6.88742 13.771 6.88742 14.6184C6.88742 15.4657 5.57264 15.3245 4.69612 15.3245ZM19.3048 15.3245C18.4283 15.3245 17.1135 15.4657 17.1135 14.6184C17.1135 13.771 18.4283 12.5 19.3048 12.5C20.1813 12.5 20.7657 13.0649 20.7657 13.9122C20.7657 14.7596 20.1813 15.3245 19.3048 15.3245V15.3245Z"
        fill="#857471"
      />
    </svg>
  ),
  funeral_restaurant: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1453 10.6668C16.5897 10.668 17.03 10.5822 17.4406 10.4145C17.8512 10.2469 18.224 10.0005 18.5374 9.68981L21.7929 6.4826C22.0503 6.22878 22.074 5.81574 21.8288 5.54941C21.7672 5.48249 21.6925 5.42861 21.6092 5.39102C21.5259 5.35343 21.4357 5.33292 21.3441 5.33074C21.2525 5.32856 21.1614 5.34475 21.0763 5.37832C20.9912 5.4119 20.914 5.46216 20.8492 5.52607L17.9476 8.38442C17.8502 8.48035 17.7181 8.53423 17.5804 8.53423C17.4427 8.53423 17.3106 8.48035 17.2132 8.38442C17.0107 8.18519 17.0217 7.84843 17.2238 7.6492L20.1127 4.80126C20.1775 4.73742 20.2284 4.66128 20.2624 4.57746C20.2964 4.49364 20.3128 4.40388 20.3106 4.31362C20.3084 4.22336 20.2876 4.13449 20.2495 4.05239C20.2114 3.97028 20.1568 3.89666 20.089 3.83598C19.9666 3.72651 19.807 3.66628 19.6417 3.66718C19.4544 3.6673 19.2748 3.74076 19.1424 3.8714L16.256 6.71642C16.1586 6.81235 16.0265 6.86623 15.8888 6.86623C15.7511 6.86623 15.6191 6.81235 15.5216 6.71642C15.3195 6.5172 15.3301 6.18043 15.5322 5.9812L18.4211 3.1341C18.4859 3.07026 18.5368 2.99412 18.5708 2.91029C18.6048 2.82647 18.6212 2.73671 18.619 2.64646C18.6168 2.5562 18.596 2.46733 18.5579 2.38522C18.5199 2.30312 18.4653 2.22949 18.3974 2.16881C18.275 2.05934 18.1154 1.99911 17.9501 2.00001C17.7628 2.00023 17.5833 2.07367 17.4508 2.20424L14.1975 5.41145C13.8823 5.72044 13.6324 6.08802 13.4622 6.49288C13.2921 6.89774 13.2052 7.33185 13.2064 7.77007V8.11309C13.2065 8.20079 13.189 8.28764 13.155 8.36867C13.121 8.4497 13.0711 8.52332 13.0082 8.58531L11.5026 10.0699C11.4869 10.0854 11.4683 10.0977 11.4477 10.1061C11.4272 10.1145 11.4052 10.1188 11.383 10.1188C11.3607 10.1188 11.3387 10.1145 11.3182 10.1061C11.2977 10.0977 11.279 10.0854 11.2633 10.0699L3.93723 2.84735C3.81079 2.72256 3.63935 2.65223 3.46043 2.65176C3.28151 2.65129 3.10969 2.72072 2.98258 2.84485C2.34205 3.47045 2.00001 4.35363 2.00001 5.39853C1.99579 7.12404 2.91577 9.10797 4.40103 10.5701L8.01376 14.1316C8.52723 14.6367 9.22301 14.9205 9.94844 14.9205C10.1797 14.9206 10.41 14.8915 10.6338 14.8339C10.69 14.8193 10.7478 14.8119 10.8059 14.8118C10.9757 14.8118 11.1392 14.8751 11.2637 14.9889L11.7453 15.4274C11.8695 15.5525 11.9393 15.7204 11.9398 15.8954V16.1263C11.9385 16.6512 12.1478 17.1553 12.522 17.5288L16.3292 21.3454L16.333 21.3496C16.7555 21.7661 17.3286 22 17.9262 22C18.5237 22 19.0968 21.7659 19.5193 21.3493C19.9418 20.9328 20.1792 20.3678 20.1791 19.7787C20.1791 19.1896 19.9417 18.6247 19.5191 18.2082L13.8123 12.5823C13.7966 12.5669 13.7841 12.5485 13.7756 12.5282C13.7671 12.508 13.7627 12.4863 13.7627 12.4644C13.7627 12.4425 13.7671 12.4208 13.7756 12.4005C13.7841 12.3803 13.7966 12.3619 13.8123 12.3464L15.3179 10.8622C15.3807 10.8003 15.4553 10.7511 15.5374 10.7176C15.6195 10.684 15.7076 10.6668 15.7964 10.6668H16.1453Z"
        fill="#857471"
      />
      <path
        d="M10.3434 15.9489C9.24696 15.9466 8.19562 15.5015 7.41745 14.7102L6.82422 14.1024C6.76002 14.0368 6.67306 14 6.58238 14C6.49171 14 6.40474 14.0368 6.34055 14.1024L2.70238 17.8103C2.05393 18.4746 1.82237 19.4524 2.14339 20.41C2.16135 20.464 2.18265 20.5167 2.20716 20.5679C2.63903 21.4738 3.4771 22 4.39392 22C4.70921 22.0008 5.02153 21.9375 5.31277 21.8137C5.60401 21.69 5.86839 21.5083 6.09059 21.2791L10.9426 16.2848C10.9631 16.2634 10.9787 16.2378 10.9884 16.2096C10.9982 16.1814 11.0018 16.1514 10.9991 16.1217V16.1103C10.9972 16.0829 10.9899 16.0563 10.9777 16.0319C10.9655 16.0075 10.9485 15.9859 10.9279 15.9684C10.9073 15.9509 10.8835 15.9379 10.8579 15.9301C10.8322 15.9223 10.8053 15.9199 10.7787 15.923C10.6341 15.9395 10.4888 15.9481 10.3434 15.9489V15.9489Z"
        fill="#857471"
      />
    </svg>
  ),
  parlor: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5736 2.16675H9.76083C8.55725 2.16675 7.58333 3.14067 7.58333 4.34425V10.451L2.4895 15.4798C2.33687 15.6308 2.23253 15.8237 2.18972 16.034C2.14691 16.2444 2.16755 16.4627 2.24903 16.6613C2.33051 16.8599 2.46916 17.0298 2.64737 17.1495C2.82559 17.2691 3.03533 17.3332 3.25 17.3334V22.7501C3.25 23.0374 3.36413 23.313 3.5673 23.5161C3.77046 23.7193 4.04601 23.8334 4.33333 23.8334H21.6667C21.954 23.8334 22.2295 23.7193 22.4327 23.5161C22.6359 23.313 22.75 23.0374 22.75 22.7501V4.34316C22.75 3.14066 21.7772 2.16675 20.5736 2.16675ZM11.8322 16.3703V21.6667H5.41666V15.6347L8.65258 12.44L11.8322 15.6932V16.3703ZM14.0833 9.75008H11.9167V7.58342H14.0833V9.75008ZM18.4167 18.4167H16.25V16.2501H18.4167V18.4167ZM18.4167 14.0834H16.25V11.9167H18.4167V14.0834ZM18.4167 9.75008H16.25V7.58342H18.4167V9.75008Z"
        fill="#B9B9B9"
      />
      <path d="M7.58333 16.25H9.74999V18.4167H7.58333V16.25Z" fill="#B9B9B9" />
    </svg>
  ),
  "funeral-director": (
    <svg
      width="143"
      height="158"
      viewBox="0 0 143 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_657_2773)">
        <mask
          id="mask0_657_2773"
          maskUnits="userSpaceOnUse"
          x="-69"
          y="-125"
          width="280"
          height="280"
        >
          <circle cx="71" cy="15" r="140" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_657_2773)">
          <path
            d="M1.50522 155.986C1.3941 116.393 28.7092 83.2539 71.5001 83.2539C114.291 83.2539 141.909 117.505 141.495 155.986"
            fill="#252525"
          />
          <path
            d="M1.50522 155.986C1.3941 116.393 28.7092 83.2539 71.5001 83.2539C114.291 83.2539 141.909 117.505 141.495 155.986"
            stroke="#252525"
            strokeWidth="2.97"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M54.0443 98.205C54.1531 108.178 58.0555 130.272 71.7229 130.272C85.3903 130.272 89.3596 108.148 89.4004 98.2051C89.4276 88.5457 82.8336 90.1883 71.7229 90.1883C60.6122 90.1883 53.9355 88.8188 54.0443 98.205Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M76.2883 102.344C76.258 108.156 75.0963 111.353 71.5001 111.353C67.9039 111.353 66.7119 108.136 66.7119 102.344C66.7119 96.722 68.5706 92.7738 71.5001 92.7738C74.4296 92.7738 76.3187 96.8724 76.2883 102.344Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M76.2883 122.957C76.258 128.769 75.0963 152.038 71.5001 152.038C67.9039 152.038 66.7119 128.749 66.7119 122.957C66.7119 117.335 68.5706 113.387 71.5001 113.387C74.4296 113.387 76.3187 117.485 76.2883 122.957Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M83.9048 103.486C86.9353 103.446 89.7234 101.482 90.7538 98.6561C91.7841 95.8302 91.8448 90.6894 89.4102 87.2322C84.6927 80.5082 68.5906 94.4072 72.4393 99.8887C75.2577 101.712 80.8743 103.526 83.9048 103.486Z"
          fill="white"
        />
        <path
          d="M89.4102 87.2322L88.3051 88.0076L88.3064 88.0095L89.4102 87.2322ZM72.4393 99.8887L71.3345 100.664L71.4854 100.879L71.7059 101.022L72.4393 99.8887ZM83.9226 104.836C87.507 104.789 90.7973 102.478 92.0221 99.1185L89.4854 98.1936C88.6495 100.486 86.3636 102.104 83.8869 102.136L83.9226 104.836ZM92.0221 99.1185C92.6132 97.4974 92.9002 95.3087 92.7273 93.0766C92.5542 90.8412 91.9097 88.437 90.514 86.4549L88.3064 88.0095C89.3453 89.4847 89.8878 91.3795 90.0354 93.2851C90.1832 95.1942 89.9247 96.9888 89.4854 98.1936L92.0221 99.1185ZM90.5154 86.4569C88.914 84.1744 86.3702 83.7734 83.95 84.281C81.5584 84.7826 79.0323 86.1923 76.8672 87.9307C74.6953 89.6746 72.7594 91.8513 71.6108 94.0215C70.5013 96.1177 69.9186 98.6479 71.3345 100.664L73.5442 99.1129C73.0357 98.3887 73.0225 97.1259 73.9971 95.2846C74.9326 93.5171 76.5954 91.6116 78.5577 90.036C80.5268 88.455 82.6701 87.3082 84.5042 86.9235C86.3097 86.5448 87.5477 86.928 88.3051 88.0076L90.5154 86.4569ZM71.7059 101.022C73.2533 102.023 75.4859 102.977 77.6848 103.673C79.8699 104.366 82.1933 104.859 83.9226 104.836L83.8869 102.136C82.5858 102.153 80.5856 101.76 78.5002 101.099C76.4286 100.443 74.4438 99.5777 73.1728 98.7553L71.7059 101.022Z"
          fill="#252525"
        />
        <path
          d="M59.4486 103.486C56.4181 103.446 53.63 101.482 52.5997 98.6561C51.5693 95.8302 51.5087 90.6894 53.9432 87.2322C58.6607 80.5082 74.7629 94.4072 70.9141 99.8886C68.6917 101.712 63.1357 103.535 59.4486 103.486Z"
          fill="white"
        />
        <path
          d="M59.4486 103.486L59.4308 104.836L59.4486 103.486ZM53.9432 87.2322L55.047 88.0095L55.0483 88.0076L53.9432 87.2322ZM70.9141 99.8886L71.7705 100.932L71.913 100.815L72.0189 100.664L70.9141 99.8886ZM59.4665 102.136C56.9898 102.104 54.704 100.486 53.868 98.1936L51.3313 99.1185C52.5561 102.478 55.8464 104.789 59.4308 104.836L59.4665 102.136ZM53.868 98.1936C53.4287 96.9888 53.1702 95.1942 53.3181 93.2851C53.4657 91.3795 54.0082 89.4847 55.047 88.0095L52.8394 86.4549C51.4437 88.437 50.7993 90.8411 50.6261 93.0766C50.4533 95.3087 50.7403 97.4974 51.3313 99.1185L53.868 98.1936ZM55.0483 88.0076C55.8057 86.928 57.0437 86.5448 58.8492 86.9235C60.6833 87.3082 62.8267 88.455 64.7958 90.036C66.758 91.6116 68.4208 93.5171 69.3563 95.2846C70.3309 97.1259 70.3177 98.3887 69.8092 99.1129L72.0189 100.664C73.4348 98.6479 72.8522 96.1177 71.7427 94.0215C70.594 91.8513 68.6581 89.6746 66.4862 87.9307C64.3212 86.1923 61.795 84.7826 59.4034 84.281C56.9833 83.7734 54.4394 84.1744 52.8381 86.4569L55.0483 88.0076ZM70.0577 98.8451C69.1415 99.5969 67.3871 100.445 65.321 101.103C63.2749 101.755 61.1157 102.158 59.4665 102.136L59.4308 104.836C61.4686 104.863 63.9309 104.379 66.1402 103.676C68.3295 102.979 70.4642 102.004 71.7705 100.932L70.0577 98.8451Z"
          fill="#252525"
        />
        <path
          d="M85.3495 83.2339C85.2687 93.1146 81.9957 98.556 71.8435 98.556C61.6912 98.556 58.3678 93.0845 58.3375 83.2339C58.3173 73.664 63.5904 66.96 71.8435 66.96C80.0966 66.96 85.4303 73.9345 85.3495 83.2339Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M67.4188 61.3682C67.338 71.2489 64.065 76.6902 53.9128 76.6902C43.7606 76.6902 40.4371 71.2188 40.4068 61.3682C40.3866 51.7982 45.6597 45.0942 53.9128 45.0942C62.1659 45.0942 67.4996 52.0688 67.4188 61.3682Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M102.775 61.3682C102.694 71.2489 99.421 76.6902 89.2688 76.6902C79.1165 76.6902 75.7931 71.2188 75.7628 61.3682C75.7425 51.7982 81.0157 45.0942 89.2688 45.0942C97.5219 45.0942 102.856 52.0688 102.775 61.3682Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M49.4885 51.9585C49.4885 57.3297 47.0136 61.6888 42.6092 61.6888C38.2049 61.6888 34.3662 57.3297 34.3662 51.9585C34.3662 46.5873 37.3866 42.2281 41.791 42.2281C46.1953 42.2281 49.4885 46.5873 49.4885 51.9585Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M44.2557 52.0587C45.7306 52.0487 45.7306 52.0386 48.2055 52.0587C48.2055 52.0587 47.2054 52.5397 44.2759 52.5798H44.286C41.3565 52.5397 40.3564 52.0587 40.3564 52.0587C40.3564 52.0587 42.2859 52.0487 44.3062 52.0587"
          stroke="#252525"
          strokeWidth="1.62"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.835 51.9585C93.835 57.3297 96.3099 61.6888 100.714 61.6888C105.119 61.6888 108.957 57.3297 108.957 51.9585C108.957 46.5873 105.937 42.2281 101.532 42.2281C97.1281 42.2281 93.835 46.5873 93.835 51.9585Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M98.7948 52.0587C100.27 52.0487 100.27 52.0386 102.745 52.0587C102.745 52.0587 101.744 52.5397 98.815 52.5798H98.8251C95.8956 52.5397 94.8955 52.0587 94.8955 52.0587C94.8955 52.0587 96.8249 52.0487 98.8453 52.0587"
          stroke="#252525"
          strokeWidth="1.62"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M99.6939 49.7038C99.5222 72.1607 87.2789 84.5265 71.6212 84.5265C55.9635 84.5265 43.599 72.0906 43.5485 49.7038C43.498 27.317 54.4584 12.7166 71.6212 12.7166C88.784 12.7166 99.8555 28.5596 99.6939 49.7038Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M71.6963 69.6236C73.2148 69.6048 73.2376 69.6237 75.763 69.1444C75.763 69.1444 74.7125 70.5504 71.6963 70.6258C68.6801 70.5504 67.6816 69.1444 67.6816 69.1444C67.6816 69.1444 69.6162 69.6048 71.6963 69.6236Z"
          stroke="#252525"
          strokeWidth="1.62"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M102.421 33.0891C99.6432 55.3756 88.7838 22.2464 71.621 22.2464C54.4582 22.2464 44.7403 56.3076 40.8209 34.2515C37.3459 14.6706 54.64 -2.34494 71.621 2.66553C87.5514 -3.34703 104.714 14.6706 102.421 33.0891Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M56.1958 44.1222C56.1958 44.1222 57.2767 43.3205 60.2062 43.3606C63.1357 43.4007 64.1358 44.1522 64.1358 44.1522C64.1358 44.1522 62.2063 43.8917 60.186 43.8817C58.893 43.8717 57.3878 43.9418 56.2059 44.1222H56.1958Z"
          stroke="#252525"
          strokeWidth="1.62"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M86.794 44.1222C86.794 44.1222 85.7131 43.3205 82.7836 43.3606C79.8541 43.4007 78.854 44.1522 78.854 44.1522C78.854 44.1522 80.7834 43.8917 82.8038 43.8817C84.0968 43.8717 85.602 43.9418 86.7839 44.1222H86.794Z"
          stroke="#252525"
          strokeWidth="1.62"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.7725 63.2521C69.7725 63.2521 70.2775 63.703 71.6514 63.693C73.0252 63.683 73.4798 63.2721 73.4798 63.2721C73.4798 63.2721 72.5807 63.4024 71.6312 63.4024C71.0251 63.4024 70.318 63.3523 69.7725 63.2521Z"
          stroke="#252525"
          strokeWidth="1.89"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.6204 51.653C61.6143 52.5932 61.3695 53.1109 60.6102 53.1109C59.8509 53.1109 59.6024 52.5903 59.6001 51.653C59.5986 50.7425 59.993 50.1046 60.6102 50.1046C61.2275 50.1046 61.6264 50.7682 61.6204 51.653Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <path
          d="M83.844 51.653C83.838 52.5932 83.5932 53.1109 82.8339 53.1109C82.0746 53.1109 81.826 52.5903 81.8237 51.653C81.8222 50.7425 82.2166 50.1046 82.8339 50.1046C83.4511 50.1046 83.8501 50.7682 83.844 51.653Z"
          fill="white"
          stroke="#252525"
          strokeWidth="2.97"
          strokeMiterlimit="10"
        />
        <rect
          x="23.5"
          y="113.5"
          width="37"
          height="57"
          rx="1.5"
          fill="#F5F5F5"
          stroke="#252525"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <rect
          x="35.5"
          y="109.5"
          width="14"
          height="6"
          rx="1.5"
          fill="white"
          stroke="#252525"
          strokeWidth="3"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_657_2773">
          <rect width="143" height="158" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  filter: (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 6.1875H7.0625C6.88016 6.1875 6.7053 6.11507 6.57636 5.98614C6.44743 5.8572 6.375 5.68234 6.375 5.5C6.375 5.31766 6.44743 5.1428 6.57636 5.01386C6.7053 4.88493 6.88016 4.8125 7.0625 4.8125H18.75C18.9323 4.8125 19.1072 4.88493 19.2361 5.01386C19.3651 5.1428 19.4375 5.31766 19.4375 5.5C19.4375 5.68234 19.3651 5.8572 19.2361 5.98614C19.1072 6.11507 18.9323 6.1875 18.75 6.1875Z"
        fill="currentColor"
      />
      <path
        d="M4.3125 6.1875H2.25C2.06766 6.1875 1.8928 6.11507 1.76386 5.98614C1.63493 5.8572 1.5625 5.68234 1.5625 5.5C1.5625 5.31766 1.63493 5.1428 1.76386 5.01386C1.8928 4.88493 2.06766 4.8125 2.25 4.8125H4.3125C4.49484 4.8125 4.6697 4.88493 4.79864 5.01386C4.92757 5.1428 5 5.31766 5 5.5C5 5.68234 4.92757 5.8572 4.79864 5.98614C4.6697 6.11507 4.49484 6.1875 4.3125 6.1875Z"
        fill="currentColor"
      />
      <path
        d="M13.9375 11.6875H2.25C2.06766 11.6875 1.8928 11.6151 1.76386 11.4861C1.63493 11.3572 1.5625 11.1823 1.5625 11C1.5625 10.8177 1.63493 10.6428 1.76386 10.5139C1.8928 10.3849 2.06766 10.3125 2.25 10.3125H13.9375C14.1198 10.3125 14.2947 10.3849 14.4236 10.5139C14.5526 10.6428 14.625 10.8177 14.625 11C14.625 11.1823 14.5526 11.3572 14.4236 11.4861C14.2947 11.6151 14.1198 11.6875 13.9375 11.6875Z"
        fill="currentColor"
      />
      <path
        d="M7.0625 17.1875H2.25C2.06766 17.1875 1.8928 17.1151 1.76386 16.9861C1.63493 16.8572 1.5625 16.6823 1.5625 16.5C1.5625 16.3177 1.63493 16.1428 1.76386 16.0139C1.8928 15.8849 2.06766 15.8125 2.25 15.8125H7.0625C7.24484 15.8125 7.4197 15.8849 7.54864 16.0139C7.67757 16.1428 7.75 16.3177 7.75 16.5C7.75 16.6823 7.67757 16.8572 7.54864 16.9861C7.4197 17.1151 7.24484 17.1875 7.0625 17.1875Z"
        fill="currentColor"
      />
      <path
        d="M5.6875 7.5625C5.27958 7.5625 4.88081 7.44154 4.54164 7.21491C4.20246 6.98828 3.93811 6.66616 3.782 6.28929C3.62589 5.91241 3.58505 5.49771 3.66463 5.09763C3.74421 4.69754 3.94065 4.33004 4.22909 4.04159C4.51754 3.75315 4.88504 3.55671 5.28513 3.47713C5.68521 3.39755 6.09991 3.43839 6.47679 3.5945C6.85366 3.75061 7.17578 4.01496 7.40241 4.35414C7.62904 4.69331 7.75 5.09208 7.75 5.5C7.75 6.04701 7.5327 6.57162 7.14591 6.95841C6.75911 7.3452 6.23451 7.5625 5.6875 7.5625ZM5.6875 4.8125C5.55153 4.8125 5.4186 4.85282 5.30555 4.92837C5.19249 5.00391 5.10437 5.11128 5.05233 5.23691C5.0003 5.36253 4.98668 5.50076 5.01321 5.63413C5.03974 5.76749 5.10522 5.88999 5.20136 5.98614C5.29751 6.08229 5.42001 6.14776 5.55338 6.17429C5.68674 6.20082 5.82497 6.1872 5.9506 6.13517C6.07622 6.08313 6.18359 5.99501 6.25914 5.88196C6.33468 5.7689 6.375 5.63598 6.375 5.5C6.375 5.31766 6.30257 5.1428 6.17364 5.01387C6.04471 4.88493 5.86984 4.8125 5.6875 4.8125Z"
        fill="currentColor"
      />
      <path
        d="M15.3125 13.0625C14.9046 13.0625 14.5058 12.9415 14.1666 12.7149C13.8275 12.4883 13.5631 12.1662 13.407 11.7893C13.2509 11.4124 13.21 10.9977 13.2896 10.5976C13.3692 10.1975 13.5656 9.83004 13.8541 9.54159C14.1425 9.25315 14.51 9.05671 14.9101 8.97713C15.3102 8.89755 15.7249 8.93839 16.1018 9.0945C16.4787 9.25061 16.8008 9.51496 17.0274 9.85414C17.254 10.1933 17.375 10.5921 17.375 11C17.375 11.547 17.1577 12.0716 16.7709 12.4584C16.3841 12.8452 15.8595 13.0625 15.3125 13.0625ZM15.3125 10.3125C15.1765 10.3125 15.0436 10.3528 14.9305 10.4284C14.8175 10.5039 14.7294 10.6113 14.6773 10.7369C14.6253 10.8625 14.6117 11.0008 14.6382 11.1341C14.6647 11.2675 14.7302 11.39 14.8264 11.4861C14.9225 11.5823 15.045 11.6478 15.1784 11.6743C15.3117 11.7008 15.45 11.6872 15.5756 11.6352C15.7012 11.5831 15.8086 11.495 15.8841 11.382C15.9597 11.2689 16 11.136 16 11C16 10.8177 15.9276 10.6428 15.7986 10.5139C15.6697 10.3849 15.4948 10.3125 15.3125 10.3125Z"
        fill="currentColor"
      />
      <path
        d="M8.4375 18.5625C8.02958 18.5625 7.63081 18.4415 7.29164 18.2149C6.95246 17.9883 6.6881 17.6662 6.532 17.2893C6.37589 16.9124 6.33505 16.4977 6.41463 16.0976C6.49421 15.6975 6.69065 15.33 6.97909 15.0416C7.26754 14.7531 7.63504 14.5567 8.03513 14.4771C8.43521 14.3975 8.84991 14.4384 9.22678 14.5945C9.60366 14.7506 9.92577 15.015 10.1524 15.3541C10.379 15.6933 10.5 16.0921 10.5 16.5C10.5 17.047 10.2827 17.5716 9.89591 17.9584C9.50911 18.3452 8.98451 18.5625 8.4375 18.5625ZM8.4375 15.8125C8.30152 15.8125 8.1686 15.8528 8.05554 15.9284C7.94249 16.0039 7.85437 16.1113 7.80233 16.2369C7.7503 16.3625 7.73668 16.5008 7.76321 16.6341C7.78974 16.7675 7.85521 16.89 7.95136 16.9861C8.04751 17.0823 8.17001 17.1478 8.30337 17.1743C8.43674 17.2008 8.57497 17.1872 8.70059 17.1352C8.82622 17.0831 8.93359 16.995 9.00913 16.882C9.08468 16.7689 9.125 16.636 9.125 16.5C9.125 16.3177 9.05257 16.1428 8.92364 16.0139C8.7947 15.8849 8.61984 15.8125 8.4375 15.8125Z"
        fill="currentColor"
      />
      <path
        d="M18.75 11.6875H16.6875C16.5052 11.6875 16.3303 11.6151 16.2014 11.4861C16.0724 11.3572 16 11.1823 16 11C16 10.8177 16.0724 10.6428 16.2014 10.5139C16.3303 10.3849 16.5052 10.3125 16.6875 10.3125H18.75C18.9323 10.3125 19.1072 10.3849 19.2361 10.5139C19.3651 10.6428 19.4375 10.8177 19.4375 11C19.4375 11.1823 19.3651 11.3572 19.2361 11.4861C19.1072 11.6151 18.9323 11.6875 18.75 11.6875Z"
        fill="currentColor"
      />
      <path
        d="M18.75 17.1875H9.8125C9.63016 17.1875 9.4553 17.1151 9.32636 16.9861C9.19743 16.8572 9.125 16.6823 9.125 16.5C9.125 16.3177 9.19743 16.1428 9.32636 16.0139C9.4553 15.8849 9.63016 15.8125 9.8125 15.8125H18.75C18.9323 15.8125 19.1072 15.8849 19.2361 16.0139C19.3651 16.1428 19.4375 16.3177 19.4375 16.5C19.4375 16.6823 19.3651 16.8572 19.2361 16.9861C19.1072 17.1151 18.9323 17.1875 18.75 17.1875Z"
        fill="currentColor"
      />
    </svg>
  ),
  check_black_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.29 5.89002L11.29 15.89C10.9 16.28 10.27 16.28 9.87998 15.89L7.04998 13.06C6.65998 12.67 6.65998 12.04 7.04998 11.65C7.43998 11.26 8.06998 11.26 8.45998 11.65L10.58 13.77L19.87 4.48002C20.26 4.09002 20.89 4.09002 21.28 4.48002C21.68 4.87002 21.68 5.50002 21.29 5.89002ZM15.77 2.74002C14.08 2.05002 12.16 1.81002 10.16 2.17002C6.08998 2.90002 2.83998 6.18002 2.14998 10.25C1.00998 17 6.62998 22.78 13.34 21.91C17.3 21.4 20.62 18.45 21.66 14.6C22.06 13.13 22.1 11.71 21.87 10.38C21.74 9.58002 20.75 9.27002 20.17 9.84002C19.94 10.07 19.84 10.41 19.9 10.73C20.12 12.06 20.02 13.48 19.38 14.99C18.22 17.7 15.7 19.69 12.77 19.96C7.66998 20.43 3.43998 16.11 4.06998 10.98C4.49998 7.44002 7.34998 4.56002 10.88 4.07002C12.61 3.83002 14.25 4.16002 15.65 4.88002C16.04 5.08002 16.51 5.01002 16.82 4.70002C17.3 4.22002 17.18 3.41002 16.58 3.10002C16.31 2.98002 16.04 2.85002 15.77 2.74002Z"
        fill="black"
      />
    </svg>
  ),
  question: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9ZM6.183 6.78713H7.11112C7.26638 6.78713 7.39012 6.66 7.41037 6.50588C7.51162 5.76788 8.01787 5.23013 8.92013 5.23013C9.69187 5.23013 10.3984 5.616 10.3984 6.54413C10.3984 7.2585 9.97762 7.587 9.31275 8.0865C8.55562 8.63663 7.956 9.279 7.99875 10.3219L8.00212 10.566C8.00331 10.6398 8.03346 10.7102 8.08608 10.762C8.13869 10.8137 8.20956 10.8428 8.28337 10.8427H9.19575C9.27034 10.8427 9.34188 10.8131 9.39462 10.7604C9.44737 10.7076 9.477 10.6361 9.477 10.5615V10.4434C9.477 9.63562 9.78413 9.4005 10.6132 8.77162C11.2984 8.25075 12.0128 7.6725 12.0128 6.45863C12.0128 4.75875 10.5773 3.9375 9.00562 3.9375C7.58025 3.9375 6.01875 4.60125 5.91188 6.50925C5.91034 6.54558 5.91624 6.58184 5.92924 6.61581C5.94223 6.64977 5.96203 6.68072 5.98742 6.70674C6.01282 6.73277 6.04327 6.75333 6.0769 6.76715C6.11054 6.78097 6.14664 6.78777 6.183 6.78713ZM8.79862 14.0355C9.48487 14.0355 9.95625 13.5922 9.95625 12.9926C9.95625 12.3716 9.48375 11.9351 8.79862 11.9351C8.14163 11.9351 7.6635 12.3716 7.6635 12.9926C7.6635 13.5922 8.14163 14.0355 8.79975 14.0355H8.79862Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  close: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5413 6.87268L12.9447 11.4682L8.34925 6.87268L6.81741 8.40451L11.4129 13L6.81741 17.5955L8.34925 19.1273L12.9447 14.5318L17.5413 19.1273L19.0732 17.5955L14.4777 13L19.0732 8.40451L17.5413 6.87268Z"
        fill="#535353"
      />
    </svg>
  ),
  location: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0001 1.76788C13.0318 1.76788 14.9804 2.57499 16.417 4.01165C17.8537 5.44832 18.6608 7.39685 18.6608 9.4286C18.6608 12.6657 16.3861 16.1936 11.8958 20.0499C11.6461 20.2644 11.3278 20.3822 10.9986 20.3819C10.6694 20.3816 10.3513 20.2632 10.102 20.0483L9.805 19.7906C5.51343 16.0349 3.33936 12.5935 3.33936 9.4286C3.33936 7.39685 4.14646 5.44832 5.58313 4.01165C7.01979 2.57499 8.96832 1.76788 11.0001 1.76788V1.76788ZM11.0001 6.48217C10.2186 6.48217 9.46919 6.7926 8.91663 7.34516C8.36407 7.89772 8.05364 8.64716 8.05364 9.4286C8.05364 10.21 8.36407 10.9595 8.91663 11.512C9.46919 12.0646 10.2186 12.375 11.0001 12.375C11.7815 12.375 12.5309 12.0646 13.0835 11.512C13.6361 10.9595 13.9465 10.21 13.9465 9.4286C13.9465 8.64716 13.6361 7.89772 13.0835 7.34516C12.5309 6.7926 11.7815 6.48217 11.0001 6.48217Z"
        fill="#2F9E44"
      />
    </svg>
  ),
  logo: (
    <svg
      width="40"
      height="39"
      viewBox="0 0 40 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9998 11.9999H20.0001V16H23.9998H28V4.00013V0.777715V0H8V4.00013H23.9998V11.9999Z"
        fill="white"
      />
      <path
        d="M24 19C22.22 19 20.4799 19.5278 18.9999 20.5168C17.5198 21.5057 16.3663 22.9113 15.6851 24.5558C15.0039 26.2004 14.8257 28.01 15.1729 29.7558C15.5202 31.5016 16.3774 33.1053 17.636 34.364C18.8947 35.6226 20.4984 36.4798 22.2442 36.8271C23.99 37.1743 25.7996 36.9961 27.4441 36.3149C29.0887 35.6337 30.4943 34.4802 31.4832 33.0001C32.4722 31.5201 33 29.78 33 28C33 25.6131 32.0518 23.3239 30.364 21.636C28.6761 19.9482 26.387 19 24 19ZM24 32.9457C23.0218 32.9457 22.0656 32.6556 21.2523 32.1121C20.4389 31.5687 19.805 30.7962 19.4307 29.8925C19.0564 28.9888 18.9585 27.9943 19.1494 27.0349C19.3403 26.0756 19.8113 25.1943 20.5031 24.5027C21.1948 23.811 22.0761 23.34 23.0355 23.1493C23.9949 22.9585 24.9893 23.0565 25.893 23.4309C26.7967 23.8053 27.5691 24.4393 28.1125 25.2527C28.6558 26.0661 28.9458 27.0223 28.9457 28.0005C28.9455 29.3121 28.4244 30.5699 27.4969 31.4973C26.5695 32.4247 25.3116 32.9457 24 32.9457Z"
        fill="white"
      />
      <path
        d="M35.8249 12H32V16.0579H35.1828C35.345 16.0579 35.5005 16.12 35.6152 16.2307C35.7299 16.3413 35.7943 16.4914 35.7943 16.6479V39H40V16.0262C40.0001 15.7944 39.9528 15.5649 39.8609 15.3507C39.7689 15.1366 39.6341 14.942 39.4641 14.7782L37.1202 12.517C36.9501 12.3529 36.7482 12.2228 36.5259 12.1341C36.3036 12.0454 36.0654 11.9998 35.8249 12Z"
        fill="white"
      />
      <path
        d="M16 16.033V8H12.0071V15.4189C12.0071 15.5732 11.946 15.7212 11.8371 15.8303C11.7282 15.9394 11.5806 16.0007 11.4266 16.0007H0V20H12.0377C12.4985 20 12.9404 19.8166 13.2663 19.4901L15.4913 17.2601C15.8161 16.9346 15.999 16.4933 16 16.033Z"
        fill="white"
      />
    </svg>
  ),
  info: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.2C11.6817 9.2 11.3765 9.07357 11.1515 8.84853C10.9264 8.62348 10.8 8.31826 10.8 8C10.8 7.68174 10.9264 7.37652 11.1515 7.15147C11.3765 6.92643 11.6817 6.8 12 6.8C12.3183 6.8 12.6235 6.92643 12.8485 7.15147C13.0736 7.37652 13.2 7.68174 13.2 8C13.2 8.31826 13.0736 8.62348 12.8485 8.84853C12.6235 9.07357 12.3183 9.2 12 9.2ZM13 16.635C13 16.9002 12.8946 17.1546 12.7071 17.3421C12.5196 17.5296 12.2652 17.635 12 17.635C11.7348 17.635 11.4804 17.5296 11.2929 17.3421C11.1054 17.1546 11 16.9002 11 16.635V11.635C11 11.3698 11.1054 11.1154 11.2929 10.9279C11.4804 10.7404 11.7348 10.635 12 10.635C12.2652 10.635 12.5196 10.7404 12.7071 10.9279C12.8946 11.1154 13 11.3698 13 11.635V16.635ZM12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  info_mono: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.08594C14.375 2.08594 17.9167 5.6276 17.9167 10.0026C17.9167 14.3776 14.375 17.9193 10 17.9193C5.62504 17.9193 2.08337 14.3776 2.08337 10.0026C2.08337 5.6276 5.62504 2.08594 10 2.08594ZM10 3.41927C6.36671 3.41927 3.41671 6.36927 3.41671 10.0026C3.41671 13.6359 6.36671 16.5859 10 16.5859C13.6334 16.5859 16.5834 13.6359 16.5834 10.0026C16.5834 6.36927 13.6334 3.41927 10 3.41927ZM10 8.66927C10.4167 8.66927 10.75 9.0026 10.75 9.41927V13.3359C10.75 13.7526 10.4167 14.0859 10 14.0859C9.58337 14.0859 9.25004 13.7526 9.25004 13.3359V9.41927C9.25004 9.0026 9.58337 8.66927 10 8.66927ZM10 5.83594C10.4584 5.83594 10.8334 6.21094 10.8334 6.66927C10.8334 7.1276 10.4584 7.5026 10 7.5026C9.54171 7.5026 9.16671 7.1276 9.16671 6.66927C9.16671 6.21094 9.54171 5.83594 10 5.83594Z"
        fill="#535353"
      />
    </svg>
  ),
  arrow_forward_ios_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_524_155)">
        <path
          d="M16.62 21.01C16.13 21.5 15.34 21.5 14.85 21.01L6.54001 12.7C6.15001 12.31 6.15001 11.68 6.54001 11.29L14.85 2.97999C15.34 2.48999 16.13 2.48999 16.62 2.97999C17.11 3.46999 17.11 4.25999 16.62 4.74999L9.38001 12L16.63 19.25C17.11 19.73 17.11 20.53 16.62 21.01Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_524_155">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  korean_gov_logo: (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="18.2432" height="18" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1939_18780"
            transform="translate(0 -0.00675673) scale(0.000976562 0.000989759)"
          />
        </pattern>
        <image
          id="image0_1939_18780"
          width="1024"
          height="1024"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
  trust_1: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill="#F5F5F5" />
      <g clipPath="url(#clip0_442_5094)">
        <path
          d="M29.7287 14.5924L11.0502 27.831L21.7888 35.7511L40.9305 21.9545L30.4962 14.5924C30.2646 14.4306 29.9603 14.4306 29.7287 14.5924Z"
          fill="#AFCBA7"
        />
        <path
          d="M11.0502 27.8308L21.7888 35.7509V41.634L11.4207 33.7469C11.1891 33.5687 11.0502 33.2946 11.0502 33.0008V27.8341V27.8308Z"
          fill="#9AAC83"
        />
        <path
          d="M21.7888 35.7508L40.9305 21.9542V26.7479C40.9305 27.0153 40.8048 27.2662 40.5931 27.428L21.7888 41.6372V35.7541V35.7508Z"
          fill="#6A8D5F"
        />
        <path
          d="M29.6922 30.3398L19.0264 22.1127L22.4868 19.7258L33.1792 27.8308L29.6922 30.3398Z"
          fill="#FFEDB7"
        />
        <path
          d="M29.6923 30.3399V35.6617L33.2123 33.0008L33.1792 27.8308L29.6923 30.3399Z"
          fill="#CFA576"
        />
      </g>
      <g clipPath="url(#clip1_442_5094)">
        <path
          d="M26.3333 7.12243L7.65479 20.3611L18.3934 28.2811L37.5351 14.4846L27.1008 7.12243C26.8692 6.96066 26.5649 6.96066 26.3333 7.12243Z"
          fill="#FDBA12"
        />
        <path
          d="M7.65479 20.3608L18.3934 28.2809V34.164L8.02531 26.277C7.79373 26.0987 7.65479 25.8247 7.65479 25.5308V20.3641V20.3608Z"
          fill="#E39528"
        />
        <path
          d="M18.3934 28.2808L37.5351 14.4843V19.2779C37.5351 19.5453 37.4094 19.7962 37.1977 19.958L18.3934 34.1672V28.2841V28.2808Z"
          fill="#C57C37"
        />
        <path
          d="M26.2969 22.8699L15.631 14.6428L19.0914 12.2559L29.7838 20.3608L26.2969 22.8699Z"
          fill="#FFEDB7"
        />
        <path
          d="M26.2969 22.8699V28.1918L29.8169 25.5308L29.7838 20.3608L26.2969 22.8699Z"
          fill="#CFA576"
        />
      </g>
      <defs>
        <clipPath id="clip0_442_5094">
          <rect
            width="29.8803"
            height="27.1639"
            fill="white"
            transform="translate(11.0502 14.47)"
          />
        </clipPath>
        <clipPath id="clip1_442_5094">
          <rect
            width="29.8803"
            height="27.1639"
            fill="white"
            transform="translate(7.65479 7)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  trust_2: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_442_5112)">
        <rect width="48" height="48" rx="10" fill="#F5F5F5" />
        <g clipPath="url(#clip1_442_5112)">
          <rect
            x="17.5933"
            y="35.4857"
            width="12.8136"
            height="13.5143"
            fill="#B9B9B9"
          />
          <path
            d="M10.4515 29.0938C10.889 29.0938 11.2437 28.7428 11.2437 28.3099C11.2437 27.877 10.889 27.526 10.4515 27.526C10.014 27.526 9.6593 27.877 9.6593 28.3099C9.6593 28.7428 10.014 29.0938 10.4515 29.0938Z"
            fill="#40C057"
          />
          <path
            d="M11.6946 23.7693C12.3134 23.157 11.5901 21.4486 10.0791 19.9534C8.56809 18.4583 6.8416 17.7425 6.22286 18.3548C5.60413 18.967 6.32744 20.6755 7.83843 22.1706C9.34942 23.6658 11.0759 24.3815 11.6946 23.7693Z"
            fill="#40C057"
          />
          <path
            d="M16.8324 10.1089C17.6341 9.31555 18.0963 8.48671 17.8648 8.25762C17.6333 8.02853 16.7957 8.48593 15.994 9.27926C15.1923 10.0726 14.73 10.9014 14.9616 11.1305C15.1931 11.3596 16.0307 10.9022 16.8324 10.1089Z"
            fill="#F4A35B"
          />
          <path
            d="M40.1617 24.4235C41.6727 22.9283 42.396 21.2199 41.7773 20.6077C41.1586 19.9954 39.4321 20.7112 37.9211 22.2063C36.4101 23.7015 35.6868 25.4099 36.3055 26.0222C36.9242 26.6344 38.6507 25.9187 40.1617 24.4235Z"
            fill="#2F9E44"
          />
          <path
            d="M39.3456 22.6705C39.9643 22.0583 39.7385 20.8421 38.8411 19.9541C37.9437 19.0661 36.7146 18.8426 36.0959 19.4549C35.4772 20.0671 35.7031 21.2833 36.6004 22.1713C37.4978 23.0593 38.7269 23.2828 39.3456 22.6705Z"
            fill="#F4A35B"
          />
          <rect
            x="15.1526"
            y="30.5714"
            width="17.6949"
            height="6.75714"
            fill="#CCCCCC"
          />
          <path
            d="M18.2034 27.667H21.1403V17.7563H18.2034V15.1095L24.0464 11.5286H26.9833V27.667H29.7966V31.8H18.2034V27.667Z"
            fill="#2F9E44"
            stroke="#2F9E44"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_442_5112">
          <rect width="48" height="48" rx="10" fill="white" />
        </clipPath>
        <clipPath id="clip1_442_5112">
          <rect
            width="36"
            height="43"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  trust_3: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="10" fill="#F5F5F5" />
      <g clipPath="url(#clip0_442_5126)">
        <path d="M30 43L23.9985 38.8832L18 43V18H30V43Z" fill="#2F9E44" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6348 7.56928L28.9314 13.8559C29.1963 14.3613 29.7091 14.7119 30.3027 14.7933L37.6736 15.8013C39.1668 16.0053 39.7646 17.7346 38.6823 18.7253L33.3485 23.6186C33.1372 23.8127 32.979 24.0522 32.8877 24.3165C32.7964 24.5808 32.7747 24.862 32.8244 25.1359L34.0838 32.0453C34.3388 33.4466 32.7776 34.5133 31.4417 33.8533L24.8485 30.5906C24.5873 30.4612 24.2966 30.3936 24.0014 30.3936C23.7062 30.3936 23.4154 30.4612 23.1542 30.5906L16.561 33.8533C15.2237 34.5133 13.6625 33.4466 13.9175 32.0453L15.177 25.1359C15.2266 24.862 15.2048 24.5808 15.1135 24.3165C15.0222 24.0522 14.8641 23.8127 14.6528 23.6186L9.31904 18.7253C8.23813 17.7346 8.83454 16.0053 10.3291 15.8013L17.6986 14.7933C18.2922 14.7119 18.8065 14.3613 19.0714 13.8559L22.3665 7.56928C23.0352 6.29461 24.9661 6.29461 25.6348 7.56928Z"
        fill="#FDBA12"
      />
      <path
        d="M19.2637 23.25H21.3262V24H22.1641V23.25H22.7031V22.541H22.1641V19.7578H21.0566L19.2637 22.5527V23.25ZM20.1543 22.541V22.5059L21.2969 20.7246H21.3379V22.541H20.1543ZM23.7051 24.0527C23.9658 24.0527 24.1914 23.833 24.1914 23.5605C24.1914 23.291 23.9658 23.0713 23.7051 23.0742C23.4297 23.0713 23.207 23.291 23.2129 23.5605C23.207 23.833 23.4297 24.0527 23.7051 24.0527ZM26.3535 19.6992C25.3955 19.6963 24.748 20.3174 24.748 21.1699C24.7539 21.9609 25.3164 22.5352 26.0781 22.5352C26.5498 22.5352 26.9688 22.3125 27.168 21.9375H27.2031C27.2002 22.7842 26.8955 23.3027 26.3184 23.3027C25.9785 23.3027 25.7354 23.1182 25.6621 22.8047H24.7949C24.8799 23.5225 25.4658 24.0586 26.3184 24.0586C27.3848 24.0586 28.0674 23.209 28.0645 21.7676C28.0645 20.2266 27.2324 19.7021 26.3535 19.6992ZM25.6094 21.1465C25.6035 20.7246 25.9258 20.3936 26.3594 20.3906C26.793 20.3936 27.1094 20.7363 27.1152 21.1406C27.1152 21.5479 26.7842 21.8906 26.3535 21.8906C25.917 21.8906 25.6094 21.5654 25.6094 21.1465Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_442_5126">
          <rect
            width="12"
            height="25"
            fill="white"
            transform="translate(18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-document-search": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 26.5577V4.44231C24 3.64574 23.3284 3 22.5 3H13.5L5 11.5V26.5577C5 27.3543 5.67157 28 6.5 28H22.5C23.3284 28 24 27.3543 24 26.5577Z"
        fill="#98B4DF"
      />
      <path
        d="M13.5 3V10C13.5 10.8284 12.8284 11.5 12 11.5H5L13.5 3Z"
        fill="#5885CB"
      />
      <rect
        width="14.4623"
        height="2.3552"
        rx="1.1776"
        transform="matrix(0.735415 0.677617 -0.677607 0.735424 19.3642 13.7683)"
        fill="#274A7F"
      />
      <ellipse
        cx="20.359"
        cy="16.359"
        rx="6.35905"
        ry="6.35905"
        fill="#274A7F"
      />
      <circle cx="20.3591" cy="16.3591" r="4.00384" fill="#F8FAFD" />
    </svg>
  ),
  "icon-document-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 1.33398H3.00004C2.82323 1.33398 2.65366 1.40422 2.52864 1.52925C2.40361 1.65427 2.33337 1.82384 2.33337 2.00065V14.0007C2.33337 14.1775 2.40361 14.347 2.52864 14.4721C2.65366 14.5971 2.82323 14.6673 3.00004 14.6673H8.66671V11.334C8.66671 10.4153 9.41471 9.66732 10.3334 9.66732H13.6667V2.00065C13.6667 1.82384 13.5965 1.65427 13.4714 1.52925C13.3464 1.40422 13.1769 1.33398 13 1.33398Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66675 11.3346V14.668L13.6667 10.668H10.3334C10.1566 10.668 9.98703 10.7382 9.86201 10.8632C9.73699 10.9883 9.66675 11.1578 9.66675 11.3346Z"
        fill="white"
      />
    </svg>
  ),
  downArrow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_12075)">
        <path
          d="M21.0108 7.37999C21.5008 7.86999 21.5008 8.65999 21.0108 9.14999L12.7008 17.46C12.3108 17.85 11.6808 17.85 11.2908 17.46L2.98078 9.14999C2.49078 8.65999 2.49078 7.86999 2.98078 7.37999C3.47078 6.88999 4.26078 6.88999 4.75078 7.37999L12.0008 14.62L19.2508 7.36999C19.7308 6.88999 20.5308 6.88999 21.0108 7.37999Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_12075">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(0 1 1 0 0 0)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  arrow_forward: (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 1L6 5L2 9" stroke="#535353" strokeWidth="2.2" />
    </svg>
  ),
  notepad: (
    <svg
      height="139px"
      version="1.1"
      viewBox="0 0 139 139"
      width="139px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="#ebebeb"
    >
      <path d="M105.431,12.668H33.57c-4.842,0-8.764,3.923-8.764,8.764v95.819c0,4.841,3.922,8.764,8.764,8.764h71.86  c4.841,0,8.764-3.923,8.764-8.764V21.432C114.194,16.592,110.271,12.668,105.431,12.668z M97.981,95.537H41.018v-8.764h56.964  V95.537z M97.981,71.877H41.018v-8.764h56.964V71.877z M97.981,48.215H41.018v-8.764h56.964V48.215z" />
    </svg>
  ),
  list: (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill="#000000"
        fillRule="evenodd"
        d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zm4 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1zM7 7a1 1 0 0 0 0 2h.001a1 1 0 0 0 0-2H7zm-1 5a1 1 0 0 1 1-1h.001a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h.001a1 1 0 1 0 0-2H7z"
        clipRule="evenodd"
      />
    </svg>
  ),
  linearrow: (
    <svg
      width="81"
      height="9"
      viewBox="0 0 81 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.3536 4.85355C80.5488 4.65829 80.5488 4.34171 80.3536 4.14645L77.1716 0.964466C76.9763 0.769204 76.6597 0.769204 76.4645 0.964466C76.2692 1.15973 76.2692 1.47631 76.4645 1.67157L79.2929 4.5L76.4645 7.32843C76.2692 7.52369 76.2692 7.84027 76.4645 8.03553C76.6597 8.2308 76.9763 8.2308 77.1716 8.03553L80.3536 4.85355ZM0 5H80V4H0V5Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  prepare_package: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7625 1.60688C12.0025 1.46438 12.295 1.46438 12.5275 1.60688L20.7175 6.58687C20.9125 6.70688 21.0325 6.92438 21.0325 7.14937L12.145 13.1246L3.25 7.22363V7.14862C3.25 6.92362 3.37 6.70613 3.565 6.59363L11.7625 1.60688Z"
        fill="#F3C07B"
      />
      <path
        d="M12.142 12.1843L20.662 7.00933C20.6994 6.98705 20.742 6.97507 20.7854 6.97462C20.8289 6.97417 20.8718 6.98526 20.9096 7.00676C20.9474 7.02825 20.9788 7.05939 21.0007 7.097C21.0225 7.1346 21.034 7.17733 21.034 7.22083V16.4758C21.0341 16.6987 20.9769 16.9178 20.8679 17.1122C20.7589 17.3066 20.6017 17.4697 20.4115 17.5858L12.4315 22.4308C12.4112 22.442 12.3891 22.4496 12.3663 22.4533C12.3461 22.4593 12.3251 22.4621 12.304 22.4616C12.2188 22.4854 12.1298 22.4922 12.042 22.4815C11.9543 22.4708 11.8695 22.4429 11.7925 22.3993H11.797L10 14.2498L12.142 12.1843Z"
        fill="#FFCE7C"
      />
      <path
        d="M12.145 22.2165V12.189L3.6325 7.01404C3.59492 6.98988 3.55151 6.97631 3.50685 6.97476C3.46219 6.97321 3.41795 6.98374 3.37878 7.00525C3.33961 7.02675 3.30697 7.05843 3.28431 7.09694C3.26164 7.13545 3.24979 7.17936 3.25 7.22404V16.479C3.25 16.9365 3.49 17.3565 3.8725 17.589L11.8 22.404C11.8338 22.4254 11.8728 22.4373 11.9127 22.4386C11.9527 22.4399 11.9923 22.4305 12.0275 22.4114C12.0626 22.3923 12.092 22.3642 12.1127 22.3299C12.1333 22.2957 12.1445 22.2565 12.145 22.2165Z"
        fill="#E19747"
      />
      <path
        d="M11.1247 20.0858V18.6158C11.1247 18.4433 11.0347 18.2858 10.8922 18.1958L8.79223 16.9283C8.64973 16.8458 8.46973 16.9433 8.46973 17.1083V18.5783C8.46973 18.7508 8.55973 18.9083 8.70223 18.9983L10.8022 20.2658C10.9447 20.3483 11.1247 20.2508 11.1247 20.0858Z"
        fill="#D3D3D3"
      />
      <path
        d="M9.07035 12.4141V8.9941L6.61035 8.8291V11.1991C6.61035 11.2741 6.64785 11.3491 6.71535 11.3941L8.72535 12.6166C8.87535 12.6991 9.07035 12.5941 9.07035 12.4141Z"
        fill="#8C5543"
      />
      <path
        d="M15.5054 3.42188L6.61035 8.82937L9.07035 10.3294L17.9654 4.92937L15.5054 3.42188Z"
        fill="#A56953"
      />
    </svg>
  ),
  "icon-twinkle-circle-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3199_12676)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9998 8.33342L10.5332 8.80008C9.73317 9.06675 9.13317 9.66675 8.8665 10.4667L8.33317 12.0001C8.19984 12.3334 7.79984 12.3334 7.73317 12.0001L7.2665 10.5334C6.99984 9.73341 6.39984 9.13342 5.59984 8.86675L3.99984 8.33342C3.6665 8.20008 3.6665 7.80008 3.99984 7.73342L5.4665 7.26675C6.2665 7.00008 6.8665 6.40008 7.13317 5.60008L7.6665 4.00008C7.79984 3.66675 8.19984 3.66675 8.2665 4.00008L8.73317 5.46675C8.99984 6.26675 9.59984 6.86675 10.3998 7.13341L11.8665 7.60008C12.3332 7.80008 12.3332 8.20008 11.9998 8.33342M7.99984 0.666748C3.93317 0.666748 0.666504 3.93341 0.666504 8.00008C0.666504 12.0667 3.93317 15.3334 7.99984 15.3334C12.0665 15.3334 15.3332 12.0667 15.3332 8.00008C15.3332 3.93341 12.0665 0.666748 7.99984 0.666748Z"
          fill="#B9B9B9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3199_12676">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "icon-money-back-mono": (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1781 12.8015H12.5328L11.9437 14.9443C11.8923 15.136 11.7788 15.3051 11.6209 15.4253C11.4631 15.5456 11.2699 15.61 11.0715 15.6087H11.0707C10.6583 15.6087 10.3081 15.3412 10.1993 14.9443L9.26904 11.5669L8.33959 14.9443C8.28818 15.136 8.17468 15.3051 8.01686 15.4253C7.85904 15.5456 7.6658 15.61 7.46741 15.6087C7.05504 15.6087 6.70486 15.342 6.59523 14.9452L6.00532 12.8015H4.35995C4.16466 12.8015 3.97736 12.7239 3.83926 12.5858C3.70117 12.4478 3.62359 12.2605 3.62359 12.0652C3.62359 11.8699 3.70117 11.6826 3.83926 11.5445C3.97736 11.4064 4.16466 11.3288 4.35995 11.3288H5.60032L5.08404 9.45352C5.05549 9.35943 5.04607 9.26057 5.05634 9.16277C5.06661 9.06498 5.09637 8.97023 5.14385 8.88412C5.19133 8.79801 5.25558 8.72229 5.3328 8.66141C5.41002 8.60053 5.49866 8.55574 5.59347 8.52967C5.68829 8.50361 5.78736 8.49679 5.88485 8.50964C5.98234 8.52248 6.07627 8.55472 6.1611 8.60445C6.24593 8.65418 6.31994 8.7204 6.37876 8.7992C6.43758 8.878 6.48003 8.96778 6.50359 9.06325L7.46741 12.5634L8.39686 9.1868C8.44799 8.99495 8.56139 8.82552 8.71926 8.70513C8.87712 8.58473 9.07051 8.52018 9.26904 8.52161C9.68141 8.52161 10.0324 8.78916 10.1412 9.1868L11.0715 12.5634L12.0345 9.06325C12.0601 8.96999 12.1039 8.88268 12.1632 8.80633C12.2226 8.72997 12.2964 8.66606 12.3805 8.61823C12.4646 8.5704 12.5572 8.5396 12.6532 8.52759C12.7492 8.51557 12.8466 8.52258 12.9398 8.5482C13.0331 8.57383 13.1204 8.61757 13.1967 8.67694C13.2731 8.7363 13.337 8.81013 13.3848 8.89419C13.4327 8.97826 13.4635 9.07092 13.4755 9.16689C13.4875 9.26286 13.4805 9.36026 13.4549 9.45352L12.9378 11.3288H14.1781C14.3734 11.3288 14.5607 11.4064 14.6988 11.5445C14.8369 11.6826 14.9145 11.8699 14.9145 12.0652C14.9145 12.2605 14.8369 12.4478 14.6988 12.5858C14.5607 12.7239 14.3734 12.8015 14.1781 12.8015ZM9.26904 2.78125C2.99632 2.78125 0.269043 8.44716 0.269043 13.4176C0.269043 17.7812 3.62359 19.6903 9.26904 19.6903C14.9145 19.6903 18.269 17.5085 18.269 13.4176C18.269 8.44716 15.5418 2.78125 9.26904 2.78125Z"
        fill="#F4A35B"
      />
      <rect
        x="5.82568"
        y="1.06445"
        width="2.18182"
        height="5.45455"
        rx="1.09091"
        transform="rotate(-15 5.82568 1.06445)"
        fill="#F4A35B"
      />
      <rect
        x="7.57715"
        y="0.170898"
        width="3.39173"
        height="5.45455"
        rx="1.69586"
        transform="rotate(2.07522 7.57715 0.170898)"
        fill="#F4A35B"
      />
      <rect
        x="10.5181"
        y="0.598633"
        width="2.18182"
        height="5.45455"
        rx="1.09091"
        transform="rotate(15 10.5181 0.598633)"
        fill="#F4A35B"
      />
    </svg>
  ),

  "icon-pin-location-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99979 8.49463C7.7593 8.49925 7.52031 8.45587 7.29679 8.36703C7.07327 8.2782 6.86971 8.14568 6.698 7.97725C6.5263 7.80881 6.3899 7.60782 6.29679 7.38605C6.20368 7.16427 6.15572 6.92616 6.15572 6.68563C6.15572 6.44511 6.20368 6.20699 6.29679 5.98522C6.3899 5.76344 6.5263 5.56246 6.698 5.39402C6.86971 5.22558 7.07327 5.09307 7.29679 5.00423C7.52031 4.9154 7.7593 4.87202 7.99979 4.87663C8.47355 4.88573 8.92484 5.08032 9.25667 5.41858C9.5885 5.75684 9.77439 6.21178 9.77439 6.68563C9.77439 7.15948 9.5885 7.61442 9.25667 7.95269C8.92484 8.29095 8.47355 8.48554 7.99979 8.49463M6.58379 0.6913C3.73712 1.32663 1.74112 4.00597 1.85312 6.92063C1.94112 9.20997 3.34579 11.258 7.52512 15.276C7.78912 15.5293 8.21179 15.5306 8.47645 15.2766C12.7991 11.1213 14.1538 9.0733 14.1538 6.6853C14.1538 2.8253 10.5985 -0.2047 6.58379 0.691967"
        fill="#B9B9B9"
      />
    </svg>
  ),
  "icon-money-out-mono": (
    <svg
      width="53"
      height="52"
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.4998 28.8166H34.978L33.3725 34.6493C33.2488 35.1112 32.9753 35.5189 32.595 35.8087C32.2146 36.0984 31.7489 36.2538 31.2708 36.2505C30.7929 36.2541 30.3273 36.0987 29.9473 35.8089C29.5672 35.5191 29.2943 35.1112 29.1713 34.6493L26.4998 24.947L23.8305 34.6493C23.7072 35.111 23.4341 35.5187 23.0542 35.8085C22.6742 36.0982 22.2088 36.2537 21.731 36.2505H21.7288C21.251 36.2539 20.7855 36.0989 20.4052 35.8095C20.0249 35.5202 19.7513 35.1129 19.6271 34.6515L18.0216 28.8166H13.4998C13.0401 28.8166 12.5992 28.634 12.2742 28.309C11.9491 27.9839 11.7665 27.543 11.7665 27.0833C11.7665 26.6236 11.9491 26.1827 12.2742 25.8577C12.5992 25.5326 13.0401 25.35 13.4998 25.35H17.0661L15.6253 20.1088C15.5568 19.887 15.5336 19.6537 15.5571 19.4227C15.5805 19.1917 15.6501 18.9678 15.7617 18.7643C15.8733 18.5607 16.0247 18.3817 16.2068 18.2377C16.389 18.0938 16.5982 17.9879 16.822 17.9264C17.0458 17.8648 17.2798 17.8489 17.5099 17.8794C17.74 17.91 17.9617 17.9865 18.1616 18.1044C18.3616 18.2223 18.5359 18.3791 18.6742 18.5656C18.8124 18.7521 18.9117 18.9645 18.9663 19.1901L21.7288 29.2196L24.3981 19.5173C24.5219 19.0555 24.7953 18.6477 25.1756 18.3579C25.556 18.0682 26.0217 17.9128 26.4998 17.9161C27.4921 17.9161 28.3371 18.5596 28.6015 19.5173L31.2708 29.2196L34.0333 19.1901C34.1551 18.7468 34.4481 18.37 34.8477 18.1427C35.0456 18.0301 35.2637 17.9576 35.4896 17.9294C35.7155 17.9011 35.9447 17.9176 36.1642 17.9779C36.3837 18.0382 36.5892 18.1412 36.7689 18.2809C36.9487 18.4206 37.0991 18.5944 37.2117 18.7923C37.3242 18.9902 37.3967 19.2083 37.425 19.4342C37.4533 19.66 37.4368 19.8893 37.3765 20.1088L35.9335 25.35H39.4998C39.7274 25.35 39.9528 25.3948 40.1631 25.4819C40.3734 25.569 40.5645 25.6967 40.7255 25.8577C40.8864 26.0186 41.0141 26.2097 41.1012 26.42C41.1883 26.6303 41.2331 26.8557 41.2331 27.0833C41.2331 27.3109 41.1883 27.5363 41.1012 27.7466C41.0141 27.9569 40.8864 28.148 40.7255 28.309C40.5645 28.4699 40.3734 28.5976 40.1631 28.6847C39.9528 28.7718 39.7274 28.8166 39.4998 28.8166ZM45.9998 4.21631H6.9998C6.48263 4.21631 5.98664 4.42175 5.62095 4.78745C5.25525 5.15315 5.0498 5.64914 5.0498 6.16631C5.0498 6.68348 5.25525 7.17947 5.62095 7.54517C5.98664 7.91086 6.48263 8.11631 6.9998 8.11631V45.1663C6.9998 45.7409 7.22808 46.292 7.63441 46.6984C8.04074 47.1047 8.59184 47.333 9.16647 47.333H43.8331C44.4078 47.333 44.9589 47.1047 45.3652 46.6984C45.7715 46.292 45.9998 45.7409 45.9998 45.1663V8.11631C46.517 8.11631 47.013 7.91086 47.3787 7.54517C47.7444 7.17947 47.9498 6.68348 47.9498 6.16631C47.9498 5.64914 47.7444 5.15315 47.3787 4.78745C47.013 4.42175 46.517 4.21631 45.9998 4.21631Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-car-solid": (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3248_7400)">
        <path
          d="M50.7804 17.875H44.6998L43.0098 13.65C41.2731 9.30617 37.1283 6.5 32.4493 6.5H19.5509C14.8729 6.5 10.7272 9.30617 8.98942 13.65L7.29942 17.875H1.21988C0.426682 17.875 -0.155272 18.6205 0.037697 19.3893L0.647072 21.8268C0.78215 22.3691 1.26965 22.75 1.82926 22.75H3.86762C2.50363 23.9413 1.62512 25.673 1.62512 27.625V32.5C1.62512 34.1372 2.25074 35.6149 3.25012 36.7585V42.25C3.25012 44.0446 4.70551 45.5 6.50012 45.5H9.75012C11.5447 45.5 13.0001 44.0446 13.0001 42.25V39H39.0001V42.25C39.0001 44.0446 40.4555 45.5 42.2501 45.5H45.5001C47.2947 45.5 48.7501 44.0446 48.7501 42.25V36.7585C49.7495 35.6159 50.3751 34.1382 50.3751 32.5V27.625C50.3751 25.673 49.4966 23.9413 48.1336 22.75H50.172C50.7316 22.75 51.2191 22.3691 51.3542 21.8268L51.9636 19.3893C52.1555 18.6205 51.5736 17.875 50.7804 17.875ZM15.0243 16.0641C15.7647 14.2137 17.5572 13 19.5509 13H32.4493C34.443 13 36.2356 14.2137 36.976 16.0641L39.0001 21.125H13.0001L15.0243 16.0641ZM9.75012 32.4797C7.80012 32.4797 6.50012 31.1838 6.50012 29.2398C6.50012 27.2959 7.80012 26 9.75012 26C11.7001 26 14.6251 28.9159 14.6251 30.8598C14.6251 32.8037 11.7001 32.4797 9.75012 32.4797ZM42.2501 32.4797C40.3001 32.4797 37.3751 32.8037 37.3751 30.8598C37.3751 28.9159 40.3001 26 42.2501 26C44.2001 26 45.5001 27.2959 45.5001 29.2398C45.5001 31.1838 44.2001 32.4797 42.2501 32.4797Z"
          fill="#CCCCCC"
        />
      </g>
      <defs>
        <clipPath id="clip0_3248_7400">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-question-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3251_7451)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4025 6.83002C10.2112 7.66269 9.63784 8.02935 9.2185 8.29802C8.7845 8.57535 8.6345 8.69135 8.6345 9.08402C8.6345 9.24315 8.57129 9.39576 8.45877 9.50828C8.34625 9.62081 8.19363 9.68402 8.0345 9.68402C7.87537 9.68402 7.72276 9.62081 7.61024 9.50828C7.49772 9.39576 7.4345 9.24315 7.4345 9.08402C7.4345 8.01402 8.09184 7.59402 8.57184 7.28669C8.95317 7.04335 9.15517 6.90002 9.23317 6.56135C9.3005 6.26735 9.24717 6.00735 9.07317 5.78869C8.84517 5.50269 8.43784 5.31735 8.0345 5.31735C7.3825 5.31735 6.85184 5.84869 6.85184 6.50069C6.85184 6.65982 6.78862 6.81243 6.6761 6.92495C6.56358 7.03747 6.41097 7.10069 6.25184 7.10069C6.09271 7.10069 5.94009 7.03747 5.82757 6.92495C5.71505 6.81243 5.65184 6.65982 5.65184 6.50069C5.65254 5.86898 5.9038 5.26335 6.35048 4.81667C6.79717 4.36998 7.4028 4.11873 8.0345 4.11802C8.8005 4.11802 9.55784 4.47135 10.0118 5.04135C10.4132 5.54535 10.5518 6.18069 10.4025 6.83002ZM8.04517 11.9894C7.833 11.9894 7.62951 11.9051 7.47949 11.755C7.32946 11.605 7.24517 11.4015 7.24517 11.1894C7.24517 10.9772 7.32946 10.7737 7.47949 10.6237C7.62951 10.4736 7.833 10.3894 8.04517 10.3894C8.25734 10.3894 8.46083 10.4736 8.61086 10.6237C8.76089 10.7737 8.84517 10.9772 8.84517 11.1894C8.84517 11.4015 8.76089 11.605 8.61086 11.755C8.46083 11.9051 8.25734 11.9894 8.04517 11.9894ZM7.99984 0.666687C3.94917 0.666687 0.666504 3.95002 0.666504 8.00002C0.666504 12.0507 3.94917 15.3334 7.99984 15.3334C12.0498 15.3334 15.3332 12.0507 15.3332 8.00002C15.3332 3.95002 12.0498 0.666687 7.99984 0.666687Z"
          fill="#8F8F8F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3251_7451">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-double-arrow-mono": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 28.5L9 19.5L10.575 17.925L18 25.35L25.425 17.925L27 19.5L18 28.5ZM18 19.0125L9 10.0125L10.575 8.4375L18 15.8625L25.425 8.4375L27 10.0125L18 19.0125Z"
        fill="#3D3D3D"
      />
    </svg>
  ),
  "icon-quote-mono": (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9976 5.31761C6.60479 8.13874 4.16437 11.4223 3.67637 15.1683C2.91667 21 8.13178 23.8544 10.7742 21.2897C13.4167 18.725 11.8327 15.4697 9.91929 14.5799C8.0059 13.69 6.83579 14 7.0399 12.8108C7.244 11.6218 9.96619 8.32489 12.3577 6.78949C12.5164 6.65457 12.5768 6.39277 12.424 6.19414C12.3235 6.06354 12.1264 5.80736 11.8327 5.42561C11.5758 5.09179 11.3298 5.10429 10.9976 5.31761Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5625 5.31761C18.1698 8.13874 15.7293 11.4223 15.2413 15.1683C14.4816 21 19.6967 23.8544 22.3392 21.2897C24.9816 18.725 23.3976 15.4697 21.4843 14.5799C19.5709 13.69 18.4007 14 18.6049 12.8108C18.809 11.6218 21.5312 8.32489 23.9227 6.78949C24.0814 6.65457 24.1417 6.39277 23.9889 6.19414C23.8885 6.06354 23.6914 5.80736 23.3976 5.42561C23.1408 5.09179 22.8948 5.10429 22.5625 5.31761Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-filter-mono": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0782 3.44999C11.2631 3.45599 11.4384 3.53364 11.567 3.66654C11.6957 3.79943 11.7676 3.97715 11.7676 4.16211C11.7676 4.34708 11.6957 4.52479 11.567 4.65769C11.4384 4.79058 11.2631 4.86824 11.0782 4.87424C10.8934 4.86824 10.7181 4.79058 10.5894 4.65769C10.4608 4.52479 10.3889 4.34708 10.3889 4.16211C10.3889 3.97715 10.4608 3.79943 10.5894 3.66654C10.7181 3.53364 10.8934 3.45599 11.0782 3.44999ZM2.62499 4.98674H8.87249C9.03987 5.43712 9.34077 5.82566 9.73494 6.10041C10.1291 6.37516 10.5978 6.52303 11.0782 6.52424C11.5586 6.52288 12.0271 6.37494 12.4211 6.1002C12.8151 5.82545 13.1159 5.437 13.2832 4.98674H15.375C15.5938 4.98674 15.8036 4.89982 15.9584 4.7451C16.1131 4.59038 16.2 4.38054 16.2 4.16174C16.2 3.94293 16.1131 3.73309 15.9584 3.57837C15.8036 3.42366 15.5938 3.33674 15.375 3.33674H13.2832C13.1158 2.88662 12.8149 2.49832 12.4209 2.22372C12.0269 1.94912 11.5585 1.80129 11.0782 1.79999C10.5979 1.80135 10.1294 1.94919 9.73529 2.22377C9.34117 2.49836 9.04018 2.88662 8.87249 3.33674H2.62499C2.40618 3.33674 2.19634 3.42366 2.04162 3.57837C1.88691 3.73309 1.79999 3.94293 1.79999 4.16174C1.79999 4.38054 1.88691 4.59038 2.04162 4.7451C2.19634 4.89982 2.40618 4.98674 2.62499 4.98674ZM15.375 8.17424H2.62499C2.40618 8.17424 2.19634 8.26116 2.04162 8.41587C1.88691 8.57059 1.79999 8.78043 1.79999 8.99924C1.79999 9.21804 1.88691 9.42788 2.04162 9.5826C2.19634 9.73732 2.40618 9.82424 2.62499 9.82424H15.375C15.5938 9.82424 15.8036 9.73732 15.9584 9.5826C16.1131 9.42788 16.2 9.21804 16.2 8.99924C16.2 8.78043 16.1131 8.57059 15.9584 8.41587C15.8036 8.26116 15.5938 8.17424 15.375 8.17424ZM6.92174 14.55C6.73862 14.5416 6.56579 14.4629 6.43918 14.3304C6.31257 14.1978 6.24192 14.0215 6.24192 13.8382C6.24192 13.6549 6.31257 13.4787 6.43918 13.3461C6.56579 13.2136 6.73862 13.1349 6.92174 13.1265C7.10661 13.1325 7.28189 13.2101 7.41054 13.343C7.5392 13.4759 7.61112 13.6536 7.61112 13.8386C7.61112 14.0236 7.5392 14.2013 7.41054 14.3342C7.28189 14.4671 7.10661 14.5447 6.92174 14.5507M15.375 13.0125H9.12749C8.9601 12.5621 8.65921 12.1736 8.26504 11.8988C7.87087 11.6241 7.40221 11.4762 6.92174 11.475C6.44139 11.4763 5.9729 11.6243 5.57888 11.899C5.18486 12.1738 4.88408 12.5622 4.71674 13.0125H2.62499C2.40618 13.0125 2.19634 13.0994 2.04162 13.2541C1.88691 13.4088 1.79999 13.6187 1.79999 13.8375C1.79999 14.0563 1.88691 14.2661 2.04162 14.4209C2.19634 14.5756 2.40618 14.6625 2.62499 14.6625H4.71674C4.88408 15.1127 5.18486 15.5012 5.57888 15.7759C5.9729 16.0507 6.44139 16.1986 6.92174 16.2C7.40216 16.1986 7.87072 16.0506 8.26485 15.7759C8.65898 15.5012 8.95992 15.1127 9.12749 14.6625H15.375C15.5938 14.6625 15.8036 14.5756 15.9584 14.4209C16.1131 14.2661 16.2 14.0563 16.2 13.8375C16.2 13.6187 16.1131 13.4088 15.9584 13.2541C15.8036 13.0994 15.5938 13.0125 15.375 13.0125Z"
        fill="#686868"
      />
    </svg>
  ),
  "funeral-hall": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.28751 10.3863C8.35413 10.3205 8.39162 10.2308 8.39162 10.1372V5.67456C8.39162 4.98832 8.94663 4.43331 9.63287 4.43331H17.5345C18.2206 4.43331 18.775 4.98821 18.775 5.67377V19.125C18.775 19.2421 18.7284 19.3545 18.6456 19.4373C18.5628 19.5201 18.4504 19.5666 18.3333 19.5666H5.66662C5.54948 19.5666 5.43714 19.5201 5.35431 19.4373C5.27149 19.3545 5.22495 19.2421 5.22495 19.125V15.1666C5.22495 14.9735 5.06851 14.8169 4.87537 14.8166C4.78785 14.8165 4.70234 14.7904 4.62968 14.7417C4.55703 14.6929 4.5005 14.6236 4.46728 14.5426L4.14348 14.6755L4.46728 14.5426C4.43406 14.4617 4.42565 14.3727 4.4431 14.2869C4.46056 14.2011 4.5031 14.1225 4.56532 14.061L8.28751 10.3863ZM11.1465 18.6833C11.3398 18.6833 11.4965 18.5266 11.4965 18.3333V14.4629V13.9681C11.4965 13.8766 11.4608 13.7888 11.3968 13.7234L9.0733 11.3461C9.0082 11.2794 8.91925 11.2415 8.82612 11.2407C8.73299 11.2399 8.64337 11.2762 8.5771 11.3416L6.21239 13.6762C6.14578 13.742 6.10829 13.8317 6.10829 13.9253V18.3333C6.10829 18.5266 6.26499 18.6833 6.45829 18.6833H11.1465ZM12.7916 9.97498C12.9849 9.97498 13.1416 9.81828 13.1416 9.62498V8.04165C13.1416 7.84835 12.9849 7.69165 12.7916 7.69165H11.2083C11.015 7.69165 10.8583 7.84835 10.8583 8.04165V9.62498C10.8583 9.81828 11.015 9.97498 11.2083 9.97498H12.7916ZM15.9583 16.3083C16.1516 16.3083 16.3083 16.1516 16.3083 15.9583V14.375C16.3083 14.1817 16.1516 14.025 15.9583 14.025H14.375C14.1817 14.025 14.025 14.1817 14.025 14.375V15.9583C14.025 16.1516 14.1817 16.3083 14.375 16.3083H15.9583ZM15.9583 13.1416C16.1516 13.1416 16.3083 12.9849 16.3083 12.7916V11.2083C16.3083 11.015 16.1516 10.8583 15.9583 10.8583H14.375C14.1817 10.8583 14.025 11.015 14.025 11.2083V12.7916C14.025 12.9849 14.1817 13.1416 14.375 13.1416H15.9583ZM15.9583 9.97498C16.1516 9.97498 16.3083 9.81828 16.3083 9.62498V8.04165C16.3083 7.84835 16.1516 7.69165 15.9583 7.69165H14.375C14.1817 7.69165 14.025 7.84835 14.025 8.04165V9.62498C14.025 9.81828 14.1817 9.97498 14.375 9.97498H15.9583Z"
        fill="white"
        stroke="white"
        strokeWidth="0.7"
        strokeLinejoin="round"
      />
      <path
        d="M8.29175 14.625H9.37508V15.7083H8.29175V14.625Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Q: (
    <svg
      width="80"
      height="94"
      viewBox="0 0 80 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.7962 57.1814H49.0399L55.5391 65.5277C59.616 60.7922 61.9793 53.5113 61.9202 44.0403C61.9793 25.6902 53.2349 15.8048 40.0591 15.7456C26.7651 15.8048 18.0798 25.6902 18.0798 44.0403C18.0798 62.3312 26.7651 72.2758 40.0591 72.335C41.7725 72.335 43.4269 72.1574 44.9631 71.8023L33.7962 57.1814ZM0 44.0403C0 16.0416 17.2526 0 40.0591 0C62.6883 0 80 16.0416 80 44.0403C80 59.3715 74.8006 71.0919 66.4106 78.6096L78.582 94H61.9202L55.0665 85.4761C50.4579 87.1927 45.3767 88.0806 40.0591 88.0806C17.2526 88.0806 0 71.9207 0 44.0403Z"
        fill="#E9E9E9"
      />
    </svg>
  ),
  linearrowFat: (
    <svg
      width="65"
      height="32"
      viewBox="0 0 65 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.0001 15.9856L48.876 0L45.3144 3.53101L54.8328 12.9677H0V18.6582H55.2101L45.3145 28.4688L48.8761 31.9998L65.0002 16.0142L64.9857 15.9998L65.0001 15.9856Z"
        fill="#252525"
      />
    </svg>
  ),
  send_outline: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4137_15325)">
        <path
          d="M19.3331 0.665754L19.9464 0.92842C19.9992 0.805862 20.014 0.670283 19.9889 0.539227C19.9637 0.40817 19.8999 0.287667 19.8055 0.193309C19.7112 0.0989517 19.5907 0.0350819 19.4596 0.00996403C19.3285 -0.0151539 19.193 -0.000363842 19.0704 0.0524204L19.3331 0.665754ZM0.666404 8.66575L0.403738 8.05242C0.290675 8.10073 0.193174 8.17937 0.122017 8.27964C0.050859 8.37991 0.00881628 8.4979 0.000536876 8.62057C-0.00774253 8.74325 0.018064 8.86582 0.0751031 8.97474C0.132142 9.08366 0.218192 9.17469 0.323738 9.23775L0.666404 8.66575ZM11.3331 19.3324L10.7611 19.6751C10.8241 19.7806 10.9152 19.8667 11.0241 19.9237C11.133 19.9808 11.2556 20.0066 11.3783 19.9983C11.5009 19.99 11.6189 19.948 11.7192 19.8768C11.8195 19.8057 11.8981 19.7082 11.9464 19.5951L11.3331 19.3324ZM19.0704 0.0524204L0.403738 8.05242L0.929071 9.27909L19.5957 1.27909L19.0704 0.0524204ZM0.323738 9.23775L6.99041 13.2391L7.67574 12.0951L1.00907 8.09509L0.323738 9.23775ZM6.75974 13.0084L10.7597 19.6751L11.9037 18.9898L7.90374 12.3231L6.75974 13.0084ZM11.9451 19.5951L19.9451 0.92842L18.7184 0.403087L10.7184 19.0698L11.9451 19.5951ZM18.8611 0.195087L6.86107 12.1951L7.80507 13.1378L19.8051 1.13775L18.8611 0.193754V0.195087Z"
          fill="#3B6EBF"
        />
      </g>
      <defs>
        <clipPath id="clip0_4137_15325">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  drawer_next: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14686 18.8644C8.19329 18.9074 8.24845 18.9415 8.30918 18.9648C8.36991 18.988 8.43502 19 8.50077 19C8.56652 19 8.63162 18.988 8.69235 18.9648C8.75308 18.9415 8.80824 18.9074 8.85468 18.8644L14.8531 13.3266C14.8997 13.2837 14.9366 13.2328 14.9618 13.1768C14.987 13.1207 15 13.0606 15 12.9999C15 12.9392 14.987 12.8791 14.9618 12.823C14.9366 12.7669 14.8997 12.716 14.8531 12.6731L8.85468 7.13534C8.76081 7.04868 8.63351 7 8.50077 7C8.36802 7 8.24072 7.04868 8.14686 7.13534C8.05299 7.22199 8.00026 7.33952 8.00026 7.46207C8.00026 7.58461 8.05299 7.70214 8.14686 7.7888L13.7924 12.9999L8.14686 18.211C8.1003 18.2538 8.06337 18.3048 8.03817 18.3608C8.01297 18.4169 8 18.477 8 18.5377C8 18.5984 8.01297 18.6585 8.03817 18.7146C8.06337 18.7706 8.1003 18.8216 8.14686 18.8644Z"
        fill="#999999"
      />
    </svg>
  ),
  drawer_home: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5971 18.278H13.0971V18.778V25.4446C13.0971 25.9018 12.721 26.278 12.2638 26.278H8.2638C7.80661 26.278 7.43047 25.9018 7.43047 25.4446V16.1113V15.6113H6.93047H4.6638C4.61786 15.6113 4.58896 15.5983 4.56872 15.5834C4.54583 15.5666 4.52485 15.5401 4.51197 15.5057C4.48639 15.4375 4.5007 15.3738 4.55461 15.3262L4.55463 15.3262L4.55843 15.3228L15.7039 5.28391C15.7041 5.28374 15.7042 5.28358 15.7044 5.28341C16.0211 5.00058 16.5065 5.00058 16.8232 5.28341C16.8234 5.28358 16.8236 5.28374 16.8237 5.28391L27.9692 15.3228L27.9691 15.3229L27.9784 15.3309C28.0128 15.3604 28.0252 15.3878 28.0303 15.4105C28.0361 15.4365 28.0346 15.4691 28.0217 15.5029C27.9963 15.5695 27.9423 15.6113 27.8638 15.6113H25.5971H25.0971V16.1113V25.4446C25.0971 25.9018 24.721 26.278 24.2638 26.278H20.2638C19.8066 26.278 19.4305 25.9018 19.4305 25.4446V18.778V18.278H18.9305H13.5971Z"
        fill="#252525"
        stroke="#252525"
      />
    </svg>
  ),
  book: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.012 18H21V4C21 3.46957 20.7893 2.96086 20.4142 2.58579C20.0391 2.21071 19.5304 2 19 2H6C4.794 2 3 2.799 3 5V19C3 21.201 4.794 22 6 22H21V20H6.012C5.55 19.988 5 19.805 5 19C5 18.195 5.55 18.012 6.012 18ZM8 6H17V8H8V6Z"
        fill="#252525"
      />
    </svg>
  ),
  book_has_bookmark: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7C6 5.34314 7.34315 4 9 4H24C25.1046 4 26 4.89543 26 6V25.3103C26 26.4149 25.1046 27.3103 24 27.3103H8C6.89543 27.3103 6 26.4149 6 25.3103V7Z"
        fill="#F18334"
      />
      <rect
        x="10.5454"
        y="7.58618"
        width="11.8182"
        height="4.48276"
        rx="1"
        fill="#FDECDD"
      />
      <path
        d="M6 25.5172C6 23.7842 7.4049 22.3793 9.13793 22.3793H26V26.6551C26 27.7597 25.1046 28.6551 24 28.6551H9.13793C7.4049 28.6551 6 27.2502 6 25.5172Z"
        fill="#F18334"
      />
      <path
        d="M7.36353 25.069C7.36353 23.8311 8.36703 22.8276 9.6049 22.8276H24.2068C25.1971 22.8276 25.9999 22.0248 25.9999 21.0345V25.3104C25.9999 26.415 25.1045 27.3104 23.9999 27.3104H9.60491C8.36703 27.3104 7.36353 26.3069 7.36353 25.069Z"
        fill="#FDECDD"
      />
      <path
        d="M18 25H23V29.2615C23 29.6152 22.6427 29.8571 22.3143 29.7257L20.8714 29.1486C20.633 29.0532 20.367 29.0532 20.1286 29.1486L18.6857 29.7257C18.3573 29.8571 18 29.6152 18 29.2615V25Z"
        fill="#753C08"
      />
    </svg>
  ),
  drawer_guidebook: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_972_14215)">
        <path
          d="M16.0571 26.1429V9.98947C16.0571 8.89462 15.5458 6.71436 12.9894 6.71436H6.34277V24.2518H13.5865C14.7053 24.2518 15.7028 25.0083 16.0664 26.1429H16.0571Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0572 26.1429V9.98947C16.0572 8.35191 17.0797 6.71436 19.1248 6.71436H25.7715V24.2518H18.5277C17.409 24.2518 16.4114 25.0083 16.0479 26.1429H16.0572Z"
          fill="#252525"
          stroke="#252525"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="16"
          y1="12.5"
          x2="16"
          y2="19.5"
          stroke="white"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_972_14215">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  drawer_estimate: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <path
        className="st0"
        d="M24.3,6.3h-2.9V8c0,0.6-0.4,1-1,1h-8.9c-0.6,0-1-0.4-1-1V6.3H7.7c-0.6,0-1,0.4-1,1v19.4c0,0.6,0.4,1,1,1h16.7
	c0.6,0,1-0.4,1-1V7.3C25.3,6.7,24.9,6.3,24.3,6.3z M16,21.7h-3.7c-0.4,0-0.6-0.3-0.6-0.7s0.3-0.7,0.6-0.7H16c0.4,0,0.6,0.3,0.6,0.7
	S16.3,21.7,16,21.7z M19.7,18.2h-7.4c-0.4,0-0.6-0.3-0.6-0.7s0.3-0.6,0.6-0.6h7.4c0.4,0,0.7,0.3,0.7,0.6S20.1,18.2,19.7,18.2z
	 M19.7,14.6h-7.4c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h7.4c0.4,0,0.7,0.3,0.7,0.6S20.1,14.6,19.7,14.6z"
      />
      <g>
        <rect
          x="11.9"
          y="5.6"
          className="st1"
          width="8.3"
          height="2.1"
          style={{ fill: "none" }}
        />
        <path
          className="st0"
          style={{ fill: "#252525" }}
          d="M20.4,4.3h-8.9c-0.6,0-1,0.4-1,1v1V8c0,0.6,0.4,1,1,1h8.9c0.6,0,1-0.4,1-1V6.3v-1C21.4,4.8,21,4.3,20.4,4.3z
		 M20.1,7.7h-8.3V5.6h8.3V7.7z"
        />
      </g>
    </svg>
  ),
  drawer_review: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <path
        style={{ fill: "#252525" }}
        d="M26.4,8.8C26.2,8.4,26,8,25.7,7.7s-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.3-1.3-0.3H8.8C7.9,6.7,7,7,6.3,7.7
	c-0.7,0.6-1,1.5-1,2.4V19c0,0.9,0.4,1.8,1,2.4c0.7,0.6,1.5,1,2.5,1h0.8v3.2c0,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.3,0.4,0.4
	c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4-0.1,0.5-0.2l5.7-4h6.2c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.4,1.1-0.7c0.3-0.3,0.6-0.7,0.8-1.1
	c0.2-0.4,0.3-0.9,0.3-1.3v-8.9C26.7,9.6,26.6,9.2,26.4,8.8z M13.1,15.1c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6
	S13.4,15.1,13.1,15.1z M16,15.1c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6S16.3,15.1,16,15.1z M18.8,15.1
	c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6S19.2,15.1,18.8,15.1z"
      />
    </svg>
  ),
  drawer_funeral_director: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.375 25.75C14.375 25.75 12.75 25.75 12.75 24.125C12.75 22.5 14.375 17.625 20.875 17.625C27.375 17.625 29 22.5 29 24.125C29 25.75 27.375 25.75 27.375 25.75H14.375ZM20.875 16C22.1679 16 23.4079 15.4864 24.3221 14.5721C25.2364 13.6579 25.75 12.4179 25.75 11.125C25.75 9.83207 25.2364 8.59209 24.3221 7.67785C23.4079 6.76361 22.1679 6.25 20.875 6.25C19.5821 6.25 18.3421 6.76361 17.4279 7.67785C16.5136 8.59209 16 9.83207 16 11.125C16 12.4179 16.5136 13.6579 17.4279 14.5721C18.3421 15.4864 19.5821 16 20.875 16Z"
        fill="#252525"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.476 25.75C11.2351 25.2427 11.115 24.6865 11.125 24.125C11.125 21.9231 12.23 19.6562 14.271 18.08C13.2523 17.7661 12.1909 17.6126 11.125 17.625C4.625 17.625 3 22.5 3 24.125C3 25.75 4.625 25.75 4.625 25.75H11.476Z"
        fill="#252525"
      />
      <path
        d="M10.3125 16C11.3899 16 12.4233 15.572 13.1851 14.8101C13.947 14.0483 14.375 13.0149 14.375 11.9375C14.375 10.8601 13.947 9.82675 13.1851 9.06488C12.4233 8.30301 11.3899 7.875 10.3125 7.875C9.23506 7.875 8.20175 8.30301 7.43988 9.06488C6.67801 9.82675 6.25 10.8601 6.25 11.9375C6.25 13.0149 6.67801 14.0483 7.43988 14.8101C8.20175 15.572 9.23506 16 10.3125 16Z"
        fill="#252525"
      />
    </svg>
  ),
  drawer_account: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16C17.3261 16 18.5979 15.4732 19.5355 14.5355C20.4732 13.5979 21 12.3261 21 11C21 9.67392 20.4732 8.40215 19.5355 7.46447C18.5979 6.52678 17.3261 6 16 6C14.6739 6 13.4021 6.52678 12.4645 7.46447C11.5268 8.40215 11 9.67392 11 11C11 12.3261 11.5268 13.5979 12.4645 14.5355C13.4021 15.4732 14.6739 16 16 16ZM26 24.3333C26 26 24.3333 26 24.3333 26H7.66667C7.66667 26 6 26 6 24.3333C6 22.6667 7.66667 17.6667 16 17.6667C24.3333 17.6667 26 22.6667 26 24.3333Z"
        fill="#252525"
      />
    </svg>
  ),
  drawer_search: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667Z"
        fill="#252525"
      />
    </svg>
  ),
  drawer_goi_icon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="26" height="26" rx="4" fill="black" />
      <path
        d="M16.9455 13.6365H15.6456V14.9366H16.9455H18.2456V11.0366V9.98933V9.73657H11.7456V11.0366H16.9455V13.6365Z"
        fill="white"
      />
      <path
        d="M16.9453 16.2366C16.4311 16.2366 15.9284 16.3891 15.5009 16.6748C15.0733 16.9604 14.74 17.3665 14.5433 17.8416C14.3465 18.3167 14.295 18.8395 14.3953 19.3438C14.4956 19.8482 14.7432 20.3114 15.1069 20.675C15.4705 21.0387 15.9338 21.2863 16.4381 21.3866C16.9425 21.4869 17.4652 21.4354 17.9403 21.2387C18.4154 21.0419 18.8215 20.7086 19.1072 20.2811C19.3928 19.8535 19.5453 19.3508 19.5453 18.8366C19.5453 18.147 19.2714 17.4857 18.7838 16.9981C18.2962 16.5105 17.6349 16.2366 16.9453 16.2366ZM16.9453 20.2653C16.6628 20.2653 16.3865 20.1815 16.1515 20.0245C15.9166 19.8675 15.7335 19.6444 15.6253 19.3833C15.5172 19.1222 15.4889 18.8349 15.544 18.5578C15.5992 18.2806 15.7353 18.026 15.9351 17.8262C16.1349 17.6264 16.3895 17.4904 16.6667 17.4353C16.9439 17.3801 17.2311 17.4085 17.4922 17.5166C17.7533 17.6248 17.9764 17.8079 18.1334 18.0429C18.2904 18.2779 18.3741 18.5541 18.3741 18.8367C18.3741 19.2156 18.2235 19.579 17.9556 19.8469C17.6876 20.1148 17.3242 20.2653 16.9453 20.2653Z"
        fill="white"
      />
      <path
        d="M20.7886 13.6361H19.5456V15.0038H20.58C20.6327 15.0038 20.6832 15.0247 20.7205 15.062C20.7578 15.0993 20.7787 15.1499 20.7787 15.2026V22.7361H22.1456V14.9931C22.1456 14.915 22.1302 14.8376 22.1003 14.7654C22.0705 14.6933 22.0266 14.6277 21.9714 14.5725L21.2096 13.8104C21.1544 13.7551 21.0887 13.7112 21.0165 13.6813C20.9442 13.6514 20.8668 13.636 20.7886 13.6361Z"
        fill="white"
      />
      <path
        d="M14.3456 14.9473V12.3365H13.0479V14.7477C13.0479 14.7978 13.028 14.8459 12.9926 14.8814C12.9572 14.9169 12.9093 14.9368 12.8592 14.9368H9.14557V16.2365H13.0578C13.2076 16.2365 13.3512 16.1769 13.4571 16.0708L14.1802 15.3461C14.2858 15.2403 14.3452 15.0969 14.3456 14.9473Z"
        fill="white"
      />
    </svg>
  ),
  drawer_goi_service: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M21.3,6.7H10.7c-2.2,0-4,1.8-4,4v10.7c0,2.2,1.8,4,4,4h10.7c2.2,0,4-1.8,4-4V10.7C25.3,8.5,23.5,6.7,21.3,6.7z M12.9,11.5
		h4.7v0.2v0.8v2.8h-0.9h-0.9v-0.9h0.9v-1.9h-3.7V11.5z M14.8,15.2c0,0.1,0,0.2-0.1,0.3l-0.5,0.5c-0.1,0.1-0.2,0.1-0.3,0.1h-2.8v-0.9
		h2.7c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1v-1.7h0.9V15.2z M18.2,19.1c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.1-0.7,0.2-1.1,0.1
		c-0.4-0.1-0.7-0.2-1-0.5c-0.3-0.3-0.4-0.6-0.5-1c-0.1-0.4,0-0.7,0.1-1.1c0.1-0.3,0.4-0.6,0.7-0.8c0.3-0.2,0.7-0.3,1-0.3
		c0.5,0,1,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3C18.5,18.4,18.4,18.8,18.2,19.1z M20.4,20.8h-1v-5.4c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0
		h-0.7v-1h0.9c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1l0.5,0.5c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2V20.8z"
        />
        <path
          d="M17.1,17.1C16.9,17,16.7,17,16.5,17c-0.2,0-0.4,0.1-0.5,0.3c-0.1,0.1-0.2,0.3-0.3,0.5s0,0.4,0.1,0.6
		c0.1,0.2,0.2,0.3,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-0.2-0.1-0.4-0.2-0.6
		C17.4,17.3,17.3,17.2,17.1,17.1z"
        />
      </g>
    </svg>
  ),
  drawer_cs: (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3064 11.0946C20.9308 11.4518 21.4371 11.9817 21.7635 12.6198C22.0899 13.2579 22.2224 13.9765 22.1447 14.6881C22.067 15.3997 21.7826 16.0734 21.3261 16.6271C20.8696 17.1809 20.2607 17.5907 19.5738 17.8067C19.331 18.9011 18.7192 19.8804 17.8397 20.5824C16.9602 21.2844 15.8657 21.6669 14.7375 21.6667H12.8811C12.717 21.6667 12.5597 21.6019 12.4436 21.4867C12.3276 21.3714 12.2624 21.2151 12.2624 21.052C12.2624 20.889 12.3276 20.7327 12.4436 20.6174C12.5597 20.5022 12.717 20.4374 12.8811 20.4374H14.7375C15.5055 20.4376 16.2547 20.2013 16.8819 19.761C17.5091 19.3207 17.9835 18.698 18.2397 17.9788H17.8313C17.6672 17.9788 17.5098 17.914 17.3938 17.7987C17.2777 17.6835 17.2125 17.5271 17.2125 17.3641V11.2175C17.2125 11.0545 17.2777 10.8982 17.3938 10.7829C17.5098 10.6676 17.6672 10.6029 17.8313 10.6029H18.4501C18.6506 10.6029 18.8473 10.6189 19.0404 10.6496C18.9011 9.28615 18.2572 8.02261 17.2336 7.10378C16.21 6.18496 14.8795 5.67627 13.4999 5.67627C12.1203 5.67627 10.7898 6.18496 9.76619 7.10378C8.74259 8.02261 8.09876 9.28615 7.95945 10.6496C8.15467 10.6185 8.35206 10.6029 8.54976 10.6029H9.16853C9.33264 10.6029 9.49002 10.6676 9.60607 10.7829C9.72211 10.8982 9.7873 11.0545 9.7873 11.2175V17.3641C9.7873 17.5271 9.72211 17.6835 9.60607 17.7987C9.49002 17.914 9.33264 17.9788 9.16853 17.9788H8.54976C7.73172 17.9797 6.93629 17.7122 6.28704 17.2178C5.63779 16.7235 5.17109 16.03 4.95943 15.245C4.74778 14.4601 4.80302 13.6277 5.11659 12.8772C5.43016 12.1266 5.98449 11.5 6.69345 11.0946C6.69345 9.30141 7.41056 7.58167 8.68702 6.31369C9.96348 5.04572 11.6947 4.33337 13.4999 4.33337C15.3051 4.33337 17.0364 5.04572 18.3128 6.31369C19.5893 7.58167 20.3064 9.30141 20.3064 11.0946ZM8.54976 11.8322C7.89333 11.8322 7.26378 12.0912 6.79962 12.5523C6.33545 13.0134 6.07468 13.6388 6.07468 14.2908C6.07468 14.9429 6.33545 15.5683 6.79962 16.0293C7.26378 16.4904 7.89333 16.7494 8.54976 16.7494V11.8322ZM20.9252 14.2908C20.9252 13.6388 20.6644 13.0134 20.2002 12.5523C19.7361 12.0912 19.1065 11.8322 18.4501 11.8322V16.7494C19.1065 16.7494 19.7361 16.4904 20.2002 16.0293C20.6644 15.5683 20.9252 14.9429 20.9252 14.2908Z"
        fill="#40C057"
        stroke="#40C057"
        strokeWidth="0.3"
      />
      <circle cx="12.9587" cy="21.125" r="0.541667" stroke="#40C057" />
    </svg>
  ),
  "icon-tombstone-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_493_6678)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7333 13.4C14.6667 13 14.3333 12.7333 14 12.7333H13.6V6.6V6.4C13.5333 3.4 11.0667 1 8.06667 1C5 1 2.46667 3.46667 2.46667 6.6V12.7333H2.06667C1.66667 12.7333 1.33333 13 1.26667 13.4L1 15H15L14.7333 13.4ZM9.73333 7H8.66667V9.6C8.66667 10 8.4 10.2667 8 10.2667C7.6 10.2667 7.33333 10 7.33333 9.6V7H6.26667C5.86667 7 5.6 6.73333 5.6 6.33333C5.6 5.93333 5.86667 5.66667 6.26667 5.66667H7.33333V4.4C7.33333 4 7.6 3.73333 8 3.73333C8.4 3.73333 8.66667 4 8.66667 4.4V5.6H9.73333C10.1333 5.6 10.4 5.86667 10.4 6.26667C10.4 6.66667 10.1333 7 9.73333 7Z"
          fill="#BEB4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_493_6678">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "header-close": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5169 5.41841C17.8127 5.17916 18.249 5.19586 18.5247 5.46919C18.8004 5.74247 18.8176 6.17499 18.5765 6.46821L18.5247 6.52485L13.0032 11.9975L18.5306 17.476L18.5814 17.5327C18.8226 17.8258 18.806 18.2583 18.5306 18.5317C18.2548 18.805 17.8176 18.8217 17.5218 18.5825L17.4651 18.5317L11.9388 13.0532L6.53546 18.4106C6.24136 18.7021 5.76413 18.7021 5.47003 18.4106C5.17602 18.119 5.17599 17.6465 5.47003 17.3549L10.8733 11.9975L5.47491 6.64595C5.18122 6.35443 5.1811 5.88173 5.47491 5.59028C5.76898 5.29876 6.24623 5.29882 6.54034 5.59028L11.9388 10.9418L17.4603 5.46919L17.5169 5.41841Z"
        fill="#252525"
      />
    </svg>
  ),
  sangjo_panel: (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.375 6.3125H50.5C48.8263 6.31417 47.2217 6.97977 46.0382 8.16323C44.8548 9.3467 44.1892 10.9513 44.1875 12.625V44.1875H12.625C10.9513 44.1892 9.3467 44.8548 8.16323 46.0382C6.97977 47.2217 6.31417 48.8263 6.3125 50.5V94.6875H94.6875V12.625C94.6858 10.9513 94.0202 9.3467 92.8368 8.16323C91.6533 6.97977 90.0487 6.31417 88.375 6.3125ZM28.4062 88.375V66.2812H41.0312V88.375H28.4062ZM88.375 88.375H47.3438V63.125C47.3438 62.2879 47.0112 61.4851 46.4193 60.8932C45.8274 60.3013 45.0246 59.9688 44.1875 59.9688H25.25C24.4129 59.9688 23.6101 60.3013 23.0182 60.8932C22.4263 61.4851 22.0938 62.2879 22.0938 63.125V88.375H12.625V50.5H50.5V12.625H88.375V88.375Z"
        fill="white"
      />
      <path
        d="M56.8125 25.25H63.125V31.5625H56.8125V25.25ZM75.75 25.25H82.0625V31.5625H75.75V25.25ZM56.8125 44.1875H63.125V50.5H56.8125V44.1875ZM75.75 44.1875H82.0625V50.5H75.75V44.1875ZM56.8125 63.125H63.125V69.4375H56.8125V63.125ZM75.75 63.125H82.0625V69.4375H75.75V63.125Z"
        fill="white"
      />
    </svg>
  ),
  funeral_panel: (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.285 76.1875C78.1902 76.1875 79.8097 75.4882 81.1433 74.0896C82.477 72.6909 83.1438 71.039 83.1438 69.1338C83.1438 67.2286 82.477 65.6091 81.1433 64.2755C79.8097 62.9418 78.1902 62.275 76.285 62.275C74.3798 62.275 72.7279 62.9418 71.3292 64.2755C69.9306 65.6091 69.2313 67.2286 69.2313 69.1338C69.2313 71.039 69.9306 72.6909 71.3292 74.0896C72.7279 75.4882 74.3798 76.1875 76.285 76.1875ZM76.1324 89.9896C78.5983 89.9896 80.8251 89.4743 82.8126 88.4437C84.8001 87.4132 86.4931 85.9409 87.8917 84.0271C85.9779 82.9965 84.0654 82.2236 82.1543 81.7083C80.2433 81.193 78.2558 80.9354 76.1918 80.9354C74.1279 80.9354 72.1206 81.193 70.1699 81.7083C68.2192 82.2236 66.3237 82.9965 64.4834 84.0271C65.882 85.9409 67.5567 87.4132 69.5074 88.4437C71.4581 89.4743 73.6664 89.9896 76.1324 89.9896ZM53.0001 97.1666C42.8417 94.8111 34.4133 89.051 27.7147 79.8864C21.0161 70.7218 17.6667 60.2139 17.6667 48.3625V26.6104C17.6667 25.1929 18.067 23.9171 18.8675 22.7831C19.668 21.6491 20.7032 20.8269 21.973 20.3166L50.6813 9.60622C51.4911 9.31177 52.264 9.16455 53.0001 9.16455C53.7362 9.16455 54.5091 9.31177 55.3188 9.60622L84.0272 20.3166C85.297 20.8269 86.3321 21.6491 87.1326 22.7831C87.9332 23.9171 88.3334 25.1929 88.3334 26.6104V51.7854C87.3029 51.2701 86.1987 50.81 85.0209 50.4052C83.8431 50.0003 82.739 49.7243 81.7084 49.5771V26.6104L53.0001 16.0104L24.2917 26.6104V48.3625C24.2917 53.9569 25.1935 59.1097 26.997 63.8208C28.8004 68.5319 31.1008 72.6725 33.898 76.2427C36.6952 79.8128 39.7869 82.7757 43.173 85.1312C46.5591 87.4868 49.8348 89.1798 53.0001 90.2104C53.4417 91.0937 54.1042 92.0875 54.9876 93.1916C55.8709 94.2958 56.607 95.1423 57.1959 95.7312C56.5334 96.0993 55.8341 96.3753 55.098 96.5593C54.3619 96.7434 53.6626 96.9458 53.0001 97.1666ZM76.4636 97.1666C70.7588 97.1666 65.882 95.1239 61.8334 91.0385C57.7848 86.9531 55.7605 82.1132 55.7605 76.5187C55.7605 70.745 57.7844 65.8235 61.8323 61.7541C65.8802 57.6847 70.7757 55.65 76.5188 55.65C82.1869 55.65 87.0636 57.6847 91.149 61.7541C95.2344 65.8235 97.2772 70.745 97.2772 76.5187C97.2772 82.1132 95.2344 86.9531 91.149 91.0385C87.0636 95.1239 82.1685 97.1666 76.4636 97.1666Z"
        fill="white"
      />
    </svg>
  ),
  parlor_panel: (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 92.75C9.72868 92.75 8.83325 91.8546 8.83325 90.75V40.75C8.83325 40.1205 9.12964 39.5277 9.63325 39.15L42.3666 14.6C43.4333 13.8 44.8999 13.8 45.9666 14.6L70.6666 33.125C69.1944 33.125 67.7221 33.2906 66.2499 33.6219C64.7777 33.9531 63.4159 34.4132 62.1645 35.0021L44.1666 21.5312L15.4583 43.0625V86.125H36.5416C37.0939 86.125 37.5416 86.5727 37.5416 87.125V91.75C37.5416 92.3023 37.0939 92.75 36.5416 92.75H10.8333ZM44.1666 92.75V84.3583C44.1666 82.8125 44.553 81.3587 45.326 79.9969C46.0989 78.6351 47.1478 77.5493 48.4728 76.7396C51.859 74.7521 55.4107 73.2431 59.128 72.2125C62.8454 71.1819 66.6916 70.6667 70.6666 70.6667C74.6416 70.6667 78.4878 71.1819 82.2051 72.2125C85.9225 73.2431 89.4742 74.7521 92.8603 76.7396C94.1853 77.5493 95.2343 78.6351 96.0072 79.9969C96.7801 81.3587 97.1666 82.8125 97.1666 84.3583V92.75H44.1666ZM50.7916 86.125H90.5416V82.9229C87.4499 81.1562 84.2395 79.776 80.9103 78.7823C77.5811 77.7885 74.1665 77.2917 70.6666 77.2917C67.1667 77.2917 63.7521 77.8069 60.4229 78.8375C57.0937 79.8681 53.8833 81.2667 50.7916 83.0333V86.125ZM70.6666 66.25C66.986 66.25 63.8576 64.9618 61.2812 62.3854C58.7048 59.809 57.4166 56.6806 57.4166 53C57.4166 49.3194 58.7048 46.191 61.2812 43.6146C63.8576 41.0382 66.986 39.75 70.6666 39.75C74.3471 39.75 77.4756 41.0382 80.052 43.6146C82.6284 46.191 83.9166 49.3194 83.9166 53C83.9166 56.6806 82.6284 59.809 80.052 62.3854C77.4756 64.9618 74.3471 66.25 70.6666 66.25ZM70.6666 59.625C72.5437 59.625 74.1171 58.9901 75.3869 57.7203C76.6567 56.4505 77.2916 54.8771 77.2916 53C77.2916 51.1229 76.6567 49.5495 75.3869 48.2797C74.1171 47.0099 72.5437 46.375 70.6666 46.375C68.7895 46.375 67.2161 47.0099 65.9463 48.2797C64.6765 49.5495 64.0416 51.1229 64.0416 53C64.0416 54.8771 64.6765 56.4505 65.9463 57.7203C67.2161 58.9901 68.7895 59.625 70.6666 59.625Z"
        fill="white"
      />
    </svg>
  ),
  funeral_ex: (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15417 84.1667C6.24237 84.1667 5.48838 83.8686 4.8922 83.2724C4.29602 82.6762 3.99792 81.9222 3.99792 81.0104V74.2771C3.99792 71.8222 4.62917 69.5953 5.89167 67.5963C7.15417 65.5974 8.90765 64.1069 11.1521 63.125C16.2722 60.8805 20.8839 59.2673 24.987 58.2854C29.0901 57.3035 33.316 56.8125 37.6646 56.8125C42.0132 56.8125 46.2215 57.3035 50.2896 58.2854C54.3576 59.2673 58.9517 60.8805 64.0719 63.125C66.3163 64.1069 68.0873 65.5974 69.3849 67.5963C70.6825 69.5953 71.3313 71.8222 71.3313 74.2771V81.0104C71.3313 81.9222 71.0332 82.6762 70.437 83.2724C69.8408 83.8686 69.0868 84.1667 68.175 84.1667H7.15417ZM75.3292 84.1667C76.0306 84.0264 76.5917 83.6581 77.0125 83.062C77.4333 82.4658 77.6438 81.7118 77.6438 80.8V74.2771C77.6438 69.8583 76.5215 66.2286 74.2771 63.388C72.0326 60.5474 69.0868 58.2503 65.4396 56.4969C70.2792 57.058 74.8382 57.8821 79.1167 58.9693C83.3951 60.0564 86.867 61.3014 89.5323 62.7042C91.8469 64.0368 93.6705 65.6851 95.0031 67.6489C96.3358 69.6128 97.0021 71.8222 97.0021 74.2771V81.0104C97.0021 81.9222 96.704 82.6762 96.1078 83.2724C95.5116 83.8686 94.7576 84.1667 93.8458 84.1667H75.3292ZM37.6646 50.3948C33.0354 50.3948 29.2479 48.9219 26.3021 45.976C23.3563 43.0302 21.8833 39.2427 21.8833 34.6135C21.8833 29.9844 23.3563 26.1969 26.3021 23.251C29.2479 20.3052 33.0354 18.8323 37.6646 18.8323C42.2938 18.8323 46.0813 20.3052 49.0271 23.251C51.9729 26.1969 53.4458 29.9844 53.4458 34.6135C53.4458 39.2427 51.9729 43.0302 49.0271 45.976C46.0813 48.9219 42.2938 50.3948 37.6646 50.3948ZM75.5396 34.6135C75.5396 39.2427 74.0667 43.0302 71.1208 45.976C68.175 48.9219 64.3875 50.3948 59.7583 50.3948C58.9868 50.3948 58.1276 50.3422 57.1807 50.237C56.2339 50.1318 55.3747 49.9389 54.6031 49.6583C56.2865 47.9048 57.5665 45.7481 58.4432 43.188C59.32 40.6279 59.7583 37.7698 59.7583 34.6135C59.7583 31.4573 59.32 28.6693 58.4432 26.2495C57.5665 23.8297 56.2865 21.6028 54.6031 19.5687C55.3747 19.3583 56.2339 19.183 57.1807 19.0427C58.1276 18.9024 58.9868 18.8323 59.7583 18.8323C64.3875 18.8323 68.175 20.3052 71.1208 23.251C74.0667 26.1969 75.5396 29.9844 75.5396 34.6135ZM10.3104 77.8542H65.0188V74.2771C65.0188 73.1548 64.6856 72.0677 64.0193 71.0156C63.353 69.9635 62.5288 69.2271 61.5469 68.8062C56.4969 66.5618 52.2535 65.0538 48.8167 64.2823C45.3799 63.5108 41.6625 63.125 37.6646 63.125C33.6667 63.125 29.9318 63.5108 26.4599 64.2823C22.988 65.0538 18.7271 66.5618 13.6771 68.8062C12.6951 69.2271 11.8885 69.9635 11.2573 71.0156C10.626 72.0677 10.3104 73.1548 10.3104 74.2771V77.8542ZM37.6646 44.0823C40.4 44.0823 42.662 43.188 44.4505 41.3995C46.2391 39.6109 47.1333 37.3489 47.1333 34.6135C47.1333 31.8781 46.2391 29.6161 44.4505 27.8276C42.662 26.039 40.4 25.1448 37.6646 25.1448C34.9292 25.1448 32.6672 26.039 30.8787 27.8276C29.0901 29.6161 28.1958 31.8781 28.1958 34.6135C28.1958 37.3489 29.0901 39.6109 30.8787 41.3995C32.6672 43.188 34.9292 44.0823 37.6646 44.0823Z"
        fill="white"
      />
    </svg>
  ),
  work_history: (
    <svg
      width="111"
      height="111"
      viewBox="0 0 111 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0341 90.0452C17.425 90.0452 16.0171 89.4418 14.8102 88.235C13.6034 87.0282 13 85.6202 13 84.0111V35.7382C13 34.1291 13.6034 32.7212 14.8102 31.5144C16.0171 30.3075 17.425 29.7041 19.0341 29.7041H37.1364V19.6473C37.1364 18.1052 37.7399 16.714 38.9467 15.4737C40.1535 14.2333 41.5615 13.6132 43.1706 13.6132H63.2843C64.8934 13.6132 66.3013 14.2333 67.5081 15.4737C68.715 16.714 69.3184 18.1052 69.3184 19.6473V29.7041H87.4207C89.0298 29.7041 90.4378 30.3075 91.6446 31.5144C92.8514 32.7212 93.4548 34.1291 93.4548 35.7382V58.3662C92.5162 57.6286 91.5608 56.9582 90.5886 56.3548C89.6165 55.7514 88.5605 55.1815 87.4207 54.6451V35.7382H19.0341V84.0111H52.624C52.8922 85.0839 53.2274 86.1231 53.6297 87.1287C54.032 88.1344 54.5013 89.1066 55.0376 90.0452H19.0341ZM43.1706 29.7041H63.2843V19.6473H43.1706V29.7041ZM77.3639 97.3867C72.0672 97.3867 67.5081 95.4759 63.6865 91.6543C59.8649 87.8327 57.9541 83.2736 57.9541 77.977C57.9541 72.6804 59.8649 68.1213 63.6865 64.2997C67.5081 60.4781 72.0672 58.5673 77.3639 58.5673C82.6605 58.5673 87.2196 60.4781 91.0412 64.2997C94.8628 68.1213 96.7736 72.6804 96.7736 77.977C96.7736 83.2736 94.8628 87.8327 91.0412 91.6543C87.2196 95.4759 82.6605 97.3867 77.3639 97.3867ZM79.0735 77.7759V67.4133C79.0735 66.8126 78.8724 66.3111 78.4701 65.9088C78.0678 65.5065 77.565 65.3054 76.9616 65.3054C76.3582 65.3054 75.8553 65.5065 75.4531 65.9088C75.0508 66.3111 74.8496 66.8129 74.8496 67.4143V77.6753C74.8496 78.0822 74.9335 78.4764 75.1011 78.8579C75.2687 79.2393 75.5201 79.5826 75.8553 79.8878L83.4985 86.9276C83.8338 87.2628 84.2696 87.4137 84.8059 87.3802C85.3423 87.3466 85.7781 87.1623 86.1133 86.827C86.5156 86.4248 86.7 85.9554 86.6664 85.4191C86.6329 84.8827 86.415 84.4469 86.0127 84.1117L79.0735 77.7759Z"
        fill="white"
      />
    </svg>
  ),
  certificate: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 12H24V13.6H7V12Z" fill="#00713E" />
      <path d="M7 16H18V17.6H7V16Z" fill="#00713E" />
      <path d="M7 23H17V24.6H7V23Z" fill="#00713E" />
      <path
        d="M27.4603 17.2302C26.1806 17.22 24.9277 17.5961 23.8651 18.3094C22.8026 19.0226 21.98 20.0398 21.5047 21.2279C21.0294 22.4161 20.9236 23.72 21.2012 24.9693C21.4787 26.2185 22.1266 27.355 23.0603 28.2302L21.1203 30.6002L22.0203 34.2102L25.6803 29.7502C26.8389 30.0927 28.0718 30.0927 29.2303 29.7502L32.8903 34.2102L33.7903 30.6002L31.8503 28.2302C32.784 27.355 33.4319 26.2185 33.7094 24.9693C33.987 23.72 33.8812 22.4161 33.4059 21.2279C32.9306 20.0398 32.108 19.0226 31.0455 18.3094C29.9829 17.5961 28.73 17.22 27.4503 17.2302H27.4603ZM27.4603 27.9102C26.6105 27.8983 25.7832 27.6356 25.0824 27.1548C24.3815 26.6741 23.8385 25.9969 23.5214 25.2084C23.2044 24.4199 23.1276 23.5552 23.3006 22.7232C23.4736 21.8911 23.8887 21.1288 24.4938 20.532C25.0989 19.9352 25.8669 19.5306 26.7013 19.3691C27.5357 19.2076 28.3992 19.2964 29.1832 19.6243C29.9673 19.9522 30.6369 20.5046 31.1079 21.212C31.5789 21.9194 31.8302 22.7503 31.8303 23.6002C31.8197 24.7504 31.354 25.8496 30.5351 26.6573C29.7161 27.4651 28.6106 27.9155 27.4603 27.9102Z"
        fill="#00713E"
      />
      <path
        d="M32 13.2201V16.5601C32.7597 17.0519 33.4351 17.6631 34 18.3701V12.3701C33.3785 12.7497 32.7046 13.0361 32 13.2201Z"
        fill="#00713E"
      />
      <path
        d="M4 28V8H22.78C22.5968 7.34903 22.5026 6.67625 22.5 6H4C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8V28C2 28.5304 2.21071 29.0391 2.58579 29.4142C2.96086 29.7893 3.46957 30 4 30H19L19.57 29.3L20.5 28.16L20.41 28H4Z"
        fill="#00713E"
      />
      <path
        d="M30 11C32.7614 11 35 8.76142 35 6C35 3.23858 32.7614 1 30 1C27.2386 1 25 3.23858 25 6C25 8.76142 27.2386 11 30 11Z"
        fill="#EA7810"
      />
    </svg>
  ),
  reviewnote: (
    <svg
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88 96C88 93.8783 88.8429 91.8434 90.3431 90.3431C91.8434 88.8429 93.8783 88 96 88H160C162.122 88 164.157 88.8429 165.657 90.3431C167.157 91.8434 168 93.8783 168 96C168 98.1217 167.157 100.157 165.657 101.657C164.157 103.157 162.122 104 160 104H96C93.8783 104 91.8434 103.157 90.3431 101.657C88.8429 100.157 88 98.1217 88 96ZM96 136H160C162.122 136 164.157 135.157 165.657 133.657C167.157 132.157 168 130.122 168 128C168 125.878 167.157 123.843 165.657 122.343C164.157 120.843 162.122 120 160 120H96C93.8783 120 91.8434 120.843 90.3431 122.343C88.8429 123.843 88 125.878 88 128C88 130.122 88.8429 132.157 90.3431 133.657C91.8434 135.157 93.8783 136 96 136ZM128 152H96C93.8783 152 91.8434 152.843 90.3431 154.343C88.8429 155.843 88 157.878 88 160C88 162.122 88.8429 164.157 90.3431 165.657C91.8434 167.157 93.8783 168 96 168H128C130.122 168 132.157 167.157 133.657 165.657C135.157 164.157 136 162.122 136 160C136 157.878 135.157 155.843 133.657 154.343C132.157 152.843 130.122 152 128 152ZM224 48V156.69C224.007 158.792 223.596 160.874 222.79 162.816C221.985 164.757 220.802 166.52 219.31 168L168 219.31C166.52 220.802 164.757 221.985 162.816 222.79C160.874 223.596 158.792 224.007 156.69 224H48C43.7565 224 39.6869 222.314 36.6863 219.314C33.6857 216.313 32 212.243 32 208V48C32 43.7565 33.6857 39.6869 36.6863 36.6863C39.6869 33.6857 43.7565 32 48 32H208C212.243 32 216.313 33.6857 219.314 36.6863C222.314 39.6869 224 43.7565 224 48ZM48 208H152V160C152 157.878 152.843 155.843 154.343 154.343C155.843 152.843 157.878 152 160 152H208V48H48V208ZM168 168V196.7L196.69 168H168Z"
        fill="black"
      />
    </svg>
  ),
  alert_fill: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <g clipPath="url(#clip0_1291_6811)">
        <path
          d="M15.5152 3.67285L25.5882 21.1192C25.7418 21.3852 25.8227 21.687 25.8227 21.9942C25.8227 22.3014 25.7418 22.6031 25.5882 22.8692C25.4346 23.1352 25.2137 23.3561 24.9477 23.5097C24.6817 23.6633 24.3799 23.7442 24.0727 23.7442H3.92671C3.61953 23.7442 3.31776 23.6633 3.05173 23.5097C2.7857 23.3561 2.56479 23.1352 2.4112 22.8692C2.25761 22.6031 2.17676 22.3014 2.17676 21.9942C2.17676 21.687 2.25762 21.3852 2.41121 21.1192L12.4842 3.67285C13.1574 2.50618 14.8409 2.50618 15.5152 3.67285ZM13.9997 17.5002C13.6903 17.5002 13.3935 17.6231 13.1748 17.8419C12.956 18.0607 12.833 18.3574 12.833 18.6669C12.833 18.9763 12.956 19.273 13.1748 19.4918C13.3935 19.7106 13.6903 19.8335 13.9997 19.8335C14.3091 19.8335 14.6059 19.7106 14.8247 19.4918C15.0435 19.273 15.1664 18.9763 15.1664 18.6669C15.1664 18.3574 15.0435 18.0607 14.8247 17.8419C14.6059 17.6231 14.3091 17.5002 13.9997 17.5002ZM13.9997 9.33352C13.714 9.33356 13.4382 9.43847 13.2246 9.62835C13.0111 9.81824 12.8746 10.0799 12.8412 10.3637L12.833 10.5002V15.1669C12.8334 15.4642 12.9472 15.7502 13.1514 15.9664C13.3555 16.1827 13.6345 16.3128 13.9313 16.3302C14.2282 16.3476 14.5205 16.2511 14.7485 16.0602C14.9765 15.8694 15.1231 15.5986 15.1582 15.3034L15.1664 15.1669V10.5002C15.1664 10.1908 15.0435 9.89402 14.8247 9.67523C14.6059 9.45643 14.3091 9.33352 13.9997 9.33352Z"
          fill="#535353"
        />
      </g>
      <defs>
        <clipPath id="clip0_1291_6811">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  won_sign: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_1445_3951)">
        <path
          d="M2.9252 2.5266C2.6627 1.7391 1.80957 1.31722 1.02676 1.57503C0.243947 1.83285 -0.182615 2.69066 0.0751971 3.47347L2.41895 10.5H1.5002C0.67051 10.5 0.000197088 11.1703 0.000197088 12C0.000197088 12.8297 0.67051 13.5 1.5002 13.5H3.41738L6.0752 21.4735C6.28614 22.1063 6.89082 22.5235 7.55645 22.5C8.22207 22.4766 8.79395 22.0125 8.95332 21.3657L10.9221 13.5H13.0783L15.0471 21.3657C15.2064 22.0125 15.7783 22.4766 16.4439 22.5C17.1096 22.5235 17.7143 22.1063 17.9252 21.4735L20.583 13.5H22.5002C23.3299 13.5 24.0002 12.8297 24.0002 12C24.0002 11.1703 23.3299 10.5 22.5002 10.5H21.5814L23.9252 3.47347C24.1877 2.68597 23.7611 1.83753 22.9783 1.57503C22.1955 1.31253 21.3424 1.7391 21.0799 2.52191L18.4174 10.5H15.4221L13.4533 2.63441C13.2893 1.96878 12.6893 1.50003 12.0002 1.50003C11.3111 1.50003 10.7111 1.96878 10.5471 2.63441L8.57832 10.5H5.57832L2.9252 2.5266ZM6.58145 13.5H7.82832L7.29395 15.6375L6.58145 13.5ZM11.6721 10.5L12.0002 9.18285L12.3283 10.5H11.6721ZM16.1721 13.5H17.4189L16.7064 15.6375L16.1721 13.5Z"
          fill="#F18334"
        />
      </g>
      <defs>
        <clipPath id="clip0_1445_3951">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  present: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.2325 12.8525C27.7612 12.36 27.2738 11.8525 27.09 11.4062C26.92 10.9975 26.91 10.32 26.9 9.66375C26.8813 8.44375 26.8612 7.06125 25.9 6.1C24.9387 5.13875 23.5562 5.11875 22.3363 5.1C21.68 5.09 21.0025 5.08 20.5938 4.91C20.1488 4.72625 19.64 4.23875 19.1475 3.7675C18.285 2.93875 17.305 2 16 2C14.695 2 13.7162 2.93875 12.8525 3.7675C12.36 4.23875 11.8525 4.72625 11.4062 4.91C11 5.08 10.32 5.09 9.66375 5.1C8.44375 5.11875 7.06125 5.13875 6.1 6.1C5.13875 7.06125 5.125 8.44375 5.1 9.66375C5.09 10.32 5.08 10.9975 4.91 11.4062C4.72625 11.8512 4.23875 12.36 3.7675 12.8525C2.93875 13.715 2 14.695 2 16C2 17.305 2.93875 18.2837 3.7675 19.1475C4.23875 19.64 4.72625 20.1475 4.91 20.5938C5.08 21.0025 5.09 21.68 5.1 22.3363C5.11875 23.5562 5.13875 24.9387 6.1 25.9C7.06125 26.8612 8.44375 26.8813 9.66375 26.9C10.32 26.91 10.9975 26.92 11.4062 27.09C11.8512 27.2738 12.36 27.7612 12.8525 28.2325C13.715 29.0613 14.695 30 16 30C17.305 30 18.2837 29.0613 19.1475 28.2325C19.64 27.7612 20.1475 27.2738 20.5938 27.09C21.0025 26.92 21.68 26.91 22.3363 26.9C23.5562 26.8813 24.9387 26.8612 25.9 25.9C26.8612 24.9387 26.8813 23.5562 26.9 22.3363C26.91 21.68 26.92 21.0025 27.09 20.5938C27.2738 20.1488 27.7612 19.64 28.2325 19.1475C29.0613 18.285 30 17.305 30 16C30 14.695 29.0613 13.7162 28.2325 12.8525ZM21.7075 13.7075L14.7075 20.7075C14.6146 20.8005 14.5043 20.8742 14.3829 20.9246C14.2615 20.9749 14.1314 21.0008 14 21.0008C13.8686 21.0008 13.7385 20.9749 13.6171 20.9246C13.4957 20.8742 13.3854 20.8005 13.2925 20.7075L10.2925 17.7075C10.1996 17.6146 10.1259 17.5043 10.0756 17.3829C10.0253 17.2615 9.99944 17.1314 9.99944 17C9.99944 16.8686 10.0253 16.7385 10.0756 16.6171C10.1259 16.4957 10.1996 16.3854 10.2925 16.2925C10.4801 16.1049 10.7346 15.9994 11 15.9994C11.1314 15.9994 11.2615 16.0253 11.3829 16.0756C11.5043 16.1259 11.6146 16.1996 11.7075 16.2925L14 18.5863L20.2925 12.2925C20.3854 12.1996 20.4957 12.1259 20.6171 12.0756C20.7385 12.0253 20.8686 11.9994 21 11.9994C21.1314 11.9994 21.2615 12.0253 21.3829 12.0756C21.5043 12.1259 21.6146 12.1996 21.7075 12.2925C21.8004 12.3854 21.8741 12.4957 21.9244 12.6171C21.9747 12.7385 22.0006 12.8686 22.0006 13C22.0006 13.1314 21.9747 13.2615 21.9244 13.3829C21.8741 13.5043 21.8004 13.6146 21.7075 13.7075Z"
        fill="#F18334"
      />
    </svg>
  ),
  seal_check_fill: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.5295 24.3224L17.0775 31.2336C16.4802 31.5652 15.5027 31.5652 14.9054 31.2336L2.4533 24.3224C2.15461 24.1567 2.0053 23.9381 2.0053 23.7196H1.87305V8.28076H29.9776V23.7196C29.9776 23.9381 29.8283 24.1567 29.5295 24.3224Z"
        fill="#F18334"
      />
      <path
        d="M29.9777 8.28082V23.7197C29.9777 23.9383 29.8284 24.1568 29.5297 24.3226L17.0777 31.2337C16.767 31.4061 16.3537 31.4882 15.9444 31.4811C15.9541 23.7502 16.1738 16.0095 15.9336 8.28076L29.9777 8.28082Z"
        fill="#F6B982"
      />
      <path
        d="M14.9059 15.7947L2.45389 8.88349C1.85652 8.55193 1.85652 8.00943 2.45389 7.67786L14.9059 0.766738C15.5033 0.435176 16.4808 0.435176 17.0781 0.766738L29.5301 7.67793C30.1275 8.00949 30.1275 8.55199 29.5301 8.88355L17.0781 15.7947C16.4808 16.1262 15.5033 16.1262 14.9059 15.7947Z"
        fill="#F9CFA9"
      />
      <path
        d="M24.4427 4.63268C24.442 4.70574 24.4217 4.77727 24.3839 4.83976C24.346 4.90224 24.292 4.95336 24.2275 4.98774L9.30792 12.9406C9.28738 12.9515 9.26592 12.9607 9.2438 12.9679L9.19336 12.9961V27.838C9.19336 27.9087 9.1749 27.9782 9.1398 28.0396C9.1047 28.101 9.05418 28.1522 8.99323 28.1881C8.93228 28.224 8.86301 28.2433 8.79229 28.2442C8.72156 28.2451 8.65183 28.2276 8.58998 28.1932L6.08998 26.8057C6.0266 26.7705 5.97379 26.719 5.93702 26.6566C5.90024 26.5941 5.88085 26.5229 5.88086 26.4504V12.0076C5.88093 11.7598 5.93663 11.5151 6.04386 11.2917C6.15109 11.0683 6.30712 10.8718 6.50042 10.7167L6.51517 10.7052C6.54792 10.6796 6.57898 10.657 6.61092 10.6354C6.65838 10.6032 6.70744 10.5734 6.75792 10.5462L21.2417 2.82568C21.3015 2.79377 21.3684 2.77736 21.4362 2.77794C21.504 2.77851 21.5706 2.79607 21.6299 2.82899L24.2336 4.27406C24.2975 4.30952 24.3506 4.36155 24.3874 4.42466C24.4242 4.48777 24.4433 4.55963 24.4427 4.63268ZM25.8185 10.9159C25.724 10.8081 25.6158 10.7131 25.4967 10.6332C25.4889 10.6279 25.4811 10.6226 25.4719 10.6166C25.4333 10.5914 25.3935 10.5678 25.3529 10.546L10.8692 2.82562C10.8093 2.79369 10.7424 2.77727 10.6746 2.77785C10.6068 2.77843 10.5402 2.79599 10.4809 2.82893L7.87723 4.27399C7.81333 4.30943 7.76016 4.36146 7.72334 4.42458C7.68653 4.48771 7.66742 4.5596 7.66804 4.63267C7.66866 4.70575 7.68899 4.7773 7.72687 4.83979C7.76475 4.90228 7.8188 4.95339 7.8833 4.98774L22.8029 12.9406C22.8237 12.9516 22.8452 12.9607 22.8671 12.968L22.9175 12.9962V27.8381C22.9175 27.9088 22.9359 27.9783 22.971 28.0397C23.0061 28.1011 23.0567 28.1523 23.1176 28.1882C23.1786 28.2241 23.2478 28.2434 23.3186 28.2443C23.3893 28.2452 23.459 28.2276 23.5209 28.1933L26.0209 26.8057C26.0842 26.7706 26.137 26.7191 26.1738 26.6566C26.2106 26.5941 26.23 26.523 26.23 26.4505V12.0076C26.2298 11.6058 26.0835 11.2178 25.8185 10.9159Z"
        fill="#FBDDC3"
      />
      <path
        d="M20.9752 8.56772C20.9752 9.58716 19.7249 10.327 18.0022 10.327C17.2996 10.327 16.6758 10.2038 16.1832 9.98897C16.1203 9.96166 16.0521 9.94856 15.9836 9.95061C15.915 9.95265 15.8478 9.96978 15.7866 10.0008C15.2732 10.2599 14.5924 10.4109 13.8149 10.4109C12.0922 10.4109 10.8418 9.67103 10.8418 8.65159C10.8418 8.13834 11.1588 7.69603 11.6934 7.38322C11.904 7.26003 11.9925 6.99709 11.8882 6.77653C11.5071 5.97066 11.5194 5.21459 11.9867 4.74722C12.2288 4.50516 12.5603 4.37722 12.9455 4.37722C13.2161 4.37722 13.51 4.44116 13.8119 4.56122C13.9279 4.60749 14.0575 4.60627 14.1726 4.55783C14.2877 4.5094 14.3791 4.41763 14.4272 4.30234C14.7375 3.56166 15.2509 3.10547 15.8665 3.10547C16.4717 3.10547 16.9782 3.54616 17.29 4.26466C17.3935 4.50316 17.6667 4.61697 17.907 4.51778C18.2225 4.38759 18.5299 4.31797 18.8122 4.31797C19.2987 4.31797 19.6021 4.51916 19.7709 4.68797C20.2304 5.14741 20.2501 5.88572 19.8887 6.67616C19.7874 6.89791 19.8772 7.16028 20.0895 7.28022C20.6446 7.59384 20.9752 8.04378 20.9752 8.56772Z"
        fill="#F18334"
      />
    </svg>
  ),
  plus: (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8917 23V14.94H0.831757V8.88416H8.8917V0.824219H14.9911V8.88416H23.0511V14.94H14.9911V23H8.8917Z"
        fill="white"
      />
    </svg>
  ),
  mingcute_sunflower_line: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9709_7774)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 2C13.12 2.017 13.768 2.543 14.193 2.947C14.7879 3.50468 15.2044 4.22599 15.39 5.02C16.0832 4.5896 16.8885 4.37421 17.704 4.401C18.29 4.416 19.12 4.503 19.57 4.929C19.996 5.379 20.082 6.209 20.097 6.795C20.1241 7.61044 19.909 8.41564 19.479 9.109C20.406 9.323 21.089 9.819 21.552 10.307C21.956 10.732 22.482 11.38 22.499 12C22.482 12.62 21.956 13.268 21.552 13.693C20.9944 14.2883 20.2731 14.7051 19.479 14.891C19.9088 15.5845 20.1242 16.3895 20.098 17.205C20.083 17.791 19.996 18.621 19.57 19.071C19.12 19.497 18.29 19.583 17.704 19.598C16.8886 19.6251 16.0834 19.41 15.39 18.98C15.2041 19.7741 14.7873 20.4954 14.192 21.053C13.767 21.457 13.118 21.983 12.499 22C11.879 21.983 11.231 21.457 10.806 21.053C10.2115 20.4952 9.79533 19.7739 9.61 18.98C8.91675 19.4104 8.11155 19.6258 7.296 19.599C6.71 19.584 5.88 19.497 5.43 19.071C5.004 18.621 4.918 17.791 4.903 17.205C4.87591 16.3896 5.09095 15.5844 5.521 14.891C4.72687 14.7051 4.00555 14.2883 3.448 13.693C3.043 13.268 2.517 12.62 2.5 12C2.517 11.38 3.043 10.732 3.447 10.307C4.00468 9.7121 4.72599 9.29561 5.52 9.11C5.0896 8.41675 4.87421 7.61155 4.901 6.796C4.916 6.21 5.003 5.38 5.429 4.93C5.879 4.504 6.709 4.417 7.295 4.403C8.11044 4.37591 8.91564 4.59095 9.609 5.021C9.823 4.094 10.319 3.411 10.807 2.948C11.233 2.544 11.88 2.017 12.5 2ZM13 15.97C12.672 16.01 12.328 16.01 12 15.97C11.722 16.61 11.5 17.257 11.5 18.001C11.5 19.003 12.079 19.568 12.5 19.861C12.921 19.568 13.5 19.003 13.5 18.001C13.5 17.257 13.278 16.61 13 15.97ZM9.34 14.454C8.691 14.71 8.076 15.011 7.55 15.537C6.842 16.245 6.851 17.054 6.943 17.558C7.447 17.649 8.256 17.659 8.964 16.951C9.49 16.425 9.791 15.81 10.047 15.161C9.78269 14.9558 9.54517 14.7183 9.34 14.454ZM15.66 14.454C15.4548 14.7183 15.2173 14.9558 14.953 15.161C15.209 15.81 15.51 16.425 16.036 16.951C16.744 17.659 17.553 17.649 18.057 17.558C18.148 17.054 18.158 16.245 17.45 15.537C16.924 15.011 16.309 14.71 15.66 14.454ZM12.5 10C11.9696 10 11.4609 10.2107 11.0858 10.5858C10.7107 10.9609 10.5 11.4696 10.5 12C10.5 12.5304 10.7107 13.0391 11.0858 13.4142C11.4609 13.7893 11.9696 14 12.5 14C13.0304 14 13.5391 13.7893 13.9142 13.4142C14.2893 13.0391 14.5 12.5304 14.5 12C14.5 11.4696 14.2893 10.9609 13.9142 10.5858C13.5391 10.2107 13.0304 10 12.5 10ZM6.5 11C5.498 11 4.933 11.579 4.64 12C4.933 12.421 5.498 13 6.5 13C7.244 13 7.891 12.778 8.531 12.5C8.48917 12.168 8.48917 11.832 8.531 11.5C7.891 11.222 7.244 11 6.5 11ZM18.5 11C17.756 11 17.109 11.222 16.469 11.5C16.509 11.828 16.509 12.172 16.469 12.5C17.109 12.778 17.756 13 18.5 13C19.502 13 20.067 12.421 20.36 12C20.067 11.579 19.502 11 18.5 11ZM8.964 7.05C8.256 6.342 7.447 6.351 6.943 6.443C6.851 6.947 6.842 7.756 7.55 8.464C8.076 8.99 8.691 9.291 9.34 9.547C9.54667 9.28167 9.78233 9.046 10.047 8.84C9.791 8.191 9.49 7.576 8.964 7.05ZM18.057 6.443C17.553 6.351 16.744 6.342 16.036 7.05C15.51 7.576 15.209 8.191 14.953 8.84C15.2183 9.04667 15.454 9.28233 15.66 9.547C16.309 9.291 16.924 8.99 17.45 8.464C18.158 7.756 18.148 6.947 18.057 6.443ZM12.5 4.14C12.079 4.432 11.5 4.997 11.5 5.999C11.5 6.743 11.722 7.39 12 8.03C12.328 7.99 12.672 7.99 13 8.03C13.278 7.39 13.5 6.743 13.5 5.999C13.5 4.997 12.921 4.433 12.5 4.14Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9709_7774">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  ph_coin_bold: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6284 5.65031C17.6325 4.65188 15 4.125 12 4.125C9 4.125 6.3675 4.65188 4.37156 5.65031C2.30813 6.68156 1.125 8.17594 1.125 9.75V14.25C1.125 15.8241 2.30813 17.3184 4.37156 18.3497C6.3675 19.3481 9.00469 19.875 12 19.875C14.9953 19.875 17.6325 19.3481 19.6284 18.3497C21.6909 17.3184 22.875 15.8241 22.875 14.25V9.75C22.875 8.17594 21.6919 6.68156 19.6284 5.65031ZM5.37844 7.66219C7.03875 6.8325 9.39 6.375 12 6.375C14.61 6.375 16.9613 6.8325 18.6216 7.66219C19.8572 8.28 20.625 9.08063 20.625 9.75C20.625 10.4194 19.8572 11.22 18.6216 11.8378C16.9613 12.6675 14.61 13.125 12 13.125C9.39 13.125 7.03875 12.6675 5.37844 11.8378C4.14281 11.22 3.375 10.4194 3.375 9.75C3.375 9.08063 4.14281 8.28 5.37844 7.66219ZM16.875 17.0044C15.6511 17.3414 14.3932 17.5395 13.125 17.595V15.345C14.3887 15.2934 15.6445 15.1204 16.875 14.8284V17.0044ZM7.125 14.8331C8.35555 15.1251 9.61133 15.2981 10.875 15.3497V17.5997C9.6068 17.5442 8.34887 17.346 7.125 17.0091V14.8331ZM3.375 14.25V13.2694C3.6943 13.4841 4.02719 13.678 4.37156 13.8497C4.53469 13.9312 4.70344 14.0091 4.875 14.0841V16.0594C3.9375 15.4913 3.375 14.8228 3.375 14.25ZM19.125 16.0594V14.0841C19.2966 14.0091 19.4653 13.9312 19.6284 13.8497C19.9728 13.678 20.3057 13.4841 20.625 13.2694V14.25C20.625 14.8228 20.0625 15.4913 19.125 16.0594Z"
        fill="white"
      />
    </svg>
  ),
  cross: (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 9.66667H9.16667V13H5.83333V9.66667H2.5V6.33333H5.83333V3H9.16667V6.33333H12.5M13.3333 0.5H1.66667C0.741667 0.5 0 1.24167 0 2.16667V13.8333C0 14.2754 0.175595 14.6993 0.488155 15.0118C0.800716 15.3244 1.22464 15.5 1.66667 15.5H13.3333C13.7754 15.5 14.1993 15.3244 14.5118 15.0118C14.8244 14.6993 15 14.2754 15 13.8333V2.16667C15 1.72464 14.8244 1.30072 14.5118 0.988155C14.1993 0.675595 13.7754 0.5 13.3333 0.5Z"
        fill="#857471"
      />
    </svg>
  ),
  camera: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_327_457)">
        <path
          d="M26.8332 22.1667C26.8332 22.7855 26.5873 23.379 26.1498 23.8166C25.7122 24.2542 25.1187 24.5 24.4998 24.5H3.49984C2.881 24.5 2.28751 24.2542 1.84992 23.8166C1.41234 23.379 1.1665 22.7855 1.1665 22.1667V9.33333C1.1665 8.71449 1.41234 8.121 1.84992 7.68342C2.28751 7.24583 2.881 7 3.49984 7H8.1665L10.4998 3.5H17.4998L19.8332 7H24.4998C25.1187 7 25.7122 7.24583 26.1498 7.68342C26.5873 8.121 26.8332 8.71449 26.8332 9.33333V22.1667Z"
          stroke="#757575"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.9998 19.8333C16.5772 19.8333 18.6665 17.744 18.6665 15.1667C18.6665 12.5893 16.5772 10.5 13.9998 10.5C11.4225 10.5 9.33317 12.5893 9.33317 15.1667C9.33317 17.744 11.4225 19.8333 13.9998 19.8333Z"
          stroke="#757575"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_327_457">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  people: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.34375 9C6.74172 9 7.875 7.86672 7.875 6.46875C7.875 5.07078 6.74172 3.9375 5.34375 3.9375C3.94578 3.9375 2.8125 5.07078 2.8125 6.46875C2.8125 7.86672 3.94578 9 5.34375 9Z"
        fill="#857471"
      />
      <path
        d="M8.22656 10.4062C7.23656 9.90352 6.14391 9.70312 5.34375 9.70312C3.77648 9.70312 0.5625 10.6643 0.5625 12.5859V14.0625H5.83594V13.4975C5.83594 12.8296 6.11719 12.1598 6.60938 11.6016C7.00207 11.1558 7.55191 10.742 8.22656 10.4062Z"
        fill="#857471"
      />
      <path
        d="M11.9531 10.125C10.1225 10.125 6.46875 11.2556 6.46875 13.5V15.1875H17.4375V13.5C17.4375 11.2556 13.7837 10.125 11.9531 10.125Z"
        fill="#857471"
      />
      <path
        d="M11.9531 9C13.6618 9 15.0469 7.61488 15.0469 5.90625C15.0469 4.19762 13.6618 2.8125 11.9531 2.8125C10.2445 2.8125 8.85938 4.19762 8.85938 5.90625C8.85938 7.61488 10.2445 9 11.9531 9Z"
        fill="#857471"
      />
    </svg>
  ),
  removeImage: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5L9 9M9 5L5 9M2.33333 1H11.6667C12.403 1 13 1.59695 13 2.33333V11.6667C13 12.403 12.403 13 11.6667 13H2.33333C1.59695 13 1 12.403 1 11.6667V2.33333C1 1.59695 1.59695 1 2.33333 1Z"
        stroke="#1E1E1E"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  "headphone-mono": (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.6308 16.6261C27.6308 13.9883 25.8108 11.7856 23.3666 11.1579V10.3833C23.3666 5.49377 19.3895 1.5166 14.5 1.5166C9.61164 1.5166 5.63447 5.49377 5.63447 10.3833V11.1579C3.18914 11.7856 1.36914 13.9883 1.36914 16.6261C1.37069 18.1281 1.9681 19.568 3.03025 20.63C4.09241 21.6919 5.53251 22.289 7.03447 22.2903C7.40578 22.2903 7.76187 22.1428 8.02442 21.8802C8.28697 21.6177 8.43447 21.2616 8.43447 20.8903V10.3833C8.43447 7.03843 11.1551 4.3166 14.5 4.3166C17.8448 4.3166 20.5666 7.03843 20.5666 10.3833V20.3104L17.6033 23.2738C17.4736 23.404 17.3194 23.5072 17.1496 23.5775C16.9798 23.6477 16.7977 23.6837 16.614 23.6833H14.3705C13.9992 23.6833 13.6431 23.8308 13.3805 24.0933C13.118 24.3559 12.9705 24.712 12.9705 25.0833C12.9705 25.4546 13.118 25.8107 13.3805 26.0732C13.6431 26.3358 13.9992 26.4833 14.3705 26.4833H16.614C17.7363 26.4833 18.791 26.0469 19.5843 25.2536L22.6118 22.2249C25.4281 21.9006 27.6308 19.5288 27.6308 16.6261"
        fill="white"
      />
    </svg>
  ),
  "icon-arrow-right-line-mono": (
    <svg
      width="31"
      height="8"
      viewBox="0 0 31 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Line 1"
        d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0V4.5Z"
        fill="white"
      />
    </svg>
  ),
  "icon-document-filled": (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9922 1.93506H5.66406C5.07147 1.93506 4.50315 2.17047 4.08412 2.58949C3.66509 3.00852 3.42969 3.57684 3.42969 4.16943V18.9507C3.42969 19.5433 3.66509 20.1116 4.08412 20.5306C4.50315 20.9497 5.07147 21.1851 5.66406 21.1851H16.3203C16.9129 21.1851 17.4812 20.9497 17.9003 20.5306C18.3193 20.1116 18.5547 19.5433 18.5547 18.9507V9.49756H13.2266C12.634 9.49756 12.0656 9.26215 11.6466 8.84312C11.2276 8.4241 10.9922 7.85578 10.9922 7.26318V1.93506ZM18.4605 8.12256C18.3544 7.76794 18.1619 7.44523 17.9002 7.18343L13.3063 2.58956C13.0446 2.32763 12.7219 2.13486 12.3672 2.02856V7.26318C12.3672 7.73756 12.7522 8.12256 13.2266 8.12256H18.4605Z"
        fill="black"
      />
    </svg>
  ),
  "icon-rectangle-mono": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="12"
        y="0.686279"
        width="16"
        height="16"
        transform="rotate(45 12 0.686279)"
        fill="#F18334"
      />
    </svg>
  ),
  "icon-quote": (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 14C2.10218 14 1.72064 13.842 1.43934 13.5607C1.15804 13.2794 1 12.8978 1 12.5V5C1 3.93913 1.42143 2.92172 2.17157 2.17157C2.92172 1.42143 3.93913 1 5 1V2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V8H5.5C5.89782 8 6.27936 8.15804 6.56066 8.43934C6.84196 8.72064 7 9.10218 7 9.5V12.5C7 12.8978 6.84196 13.2794 6.56066 13.5607C6.27936 13.842 5.89782 14 5.5 14H2.5ZM9.5 14C9.10218 14 8.72064 13.842 8.43934 13.5607C8.15804 13.2794 8 12.8978 8 12.5V5C8 3.93913 8.42143 2.92172 9.17157 2.17157C9.92172 1.42143 10.9391 1 12 1V2C11.2044 2 10.4413 2.31607 9.87868 2.87868C9.31607 3.44129 9 4.20435 9 5V8H12.5C12.8978 8 13.2794 8.15804 13.5607 8.43934C13.842 8.72064 14 9.10218 14 9.5V12.5C14 12.8978 13.842 13.2794 13.5607 13.5607C13.2794 13.842 12.8978 14 12.5 14H9.5Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-people": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5251 8.53402C8.4676 8.53402 10.0426 6.95902 10.0426 5.01652C10.0426 3.07402 8.4676 1.49902 6.5251 1.49902C4.5826 1.49902 3.0076 3.07402 3.0076 5.01652C3.0076 6.95902 4.5826 8.53402 6.5251 8.53402Z"
        fill="#69A5FF"
      />
      <path
        d="M6.52503 9.92188C3.42754 9.92188 0.870036 12.2169 0.457536 15.2019C0.397536 15.6519 0.750036 16.0569 1.20754 16.0569H12.66C12.66 12.6744 9.91504 9.92938 6.53254 9.92938L6.52503 9.92188Z"
        fill="#69A5FF"
      />
      <path
        d="M11.4751 9.91863C11.2426 9.91863 11.0176 9.93363 10.7926 9.95613C12.7876 11.2461 14.1226 13.4961 14.1226 16.0461H16.8001C17.2576 16.0461 17.6101 15.6411 17.5501 15.1911C17.1376 12.2061 14.5726 9.91113 11.4826 9.91113L11.4751 9.91863Z"
        fill="#69A5FF"
      />
      <path
        d="M10.1701 8.27902C10.5751 8.44402 11.0101 8.53402 11.4751 8.53402C13.4176 8.53402 14.9926 6.95902 14.9926 5.01652C14.9926 3.07402 13.4176 1.49902 11.4751 1.49902C11.0101 1.49902 10.5751 1.59652 10.1701 1.75402C11.0026 2.59402 11.5126 3.74902 11.5126 5.01652C11.5126 6.28402 10.9951 7.43902 10.1701 8.27902Z"
        fill="#69A5FF"
      />
    </svg>
  ),
  "icon-object": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38251 5.9175H14.94C15.15 5.9175 15.315 5.7525 15.315 5.5425V3.4125L13.5975 1.635C13.515 1.5525 13.4025 1.5 13.29 1.5H5.03251C4.92001 1.5 4.80751 1.545 4.72501 1.635L3.00751 3.4125V5.5425C3.00751 5.7525 3.17251 5.9175 3.38251 5.9175Z"
        fill="#FF8741"
      />
      <path
        d="M14.9325 7.3125H3.375C3.165 7.3125 3 7.4775 3 7.6875V15.7875C3 16.2 3.3375 16.5375 3.75 16.5375H14.5575C14.97 16.5375 15.3075 16.2 15.3075 15.7875V7.6875C15.3075 7.4775 15.1425 7.3125 14.9325 7.3125ZM10.8975 13.7475C10.8975 13.995 10.695 14.1975 10.4475 14.1975H7.86C7.6125 14.1975 7.41 13.995 7.41 13.7475V10.1025C7.41 9.855 7.6125 9.6525 7.86 9.6525H10.4475C10.695 9.6525 10.8975 9.855 10.8975 10.1025V13.7475Z"
        fill="#FF8741"
      />
    </svg>
  ),
  "icon-service-bus": (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7455 47.3203H26.3316V50.0814C26.3316 51.3086 25.3275 52.3126 24.1004 52.3126H20.9767C19.7495 52.3126 18.7455 51.3086 18.7455 50.0814V47.3203Z"
        fill="#252525"
      />
      <path
        d="M37.6684 47.3203H45.2545V50.0814C45.2545 51.3086 44.2504 52.3126 43.0233 52.3126H39.8996C38.6724 52.3126 37.6684 51.3086 37.6684 50.0814V47.3203Z"
        fill="#252525"
      />
      <path
        d="M19.4427 16H44.5437C46.4681 16 48.0299 17.5618 48.0299 19.4863V46.8464C48.0299 47.6134 47.4024 48.2409 46.6354 48.2409H17.351C16.584 48.2409 15.9565 47.6134 15.9565 46.8464V19.4863C15.9565 17.5618 17.5183 16 19.4427 16Z"
        fill="#686868"
      />
      <path
        d="M48.0299 20.3784H15.9565V34.5744H48.0299V20.3784Z"
        fill="#252525"
      />
      <path
        d="M15.9565 38.6465H48.0299V46.8462C48.0299 47.6131 47.4024 48.2407 46.6354 48.2407H17.351C16.584 48.2407 15.9565 47.6131 15.9565 46.8462V38.6465Z"
        fill="#B9B9B9"
      />
      <path
        d="M15.0917 22.9033H15.9563V32.3162H15.0917C13.9343 32.3162 13 31.3819 13 30.2245V24.9951C13 23.8376 13.9343 22.9033 15.0917 22.9033Z"
        fill="#686868"
      />
      <path
        d="M48.9083 32.3159H48.0437V22.903H48.9083C50.0657 22.903 51 23.8373 51 24.9948V30.2242C51 31.3816 50.0657 32.3159 48.9083 32.3159Z"
        fill="#686868"
      />
      <path
        d="M15.9565 40.9897H21.7833C22.8431 40.9897 23.7216 41.8543 23.7216 42.9281C23.7216 43.9879 22.857 44.8665 21.7833 44.8665H15.9565V41.0037V40.9897Z"
        fill="#E9E9E9"
      />
      <path
        d="M41.0294 40.9895H48.0437V44.8523H42.2169C41.1571 44.8523 40.2785 43.9877 40.2785 42.9139C40.2785 41.8541 41.1431 40.9756 42.2169 40.9756L41.0294 40.9895Z"
        fill="#E9E9E9"
      />
    </svg>
  ),
  "icon-service-ugol": (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.6303 47.8489C46.6303 50.6688 40.0773 53.0012 31.994 53.0012C23.9107 53.0012 17.3576 50.6688 17.3576 47.8489C17.3576 45.029 23.9107 42.7397 31.994 42.7397C40.0773 42.7397 46.6303 45.029 46.6303 47.8489Z"
        fill="#8F8F8F"
      />
      <path d="M47.9938 21.8291H16V43.7342H47.9938V21.8291Z" fill="#B9B9B9" />
      <path
        d="M47.9938 43.7338C47.9938 46.5537 40.8299 50.2313 31.9938 50.2313C23.1577 50.2313 16 46.5599 16 43.7338C16 40.9077 23.1639 39.2417 32 39.2417C40.8361 39.2417 48 40.9139 48 43.7338H47.9938Z"
        fill="#B9B9B9"
      />
      <path
        d="M32 26.5C40.8366 26.5 48 23.9082 48 21.8294C48 19.7506 40.8366 18.0654 32 18.0654C23.1634 18.0654 16 19.7506 16 21.8294C16 23.9082 23.1634 26.5 32 26.5Z"
        fill="#8F8F8F"
      />
      <path d="M46 15H18V20H46V15Z" fill="#B9B9B9" />
      <path
        d="M32 23.5C39.732 23.5 46 21.5714 46 19.8081C46 18.0447 39.732 16.6152 32 16.6152C24.268 16.6152 18 18.0447 18 19.8081C18 21.5714 24.268 23.5 32 23.5Z"
        fill="#B9B9B9"
      />
      <path
        d="M32 18.5C39.732 18.5 46 16.9562 46 15.1928C46 13.4295 39.732 11 32 11C24.268 11 18 13.4295 18 15.1928C18 16.9562 24.268 18.5 32 18.5Z"
        fill="#DEDEDE"
      />
      <path
        d="M31.8827 44.16C33.6536 44.16 35.2826 43.8515 36.5969 43.4134C37.0103 43.2776 37.2818 42.9135 37.2818 42.5186V31.9548C37.2818 31.3563 36.6895 30.9058 36.0416 31.0169C34.8322 31.2205 33.4068 31.3378 31.8765 31.3378C30.3462 31.3378 28.9209 31.2205 27.7115 31.0169C27.0636 30.9058 26.4712 31.3624 26.4712 31.9548V42.5186C26.4712 42.9197 26.7427 43.2776 27.1561 43.4134C28.4766 43.8515 30.1056 44.16 31.8703 44.16H31.8827Z"
        fill="white"
      />
    </svg>
  ),
  "icon-service-support": (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.773 9.73219C38.6061 8.89871 34.4967 8.02899 31.5324 8C28.4739 8.05798 24.4587 8.89871 23.2918 9.73219C22.125 10.5657 21.7916 19.4658 21.7916 19.4658L30.6265 18.712C31.228 18.6613 31.8296 18.6613 32.4311 18.712L41.266 19.4658C41.266 19.4658 40.9326 10.5657 39.7658 9.73219H39.773Z"
        fill="#857471"
      />
      <path
        d="M51.4853 55.2478C49.5719 37.0489 14.4208 37.0489 12.5074 55.2478C12.4205 56.0885 13.109 56.8133 13.957 56.8133H50.043C50.891 56.8133 51.5795 56.0885 51.4926 55.2478H51.4853Z"
        fill="#B9B9B9"
      />
      <path
        d="M34.8954 38.7012H28.3726V45.4125H34.8954V38.7012Z"
        fill="#FFCBC2"
      />
      <path
        d="M23.6978 33.2071C24.785 32.1272 24.5603 30.1486 23.1905 28.7861C21.8207 27.4308 19.8348 27.1988 18.7477 28.286C17.6606 29.3659 17.8852 31.3445 19.255 32.707C20.6248 34.0624 22.6107 34.2943 23.6978 33.2071Z"
        fill="#FFCBC2"
      />
      <path
        d="M44.0491 32.707C45.4189 31.3445 45.6436 29.3659 44.5565 28.286C43.4693 27.1988 41.4762 27.4308 40.1136 28.7861C38.7438 30.1486 38.5192 32.1272 39.6063 33.2071C40.6935 34.2943 42.6866 34.0624 44.0491 32.707Z"
        fill="#FFCBC2"
      />
      <path
        d="M43.0928 26.4524C43.0928 34.0987 38.7514 40.1505 31.4965 40.1505C24.2416 40.1505 19.9003 34.0987 19.9003 26.4524C19.9003 18.8061 24.2416 12.6094 31.4965 12.6094C38.7514 12.6094 43.0928 18.8061 43.0928 26.4524Z"
        fill="#FFCBC2"
      />
      <path
        d="M28.1984 30.8233C28.7203 30.8233 29.1479 30.345 29.1479 29.7652C29.1479 29.1854 28.7203 28.707 28.1984 28.707C27.6766 28.707 27.2562 29.1781 27.2562 29.7652C27.2562 30.3522 27.6838 30.8233 28.1984 30.8233Z"
        fill="#252525"
      />
      <path
        d="M35.0621 30.8233C35.584 30.8233 36.0116 30.345 36.0116 29.7652C36.0116 29.1854 35.5912 28.707 35.0621 28.707C34.533 28.707 34.1199 29.1781 34.1199 29.7652C34.1199 30.3522 34.5403 30.8233 35.0621 30.8233Z"
        fill="#252525"
      />
      <path
        d="M33.3512 34.9178C33.3512 34.6279 32.7497 35.1497 31.6553 35.1497C30.5609 35.1497 29.9593 34.6279 29.9593 34.9178C29.9593 35.2077 30.7203 35.9107 31.6553 35.9107C32.5902 35.9107 33.3512 35.2149 33.3512 34.9178Z"
        fill="#252525"
      />
      <path
        d="M43.2233 27.699C42.6 30.098 34.1202 20.4368 34.1202 20.4368C34.1202 20.4368 20.6831 29.4892 20.0815 27.699C17.4434 19.8208 23.2632 12.6094 31.656 12.6094C40.0488 12.6094 45.1439 20.2919 43.2233 27.699Z"
        fill="#252525"
      />
      <path
        d="M31.6778 45.4129L28.3729 41.7891C26.8364 41.9847 25.771 42.2819 24.6693 42.5863L26.2203 47.5799C26.532 48.5946 27.7931 48.9353 28.5831 48.225L31.6778 45.4129Z"
        fill="white"
      />
      <path
        d="M31.5903 45.4124L34.8953 41.6074C36.4318 41.8031 37.5117 42.093 38.6133 42.3974L37.0478 47.5795C36.7362 48.5942 35.4751 48.9348 34.6851 48.2245L31.5903 45.4124Z"
        fill="white"
      />
      <path
        d="M40.6866 43.0205L40.1431 46.7748C39.6865 49.9203 38.3529 52.2468 31.6416 52.2468C28.4743 52.2468 24.3939 52.2468 23.1401 46.7893L22.6182 43.2814C21.4224 43.7453 21.0093 43.8685 19.9583 44.5208V56.82H42.9044V43.9337C41.9767 43.4409 41.7086 43.3829 40.6866 43.0205Z"
        fill="#857471"
      />
    </svg>
  ),
  "icon-service-call-human-circle": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#F5F5F5" />
      <path
        d="M30.2265 31.7432H25.2119V36.9039H30.2265V31.7432Z"
        fill="#FFCBC2"
      />
      <path
        d="M42.9862 44.4639C42.4325 39.157 38.1946 35.8806 33.08 34.5961V34.5807C32.2417 34.35 31.411 34.127 30.2266 33.9731L28.2807 36.2113C27.9808 36.5574 27.4424 36.5651 27.1347 36.2267L25.212 34.1193C24.0275 34.2731 23.2123 34.4961 22.3662 34.7346V34.75C17.5054 36.119 13.5598 39.3493 13.0061 44.4562C12.9369 45.1099 13.4676 45.6714 14.1213 45.6714H41.8787C42.5324 45.6714 43.0631 45.1176 42.9939 44.4639H42.9862Z"
        fill="#8F8F8F"
      />
      <path
        d="M36.5334 22.3213C36.5334 28.2051 33.1954 32.8582 27.6116 32.8582C22.0278 32.8582 18.6899 28.2051 18.6899 22.3213C18.6899 16.4376 22.0355 11.6768 27.6193 11.6768C33.2031 11.6768 36.5411 16.4453 36.5411 22.3213H36.5334Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.0813 25.6825C25.4813 25.6825 25.8121 25.3133 25.8121 24.8671C25.8121 24.421 25.4813 24.0518 25.0813 24.0518C24.6813 24.0518 24.3582 24.4133 24.3582 24.8671C24.3582 25.321 24.689 25.6825 25.0813 25.6825Z"
        fill="#252525"
      />
      <path
        d="M30.3574 25.6825C30.7574 25.6825 31.0882 25.3133 31.0882 24.8671C31.0882 24.421 30.7651 24.0518 30.3574 24.0518C29.9497 24.0518 29.6343 24.4133 29.6343 24.8671C29.6343 25.321 29.9574 25.6825 30.3574 25.6825Z"
        fill="#252525"
      />
      <path
        d="M29.0426 28.8284C29.0426 28.6053 28.581 29.0053 27.7349 29.0053C26.8887 29.0053 26.4272 28.6053 26.4272 28.8284C26.4272 29.0515 27.0118 29.5899 27.7349 29.5899C28.458 29.5899 29.0426 29.0515 29.0426 28.8284Z"
        fill="#252525"
      />
      <path
        d="M36.6333 23.2827C36.1565 25.1286 29.6344 17.6989 29.6344 17.6989C29.6344 17.6989 19.2974 24.6594 18.836 23.2827C16.8055 17.2221 21.2818 11.6768 27.7347 11.6768C34.1875 11.6768 38.11 17.5836 36.6333 23.2827Z"
        fill="#252525"
      />
      <path
        d="M34.8028 30.689H32.3955C31.9956 30.689 31.6725 30.366 31.6725 29.9661C31.6725 29.5661 31.9956 29.2431 32.3955 29.2431H34.8028C35.3489 29.2431 35.7873 28.8047 35.7873 28.2586V25.5975C35.7873 25.1975 36.1103 24.8745 36.5103 24.8745C36.9102 24.8745 37.2333 25.1975 37.2333 25.5975V28.2586C37.2333 29.6046 36.1411 30.6967 34.7952 30.6967L34.8028 30.689Z"
        fill="#686868"
      />
      <path
        d="M32.8188 28.7046H31.9573C31.2605 28.7046 30.6957 29.2694 30.6957 29.9661C30.6957 30.6629 31.2605 31.2277 31.9573 31.2277H32.8188C33.5155 31.2277 34.0804 30.6629 34.0804 29.9661C34.0804 29.2694 33.5155 28.7046 32.8188 28.7046Z"
        fill="#5E98EF"
      />
      <path
        d="M37.5101 19.468H35.9719C35.9719 15.6455 32.2263 12.5382 27.6193 12.5382C23.0123 12.5382 19.2667 15.6455 19.2667 19.468H17.7285C17.7361 14.7994 22.1663 11 27.627 11C33.0877 11 37.5178 14.7994 37.5178 19.468H37.5101Z"
        fill="#686868"
      />
      <path
        d="M19.4589 18.0215C16.9977 18.0215 15.0057 20.0135 15.0057 22.4747C15.0057 24.9358 16.9977 26.9278 19.4589 26.9278V18.0292V18.0215Z"
        fill="#5E98EF"
      />
      <path
        d="M35.7873 18.0215C38.2485 18.0215 40.2405 20.0135 40.2405 22.4747C40.2405 24.9358 38.2485 26.9278 35.7873 26.9278V18.0292V18.0215Z"
        fill="#5E98EF"
      />
    </svg>
  ),
  "icon-service-call-human": (
    <svg
      width="36"
      height="43"
      viewBox="0 0 36 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6719 25.4912H14.6543V31.6841H20.6719V25.4912Z"
        fill="#FFCBC2"
      />
      <path
        d="M35.9835 40.7569C35.319 34.3886 30.2336 30.4569 24.096 28.9155V28.8971C23.09 28.6202 22.0932 28.3526 20.6719 28.168L18.3369 30.8537C17.9769 31.269 17.3309 31.2783 16.9617 30.8722L14.6543 28.3433C13.233 28.5279 12.2547 28.7956 11.2395 29.0817V29.1001C5.4065 30.743 0.671818 34.6193 0.00730212 40.7476C-0.0757624 41.5321 0.561066 42.2059 1.34556 42.2059H34.6544C35.4389 42.2059 36.0758 41.5414 35.9927 40.7569H35.9835Z"
        fill="#8F8F8F"
      />
      <path
        d="M28.24 14.1846C28.24 21.2451 24.2345 26.8289 17.5339 26.8289C10.8334 26.8289 6.82782 21.2451 6.82782 14.1846C6.82782 7.12412 10.8426 1.41113 17.5431 1.41113C24.2437 1.41113 28.2492 7.13335 28.2492 14.1846H28.24Z"
        fill="#FFCBC2"
      />
      <path
        d="M14.4976 18.2186C14.9776 18.2186 15.3745 17.7756 15.3745 17.2402C15.3745 16.7048 14.9776 16.2617 14.4976 16.2617C14.0176 16.2617 13.6299 16.6956 13.6299 17.2402C13.6299 17.7848 14.0268 18.2186 14.4976 18.2186Z"
        fill="#252525"
      />
      <path
        d="M20.8289 18.2186C21.3089 18.2186 21.7059 17.7756 21.7059 17.2402C21.7059 16.7048 21.3182 16.2617 20.8289 16.2617C20.3397 16.2617 19.9612 16.6956 19.9612 17.2402C19.9612 17.7848 20.3489 18.2186 20.8289 18.2186Z"
        fill="#252525"
      />
      <path
        d="M19.2511 21.9933C19.2511 21.7256 18.6972 22.2056 17.6818 22.2056C16.6665 22.2056 16.1126 21.7256 16.1126 21.9933C16.1126 22.261 16.8141 22.9071 17.6818 22.9071C18.5495 22.9071 19.2511 22.261 19.2511 21.9933Z"
        fill="#252525"
      />
      <path
        d="M28.36 15.3383C27.7878 17.5533 19.9612 8.63774 19.9612 8.63774C19.9612 8.63774 7.55693 16.9903 7.00317 15.3383C4.56661 8.06552 9.93812 1.41113 17.6816 1.41113C25.425 1.41113 30.132 8.4993 28.36 15.3383Z"
        fill="#252525"
      />
      <path
        d="M26.1634 24.2264H23.2746C22.7947 24.2264 22.407 23.8388 22.407 23.3589C22.407 22.879 22.7947 22.4913 23.2746 22.4913H26.1634C26.8187 22.4913 27.3448 21.9652 27.3448 21.31V18.1166C27.3448 17.6367 27.7324 17.249 28.2123 17.249C28.6923 17.249 29.0799 17.6367 29.0799 18.1166V21.31C29.0799 22.9251 27.7693 24.2357 26.1542 24.2357L26.1634 24.2264Z"
        fill="#686868"
      />
      <path
        d="M23.7826 21.8447H22.7487C21.9127 21.8447 21.2349 22.5225 21.2349 23.3586C21.2349 24.1946 21.9127 24.8724 22.7487 24.8724H23.7826C24.6187 24.8724 25.2964 24.1946 25.2964 23.3586C25.2964 22.5225 24.6187 21.8447 23.7826 21.8447Z"
        fill="#5E98EF"
      />
      <path
        d="M29.4122 10.7612H27.5663C27.5663 6.17416 23.0716 2.44549 17.5432 2.44549C12.0148 2.44549 7.52004 6.17416 7.52004 10.7612H5.67416C5.68339 5.15893 10.9995 0.599609 17.5524 0.599609C24.1053 0.599609 29.4214 5.15893 29.4214 10.7612H29.4122Z"
        fill="#686868"
      />
      <path
        d="M7.75074 9.02539C4.79733 9.02539 2.40692 11.4158 2.40692 14.3692C2.40692 17.3226 4.79733 19.713 7.75074 19.713V9.03462V9.02539Z"
        fill="#5E98EF"
      />
      <path
        d="M27.3447 9.02539C30.2981 9.02539 32.6885 11.4158 32.6885 14.3692C32.6885 17.3226 30.2981 19.713 27.3447 19.713V9.03462V9.02539Z"
        fill="#5E98EF"
      />
    </svg>
  ),
  "icon-service-call-human-and-money": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path
        d="M29.619 28.5449H23.3262V34.8957H29.619V28.5449Z"
        fill="#FFCBC2"
      />
      <path
        d="M45.6298 44.1999C44.9349 37.6693 39.6168 33.6374 33.1984 32.0568V32.0379C32.1464 31.7539 31.104 31.4795 29.6177 31.2902L27.1758 34.0444C26.7994 34.4703 26.1238 34.4798 25.7377 34.0633L23.3248 31.47C21.8385 31.6593 20.8154 31.9338 19.7537 32.2272V32.2461C13.6539 33.9308 8.70256 37.906 8.00764 44.1905C7.92077 44.995 8.58674 45.6859 9.40713 45.6859H44.2399C45.0603 45.6859 45.7263 45.0044 45.6394 44.1999H45.6298Z"
        fill="#8F8F8F"
      />
      <path
        d="M37.5325 16.9506C37.5325 24.191 33.3436 29.9172 26.3365 29.9172C19.3294 29.9172 15.1406 24.191 15.1406 16.9506C15.1406 9.71017 19.3391 3.85156 26.3462 3.85156C33.3533 3.85156 37.5421 9.71963 37.5421 16.9506H37.5325Z"
        fill="#FFCBC2"
      />
      <path
        d="M23.1593 21.0869C23.6613 21.0869 24.0764 20.6325 24.0764 20.0835C24.0764 19.5344 23.6613 19.0801 23.1593 19.0801C22.6574 19.0801 22.252 19.525 22.252 20.0835C22.252 20.642 22.667 21.0869 23.1593 21.0869Z"
        fill="#252525"
      />
      <path
        d="M29.7824 21.0869C30.2843 21.0869 30.6994 20.6325 30.6994 20.0835C30.6994 19.5344 30.294 19.0801 29.7824 19.0801C29.2708 19.0801 28.875 19.525 28.875 20.0835C28.875 20.642 29.2804 21.0869 29.7824 21.0869Z"
        fill="#252525"
      />
      <path
        d="M28.1317 24.9583C28.1317 24.6837 27.5525 25.176 26.4906 25.176C25.4288 25.176 24.8496 24.6837 24.8496 24.9583C24.8496 25.2328 25.5832 25.8954 26.4906 25.8954C27.398 25.8954 28.1317 25.2328 28.1317 24.9583Z"
        fill="#252525"
      />
      <path
        d="M37.657 18.1337C37.0586 20.4052 28.874 11.2624 28.874 11.2624C28.874 11.2624 15.9021 19.8279 15.323 18.1337C12.775 10.6756 18.3923 3.85156 26.49 3.85156C34.5877 3.85156 39.5101 11.1204 37.657 18.1337Z"
        fill="#252525"
      />
      <path
        d="M35.3618 27.249H32.3408C31.839 27.249 31.4336 26.8515 31.4336 26.3593C31.4336 25.8672 31.839 25.4697 32.3408 25.4697H35.3618C36.0471 25.4697 36.5972 24.9302 36.5972 24.2582V20.9834C36.5972 20.4913 37.0026 20.0938 37.5045 20.0938C38.0064 20.0938 38.4117 20.4913 38.4117 20.9834V24.2582C38.4117 25.9145 37.0412 27.2585 35.3522 27.2585L35.3618 27.249Z"
        fill="#686868"
      />
      <path
        d="M32.8693 24.8057H31.7882C30.9139 24.8057 30.2051 25.5007 30.2051 26.3581C30.2051 27.2155 30.9139 27.9105 31.7882 27.9105H32.8693C33.7437 27.9105 34.4524 27.2155 34.4524 26.3581C34.4524 25.5007 33.7437 24.8057 32.8693 24.8057Z"
        fill="#5E98EF"
      />
      <path
        d="M38.7596 13.4411H36.8293C36.8293 8.73714 32.1289 4.91343 26.3476 4.91343C20.5662 4.91343 15.8659 8.73714 15.8659 13.4411H13.9355C13.9452 7.69603 19.5045 3.02051 26.3572 3.02051C33.2099 3.02051 38.7692 7.69603 38.7692 13.4411H38.7596Z"
        fill="#686868"
      />
      <path
        d="M16.1059 11.6611C13.0174 11.6611 10.5176 14.1125 10.5176 17.1412C10.5176 20.1698 13.0174 22.6212 16.1059 22.6212V11.6706V11.6611Z"
        fill="#5E98EF"
      />
      <path
        d="M36.5957 11.6611C39.6842 11.6611 42.184 14.1125 42.184 17.1412C42.184 20.1698 39.6842 22.6212 36.5957 22.6212V11.6706V11.6611Z"
        fill="#5E98EF"
      />
      <path
        d="M51.686 38.1562H24.9151C24.222 38.1562 23.6602 38.7181 23.6602 39.4112V55.7244C23.6602 56.4175 24.222 56.9793 24.9151 56.9793H51.686C52.3791 56.9793 52.9409 56.4175 52.9409 55.7244V39.4112C52.9409 38.7181 52.3791 38.1562 51.686 38.1562Z"
        fill="#CFE8D5"
      />
      <path
        d="M49.8551 39.9637C50.5481 39.9637 51.11 40.5256 51.11 41.2186V53.9169C51.11 54.61 50.5481 55.1718 49.8551 55.1718H26.746C26.053 55.1718 25.4911 54.61 25.4911 53.9169V41.2186C25.4911 40.5256 26.053 39.9637 26.746 39.9637H49.8551ZM52.9409 39.4112C52.9409 38.7181 52.3791 38.1562 51.686 38.1562H24.9151C24.222 38.1562 23.6602 38.7181 23.6602 39.4112V55.7244C23.6602 56.4175 24.222 56.9793 24.9151 56.9793H51.686C52.3791 56.9793 52.9409 56.4175 52.9409 55.7244V39.4112Z"
        fill="#77B78B"
      />
      <path
        d="M24.9059 51.4361C24.2287 51.2887 23.6602 51.8646 23.6602 52.5576V55.7269C23.6602 56.42 24.222 56.9818 24.9151 56.9818H28.1581C28.8512 56.9818 29.4275 56.4128 29.2745 55.7368C28.7895 53.594 27.0788 51.9091 24.9059 51.4361Z"
        fill="#77B78B"
      />
      <path
        d="M52.9404 52.5576C52.9404 51.8646 52.3719 51.2887 51.6947 51.4361C49.5218 51.9091 47.811 53.594 47.326 55.7368C47.173 56.4128 47.7493 56.9818 48.4424 56.9818H51.6855C52.3785 56.9818 52.9404 56.42 52.9404 55.7269V52.5576Z"
        fill="#77B78B"
      />
      <path
        d="M48.4424 38.1562C47.7493 38.1562 47.173 38.7253 47.326 39.4012C47.811 41.5441 49.5218 43.2289 51.6947 43.702C52.3719 43.8494 52.9404 43.2735 52.9404 42.5804V39.4112C52.9404 38.7181 52.3785 38.1562 51.6855 38.1562H48.4424Z"
        fill="#77B78B"
      />
      <path
        d="M23.6602 42.5804C23.6602 43.2735 24.2287 43.8494 24.9059 43.702C27.0788 43.2289 28.7895 41.5441 29.2745 39.4012C29.4275 38.7253 28.8512 38.1562 28.1581 38.1562H24.9151C24.222 38.1562 23.6602 38.7181 23.6602 39.4112V42.5804Z"
        fill="#77B78B"
      />
      <path
        d="M38.2993 52.8805C41.2702 52.8805 43.6787 50.503 43.6787 47.5701C43.6787 44.6373 41.2702 42.2598 38.2993 42.2598C35.3283 42.2598 32.9199 44.6373 32.9199 47.5701C32.9199 50.503 35.3283 52.8805 38.2993 52.8805Z"
        fill="#91CBA5"
      />
      <path
        d="M41.6758 47.0538H41.2097L41.5636 45.8804C41.6067 45.7426 41.5981 45.5953 41.5377 45.4623C41.4773 45.3292 41.378 45.2342 41.2571 45.1867C41.132 45.1345 40.9939 45.144 40.8773 45.2057C40.7565 45.2722 40.6658 45.3863 40.6227 45.524L39.8285 48.08L38.9998 45.5193C38.9307 45.315 38.7451 45.182 38.5293 45.182C38.3135 45.182 38.1279 45.315 38.0546 45.524L37.2302 48.099L36.4058 45.5193C36.3626 45.3815 36.2677 45.2722 36.1511 45.2057C36.0303 45.1392 35.8965 45.1297 35.7713 45.182C35.508 45.2865 35.3742 45.5953 35.4649 45.8851L35.8317 47.0491H35.344C35.0764 47.0491 34.8477 47.3009 34.8477 47.5954C34.8477 47.89 35.0764 48.1418 35.344 48.1418H36.1857L36.7597 49.9519C36.8245 50.1562 37.01 50.2892 37.2302 50.2892C37.4503 50.2892 37.6316 50.1562 37.7049 49.9471L38.525 47.3674L39.3624 49.9519C39.4271 50.1562 39.6127 50.2892 39.8285 50.2892C40.0443 50.2892 40.2342 50.1514 40.3033 49.9376L40.8557 48.1465H41.6715C41.9391 48.1465 42.1679 47.8947 42.1679 47.6002C42.1679 47.3056 41.9391 47.0538 41.6715 47.0538H41.6758Z"
        fill="white"
      />
    </svg>
  ),
  "icon-service-coin-cycle": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.01 36.6461C30.9997 36.6461 36.666 30.9798 36.666 23.99C36.666 17.0003 30.9997 11.334 24.01 11.334C17.0203 11.334 11.354 17.0003 11.354 23.99C11.354 30.9798 17.0203 36.6461 24.01 36.6461Z"
        fill="#FFB65C"
      />
      <path
        d="M30.8148 22.6386H30.4075L30.944 21.0193C31.1824 20.2941 30.795 19.4994 30.0698 19.251C29.3446 18.9928 28.5499 19.4001 28.3015 20.1252L27.0796 23.7115L25.7981 20.1054C25.5895 19.5491 25.0729 19.1716 24.4769 19.1716C23.8809 19.1716 23.3643 19.5391 23.1557 20.1054L21.8742 23.7512L20.5927 20.1054C20.3344 19.3802 19.5297 18.9928 18.8046 19.251C18.0794 19.5093 17.6919 20.2941 17.9502 21.0392L18.5065 22.6386H18.0794C17.3144 22.6386 16.6886 23.2744 16.6886 24.0293C16.6886 24.7843 17.3244 25.4201 18.0794 25.4201H19.49L20.5529 28.45C20.7616 29.0063 21.2781 29.3838 21.8742 29.3838C22.4702 29.3838 22.9868 29.0163 23.1954 28.45L24.4769 24.7843L25.7783 28.45C25.9869 29.0063 26.5034 29.3838 27.0995 29.3838C27.6955 29.3838 28.2121 28.9964 28.4207 28.4401L29.4439 25.4301H30.8049C31.5698 25.4301 32.1957 24.7943 32.1957 24.0393C32.1957 23.2843 31.5599 22.6485 30.8049 22.6485H30.8248L30.8148 22.6386Z"
        fill="white"
      />
      <path
        d="M5.49287 22.7865C5.49287 22.7865 5.43327 22.7865 5.40347 22.7865C4.57894 22.7369 3.95309 22.0315 4.00276 21.2169C4.5094 12.6339 10.2314 5.59061 18.5661 3.26603C24 1.75605 28.8081 3.20643 31.8877 4.67668C32.6327 5.0343 32.9407 5.91844 32.5831 6.6635C32.2254 7.40855 31.3413 7.71651 30.5962 7.35888C27.9736 6.09725 23.9007 4.86542 19.3608 6.12705C12.2679 8.10394 7.40021 14.0843 6.97305 21.3759C6.92338 22.1706 6.26773 22.7766 5.48294 22.7766L5.49287 22.7865Z"
        fill="#FF8730"
      />
      <path
        d="M28.818 9.54513C28.2617 9.54513 27.7551 9.16763 27.616 8.60139C27.4471 7.9358 27.8544 7.26028 28.52 7.10134L31.381 6.39602L30.6757 3.535C30.5068 2.86941 30.9141 2.1939 31.5797 2.03495C32.2453 1.876 32.9208 2.27337 33.0797 2.93895L34.0831 7.01193C34.252 7.67752 33.8447 8.35303 33.1791 8.51198L29.1061 9.51532C29.0068 9.53519 28.9074 9.55506 28.8081 9.55506L28.818 9.54513Z"
        fill="#FF8730"
      />
      <path
        d="M24.745 45.3577C21.8741 45.3577 18.9535 44.6722 16.1123 43.3013C15.3673 42.9437 15.0593 42.0596 15.417 41.3145C15.7746 40.5695 16.6587 40.2615 17.4038 40.6191C20.0264 41.8808 24.0993 43.1126 28.6392 41.851C35.7321 39.8741 40.5998 33.8938 41.027 26.6021C41.0766 25.7776 41.772 25.1319 42.5965 25.2014C43.4211 25.2511 44.0469 25.9564 43.9972 26.771C43.4906 35.3541 37.7785 42.3973 29.4339 44.712C27.9041 45.1391 26.3246 45.3478 24.7351 45.3478L24.745 45.3577Z"
        fill="#FF8730"
      />
      <path
        d="M16.1223 46.0033C15.566 46.0033 15.0594 45.6258 14.9203 45.0596L13.917 40.9866C13.7481 40.321 14.1554 39.6455 14.821 39.4865L18.8939 38.4832C19.5496 38.3242 20.235 38.7216 20.394 39.3872C20.5629 40.0528 20.1556 40.7283 19.49 40.8872L16.619 41.5926L17.3244 44.4536C17.4932 45.1192 17.0859 45.7947 16.4204 45.9536C16.321 45.9735 16.2217 45.9934 16.1223 45.9934V46.0033Z"
        fill="#FF8730"
      />
    </svg>
  ),
  "icon-service-cash-receipt": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="2" width="34" height="44" rx="3" fill="#BDD5FF" />
      <path
        d="M16.1812 30.9895C15.9396 30.9895 15.698 30.8949 15.5223 30.7372L13.7871 29.1286C13.4137 28.7817 13.4027 28.2035 13.7651 27.8355C14.1275 27.478 14.7316 27.4675 15.1159 27.8145L16.1483 28.7712L18.4766 26.3006C18.828 25.9221 19.4321 25.9011 19.8164 26.2375C20.2118 26.5739 20.2338 27.1521 19.8823 27.5201L16.8951 30.6951C16.7194 30.8738 16.4778 30.9895 16.2252 31C16.2252 31 16.2032 31 16.1922 31L16.1812 30.9895Z"
        fill="#69A5FF"
      />
      <path
        d="M33.5446 29.4016H23.6383C23.1112 29.4016 22.6829 28.9916 22.6829 28.4869C22.6829 27.9823 23.1112 27.5723 23.6383 27.5723H33.5446C34.0717 27.5723 34.5 27.9823 34.5 28.4869C34.5 28.9916 34.0717 29.4016 33.5446 29.4016Z"
        fill="#69A5FF"
      />
      <path
        d="M16.1812 38.9895C15.9396 38.9895 15.698 38.8949 15.5223 38.7372L13.7871 37.1286C13.4137 36.7817 13.4027 36.2035 13.7651 35.8355C14.1275 35.478 14.7316 35.4675 15.1159 35.8145L16.1483 36.7712L18.4766 34.3006C18.828 33.9221 19.4321 33.9011 19.8164 34.2375C20.2118 34.5739 20.2338 35.1521 19.8823 35.5201L16.8951 38.6951C16.7194 38.8738 16.4778 38.9895 16.2252 39C16.2252 39 16.2032 39 16.1922 39L16.1812 38.9895Z"
        fill="#69A5FF"
      />
      <path
        d="M33.5446 37.4016H23.6383C23.1112 37.4016 22.6829 36.9916 22.6829 36.4869C22.6829 35.9823 23.1112 35.5723 23.6383 35.5723H33.5446C34.0717 35.5723 34.5 35.9823 34.5 36.4869C34.5 36.9916 34.0717 37.4016 33.5446 37.4016Z"
        fill="#69A5FF"
      />
      <path
        d="M24 23C28.1421 23 31.5 19.6421 31.5 15.5C31.5 11.3579 28.1421 8 24 8C19.8579 8 16.5 11.3579 16.5 15.5C16.5 19.6421 19.8579 23 24 23Z"
        fill="#69A5FF"
      />
      <path
        d="M28.1372 14.6536H27.871L28.2218 13.6012C28.3791 13.1294 28.1251 12.6093 27.6533 12.452C27.1815 12.2826 26.6613 12.5488 26.5041 13.0205L25.7057 15.3552L24.871 13.0085C24.738 12.6455 24.3992 12.4036 24.0122 12.4036C23.6251 12.4036 23.2863 12.6455 23.1533 13.0085L22.3186 15.3794L21.4839 13.0085C21.3146 12.5367 20.7944 12.2826 20.3226 12.452C19.8509 12.6214 19.5968 13.1294 19.7662 13.6133L20.1291 14.6536H19.8509C19.3549 14.6536 18.9436 15.0649 18.9436 15.5609C18.9436 16.0568 19.3549 16.4681 19.8509 16.4681H20.7702L21.4597 18.4399C21.5928 18.8028 21.9315 19.0447 22.3186 19.0447C22.7057 19.0447 23.0444 18.8028 23.1775 18.4399L24.0122 16.0568L24.8589 18.4399C24.992 18.8028 25.3307 19.0447 25.7178 19.0447C26.1049 19.0447 26.4436 18.7907 26.5767 18.4278L27.242 16.4681H28.1251C28.621 16.4681 29.0323 16.0568 29.0323 15.5609C29.0323 15.0649 28.621 14.6536 28.1251 14.6536H28.1372Z"
        fill="white"
      />
    </svg>
  ),
  "icon-service-moneybag": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.0543 13.7891H16.9551C11.0142 17.8064 7 22.8036 7 28.5749C7 36.0315 13.1488 39.9999 23 39.9999C32.8512 39.9999 39 36.0315 39 28.5749C39 22.8036 34.9858 17.8064 29.0449 13.7989L29.0543 13.7891Z"
        fill="#FFB65C"
      />
      <path
        d="M28.516 12.3292H17.7297L16.0012 7.44961C15.6801 6.21501 16.5301 5 17.7013 5H28.5349C29.7061 5 30.5561 6.22481 30.235 7.44961L28.5065 12.3292H28.516Z"
        fill="#FFB65C"
      />
      <path
        d="M28.6104 10.5664H17.3991C16.4601 10.5664 15.699 11.3561 15.699 12.3301V12.3399C15.699 13.314 16.4601 14.1036 17.3991 14.1036H28.6104C29.5494 14.1036 30.3105 13.314 30.3105 12.3399V12.3301C30.3105 11.3561 29.5494 10.5664 28.6104 10.5664Z"
        fill="#895842"
      />
      <path
        d="M36 45C40.9662 45 45 40.9662 45 36C45 31.0338 40.9662 27 36 27C31.0338 27 27 31.0338 27 36C27 40.9662 31.0338 45 36 45Z"
        fill="#ED3C32"
      />
      <path
        d="M37.6994 36.002L40.1499 33.5514C40.6167 33.0847 40.6167 32.3315 40.1499 31.8541C39.6831 31.3767 38.9299 31.3873 38.4526 31.8541L36.002 34.3046L33.5514 31.8541C33.0847 31.3873 32.3315 31.3873 31.8541 31.8541C31.3767 32.3208 31.3873 33.074 31.8541 33.5514L34.3046 36.002L31.8541 38.4526C31.3873 38.9193 31.3873 39.6725 31.8541 40.1499C32.0875 40.3833 32.3951 40.5 32.7028 40.5C33.0104 40.5 33.318 40.3833 33.5514 40.1499L36.002 37.6994L38.4526 40.1499C38.6859 40.3833 38.9936 40.5 39.3012 40.5C39.6089 40.5 39.9165 40.3833 40.1499 40.1499C40.6167 39.6831 40.6167 38.9299 40.1499 38.4526L37.6994 36.002Z"
        fill="white"
      />
    </svg>
  ),
  "icon-service-promise": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#F5F5F5" />
      <path
        d="M33.4687 32.826L37.663 34.8409L43.0174 23.695C43.5584 22.5688 43.0809 21.2082 41.9546 20.6671L41.8381 20.6112C40.7119 20.0701 39.3512 20.5477 38.8102 21.6739L33.4557 32.8198L33.4687 32.826Z"
        fill="#FFC6BC"
      />
      <path
        d="M19.246 31.3529L23.4403 33.3678L27.5821 24.7462C28.1231 23.62 27.6455 22.2593 26.5193 21.7183L26.4028 21.6623C25.2765 21.1213 23.9159 21.5989 23.3748 22.7251L19.2331 31.3467L19.246 31.3529Z"
        fill="#FFC6BC"
      />
      <path
        d="M21.9064 43.4279L22.4113 43.6705C27.3435 46.0398 33.2652 43.9613 35.6346 39.0292L37.8485 34.4207L22.8577 27.2193C21.0065 26.33 18.7835 27.1103 17.8942 28.9615L17.291 30.2172C14.9216 35.1493 17.0001 41.071 21.9323 43.4404L21.9064 43.4279Z"
        fill="#FFC6BC"
      />
      <path
        d="M26.3696 32.252L26.2661 32.2023C25.1364 31.6596 24.6606 30.304 25.2033 29.1744L27.6722 24.0351C28.2148 22.9055 29.5705 22.4297 30.7001 22.9723L30.8037 23.0221C31.9333 23.5647 32.4091 24.9204 31.8665 26.05L29.3976 31.1893C28.8549 32.3189 27.4993 32.7947 26.3696 32.252Z"
        fill="#FFC6BC"
      />
      <path
        d="M30.5844 34.0504L30.4809 34.0006C29.3512 33.458 28.8754 32.1023 29.4181 30.9727L31.8061 26.0017C32.3487 24.8721 33.7044 24.3963 34.834 24.9389L34.9376 24.9887C36.0672 25.5313 36.543 26.887 36.0004 28.0166L33.6124 32.9876C33.0697 34.1172 31.714 34.593 30.5844 34.0504Z"
        fill="#FFC6BC"
      />
      <path
        d="M30.0012 30.6824C30.1411 30.6286 30.2492 30.534 30.3253 30.3985L31.1023 28.8705C31.2392 28.5864 31.1128 28.2504 30.8431 28.1124C30.5734 27.9744 30.223 28.1019 30.085 28.3716L29.308 29.8997C29.1712 30.1837 29.2975 30.5198 29.5672 30.6577C29.7015 30.7196 29.8612 30.7362 30.0012 30.6824Z"
        fill="#FF9C99"
      />
      <path
        d="M25.8606 28.6931C26.0006 28.6393 26.1086 28.5447 26.1847 28.4093L26.9617 26.8812C27.0986 26.5972 26.9723 26.2611 26.7025 26.1231C26.4328 25.9852 26.0824 26.1126 25.9445 26.3823L25.1675 27.9104C25.0306 28.1944 25.1569 28.5305 25.4266 28.6685C25.561 28.7303 25.7207 28.747 25.8606 28.6931Z"
        fill="#FF9C99"
      />
      <path
        d="M28.9359 30.691C28.6003 31.3934 28.5588 32.1743 28.8158 32.9037C29.0728 33.6332 29.5932 34.2274 30.2946 34.5486C30.997 34.8842 31.7779 34.9257 32.5073 34.6687C33.2368 34.4117 33.831 33.8913 34.1522 33.19L35.8929 29.558C36.0298 29.2739 35.9035 28.9379 35.6338 28.7999C35.364 28.6619 35.0136 28.7894 34.8757 29.0591L33.135 32.6911C32.7243 33.5432 31.6302 33.9287 30.778 33.5181C30.3597 33.3195 30.0296 32.9556 29.8802 32.5061C29.7309 32.0565 29.7523 31.5796 29.951 31.1612L28.9348 30.6767L28.9359 30.691Z"
        fill="#FF9C99"
      />
      <path
        d="M22.4988 29.7109L22.5486 29.6074C23.0912 28.4777 24.4469 28.0019 25.5765 28.5446L29.3307 30.348C30.4603 30.8907 30.9361 32.2463 30.3935 33.3759L30.3437 33.4795C29.801 34.6091 28.4454 35.0849 27.3158 34.5423L23.5616 32.7388C22.432 32.1962 21.9561 30.8405 22.4988 29.7109Z"
        fill="#FFC6BC"
      />
      <path
        d="M21.4014 26.8705C21.9443 27.0021 23.1453 27.6455 23.1453 27.6455L29.4194 30.986C30.3012 31.4087 30.6692 32.461 30.2464 33.3429C29.8236 34.2247 28.7713 34.5927 27.8895 34.1699L25.2515 33.0019C25.1018 32.9268 24.9288 32.9256 24.7613 32.9959C24.6082 33.0651 24.4891 33.2038 24.4591 33.3789C24.1716 34.5241 23.6562 35.5139 22.9392 36.5045C22.7572 36.7631 22.812 37.1046 23.0717 37.301C23.3304 37.483 23.6862 37.4272 23.8682 37.1685C24.455 36.3606 24.9086 35.5052 25.2433 34.6012C25.314 34.3942 25.5509 34.2898 25.7458 34.3903L27.4192 35.185C28.137 35.5338 28.9301 35.5456 29.632 35.3051C30.3339 35.0646 30.9424 34.5431 31.2769 33.8264C31.9745 32.3908 31.3528 30.652 29.9183 29.9687L23.5527 26.7504C23.1035 26.5252 22.3119 26.1532 21.8009 26.0624L21.4025 26.8848L21.4014 26.8705Z"
        fill="#FF9C99"
      />
      <rect
        x="25.5148"
        y="13.5615"
        width="3.8"
        height="3.8"
        transform="rotate(31.2989 25.5148 13.5615)"
        fill="#F5756E"
      />
      <rect
        x="32"
        y="17.1562"
        width="3.15452"
        height="3.15452"
        transform="rotate(-29.2154 32 17.1562)"
        fill="#FFB862"
      />
      <ellipse
        cx="31.0742"
        cy="10.6894"
        rx="1.75251"
        ry="1.75251"
        transform="rotate(-5.39485 31.0742 10.6894)"
        fill="#6DA6FC"
      />
    </svg>
  ),
  "icon-service-scale": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#F5F5F5" />
      <path
        d="M16.9848 29.0898H14.5178V32.8287H16.9848V29.0898Z"
        fill="#CCCCCC"
      />
      <path
        d="M14.5787 17.283L10.3249 24.3137C9.76652 25.2281 10.4264 26.3964 11.5026 26.3964H20.0102C21.0762 26.3964 21.7361 25.2281 21.1878 24.3137L16.934 17.283C16.396 16.3991 15.1168 16.3991 14.5889 17.283H14.5787Z"
        fill="#69A5FF"
      />
      <path
        d="M10.4975 27.3203H21.0051C21.2792 27.3203 21.5025 27.5438 21.5025 27.8181C21.5025 28.6614 20.8122 29.3523 19.9695 29.3523H11.533C10.6904 29.3523 10 28.6614 10 27.8181C10 27.5438 10.2234 27.3203 10.4975 27.3203Z"
        fill="#8F8F8F"
      />
      <path
        d="M41.4924 23.5723H39.0254V27.1892H41.4924V23.5723Z"
        fill="#CCCCCC"
      />
      <path
        d="M40.2538 22.1599C43.0573 22.1599 45.3299 19.8855 45.3299 17.0799C45.3299 14.2744 43.0573 12 40.2538 12C37.4503 12 35.1776 14.2744 35.1776 17.0799C35.1776 19.8855 37.4503 22.1599 40.2538 22.1599Z"
        fill="#FF8741"
      />
      <path
        d="M34.9949 22.7188H45.5026C45.7767 22.7188 46 22.9423 46 23.2166C46 24.0599 45.3097 24.7507 44.467 24.7507H36.0406C35.198 24.7507 34.5076 24.0599 34.5076 23.2166C34.5076 22.9423 34.731 22.7188 35.0051 22.7188H34.9949Z"
        fill="#8F8F8F"
      />
      <path
        d="M29.9493 30.0137H27.4112V34.6287H29.9493V30.0137Z"
        fill="#8F8F8F"
      />
      <path
        d="M34.467 41.0854H22.9036L24.5888 34.5748C24.7919 33.6617 25.6142 33.0166 26.5685 33.0166H30.802C31.7564 33.0166 32.5787 33.6617 32.7817 34.5748L34.467 41.0854Z"
        fill="#CCCCCC"
      />
      <path
        d="M34.5482 40.5195H22.8122C22.3636 40.5195 22 40.875 22 41.3135V42.2067C22 42.6452 22.3636 43.0007 22.8122 43.0007H34.5482C34.9968 43.0007 35.3604 42.6452 35.3604 42.2067V41.3135C35.3604 40.875 34.9968 40.5195 34.5482 40.5195Z"
        fill="#8F8F8F"
      />
      <path
        d="M41.7397 25.607L13.7686 31.2715C13.0817 31.4107 12.6375 32.0807 12.7765 32.7682C12.9155 33.4556 13.5851 33.9002 14.272 33.761L42.2431 28.0965C42.93 27.9574 43.3742 27.2874 43.2352 26.5999C43.0962 25.9124 42.4266 25.4679 41.7397 25.607Z"
        fill="#CCCCCC"
      />
    </svg>
  ),
  "icon-service-bus-mono": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17749 14.1512C3.17749 14.8112 3.71749 15.3512 4.37749 15.3512H4.76749C5.42749 15.3512 5.96749 14.8112 5.96749 14.1512V13.7012H3.17749V14.1512Z"
        fill="#686868"
      />
      <path
        d="M10.1375 14.1512C10.1375 14.8112 10.6775 15.3512 11.3375 15.3512H11.7275C12.3875 15.3512 12.9275 14.8112 12.9275 14.1512V13.7012H10.1375V14.1512Z"
        fill="#686868"
      />
      <path
        d="M12.08 0.650391H4.03251C3.08751 0.650391 2.31501 1.34789 2.18751 2.26289H13.9325C13.805 1.35539 13.0325 0.650391 12.0875 0.650391H12.08Z"
        fill="#686868"
      />
      <path
        d="M2.0525 3.02117C1.3325 3.02117 0.747498 3.60617 0.747498 4.32617V5.87117C0.747498 6.59117 1.3325 7.17617 2.0525 7.17617V3.01367V3.02117Z"
        fill="#686868"
      />
      <path
        d="M13.9475 3.02117C14.6675 3.02117 15.2525 3.60617 15.2525 4.32617V5.87117C15.2525 6.59117 14.6675 7.17617 13.9475 7.17617V3.01367V3.02117Z"
        fill="#686868"
      />
      <path
        d="M2.14999 7.92578V12.2008C2.14999 12.6133 2.48749 12.9508 2.89999 12.9508H13.1975C13.61 12.9508 13.9475 12.6133 13.9475 12.2008V7.92578H2.14999ZM4.66999 11.5633C4.04749 11.5633 3.54499 11.0608 3.54499 10.4383C3.54499 9.81578 4.04749 9.31328 4.66999 9.31328C5.29249 9.31328 5.79499 9.81578 5.79499 10.4383C5.79499 11.0608 5.29249 11.5633 4.66999 11.5633ZM11.42 11.5633C10.7975 11.5633 10.295 11.0608 10.295 10.4383C10.295 9.81578 10.7975 9.31328 11.42 9.31328C12.0425 9.31328 12.545 9.81578 12.545 10.4383C12.545 11.0608 12.0425 11.5633 11.42 11.5633Z"
        fill="#686868"
      />
    </svg>
  ),
  "icon-service-ugol-mono": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38251 5.9175H14.94C15.15 5.9175 15.315 5.7525 15.315 5.5425V3.4125L13.5975 1.635C13.515 1.5525 13.4025 1.5 13.29 1.5H5.03251C4.92001 1.5 4.80751 1.545 4.72501 1.635L3.00751 3.4125V5.5425C3.00751 5.7525 3.17251 5.9175 3.38251 5.9175Z"
        fill="#FF8741"
      />
      <path
        d="M14.9325 7.3125H3.375C3.165 7.3125 3 7.4775 3 7.6875V15.7875C3 16.2 3.3375 16.5375 3.75 16.5375H14.5575C14.97 16.5375 15.3075 16.2 15.3075 15.7875V7.6875C15.3075 7.4775 15.1425 7.3125 14.9325 7.3125ZM10.8975 13.7475C10.8975 13.995 10.695 14.1975 10.4475 14.1975H7.86C7.6125 14.1975 7.41 13.995 7.41 13.7475V10.1025C7.41 9.855 7.6125 9.6525 7.86 9.6525H10.4475C10.695 9.6525 10.8975 9.855 10.8975 10.1025V13.7475Z"
        fill="#FF8741"
      />
    </svg>
  ),
  "icon-service-arrow-right-line": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 12.3942C18.792 11.6242 18.792 10.3758 18 9.60581L13.0601 4.8029C12.6642 4.41791 12.0222 4.41791 11.6262 4.8029C11.2302 5.1879 11.2302 5.8121 11.6262 6.1971L16.5661 11L11.6262 15.8029C11.2302 16.1879 11.2302 16.8121 11.6262 17.1971C12.0222 17.5821 12.6642 17.5821 13.0601 17.1971L18 12.3942Z"
        fill="#8F8F8F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 10.7871C3 10.2348 3.44772 9.78711 4 9.78711H16.7972C17.3495 9.78711 17.7972 10.2348 17.7972 10.7871C17.7972 11.3394 17.3495 11.7871 16.7972 11.7871H4C3.44772 11.7871 3 11.3394 3 10.7871Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  "icon-service-document-search-circle": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#F5F5F5" />
      <path
        d="M37 39.8774V14.9976C37 14.1015 36.2445 13.375 35.3125 13.375H25.1875L15.625 22.9375V39.8774C15.625 40.7735 16.3805 41.5 17.3125 41.5H35.3125C36.2445 41.5 37 40.7735 37 39.8774Z"
        fill="#98B4DF"
      />
      <path
        d="M25.1875 13.375V21.25C25.1875 22.182 24.432 22.9375 23.5 22.9375H15.625L25.1875 13.375Z"
        fill="#5885CB"
      />
      <rect
        width="16.27"
        height="2.6496"
        rx="1.3248"
        transform="matrix(0.735415 0.677617 -0.677607 0.735424 31.7847 25.4897)"
        fill="#274A7F"
      />
      <ellipse
        cx="32.9039"
        cy="28.4039"
        rx="7.15393"
        ry="7.15393"
        fill="#274A7F"
      />
      <circle cx="32.904" cy="28.4037" r="4.50433" fill="#F8FAFD" />
    </svg>
  ),
  "icon-service-book-has-bookmark-circle": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="28" fill="#F5F5F5" />
      <path
        d="M16.75 17.2C16.75 15.7088 17.9588 14.5 19.45 14.5H37.45C38.4441 14.5 39.25 15.3059 39.25 16.3V38.9241C39.25 39.9183 38.4441 40.7241 37.45 40.7241H18.55C17.5559 40.7241 16.75 39.9183 16.75 38.9241V17.2Z"
        fill="#F18334"
      />
      <rect
        x="21.8636"
        y="18.5347"
        width="13.2955"
        height="5.0431"
        rx="0.9"
        fill="#FDECDD"
      />
      <path
        d="M16.75 38.7069C16.75 36.7573 18.3305 35.1768 20.2802 35.1768H39.25V40.4371C39.25 41.4312 38.4441 42.2371 37.45 42.2371H20.2802C18.3305 42.2371 16.75 40.6566 16.75 38.7069Z"
        fill="#F18334"
      />
      <path
        d="M18.2839 38.2024C18.2839 36.8098 19.4129 35.6808 20.8055 35.6808H37.4498C38.444 35.6808 39.2498 34.8749 39.2498 33.8808V33.6636V38.9239C39.2498 39.918 38.444 40.7239 37.4498 40.7239H20.8055C19.4129 40.7239 18.2839 39.595 18.2839 38.2024Z"
        fill="#FDECDD"
      />
      <path
        d="M30.25 38.125H35.875V43.0853C35.875 43.4037 35.5535 43.6214 35.2579 43.5031L33.3968 42.7587C33.1822 42.6729 32.9428 42.6729 32.7282 42.7587L30.8671 43.5031C30.5715 43.6214 30.25 43.4037 30.25 43.0853V38.125Z"
        fill="#753C08"
      />
    </svg>
  ),
  "icon-service-shield-mono": (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 35.5C20 35.5 7 30.8222 7 21.1695V10.1246L20 4.5V35.5Z"
        fill="#6DA6FC"
      />
      <path
        d="M20.0001 35.5C20.0001 35.5 33.0001 30.8222 33.0001 21.1695V10.1246L20.0001 4.5V35.5Z"
        fill="#84AFEF"
      />
      <path
        d="M20 30.1535C20 30.1535 11.4694 27.0906 11.4694 20.7607V13.5212L20 9.8457V30.1535Z"
        fill="#C4D7F7"
      />
      <path
        d="M20.0001 30.1535C20.0001 30.1535 28.5308 27.0906 28.5308 20.7607V13.5212L20.0001 9.8457V30.1535Z"
        fill="#C4D7F7"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M20.0001 35.5C20.0001 35.5 33.0001 30.8222 33.0001 21.1695V10.1246L20.0001 4.5V35.5Z"
          fill="#A5CCFF"
        />
      </g>
    </svg>
  ),
  "icon-no-visitor": (
    <svg
      width="30"
      height="37"
      viewBox="0 0 30 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.98 28.5601C21.86 16.9201 1.13003 16.9201 0.0100271 28.5601C-0.0399729 29.1001 0.360027 29.5601 0.860027 29.5601H22.13C22.63 29.5601 23.03 29.1001 22.98 28.5601Z"
        fill="#252525"
      />
      <path
        d="M0 28.6602H22.99V33.9802H2.01C0.91 33.9802 0 33.0502 0 31.9202V28.6602Z"
        fill="#252525"
      />
      <path d="M13.52 16.7002H9.46002V24.3602H13.52V16.7002Z" fill="#FFB1A8" />
      <path
        d="M6.53999 13.1796C7.21999 12.4896 7.07999 11.2196 6.21999 10.3496C5.36999 9.48959 4.11999 9.32959 3.44999 10.0296C2.76999 10.7196 2.90999 11.9896 3.76999 12.8596C4.61999 13.7196 5.86999 13.8796 6.53999 13.1796Z"
        fill="#FFB1A8"
      />
      <path
        d="M19.22 12.8598C20.07 11.9798 20.21 10.7198 19.54 10.0298C18.86 9.32978 17.62 9.47978 16.77 10.3498C15.92 11.2298 15.78 12.4898 16.45 13.1798C17.13 13.8798 18.37 13.7298 19.22 12.8598Z"
        fill="#FFB1A8"
      />
      <path
        d="M18.63 8.85C18.63 13.74 15.92 17.61 11.4 17.61C6.87998 17.61 4.16998 13.74 4.16998 8.85C4.16998 3.96 6.87998 0 11.4 0C15.92 0 18.63 3.96 18.63 8.85Z"
        fill="#FFB1A8"
      />
      <path
        d="M9.35001 11.65C9.67001 11.65 9.94001 11.34 9.94001 10.97C9.94001 10.6 9.67001 10.29 9.35001 10.29C9.03001 10.29 8.76001 10.59 8.76001 10.97C8.76001 11.35 9.03001 11.65 9.35001 11.65Z"
        fill="#252525"
      />
      <path
        d="M13.62 11.65C13.94 11.65 14.21 11.34 14.21 10.97C14.21 10.6 13.95 10.29 13.62 10.29C13.29 10.29 13.03 10.59 13.03 10.97C13.03 11.35 13.29 11.65 13.62 11.65Z"
        fill="#252525"
      />
      <path
        d="M18.71 9.66C18.32 11.19 13.03 5.02 13.03 5.02C13.03 5.02 4.65998 10.82 4.27998 9.66C2.63998 4.61 6.26998 0 11.49 0C16.71 0 19.89 4.91 18.7 9.66H18.71Z"
        fill="#252525"
      />
      <path
        d="M9.45999 18.6804L11.48 22.2304L13.54 18.6504L15.32 20.3304L11.48 30.0704L7.73999 20.3104L9.45999 18.6804Z"
        fill="white"
      />
      <path
        d="M11.48 22.2305L10.42 23.4305L10.98 25.0405H12.1L12.64 23.4305L11.48 22.2305Z"
        fill="#252525"
      />
      <path
        d="M13.34 31.3202H9.71997L10.97 24.9902H12.09L13.33 31.3202H13.34Z"
        fill="#252525"
      />
      <path
        d="M23 37.0005C26.86 37.0005 30 33.8605 30 29.9905C30 26.1205 26.86 22.9805 23 22.9805C19.14 22.9805 16 26.1205 16 29.9905C16 33.8605 19.14 37.0005 23 37.0005Z"
        fill="#ED3C32"
      />
      <path
        d="M24.38 29.9905L26.38 27.9805C26.76 27.6005 26.76 26.9805 26.38 26.5905C26 26.2005 25.38 26.2105 25 26.5905L23 28.6005L21 26.5905C20.62 26.2105 20 26.2105 19.62 26.5905C19.23 26.9705 19.24 27.5905 19.62 27.9805L21.62 29.9905L19.62 32.0005C19.24 32.3805 19.24 33.0005 19.62 33.3905C19.81 33.5805 20.06 33.6805 20.32 33.6805C20.58 33.6805 20.82 33.5805 21.02 33.3905L23.02 31.3805L25.02 33.3905C25.21 33.5805 25.46 33.6805 25.72 33.6805C25.98 33.6805 26.22 33.5805 26.42 33.3905C26.8 33.0105 26.8 32.3905 26.42 32.0005L24.42 29.9905H24.4H24.38Z"
        fill="white"
      />
    </svg>
  ),
  "icon-two-visitor": (
    <svg
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9876 21.0397C31.1322 12.4607 15.4359 12.4607 14.5805 21.0397C14.5433 21.4297 14.8501 21.7825 15.2314 21.7825H31.346C31.7273 21.7825 32.0341 21.439 31.9969 21.0397H31.9876Z"
        fill="#535353"
      />
      <path
        d="M14.5805 21.1133H31.997V24.3815C31.997 25.2821 31.2531 26.0249 30.3511 26.0249H16.217C15.3151 26.0249 14.5712 25.2821 14.5712 24.3815V21.1133H14.5805Z"
        fill="#535353"
      />
      <path d="M24.8184 12.293H21.7405V17.938H24.8184V12.293Z" fill="#FFE4E1" />
      <path
        d="M19.5273 9.71065C20.0387 9.19999 19.9364 8.27152 19.2855 7.63088C18.6346 6.99024 17.6954 6.88811 17.1933 7.38948C16.6819 7.90014 16.7841 8.83789 17.4351 9.46925C18.086 10.1099 19.0251 10.212 19.5273 9.71065Z"
        fill="#FFE4E1"
      />
      <path
        d="M29.1328 9.46926C29.7837 8.82861 29.886 7.89086 29.3746 7.38949C28.8631 6.87883 27.924 6.99025 27.2823 7.63089C26.6314 8.27153 26.5291 9.20929 27.0406 9.71066C27.552 10.2213 28.4912 10.1099 29.1328 9.46926Z"
        fill="#FFE4E1"
      />
      <path
        d="M28.6865 6.5276C28.6865 10.1301 26.6408 12.9804 23.2189 12.9804C19.7969 12.9804 17.7512 10.1301 17.7512 6.5276C17.7512 2.92515 19.7969 0.00976562 23.2189 0.00976562C26.6408 0.00976562 28.6865 2.93444 28.6865 6.5276Z"
        fill="#FFE4E1"
      />
      <path
        d="M21.6475 8.58868C21.8986 8.58868 22.1031 8.36585 22.1031 8.08731C22.1031 7.80877 21.8986 7.58594 21.6475 7.58594C21.3964 7.58594 21.2012 7.80877 21.2012 8.08731C21.2012 8.36585 21.4057 8.58868 21.6475 8.58868Z"
        fill="#252525"
      />
      <path
        d="M24.8926 8.58868C25.1437 8.58868 25.3483 8.36585 25.3483 8.08731C25.3483 7.80877 25.153 7.58594 24.8926 7.58594C24.6323 7.58594 24.4463 7.80877 24.4463 8.08731C24.4463 8.36585 24.6416 8.58868 24.8926 8.58868Z"
        fill="#252525"
      />
      <path
        d="M28.7517 7.11206C28.4541 8.24479 24.4557 3.6953 24.4557 3.6953C24.4557 3.6953 18.114 7.95696 17.8257 7.11206C16.5797 3.39819 19.3321 0 23.2933 0C27.2546 0 29.663 3.62102 28.761 7.11206H28.7517Z"
        fill="#535353"
      />
      <path
        d="M21.7311 13.75L23.2654 16.3683L24.8183 13.7314L26.1759 14.9663L23.2654 22.1434L20.4293 14.957L21.7311 13.75Z"
        fill="white"
      />
      <path
        d="M23.2653 16.3691L22.4563 17.2605L22.884 18.4396H23.7395L24.1487 17.2605L23.2653 16.3691Z"
        fill="#535353"
      />
      <path
        d="M24.6787 23.0725H21.9355L22.884 18.4023H23.7395L24.688 23.0725H24.6787Z"
        fill="#535353"
      />
      <path
        d="M18.8485 25.1011C17.9279 15.8257 0.948497 15.8257 0.0279243 25.1011C-0.0092705 25.5282 0.316184 25.8995 0.725328 25.8995H18.1511C18.5603 25.8995 18.895 25.5282 18.8485 25.1011Z"
        fill="#252525"
      />
      <path
        d="M0 25.1279H18.8485V27.5048C18.8485 28.3311 18.1325 28.9996 17.2584 28.9996H1.59938C0.7253 28.9996 0.00929892 28.3219 0.00929892 27.5048V25.1279H0Z"
        fill="#252525"
      />
      <path
        d="M11.0933 15.6494H7.7644V21.7494H11.0933V15.6494Z"
        fill="#FCD8D4"
      />
      <path
        d="M5.37462 12.8447C5.93254 12.297 5.82095 11.2849 5.11425 10.5886C4.41685 9.90151 3.39399 9.78081 2.84537 10.3379C2.28745 10.8857 2.39903 11.8977 3.10573 12.5941C3.80313 13.2811 4.82599 13.4018 5.37462 12.8447Z"
        fill="#FCD8D4"
      />
      <path
        d="M15.7706 12.5941C16.468 11.8977 16.5796 10.8857 16.031 10.3379C15.4731 9.78081 14.4595 9.90151 13.7621 10.5886C13.0647 11.2849 12.9531 12.297 13.5018 12.8447C14.0597 13.4018 15.0732 13.2811 15.7706 12.5941Z"
        fill="#FCD8D4"
      />
      <path
        d="M15.2777 9.40107C15.2777 13.3006 13.0553 16.3831 9.35443 16.3831C5.65354 16.3831 3.43115 13.3006 3.43115 9.40107C3.43115 5.50151 5.65354 2.34473 9.35443 2.34473C13.0553 2.34473 15.2777 5.50151 15.2777 9.40107Z"
        fill="#FCD8D4"
      />
      <path
        d="M7.67128 11.6288C7.93164 11.6288 8.15481 11.3781 8.15481 11.0903C8.15481 10.8024 7.93164 10.5518 7.67128 10.5518C7.41091 10.5518 7.18774 10.7932 7.18774 11.0903C7.18774 11.3874 7.41091 11.6288 7.67128 11.6288Z"
        fill="#252525"
      />
      <path
        d="M11.177 11.6288C11.4374 11.6288 11.6605 11.3781 11.6605 11.0903C11.6605 10.8024 11.4467 10.5518 11.177 10.5518C10.9074 10.5518 10.6935 10.7932 10.6935 11.0903C10.6935 11.3874 10.9074 11.6288 11.177 11.6288Z"
        fill="#252525"
      />
      <path
        d="M15.3428 10.0417C15.0266 11.2673 10.6934 6.34642 10.6934 6.34642C10.6934 6.34642 3.83099 10.9609 3.52413 10.0417C2.17581 6.02146 5.1514 2.34473 9.42881 2.34473C13.7062 2.34473 16.3099 6.25357 15.3335 10.0417H15.3428Z"
        fill="#252525"
      />
      <path
        d="M7.76436 17.2266L9.41953 20.0584L11.1026 17.208L12.5625 18.545L9.41953 26.307L6.35095 18.5264L7.76436 17.2266Z"
        fill="white"
      />
      <path
        d="M9.41961 20.0596L8.54553 21.0159L9.00117 22.2972H9.92174L10.3681 21.0159L9.41961 20.0596Z"
        fill="#252525"
      />
      <path
        d="M10.9446 27.3023H7.97827L9.00113 22.2607H9.9217L10.9446 27.3023Z"
        fill="#252525"
      />
    </svg>
  ),
  "icon-three-visitor": (
    <svg
      width="38"
      height="32"
      viewBox="0 0 38 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.4885 20.8551C36.6471 12.3517 21.1083 12.3517 20.2669 20.8551C20.2311 21.2489 20.5354 21.5891 20.9114 21.5891H36.853C37.229 21.5891 37.5333 21.2489 37.4975 20.8551H37.4885Z"
        fill="#535353"
      />
      <path
        d="M20.2669 20.9258H37.4975V25.7861C37.4975 26.7708 36.6919 27.5763 35.7073 27.5763H22.0571C21.0725 27.5763 20.2669 26.7708 20.2669 25.7861V20.9258Z"
        fill="#535353"
      />
      <path
        d="M30.3993 12.1904H27.356V17.7848H30.3993V12.1904Z"
        fill="#FFEDEB"
      />
      <path
        d="M25.1631 9.62311C25.6733 9.12186 25.5659 8.19096 24.9304 7.55544C24.2949 6.91992 23.364 6.81251 22.8538 7.32271C22.3436 7.82397 22.451 8.75487 23.0865 9.39038C23.722 10.0259 24.6529 10.1333 25.1631 9.62311Z"
        fill="#FFEDEB"
      />
      <path
        d="M34.6692 9.39038C35.3047 8.75487 35.4121 7.83292 34.9019 7.32271C34.3917 6.81251 33.4608 6.91992 32.8253 7.55544C32.1898 8.19096 32.0823 9.11291 32.5925 9.62311C33.1028 10.1333 34.0337 10.0259 34.6692 9.39038Z"
        fill="#FFEDEB"
      />
      <path
        d="M34.2304 6.4704C34.2304 10.0418 32.1985 12.8703 28.815 12.8703C25.4316 12.8703 23.3997 10.0418 23.3997 6.4704C23.3997 2.89897 25.4316 0.0078125 28.815 0.0078125C32.1985 0.0078125 34.2304 2.89897 34.2304 6.4704Z"
        fill="#FFEDEB"
      />
      <path
        d="M27.2665 8.51195C27.5082 8.51195 27.7141 8.28817 27.7141 8.01965C27.7141 7.75112 27.5172 7.52734 27.2665 7.52734C27.0159 7.52734 26.8279 7.75112 26.8279 8.01965C26.8279 8.28817 27.0249 8.51195 27.2665 8.51195Z"
        fill="#252525"
      />
      <path
        d="M30.4709 8.51195C30.7126 8.51195 30.9185 8.28817 30.9185 8.01965C30.9185 7.75112 30.7216 7.52734 30.4709 7.52734C30.2203 7.52734 30.0323 7.75112 30.0323 8.01965C30.0323 8.28817 30.2293 8.51195 30.4709 8.51195Z"
        fill="#252525"
      />
      <path
        d="M34.2841 7.05335C33.9887 8.17222 30.0324 3.66094 30.0324 3.66094C30.0324 3.66094 23.7578 7.88579 23.4714 7.05335C22.2361 3.37451 24.9572 0 28.8777 0C32.7982 0 35.1792 3.58933 34.2841 7.05335Z"
        fill="#535353"
      />
      <path
        d="M27.3472 13.6331L28.8689 16.2289L30.3995 13.6152L31.7421 14.8415L28.8689 21.9486L26.0672 14.8236L27.3472 13.6331Z"
        fill="white"
      />
      <path
        d="M28.8688 16.2285L28.0721 17.1057L28.4928 18.2783H29.3342L29.746 17.1057L28.8688 16.2285Z"
        fill="#535353"
      />
      <path
        d="M30.2652 22.8698H27.5531L28.484 18.2422H29.3254L30.2652 22.8698Z"
        fill="#535353"
      />
      <path
        d="M17.7245 20.8551C16.8831 12.3517 1.34426 12.3517 0.502867 20.8551C0.467063 21.2489 0.771397 21.5891 1.14734 21.5891H17.089C17.4649 21.5891 17.7692 21.2489 17.7334 20.8551H17.7245Z"
        fill="#535353"
      />
      <path
        d="M0.502869 20.9258H17.7334V25.7861C17.7334 26.7708 16.9279 27.5763 15.9433 27.5763H2.29306C1.30845 27.5763 0.502869 26.7708 0.502869 25.7861V20.9258Z"
        fill="#535353"
      />
      <path
        d="M10.6353 12.1904H7.59198V17.7848H10.6353V12.1904Z"
        fill="#FFEDEB"
      />
      <path
        d="M5.39909 9.62311C5.90929 9.12186 5.80188 8.19096 5.16636 7.55544C4.53085 6.91992 3.59995 6.81251 3.08974 7.32271C2.57954 7.82397 2.68695 8.75487 3.32247 9.39038C3.95799 10.0259 4.88888 10.1333 5.39909 9.62311Z"
        fill="#FFEDEB"
      />
      <path
        d="M14.9051 9.39038C15.5407 8.75487 15.6481 7.83292 15.1379 7.32271C14.6276 6.81251 13.6968 6.91992 13.0612 7.55544C12.4257 8.19096 12.3183 9.11291 12.8285 9.62311C13.3387 10.1333 14.2696 10.0259 14.9051 9.39038Z"
        fill="#FFEDEB"
      />
      <path
        d="M14.4574 6.4704C14.4574 10.0418 12.4256 12.8703 9.04209 12.8703C5.65863 12.8703 3.62677 10.0418 3.62677 6.4704C3.62677 2.89897 5.65863 0.0078125 9.04209 0.0078125C12.4256 0.0078125 14.4574 2.89897 14.4574 6.4704Z"
        fill="#FFEDEB"
      />
      <path
        d="M7.5025 8.51195C7.74417 8.51195 7.95005 8.28817 7.95005 8.01965C7.95005 7.75112 7.75312 7.52734 7.5025 7.52734C7.25187 7.52734 7.0639 7.75112 7.0639 8.01965C7.0639 8.28817 7.26082 8.51195 7.5025 8.51195Z"
        fill="#252525"
      />
      <path
        d="M10.7069 8.51195C10.9486 8.51195 11.1545 8.28817 11.1545 8.01965C11.1545 7.75112 10.9575 7.52734 10.7069 7.52734C10.4563 7.52734 10.2683 7.75112 10.2683 8.01965C10.2683 8.28817 10.4652 8.51195 10.7069 8.51195Z"
        fill="#252525"
      />
      <path
        d="M14.5201 7.05335C14.2247 8.17222 10.2684 3.66094 10.2684 3.66094C10.2684 3.66094 3.99374 7.88579 3.70731 7.05335C2.47208 3.37451 5.19317 0 9.11369 0C13.0342 0 15.4152 3.58933 14.5201 7.05335Z"
        fill="#535353"
      />
      <path
        d="M7.58313 13.6331L9.10479 16.2289L10.6354 13.6152L11.978 14.8415L9.10479 21.9486L6.29419 14.8236L7.58313 13.6331Z"
        fill="white"
      />
      <path
        d="M9.10474 16.2285L8.30811 17.1057L8.7288 18.2783H9.57019L9.98194 17.1057L9.10474 16.2285Z"
        fill="#535353"
      />
      <path
        d="M10.5012 22.8698H7.78906L8.71996 18.2422H9.56135L10.5012 22.8698Z"
        fill="#535353"
      />
      <path
        d="M28.3226 25.6796C27.4096 16.487 10.6086 16.487 9.69565 25.6796C9.6509 26.1003 9.98208 26.4673 10.3849 26.4673H27.6333C28.0361 26.4673 28.3673 26.1003 28.3226 25.6796Z"
        fill="#252525"
      />
      <path
        d="M9.69568 25.752H28.3316V29.95C28.3316 30.9346 27.526 31.7401 26.5414 31.7401H11.4859C10.5013 31.7401 9.69568 30.9346 9.69568 29.95V25.752Z"
        fill="#252525"
      />
      <path
        d="M20.6517 16.3105H17.3578V22.3614H20.6517V16.3105Z"
        fill="#FFC2BB"
      />
      <path
        d="M14.9946 13.5341C15.5407 12.9881 15.4332 11.9856 14.7351 11.2963C14.0458 10.6071 13.0433 10.4907 12.4884 11.0457C11.9424 11.5917 12.0498 12.5942 12.748 13.2834C13.4372 13.9727 14.4397 14.089 14.9946 13.5341Z"
        fill="#FFC2BB"
      />
      <path
        d="M25.2705 13.2749C25.9597 12.5857 26.0761 11.5832 25.5301 11.0372C24.9841 10.4912 23.9726 10.6075 23.2834 11.2878C22.5942 11.977 22.4778 12.9795 23.0238 13.5255C23.5698 14.0716 24.5813 13.9552 25.2705 13.2749Z"
        fill="#FFC2BB"
      />
      <path
        d="M24.7869 10.1157C24.7869 13.9825 22.5939 17.0348 18.924 17.0348C15.2541 17.0348 13.0612 13.9736 13.0612 10.1157C13.0612 6.25783 15.2541 3.125 18.924 3.125C22.5939 3.125 24.7869 6.25783 24.7869 10.1157Z"
        fill="#FFC2BB"
      />
      <path
        d="M17.2681 12.327C17.5277 12.327 17.7515 12.0854 17.7515 11.79C17.7515 11.4946 17.5366 11.2529 17.2681 11.2529C16.9996 11.2529 16.7937 11.4946 16.7937 11.79C16.7937 12.0854 17.0085 12.327 17.2681 12.327Z"
        fill="#252525"
      />
      <path
        d="M20.7322 12.327C20.9917 12.327 21.2155 12.0854 21.2155 11.79C21.2155 11.4946 21.0007 11.2529 20.7322 11.2529C20.4636 11.2529 20.2578 11.4946 20.2578 11.79C20.2578 12.0854 20.4726 12.327 20.7322 12.327Z"
        fill="#252525"
      />
      <path
        d="M24.8585 10.7512C24.5452 11.9596 20.2577 7.08132 20.2577 7.08132C20.2577 7.08132 13.4729 11.6553 13.1686 10.7512C11.8349 6.76804 14.7797 3.125 19.0135 3.125C23.2473 3.125 25.8252 7.00971 24.8585 10.7512Z"
        fill="#252525"
      />
      <path
        d="M17.3488 17.8665L18.9958 20.6771L20.6517 17.8486L22.1018 19.1644L18.9958 26.8622L15.9614 19.1555L17.3488 17.8665Z"
        fill="white"
      />
      <path
        d="M18.9958 20.6787L18.1365 21.6275L18.5841 22.8985H19.4971L19.9446 21.6275L18.9958 20.6787Z"
        fill="#252525"
      />
      <path
        d="M20.5085 27.8571H17.5726L18.584 22.8535H19.497L20.5085 27.8571Z"
        fill="#252525"
      />
    </svg>
  ),
  "icon-ugol-has-coin": (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8.5101C6.20914 8.5101 8 6.71697 8 4.50505C8 2.29312 6.20914 0.5 4 0.5C1.79086 0.5 0 2.29312 0 4.50505C0 6.71697 1.79086 8.5101 4 8.5101Z"
        fill="#FFF0D9"
      />
      <path
        d="M6.1354 4.67345C5.1354 5.26795 4.65624 5.84159 4.14582 7.00973C4.08332 7.15575 3.90624 7.15575 3.84374 7.00973C3.33332 5.83116 2.85416 5.26795 1.85416 4.67345C1.72916 4.60044 1.72916 4.39185 1.85416 4.31884C2.85416 3.72434 3.33332 3.1507 3.84374 1.98256C3.90624 1.83654 4.08332 1.83654 4.14582 1.98256C4.65624 3.16113 5.1354 3.72434 6.1354 4.31884C6.2604 4.39185 6.2604 4.60044 6.1354 4.67345Z"
        fill="#FFA953"
      />
      <path
        d="M32.6507 13.8031C32.0479 14.1672 31.7608 14.5025 31.445 15.2116C31.4067 15.2978 31.3014 15.2978 31.2632 15.2116C30.9569 14.5025 30.6699 14.1576 30.0574 13.8031C29.9809 13.7552 29.9809 13.6306 30.0574 13.5923C30.6603 13.2282 30.9474 12.8928 31.2632 12.1838C31.3014 12.0976 31.4067 12.0976 31.445 12.1838C31.7512 12.8928 32.0383 13.2378 32.6507 13.5923C32.7273 13.6402 32.7273 13.7648 32.6507 13.8031Z"
        fill="white"
      />
      <path
        d="M26.6029 30.1203C26.6029 32.2474 21.6746 34.0008 15.5885 34.0008C9.50239 34.0008 4.57416 32.2474 4.57416 30.1203C4.57416 27.9932 9.50239 26.2686 15.5885 26.2686C21.6746 26.2686 26.6029 27.9932 26.6029 30.1203Z"
        fill="#B6C7E0"
      />
      <path
        d="M27.6268 10.5166H3.55023V27.0159H27.6268V10.5166Z"
        fill="#DFE7F2"
      />
      <path
        d="M27.6268 27.016C27.6268 29.1431 22.2392 31.9122 15.5885 31.9122C8.93779 31.9122 3.55023 29.1431 3.55023 27.016C3.55023 24.889 8.93779 23.6338 15.5885 23.6338C22.2392 23.6338 27.6268 24.889 27.6268 27.016Z"
        fill="#DFE7F2"
      />
      <path
        d="M15.5981 14.0332C22.2488 14.0332 27.6364 12.0786 27.6364 10.5168C27.6364 8.955 22.2488 7.68066 15.5981 7.68066C8.94738 7.68066 3.55981 8.94542 3.55981 10.5168C3.55981 12.0881 8.94738 14.0332 15.5981 14.0332Z"
        fill="#B6C7E0"
      />
      <path
        d="M26.1244 5.37207H5.05261V9.13758H26.1244V5.37207Z"
        fill="#DFE7F2"
      />
      <path
        d="M15.5981 11.7715C21.4163 11.7715 26.134 10.3151 26.134 8.99284C26.134 7.6706 21.4163 6.58789 15.5981 6.58789C9.77989 6.58789 5.06219 7.66101 5.06219 8.99284C5.06219 10.3247 9.77989 11.7715 15.5981 11.7715Z"
        fill="#DFE7F2"
      />
      <path
        d="M15.5981 8.00657C21.4163 8.00657 26.134 6.84722 26.134 5.5154C26.134 4.18357 21.4163 2.35352 15.5981 2.35352C9.77989 2.35352 5.06219 4.18357 5.06219 5.5154C5.06219 6.84722 9.77989 8.00657 15.5981 8.00657Z"
        fill="#FAFCFF"
      />
      <path
        d="M15.5024 27.3424C16.8325 27.3424 18.0574 27.1124 19.0526 26.7771C19.3684 26.6717 19.5694 26.4034 19.5694 26.1064V18.1442C19.5694 17.6939 19.1196 17.3585 18.6316 17.4352C17.7225 17.5885 16.6507 17.6747 15.5024 17.6747C14.3541 17.6747 13.2823 17.5885 12.3732 17.4352C11.8852 17.3489 11.4354 17.6939 11.4354 18.1442V26.1064C11.4354 26.413 11.6363 26.6813 11.9521 26.7771C12.9473 27.1028 14.1722 27.3424 15.5024 27.3424Z"
        fill="#FAFCFF"
      />
      <path
        d="M27.6268 25.7594C29.9575 25.7594 31.8469 23.8677 31.8469 21.534C31.8469 19.2004 29.9575 17.3086 27.6268 17.3086C25.2961 17.3086 23.4067 19.2004 23.4067 21.534C23.4067 23.8677 25.2961 25.7594 27.6268 25.7594Z"
        fill="#FFF0D9"
      />
      <path
        d="M27.6268 17.3094C25.2919 17.3094 23.4067 19.2065 23.4067 21.5348C23.4067 23.8631 25.3014 25.7602 27.6268 25.7602V17.2998V17.3094Z"
        fill="#FFD69A"
      />
      <path
        d="M29.8947 21.7263C28.8421 22.3587 28.3254 22.9527 27.7895 24.1983C27.7225 24.3516 27.5407 24.3516 27.4737 24.1983C26.9378 22.9527 26.4306 22.3587 25.3684 21.7263C25.2345 21.6496 25.2345 21.4293 25.3684 21.3526C26.4211 20.7202 26.9378 20.1262 27.4737 18.8806C27.5407 18.7273 27.7225 18.7273 27.7895 18.8806C28.3254 20.1262 28.8325 20.7202 29.8947 21.3526C30.0287 21.4293 30.0287 21.6496 29.8947 21.7263Z"
        fill="#FFA54B"
      />
    </svg>
  ),
  "icon-number-1-rect": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1780)">
        {/* 이 rect만 fill 어트리뷰트를 가지고 있으므로, ColorIcon의 color prop이 적용됩니다 */}
        <rect width="20" height="20" rx="4" fill="#252525" />
        {/* path는 fill 어트리뷰트가 없으니 CSS override를 피하고, inline style로 흰색을 고정합니다 */}
        <path
          d="M11.5563 5V14.8984H9.76526V6.73633H9.71057L7.40002 8.21289V6.58594L9.84729 5H11.5563Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1780">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "icon-number-2-rect": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1784)">
        <rect width="20" height="20" rx="4" fill="#252525" />
        <path
          d="M6.64109 14.7354V13.4502L10.1411 10.0732C11.1391 9.0752 11.6587 8.4873 11.6587 7.65332C11.6587 6.7373 10.9341 6.14941 9.96336 6.14941C8.93796 6.14941 8.28171 6.79199 8.29539 7.79004H6.60007C6.5864 5.91699 7.99461 4.7002 9.97703 4.7002C12.0005 4.7002 13.3677 5.90332 13.3677 7.57129C13.3677 8.69238 12.8208 9.59473 10.8794 11.4268L9.1157 13.1768V13.2451H13.518V14.7354H6.64109Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1784">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "icon-number-3-rect": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1788)">
        <rect width="20" height="20" rx="4" fill="#252525" />
        <path
          d="M10.1641 15.1719C8.04492 15.1719 6.54102 14.0234 6.5 12.3555H8.29102C8.3457 13.1484 9.13867 13.668 10.1641 13.668C11.2578 13.668 12.0371 13.0664 12.0371 12.1914C12.0371 11.3027 11.2715 10.6602 9.98633 10.6602H9.09766V9.29297H9.98633C11.0391 9.29297 11.7773 8.70508 11.7637 7.84375C11.7773 7.00977 11.1484 6.44922 10.1777 6.44922C9.24805 6.44922 8.44141 6.96875 8.41406 7.80273H6.70508C6.74609 6.13477 8.25 5 10.1914 5C12.2012 5 13.5 6.23047 13.4863 7.74805C13.5 8.85547 12.7617 9.66211 11.6816 9.88086V9.96289C13.0762 10.1543 13.8691 11.043 13.8555 12.2871C13.8691 13.9551 12.3105 15.1719 10.1641 15.1719Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1788">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "icon-number-4-rect": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1792)">
        {/* 기본 배경색만 바꾸고 싶다면 여긴 건드릴 필요 없이, ColorIcon의 color prop으로 */}
        <rect width="20" height="20" rx="4" fill="#FF8741" />
        <path
          d="M6 13.0527V11.6309L10.2793 5H12.4941V11.5898H13.793V13.0527H12.4941V14.8984H10.7988V13.0527H6ZM7.81836 11.5898H10.8262V7.02344H10.7168L7.81836 11.5215V11.5898Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1792">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-1": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1780)">
        {/* 이 rect만 fill 어트리뷰트를 가지고 있으므로, ColorIcon의 color prop이 적용됩니다 */}
        {/* <rect width="20" height="20" rx="4" fill="#252525" /> */}
        {/* path는 fill 어트리뷰트가 없으니 CSS override를 피하고, inline style로 흰색을 고정합니다 */}
        <path
          d="M11.5563 5V14.8984H9.76526V6.73633H9.71057L7.40002 8.21289V6.58594L9.84729 5H11.5563Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1780">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-1-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11585_3416)">
        {/* circle에 fill 속성을 추가 */}
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <path
          d="M11.1484 5.51562V14H9.61328V7.00391H9.56641L7.58594 8.26953V6.875L9.68359 5.51562H11.1484Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_11585_3416">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-2-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11585_3434)">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <path
          d="M6.70321 14V12.8984L9.70321 10.0039C10.5587 9.14844 11.004 8.64453 11.004 7.92969C11.004 7.14453 10.3829 6.64062 9.55087 6.64062C8.67196 6.64062 8.10946 7.19141 8.12118 8.04688H6.66805C6.65633 6.44141 7.86337 5.39844 9.56258 5.39844C11.297 5.39844 12.4688 6.42969 12.4688 7.85938C12.4688 8.82031 12.0001 9.59375 10.336 11.1641L8.8243 12.6641V12.7227H12.5977V14H6.70321Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_11585_3434">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-3-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11585_3437)">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <path
          d="M9.78516 14.1172C7.96875 14.1172 6.67969 13.1328 6.64453 11.7031H8.17969C8.22656 12.3828 8.90625 12.8281 9.78516 12.8281C10.7227 12.8281 11.3906 12.3125 11.3906 11.5625C11.3906 10.8008 10.7344 10.25 9.63281 10.25H8.87109V9.07812H9.63281C10.5352 9.07812 11.168 8.57422 11.1562 7.83594C11.168 7.12109 10.6289 6.64062 9.79688 6.64062C9 6.64062 8.30859 7.08594 8.28516 7.80078H6.82031C6.85547 6.37109 8.14453 5.39844 9.80859 5.39844C11.5312 5.39844 12.6445 6.45312 12.6328 7.75391C12.6445 8.70312 12.0117 9.39453 11.0859 9.58203V9.65234C12.2812 9.81641 12.9609 10.5781 12.9492 11.6445C12.9609 13.0742 11.625 14.1172 9.78516 14.1172Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_11585_3437">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-4-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11585_3440)">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <path
          d="M6.55078 12.418V11.1992L10.2188 5.51562H12.1172V11.1641H13.2305V12.418H12.1172V14H10.6641V12.418H6.55078ZM8.10938 11.1641H10.6875V7.25H10.5938L8.10938 11.1055V11.1641Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_11585_3440">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-5-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="currentColor" />
      <path
        d="M9.71484 14.1172C8.01562 14.1172 6.77344 13.1094 6.72656 11.7031H8.21484C8.26172 12.3945 8.90625 12.8867 9.71484 12.8867C10.6641 12.8867 11.3438 12.1953 11.3438 11.2578C11.3438 10.2852 10.6406 9.59375 9.66797 9.59375C9.01172 9.58203 8.53125 9.81641 8.26172 10.3203H6.84375L7.35938 5.51562H12.375V6.79297H8.61328L8.35547 9.04297H8.4375C8.76562 8.66797 9.38672 8.39844 10.0781 8.39844C11.6602 8.39844 12.8203 9.58203 12.8203 11.2109C12.8203 12.9102 11.543 14.1172 9.71484 14.1172Z"
        fill="white"
      />
    </svg>
  ),
  "icon-number-2": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1784)">
        {/* <rect width="20" height="20" rx="4" fill="#252525" /> */}
        <path
          d="M6.64109 14.7354V13.4502L10.1411 10.0732C11.1391 9.0752 11.6587 8.4873 11.6587 7.65332C11.6587 6.7373 10.9341 6.14941 9.96336 6.14941C8.93796 6.14941 8.28171 6.79199 8.29539 7.79004H6.60007C6.5864 5.91699 7.99461 4.7002 9.97703 4.7002C12.0005 4.7002 13.3677 5.90332 13.3677 7.57129C13.3677 8.69238 12.8208 9.59473 10.8794 11.4268L9.1157 13.1768V13.2451H13.518V14.7354H6.64109Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1784">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  "icon-number-3": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1788)">
        {/* <rect width="20" height="20" rx="4" fill="#252525" /> */}
        <path
          d="M10.1641 15.1719C8.04492 15.1719 6.54102 14.0234 6.5 12.3555H8.29102C8.3457 13.1484 9.13867 13.668 10.1641 13.668C11.2578 13.668 12.0371 13.0664 12.0371 12.1914C12.0371 11.3027 11.2715 10.6602 9.98633 10.6602H9.09766V9.29297H9.98633C11.0391 9.29297 11.7773 8.70508 11.7637 7.84375C11.7773 7.00977 11.1484 6.44922 10.1777 6.44922C9.24805 6.44922 8.44141 6.96875 8.41406 7.80273H6.70508C6.74609 6.13477 8.25 5 10.1914 5C12.2012 5 13.5 6.23047 13.4863 7.74805C13.5 8.85547 12.7617 9.66211 11.6816 9.88086V9.96289C13.0762 10.1543 13.8691 11.043 13.8555 12.2871C13.8691 13.9551 12.3105 15.1719 10.1641 15.1719Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1788">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-4": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_1792)">
        {/* 기본 배경색만 바꾸고 싶다면 여긴 건드릴 필요 없이, ColorIcon의 color prop으로 */}
        {/* <rect width="20" height="20" rx="4" fill="#FF8741" /> */}
        <path
          d="M6 13.0527V11.6309L10.2793 5H12.4941V11.5898H13.793V13.0527H12.4941V14.8984H10.7988V13.0527H6ZM7.81836 11.5898H10.8262V7.02344H10.7168L7.81836 11.5215V11.5898Z"
          style={{ fill: "white" }}
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_1792">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-1-gray-circle": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clip-path="url(#clip0_2628_2443)">
        <circle cx="15" cy="15" r="15" fill="#E9E9E9" />
        <path
          d="M16.7227 8.27344V21H14.4199V10.5059H14.3496L11.3789 12.4043V10.3125L14.5254 8.27344H16.7227Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2628_2443">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-2-gray-circle": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clip-path="url(#clip0_2628_2446)">
        <circle cx="15" cy="15" r="15" fill="#E9E9E9" />
        <path
          d="M11.0529 21V19.3477L15.5529 15.0059C16.8361 13.7227 17.504 12.9668 17.504 11.8945C17.504 10.7168 16.5724 9.96094 15.3243 9.96094C14.006 9.96094 13.1622 10.7871 13.1798 12.0703H11.0001C10.9825 9.66211 12.7931 8.09766 15.3419 8.09766C17.9435 8.09766 19.7013 9.64453 19.7013 11.7891C19.7013 13.2305 18.9982 14.3906 16.5021 16.7461L14.2345 18.9961V19.084H19.8947V21H11.0529Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2628_2446">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "icon-number-3-gray-circle": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clip-path="url(#clip0_2628_2449)">
        <circle cx="15" cy="15" r="15" fill="#E9E9E9" />
        <path
          d="M15.3105 21.1758C12.5859 21.1758 10.6523 19.6992 10.5996 17.5547H12.9023C12.9727 18.5742 13.9922 19.2422 15.3105 19.2422C16.7168 19.2422 17.7188 18.4688 17.7188 17.3438C17.7188 16.2012 16.7344 15.375 15.082 15.375H13.9395V13.6172H15.082C16.4355 13.6172 17.3848 12.8613 17.3672 11.7539C17.3848 10.6816 16.5762 9.96094 15.3281 9.96094C14.1328 9.96094 13.0957 10.6289 13.0605 11.7012H10.8633C10.916 9.55664 12.8496 8.09766 15.3457 8.09766C17.9297 8.09766 19.5996 9.67969 19.582 11.6309C19.5996 13.0547 18.6504 14.0918 17.2617 14.373V14.4785C19.0547 14.7246 20.0742 15.8672 20.0566 17.4668C20.0742 19.6113 18.0703 21.1758 15.3105 21.1758Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2628_2449">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "gray-rectangle-3d": (
    <svg
      width="111"
      height="277"
      viewBox="0 0 111 277"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53.9662 1.7168C55.0424 1.37959 56.18 1.40382 57.2474 1.78906L105.425 19.1758L105.66 19.2666C108.052 20.2578 109.606 22.9061 109.606 25.8164V244.383C109.606 247.293 108.052 249.941 105.66 250.933L105.425 251.023L57.2474 268.411C56.18 268.796 55.0423 268.821 53.9662 268.483L53.7523 268.411L5.57458 251.023C3.04948 250.112 1.39392 247.387 1.39392 244.383V25.8164C1.39403 22.8122 3.04945 20.0871 5.57458 19.1758L53.7523 1.78906L53.9662 1.7168Z"
        fill="#DEDEDE"
        stroke="#B9B9B9"
      />
      <mask
        id="mask0_7952_19792"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="109"
        height="268"
      >
        <path
          d="M105.255 19.6463C107.543 20.4717 109.106 22.9771 109.106 25.8167V244.383C109.106 247.223 107.543 249.728 105.255 250.553L57.0779 267.941C56.0491 268.312 54.9507 268.312 53.922 267.941L5.74444 250.553C3.45738 249.728 1.89392 247.223 1.89392 244.383V25.8167C1.89392 22.9771 3.45738 20.4717 5.74444 19.6463L53.922 2.25893C54.9507 1.88765 56.0491 1.88765 57.0779 2.25893L105.255 19.6463Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_7952_19792)">
        <path
          d="M1.8938 21.0352L55.4998 40.3817V352.345L1.8938 332.998V21.0352Z"
          fill="#E9E9E9"
        />
        <path
          d="M55.4999 1.68945L1.89391 21.036L55.4999 40.3825L109.106 21.036L55.4999 1.68945Z"
          fill="#F5F5F5"
        />
      </g>
    </svg>
  ),
  "orange-rectangle-3d": (
    <svg
      width="111"
      height="166"
      viewBox="0 0 111 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53.9662 1.7168C55.0424 1.37959 56.18 1.40382 57.2474 1.78906L105.425 19.1758L105.66 19.2666C108.052 20.2578 109.606 22.9061 109.606 25.8164V140.383C109.606 143.293 108.052 145.941 105.66 146.933L105.425 147.023L57.2474 164.411C56.1801 164.796 55.0423 164.821 53.9662 164.483L53.7523 164.411L5.57458 147.023C3.04948 146.112 1.39392 143.387 1.39392 140.383V25.8164C1.39403 22.8122 3.04945 20.0871 5.57458 19.1758L53.7523 1.78906L53.9662 1.7168Z"
        fill="#F9CFA9"
        stroke="#F4A35B"
      />
      <mask
        id="mask0_7952_19806"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="109"
        height="164"
      >
        <path
          d="M105.255 19.6463C107.543 20.4717 109.106 22.9771 109.106 25.8167V140.383C109.106 143.223 107.543 145.728 105.255 146.553L57.0779 163.941C56.0491 164.312 54.9507 164.312 53.922 163.941L5.74444 146.553C3.45738 145.728 1.89392 143.223 1.89392 140.383V25.8167C1.89392 22.9771 3.45738 20.4717 5.74444 19.6463L53.922 2.25893C54.9507 1.88765 56.0491 1.88765 57.0779 2.25893L105.255 19.6463Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_7952_19806)">
        <path
          d="M1.8938 21.0352L55.4998 40.3817V352.345L1.8938 332.998V21.0352Z"
          fill="#FCE7D4"
        />
        <path
          d="M55.4999 1.68945L1.89391 21.036L55.4999 40.3825L109.106 21.036L55.4999 1.68945Z"
          fill="#FEF5EE"
        />
      </g>
    </svg>
  ),
  "icon-match-file": (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66 73.0337V12.2163C66 10.0258 64.1532 8.25 61.875 8.25H37.125L13.75 31.625V73.0337C13.75 75.2242 15.5968 77 17.875 77H61.875C64.1532 77 66 75.2242 66 73.0337Z"
        fill="#98B4DF"
      />
      <path
        d="M37.125 8.25V27.5C37.125 29.7782 35.2782 31.625 33 31.625H13.75L37.125 8.25Z"
        fill="#5885CB"
      />
      <rect
        width="39.7712"
        height="6.47681"
        rx="3.2384"
        transform="matrix(0.735415 0.677617 -0.677607 0.735424 53.2578 37.8672)"
        fill="#274A7F"
      />
      <ellipse
        cx="55.9874"
        cy="44.9874"
        rx="17.4874"
        ry="17.4874"
        fill="#274A7F"
      />
      <circle cx="55.9793" cy="44.9871" r="11.0106" fill="#F8FAFD" />
    </svg>
  ),
  icon_plus_v2: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C7.41421 1.81059e-08 7.75 0.335786 7.75 0.75V6.25H13.25C13.6642 6.25 14 6.58579 14 7C14 7.41421 13.6642 7.75 13.25 7.75H7.75V13.25C7.75 13.6642 7.41421 14 7 14C6.58579 14 6.25 13.6642 6.25 13.25V7.75H0.75C0.335786 7.75 0 7.41421 0 7C0 6.58579 0.335786 6.25 0.75 6.25H6.25V0.75C6.25 0.335786 6.58579 -1.81058e-08 7 0Z"
        fill="white"
      />
    </svg>
  ),
  arrow_right_small_v2: (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.05025 1.05025L6 6L1.05025 10.9497"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  icon_speech_bubble: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="16" cy="15" rx="13" ry="11" fill="#535353" />
      <path
        d="M5.73409 25.7785L6.99998 21.5L12 24.5L7.14415 26.9547C6.36177 27.3502 5.48537 26.6192 5.73409 25.7785Z"
        fill="#535353"
      />
      <circle cx="9.5" cy="15" r="1.5" fill="white" />
      <circle cx="16" cy="15" r="1.5" fill="white" />
      <circle cx="22.5" cy="15" r="1.5" fill="white" />
    </svg>
  ),
  chevron_right_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0503 7.05025L17 12L12.0503 16.9497"
        stroke="#535353"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  chevron_up_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9497 13.9498L12 9.00006L7.05025 13.9498"
        stroke="#686868"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  chevron_down_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.05025 10.0502L12 14.9999L16.9497 10.0502"
        stroke="#686868"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  thumbnail_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.5"
        y="3.50003"
        width="7.5"
        height="7.5"
        rx="1"
        fill="#FF9B56"
      />
      <rect x="13" y="3.50003" width="7.5" height="7.5" rx="1" fill="#FF9B56" />
      <rect x="3.5" y="13" width="7.5" height="7.5" rx="1" fill="#FF9B56" />
      <rect x="13" y="13" width="7.5" height="7.5" rx="1" fill="#FF9B56" />
    </svg>
  ),
  icon_normal_circle_check: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 17.4167 17.4167"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70833 0C13.5208 0 17.4167 3.89583 17.4167 8.70833C17.4167 13.5208 13.5208 17.4167 8.70833 17.4167C3.89583 17.4167 0 13.5208 0 8.70833C0 3.89583 3.89583 0 8.70833 0Z"
        fill="#CBCDCF"
      />
      <path
        d="M11.8342 5.92165C12.1092 5.61915 12.5675 5.60081 12.87 5.87581C13.1725 6.15081 13.1909 6.60915 12.9159 6.91165L8.33252 11.9533C8.19502 12.1 8.01169 12.1916 7.81002 12.1916C7.60835 12.1916 7.41585 12.1183 7.27835 11.9808L4.52835 9.23081C4.24418 8.94665 4.24418 8.47915 4.52835 8.19498C4.81252 7.91081 5.28002 7.91081 5.56418 8.19498L7.77335 10.4041L11.8434 5.93081L11.8342 5.92165Z"
        fill="white"
      />
    </svg>
  ),
  icon_normal_circle_check_active: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 17.4167 17.4167"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70833 0C13.5208 0 17.4167 3.89583 17.4167 8.70833C17.4167 13.5208 13.5208 17.4167 8.70833 17.4167C3.89583 17.4167 0 13.5208 0 8.70833C0 3.89583 3.89583 0 8.70833 0Z"
        fill="black"
      />
      <path
        d="M11.8342 5.92165C12.1092 5.61915 12.5675 5.60081 12.87 5.87581C13.1725 6.15081 13.1909 6.60915 12.9159 6.91165L8.33252 11.9533C8.19502 12.1 8.01169 12.1916 7.81002 12.1916C7.60835 12.1916 7.41585 12.1183 7.27835 11.9808L4.52835 9.23081C4.24418 8.94665 4.24418 8.47915 4.52835 8.19498C4.81252 7.91081 5.28002 7.91081 5.56418 8.19498L7.77335 10.4041L11.8434 5.93081L11.8342 5.92165Z"
        fill="white"
      />
    </svg>
  ),
  icon_normal_check: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0381 6.12598C18.521 5.5948 19.3428 5.55536 19.874 6.03809C20.4052 6.52097 20.4446 7.34276 19.9619 7.87402L11.2119 17.499C10.9728 17.762 10.6365 17.9163 10.2812 17.9248C9.92584 17.9333 9.58244 17.7953 9.33105 17.5439L4.08105 12.2939C3.57337 11.7863 3.57337 10.9637 4.08105 10.4561C4.58874 9.94837 5.41126 9.94837 5.91895 10.4561L10.2051 14.7422L18.0381 6.12598Z"
        fill="#171819"
      />
    </svg>
  ),
  funeral_facility_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.4 2.5) scale(1.1176)">
        <path
          d="M7.7002 4.90039C8.30764 4.90039 8.7997 5.39258 8.7998 6V17H5.50488V15.8994C5.50467 15.2921 5.01168 14.7998 4.4043 14.7998C3.79709 14.8 3.3049 15.2922 3.30469 15.8994V17H0V6C0.000105359 5.39258 0.493138 4.90039 1.10059 4.90039H7.7002ZM1.98438 11.5V13.1504H3.63477V11.5H1.98438ZM5.28906 11.5V13.1504H6.93945V11.5H5.28906ZM1.98438 8.2002V9.85059H3.63477V8.2002H1.98438ZM5.28906 8.2002V9.85059H6.93945V8.2002H5.28906Z"
          fill="#69A5FF"
        />
        <path
          d="M14.291 0C14.8982 0.000211036 15.3904 0.492406 15.3906 1.09961V17H9.89062V6C9.89062 4.78497 8.90546 3.7998 7.69043 3.7998H4.39062V1.10156C4.39062 0.49418 4.8829 0.000211579 5.49023 0H14.291ZM7.69043 4.89941C7.83269 4.89941 7.96887 4.92638 8.09375 4.97559C7.96944 4.92685 7.83397 4.90042 7.69238 4.90039H4.39062V4.89941H7.69043Z"
          fill="#69A5FF"
        />
      </g>
    </svg>
  ),
  guidebook_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.69 2.5) scale(0.7308)">
        <path
          d="M0 3C0 1.34314 1.34315 0 3 0H18C19.1046 0 20 0.895431 20 2V21.3103C20 22.4149 19.1046 23.3103 18 23.3103H2C0.895431 23.3103 0 22.4149 0 21.3103V3Z"
          fill="#F18334"
        />
        <rect
          x="4.54541"
          y="3.5862"
          width="11.8182"
          height="4.48276"
          rx="1"
          fill="#FDECDD"
        />
        <path
          d="M0 21.5172C0 19.7842 1.4049 18.3793 3.13793 18.3793H20V22.6552C20 23.7597 19.1046 24.6552 18 24.6552H3.13793C1.4049 24.6552 0 23.2503 0 21.5172Z"
          fill="#F18334"
        />
        <path
          d="M1.36353 21.069C1.36353 19.8311 2.36703 18.8276 3.6049 18.8276H18.2068C19.1971 18.8276 19.9999 18.0248 19.9999 17.0345V21.3104C19.9999 22.4149 19.1045 23.3104 17.9999 23.3104H3.60491C2.36703 23.3104 1.36353 22.3069 1.36353 21.069Z"
          fill="#FDECDD"
        />
        <path
          d="M12 21H17V25.2615C17 25.6152 16.6427 25.8571 16.3143 25.7257L14.8714 25.1486C14.633 25.0532 14.367 25.0532 14.1286 25.1486L12.6857 25.7257C12.3573 25.8571 12 25.6152 12 25.2615V21Z"
          fill="#753C08"
        />
      </g>
    </svg>
  ),
  gift_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7.50006H20V20.5001C20 21.0523 19.5523 21.5001 19 21.5001H5C4.44772 21.5001 4 21.0523 4 20.5001V7.50006Z"
        fill="#FFD37B"
      />
      <rect x="4" y="7.50006" width="16" height="3.5" fill="#FDC358" />
      <rect x="2.5" y="4.50006" width="19" height="5" rx="0.5" fill="#FFD37B" />
      <rect x="10.5" y="4.50006" width="3" height="17" fill="#FF9B56" />
      <path
        d="M13 4.50006H7.75V2.57641C7.75 2.20058 8.14909 1.95911 8.482 2.13349L13 4.50006Z"
        fill="#FF9B56"
      />
      <path
        d="M11 4.50006H16.25V2.57641C16.25 2.20058 15.8509 1.95911 15.518 2.13349L11 4.50006Z"
        fill="#FF9B56"
      />
    </svg>
  ),
  payment_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2.00006C17.5523 2.00006 18 2.44778 18 3.00006V20.0001H17.0322L15.748 18.6837C15.6499 18.5831 15.4878 18.5831 15.3896 18.6837L14.1201 19.9844L12.8506 18.6837C12.7525 18.5833 12.5913 18.5834 12.4932 18.6837L11.2227 19.9844L9.9541 18.6837C9.856 18.5831 9.69381 18.5831 9.5957 18.6837L8.34473 19.9649L7.31055 18.7296C7.21063 18.6104 7.02763 18.6104 6.92773 18.7296L5.89355 19.9649L4.64258 18.6837C4.54454 18.5833 4.38325 18.5834 4.28516 18.6837L3 20.0001V3.00006C3 2.44778 3.44772 2.00006 4 2.00006H17Z"
        fill="#D1E6FF"
      />
      <rect
        x="5.75"
        y="5.50006"
        width="9.5"
        height="1"
        rx="0.5"
        fill="#A0C9FF"
      />
      <rect
        x="5.75"
        y="9.50006"
        width="9.5"
        height="1"
        rx="0.5"
        fill="#A0C9FF"
      />
      <rect
        x="5.75"
        y="13.5001"
        width="9.5"
        height="1"
        rx="0.5"
        fill="#A0C9FF"
      />
      <path
        d="M16.5 22.0001C19.2614 22.0001 21.5 19.7615 21.5 17.0001C21.5 14.2386 19.2614 12.0001 16.5 12.0001C13.7386 12.0001 11.5 14.2386 11.5 17.0001C11.5 19.7615 13.7386 22.0001 16.5 22.0001Z"
        fill="#FDC358"
      />
      <path
        d="M19.0967 16.515H18.7146L19.0047 15.659C19.0401 15.5585 19.033 15.451 18.9835 15.354C18.934 15.257 18.8526 15.1876 18.7535 15.153C18.6509 15.1149 18.5377 15.1218 18.4422 15.1669C18.3432 15.2154 18.2689 15.2985 18.2335 15.399L17.5825 17.2635L16.9033 15.3956C16.8467 15.2466 16.6946 15.1495 16.5177 15.1495C16.3408 15.1495 16.1887 15.2466 16.1285 15.399L15.4528 17.2774L14.7771 15.3956C14.7417 15.2951 14.6639 15.2154 14.5684 15.1669C14.4693 15.1183 14.3597 15.1114 14.2571 15.1495C14.0413 15.2258 13.9316 15.451 14.0059 15.6624L14.3066 16.5115H13.9068C13.6875 16.5115 13.5 16.6952 13.5 16.9101C13.5 17.1249 13.6875 17.3086 13.9068 17.3086H14.5967L15.0672 18.629C15.1203 18.778 15.2724 18.8751 15.4528 18.8751C15.6333 18.8751 15.7818 18.778 15.842 18.6255L16.5142 16.7437L17.2005 18.629C17.2535 18.778 17.4057 18.8751 17.5825 18.8751C17.7594 18.8751 17.9151 18.7746 17.9717 18.6186L18.4245 17.3121H19.0932C19.3125 17.3121 19.5 17.1284 19.5 16.9135C19.5 16.6987 19.3125 16.515 19.0932 16.515H19.0967Z"
        fill="white"
      />
    </svg>
  ),
  write_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3.75" y="2" width="16" height="20" rx="1" fill="#D1E6FF" />
      <rect x="7" y="5.5" width="9.5" height="1" rx="0.5" fill="#A0C9FF" />
      <rect x="7" y="9.5" width="9.5" height="1" rx="0.5" fill="#A0C9FF" />
      <rect x="7" y="13.5" width="9.5" height="1" rx="0.5" fill="#A0C9FF" />
      <path
        d="M20.2617 9.49262C20.5441 9.26397 20.9583 9.30751 21.187 9.58986L22.6964 11.4539C22.9251 11.7363 22.8815 12.1505 22.5992 12.3792L13.7894 19.5132C13.6717 19.6085 13.5246 19.6603 13.3731 19.6598L11.0724 19.6517C10.8641 19.6509 10.709 19.4593 10.7516 19.2555L11.222 17.0034C11.253 16.855 11.3342 16.722 11.4519 16.6266L20.2617 9.49262Z"
        fill="#7CA3D7"
      />
    </svg>
  ),
  icon_subtract_circle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5ZM13.8887 6.11133C13.5958 5.81843 13.121 5.81843 12.8281 6.11133L10 8.93945L7.17188 6.11133L7.11426 6.05957C6.81968 5.81962 6.3858 5.83685 6.11133 6.11133C5.83685 6.3858 5.81962 6.81968 6.05957 7.11426L6.11133 7.17188L8.93945 10L6.11133 12.8281L6.05957 12.8857C5.81962 13.1803 5.83685 13.6142 6.11133 13.8887C6.3858 14.1631 6.81968 14.1804 7.11426 13.9404L7.17188 13.8887L10 11.0605L12.8281 13.8887C13.121 14.1816 13.5958 14.1816 13.8887 13.8887C14.1816 13.5958 14.1816 13.121 13.8887 12.8281L11.0605 10L13.8887 7.17188C14.1816 6.87898 14.1816 6.40422 13.8887 6.11133Z"
        fill="#8F8F8F"
      />
    </svg>
  ),
  icon_Graphic_Guidebook: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7.8004C8 5.37035 9.96995 3.40039 12.4 3.40039H37.2C38.7464 3.40039 40 4.65399 40 6.20039V37.4969C40 39.2643 38.5673 40.6969 36.8 40.6969H11.2C9.43269 40.6969 8 39.2643 8 37.4969V7.8004Z"
        fill="#FF8442"
      />
      <rect
        x="14.6016"
        y="8.80078"
        width="20"
        height="7.2"
        rx="1.6"
        fill="#FFF1D7"
      />
      <path
        d="M8 37.7656C8 35.0042 10.2386 32.7656 13 32.7656H40V39.9656C40 41.512 38.7464 42.7656 37.2 42.7656H13C10.2386 42.7656 8 40.527 8 37.7656Z"
        fill="#FF8442"
      />
      <path
        d="M10.1836 36.9962C10.1836 35.0156 11.7892 33.41 13.7698 33.41H37.1328C38.7173 33.41 40.0018 32.1255 40.0018 30.541V37.3824C40.0018 39.1497 38.5691 40.5824 36.8018 40.5824H13.7698C11.7892 40.5824 10.1836 38.9768 10.1836 36.9962Z"
        fill="#FFF1D7"
      />
      <path
        d="M27.3086 37H35.3086V44.0093C35.3086 44.2923 35.0228 44.4858 34.76 44.3807L31.7543 43.1784C31.4682 43.0639 31.149 43.0639 30.8629 43.1784L27.8571 44.3807C27.5944 44.4858 27.3086 44.2923 27.3086 44.0093V37Z"
        fill="#943F12"
      />
    </svg>
  ),
  building: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.168 6.50859C14.168 4.7553 15.5893 3.33398 17.3426 3.33398H28.9925C30.9304 3.33398 32.5013 4.90492 32.5013 6.84276V36.6673H14.168V6.50859Z"
        fill="#99A8B0"
      />
      <path
        d="M7.5 13.1746C7.5 11.4213 8.92132 10 10.6746 10H22.3246C24.2624 10 25.8333 11.5709 25.8333 13.5088V36.6667H7.5V13.1746Z"
        fill="#C7D0D6"
      />
      <rect
        x="12.832"
        y="14.334"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="17.832"
        y="14.334"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="12.832"
        y="19.3398"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="17.832"
        y="19.3398"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="12.832"
        y="24.3398"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="17.832"
        y="24.3398"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <path
        d="M14.332 32.6673C14.332 31.3787 15.3767 30.334 16.6654 30.334C17.954 30.334 18.9987 31.3787 18.9987 32.6673V36.6673H14.332V32.6673Z"
        fill="#718189"
      />
    </svg>
  ),
  icon_Buildingcoin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M26.5 34C30.366 34 33.5 30.866 33.5 27C33.5 23.134 30.366 20 26.5 20C22.634 20 19.5 23.134 19.5 27C19.5 30.866 22.634 34 26.5 34Z"
        fill="#FDC358"
      />
      <path
        d="M30.1354 26.3209H29.6005L30.0066 25.1225C30.0561 24.9818 30.0462 24.8314 29.9769 24.6955C29.9075 24.5597 29.7936 24.4626 29.6549 24.4141C29.5113 24.3607 29.3528 24.3704 29.2191 24.4335C29.0804 24.5014 28.9764 24.6179 28.9269 24.7586L28.0156 27.3689L27.0646 24.7537C26.9854 24.5451 26.7724 24.4092 26.5248 24.4092C26.2771 24.4092 26.0641 24.5451 25.9799 24.7586L25.034 27.3883L24.088 24.7537C24.0384 24.613 23.9295 24.5014 23.7957 24.4335C23.6571 24.3656 23.5035 24.3559 23.3599 24.4092C23.0578 24.516 22.9042 24.8314 23.0082 25.1273L23.4292 26.316H22.8696C22.5625 26.316 22.3 26.5732 22.3 26.874C22.3 27.1748 22.5625 27.432 22.8696 27.432H23.8354L24.4941 29.2805C24.5684 29.4891 24.7814 29.625 25.034 29.625C25.2865 29.625 25.4946 29.4891 25.5788 29.2757L26.5198 26.6411L27.4806 29.2805C27.5549 29.4891 27.7679 29.625 28.0156 29.625C28.2632 29.625 28.4811 29.4843 28.5604 29.266L29.1943 27.4368H30.1304C30.4375 27.4368 30.7 27.1797 30.7 26.8788C30.7 26.578 30.4375 26.3209 30.1304 26.3209H30.1354Z"
        fill="white"
      />
      <path
        d="M27.1924 3C28.1864 3.00004 28.9921 3.8058 28.9922 4.7998V19.5801C28.0677 19.2069 27.0581 19 26 19C24.4115 19 22.9321 19.4644 21.6875 20.2627V13.2451C21.6875 11.1704 20.0054 9.48828 17.9307 9.48828H12.2969V4.80273C12.2969 3.80864 13.1026 3.00003 14.0967 3H27.1924Z"
        fill="#99A8B0"
      />
      <path
        d="M18.1484 11.3486C19.1856 11.3489 20.0264 12.1894 20.0264 13.2266V21.6807C18.7666 23.0944 18 24.9574 18 27C18 28.8969 18.6615 30.6385 19.7646 32.0098H5V13.2266C5 12.1893 5.84074 11.3488 6.87793 11.3486H18.1484Z"
        fill="#C7D0D6"
      />
      <rect x="8.20001" y="15" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="15" width="3" height="3" fill="#718189" />
      <rect x="8.20001" y="20" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="20" width="3" height="3" fill="#718189" />
      <rect x="8.20001" y="25" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="25" width="3" height="3" fill="#718189" />
    </svg>
  ),
  icon_Buildingfire: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <circle cx="26.5" cy="27" r="7" fill="#EF4452" />
      <path
        d="M28.7574 25.1041C28.8397 25.6833 28.9352 26.0149 28.5425 26.0149C28.0081 26.0149 28.0079 24.6806 27.1036 23.9204C26.2089 23.1686 25.5415 23.3514 25.5274 23.3554C25.5272 23.3556 25.5268 23.356 25.5266 23.3562C26.2718 24.0126 25.8562 25.0913 25.3685 25.3887C24.9005 25.674 24.3663 25.3142 24.646 24.4675C24.031 25.3547 23.5 26.4299 23.5 27.5012C23.5 29.2492 24.8432 30.6663 26.5 30.6663C28.1568 30.6663 29.5 29.2492 29.5 27.5012C29.5 26.6753 29.1837 25.847 28.7574 25.1041Z"
        fill="white"
      />
      <path
        d="M27.1924 3C28.1864 3.00004 28.9921 3.8058 28.9922 4.7998V19.5801C28.0677 19.2069 27.0581 19 26 19C24.4115 19 22.9321 19.4644 21.6875 20.2627V13.2451C21.6875 11.1704 20.0054 9.48828 17.9307 9.48828H12.2969V4.80273C12.2969 3.80864 13.1026 3.00003 14.0967 3H27.1924Z"
        fill="#99A8B0"
      />
      <path
        d="M18.1484 11.3486C19.1856 11.3489 20.0264 12.1894 20.0264 13.2266V21.6807C18.7666 23.0944 18 24.9574 18 27C18 28.8969 18.6615 30.6385 19.7646 32.0098H5V13.2266C5 12.1893 5.84074 11.3488 6.87793 11.3486H18.1484Z"
        fill="#C7D0D6"
      />
      <rect x="8.20001" y="15" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="15" width="3" height="3" fill="#718189" />
      <rect x="8.20001" y="20" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="20" width="3" height="3" fill="#718189" />
      <rect x="8.20001" y="25" width="3" height="3" fill="#718189" />
      <rect x="13.2" y="25" width="3" height="3" fill="#718189" />
    </svg>
  ),
  icon_Write: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <rect x="5.625" y="3" width="24" height="30" rx="1.5" fill="#D1E6FF" />
      <rect
        x="10.5"
        y="8.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <rect
        x="10.5"
        y="14.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <rect
        x="10.5"
        y="20.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <path
        d="M30.3927 14.2392C30.8162 13.8962 31.4376 13.9615 31.7805 14.385L34.0448 17.1811C34.3877 17.6046 34.3224 18.226 33.8989 18.569L20.6842 29.27C20.5076 29.413 20.287 29.4907 20.0598 29.4899L16.6087 29.4777C16.2963 29.4766 16.0636 29.1892 16.1275 28.8835L16.8331 25.5053C16.8796 25.2828 17.0014 25.0832 17.178 24.9402L30.3927 14.2392Z"
        fill="#7CA3D7"
      />
    </svg>
  ),
  // 고이 디자인 시스템 로고 Signature(검정) (goi-agent design-system/assets/logos/goi-signature-black.svg). 형태 변형 금지
  icon_Logo_GoiSignature: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g>
        <g transform="matrix(1 0 0 1 0.9951 1.3875)">
          <path
            d="M 27 9.08 C 27.35 9.08 27.68 9.22 27.93 9.47 L 29.62 11.16 C 29.87 11.41 30.01 11.74 30.01 12.09 L 30.01 29.22 L 26.98 29.22 L 26.98 12.54 C 26.98 12.3 26.78 12.1 26.54 12.1 L 24.25 12.1 L 24.25 9.07 L 27 9.07 L 27 9.08 Z M 17.97 14.18 C 21.66 14.18 24.65 17.17 24.65 20.86 C 24.65 24.55 21.66 27.54 17.97 27.54 C 14.28 27.54 11.29 24.55 11.29 20.86 C 11.29 17.17 14.28 14.18 17.97 14.18 Z M 17.97 17.19 C 15.94 17.19 14.3 18.83 14.3 20.86 C 14.3 22.89 15.94 24.53 17.97 24.53 C 20 24.53 21.64 22.89 21.64 20.86 C 21.64 18.83 20 17.19 17.97 17.19 Z M 12.13 6.05 L 12.13 12.12 C 12.13 12.47 11.99 12.8 11.74 13.05 L 10.05 14.74 C 9.8 14.99 9.47 15.13 9.12 15.13 L 0 15.13 L 0 12.1 L 8.66 12.1 C 8.9 12.1 9.1 11.9 9.1 11.66 L 9.1 6.05 L 12.13 6.05 Z M 21.2 12.11 L 15.15 12.11 L 15.15 9.08 L 18.18 9.08 L 18.18 3.03 L 6.06 3.03 L 6.06 0 L 21.19 0 L 21.19 12.11 L 21.2 12.11 Z"
            fill="#171819"
          />
        </g>
      </g>
    </svg>
  ),
  icon_Logo_CCM: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5651 10.7645C24.5651 11.1003 24.2927 11.3718 23.9569 11.3718C23.6211 11.3718 23.3496 11.0993 23.3496 10.7645C23.3496 10.4297 23.6211 10.1562 23.9569 10.1562C24.2927 10.1562 24.5651 10.4287 24.5651 10.7645Z"
        fill="#F08300"
      />
      <path
        d="M17.7617 12.9032C17.7617 13.5959 18.3247 14.1589 19.0175 14.1589H19.9907V13.5939H19.0175C18.6374 13.5939 18.3278 13.2842 18.3278 12.9042C18.3278 12.5241 18.6364 12.2145 19.0175 12.2145H19.9907V11.6484H19.0175C18.3247 11.6484 17.7617 12.2115 17.7617 12.9032Z"
        fill="#7D8488"
      />
      <path
        d="M20.1328 12.9032C20.1328 13.5959 20.6958 14.1589 21.3896 14.1589H22.3618V13.5939H21.3896C21.0095 13.5939 20.6989 13.2842 20.6989 12.9042C20.6989 12.5241 21.0085 12.2145 21.3896 12.2145H22.3618V11.6484H21.3896C20.6968 11.6484 20.1328 12.2115 20.1328 12.9032Z"
        fill="#7D8488"
      />
      <path
        d="M26.5085 10.7645C26.5085 11.1003 26.237 11.3718 25.9012 11.3718C25.5654 11.3718 25.293 11.0993 25.293 10.7645C25.293 10.4297 25.5654 10.1562 25.9012 10.1562C26.237 10.1562 26.5085 10.4287 26.5085 10.7645Z"
        fill="#5B98D2"
      />
      <path
        d="M25.9004 11.6484C25.5083 11.6484 25.1584 11.8284 24.9272 12.1109C24.6969 11.8284 24.3461 11.6484 23.954 11.6484C23.2622 11.6484 22.6992 12.2115 22.6992 12.9032V14.1589H23.2643V12.9032C23.2643 12.5231 23.5739 12.2135 23.954 12.2135C24.334 12.2135 24.6437 12.5231 24.6437 12.9032V14.1589H25.2097V12.9032C25.2097 12.5231 25.5194 12.2135 25.9004 12.2135C26.2814 12.2135 26.5901 12.5231 26.5901 12.9032V14.1589H27.1551V12.9032C27.1551 12.2115 26.5921 11.6484 25.8994 11.6484H25.9004Z"
        fill="#7D8488"
      />
      <path
        d="M31.13 12.453C30.4121 10.7559 29.3846 9.23263 28.0766 7.92356C26.7676 6.61549 25.2434 5.58793 23.5463 4.87005C21.7898 4.12704 19.9238 3.75 18.0005 3.75C16.0772 3.75 14.2102 4.12704 12.4537 4.87005C10.7566 5.58793 9.23243 6.61549 7.92441 7.92356C6.61538 9.23162 5.58887 10.7559 4.87102 12.453C4.12702 14.2105 3.75 16.0766 3.75 18C3.75 19.7706 4.07173 21.4989 4.70412 23.1378C4.79762 23.3791 5.02887 23.5269 5.27217 23.5269C5.34456 23.5269 5.41896 23.5138 5.49235 23.4857C5.80604 23.364 5.96187 23.0121 5.84022 22.6984C5.26111 21.2003 4.96754 19.6198 4.96754 18C4.96754 16.2405 5.31239 14.5333 5.99204 12.9266C6.64856 11.3752 7.5876 9.98067 8.78503 8.78421C9.98145 7.58774 11.3759 6.64766 12.9273 5.99111C14.5339 5.31244 16.2401 4.96758 17.9995 4.96758C19.7589 4.96758 21.4651 5.31244 23.0717 5.99111C24.6231 6.64766 26.0175 7.58774 27.214 8.78421C28.4114 9.98067 29.3504 11.3752 30.007 12.9266C30.6866 14.5333 31.0315 16.2395 31.0315 18C31.0315 19.6198 30.7379 21.2013 30.1588 22.6984C30.0381 23.0121 30.194 23.365 30.5076 23.4857C30.8213 23.6073 31.1732 23.4515 31.2949 23.1378C31.9283 21.4989 32.25 19.7706 32.25 18C32.25 16.0766 31.873 14.2105 31.13 12.453Z"
        fill="#5B98D2"
      />
      <path
        d="M25.0556 26.9754C25.0556 26.8195 24.9128 26.7109 24.7158 26.7109C24.5187 26.7109 24.377 26.8165 24.377 26.9754C24.377 27.1342 24.5247 27.2388 24.7158 27.2388C24.9068 27.2388 25.0556 27.1302 25.0556 26.9754Z"
        fill="#5B98D2"
      />
      <path
        d="M13.5922 27.5859C13.3429 27.5859 13.0664 27.6453 13.0664 27.8604C13.0664 28.0756 13.3429 28.1268 13.5922 28.1268C13.8416 28.1268 14.113 28.0776 14.113 27.8604C14.113 27.6432 13.8365 27.5859 13.5922 27.5859Z"
        fill="#5B98D2"
      />
      <path
        d="M11.0398 27.5859C10.7191 27.5859 10.502 27.6764 10.502 27.8554C10.502 28.0343 10.7191 28.1218 11.0398 28.1218C11.3606 28.1218 11.5777 28.0353 11.5777 27.8554C11.5777 27.6754 11.3656 27.5859 11.0398 27.5859Z"
        fill="#5B98D2"
      />
      <path
        d="M20.1069 26.8335C20.3532 26.8335 20.492 26.6877 20.492 26.5269C20.492 26.3419 20.3613 26.2031 20.1069 26.2031C19.8525 26.2031 19.7168 26.3539 19.7168 26.5269C19.7168 26.6998 19.8525 26.8335 20.1069 26.8335Z"
        fill="#5B98D2"
      />
      <path
        d="M30.2686 24.6514C30.16 24.4614 29.9579 24.3438 29.7398 24.3438H6.26272C6.04355 24.3438 5.84247 24.4614 5.73388 24.6514C5.6253 24.8414 5.62832 25.0747 5.73992 25.2637C6.97957 27.353 8.74505 29.1035 10.8453 30.3251C13.0089 31.5849 15.4832 32.2505 18.0017 32.2505C20.5203 32.2505 22.9945 31.5849 25.1582 30.3251C27.2574 29.1025 29.0229 27.353 30.2636 25.2637C30.3752 25.0747 30.3772 24.8414 30.2686 24.6514ZM23.9849 26.1887H24.567V25.9273H24.8515V26.1887H25.4467V26.428H23.9849V26.1887ZM23.3404 25.9595H23.6219V27.7612V27.8105H23.3404V27.5833H22.6567V27.349H23.3404V25.9595ZM22.3802 25.9595C22.6879 25.9595 23.0066 26.1002 23.0066 26.4039C23.0066 26.7075 22.6879 26.8483 22.3802 26.8483C22.0726 26.8483 21.7549 26.7105 21.7549 26.4039C21.7549 26.0972 22.0736 25.9595 22.3802 25.9595ZM20.1121 25.9816C20.5042 25.9816 20.7656 26.2118 20.7656 26.5265C20.7656 26.8412 20.4871 27.0574 20.1121 27.0574C19.6948 27.0574 19.4455 26.8523 19.4455 26.5265C19.4455 26.2008 19.7149 25.9816 20.1121 25.9816ZM14.1088 25.9595H14.3853V27.3269H14.1088V26.6924H13.5951V26.4552H14.1088V25.9595ZM10.224 25.9816H11.71C11.7914 25.9816 11.8608 26.0439 11.8608 26.1294V26.3516C11.8608 26.4773 11.8286 26.6894 11.7351 26.8774L11.4657 26.8754C11.5059 26.7568 11.5823 26.4853 11.5823 26.3647V26.234C11.5823 26.2169 11.5752 26.2098 11.5571 26.2098H10.224V25.9826V25.9816ZM11.0414 28.3514C10.5849 28.3514 10.2099 28.1986 10.2099 27.8547C10.2099 27.5109 10.5849 27.356 11.0414 27.356C11.4978 27.356 11.8738 27.5119 11.8738 27.8547C11.8738 28.1976 11.5008 28.3514 11.0414 28.3514ZM12.1523 27.1841V27.2334H9.9284V27.0011H10.7729V26.4954H11.0514V27.0011H12.1523V27.1841ZM12.3534 27.1167C12.7083 26.9669 12.9677 26.7095 12.9677 26.4924V26.2581H12.5083V26.0309H13.7248V26.2581H13.2563V26.4924C13.2563 26.7518 13.6122 26.9539 13.8394 27.0524L13.6645 27.2374C13.4744 27.158 13.2422 27.0001 13.1185 26.8443C12.9808 27.0172 12.7304 27.2173 12.5284 27.2957L12.3534 27.1157V27.1167ZM13.5921 28.3584C13.2422 28.3584 12.7958 28.277 12.7958 27.8618C12.7958 27.4465 13.2945 27.359 13.5921 27.359C13.9399 27.359 14.3873 27.4455 14.3873 27.8618C14.3873 28.278 13.9399 28.3584 13.5921 28.3584ZM16.7048 28.2599V28.3092H16.4253V26.9438H15.9316C15.9316 27.529 15.3425 27.8406 14.8579 27.9512L14.7121 27.7512C15.0801 27.6627 15.6451 27.4184 15.6451 26.981L15.6481 26.3415C15.6481 26.3245 15.6381 26.3164 15.621 26.3164H14.7744V26.0801H15.7858C15.8723 26.0801 15.9316 26.1515 15.9316 26.2309V26.7075H16.4253V25.9595H16.7048V28.2599ZM18.1184 27.7019C17.8419 27.7411 17.6217 27.7662 17.1924 27.7662C17.1029 27.7662 17.0416 27.6989 17.0416 27.6174V26.7678H17.671C17.6891 26.7678 17.6961 26.7578 17.6961 26.7407V26.2812H17.0416V26.057H17.9776V26.987H17.3211V27.5109C17.3211 27.528 17.3281 27.535 17.3462 27.535C17.5654 27.537 17.7956 27.5249 18.1184 27.4757V27.6999V27.7019ZM19.0614 28.2599V28.3092H18.7819V26.981H18.5135V28.2529H18.235V25.9575H18.5135V26.7447H18.7819V25.9575H19.0614V28.2599ZM20.9496 27.3621V27.3932L20.9144 27.4063C20.7304 27.4656 20.5293 27.4777 20.2207 27.4857V28.2981H19.9391V27.4857H19.356V27.2464H20.1412C20.4348 27.2464 20.7334 27.2193 20.9486 27.17V27.3631L20.9496 27.3621ZM21.3316 28.2599V28.3092H21.0481V25.9615H21.3316V28.2599ZM21.6544 26.9518H22.3772C22.6829 26.9518 23.0438 26.9177 23.2348 26.8704V27.1027L23.2007 27.1177C23.0227 27.1851 22.6728 27.1942 22.4104 27.1942V27.5792H22.1249V27.1942H21.6554V26.9518H21.6544ZM23.6571 28.2629V28.3122H22.1581C22.0786 28.3122 22.0083 28.2478 22.0083 28.1614V27.6828H22.2898V28.0478C22.2898 28.0649 22.3018 28.0729 22.3119 28.0729H23.6571V28.2629ZM25.5724 27.8226V27.8507L25.5372 27.8648C25.3582 27.9311 25.0063 27.9442 24.6494 27.9442H23.9507V27.712H24.5851V27.4626C24.2965 27.4153 24.0894 27.2334 24.0894 26.976C24.0894 26.6874 24.3629 26.4793 24.7158 26.4793C25.0687 26.4793 25.3472 26.6864 25.3472 26.976C25.3472 27.2223 25.1401 27.4123 24.8636 27.4596V27.7109C25.1079 27.7039 25.3753 27.6788 25.5724 27.6295V27.8215V27.8226ZM25.9575 28.2599V28.3092H25.6759V25.9575H25.9575V28.2599Z"
        fill="#5B98D2"
      />
      <path
        d="M22.3763 26.6341C22.5613 26.6341 22.7312 26.5678 22.7312 26.4069C22.7312 26.246 22.5613 26.1797 22.3763 26.1797C22.2004 26.1797 22.0234 26.246 22.0234 26.4069C22.0234 26.5678 22.2014 26.6341 22.3763 26.6341Z"
        fill="#5B98D2"
      />
      <path
        d="M8.71459 17.3517C9.04939 17.8997 9.94219 18.4818 10.461 18.6447L10.831 18.1933C10.2146 17.9902 9.00817 17.2673 9.00817 16.5152V15.7812H8.42202V16.5152C8.42202 17.2894 7.20047 17.9902 6.57812 18.1933L6.96319 18.6508C7.54331 18.4527 8.37075 17.8534 8.71359 17.3517H8.71459Z"
        fill="#7D8488"
      />
      <path
        d="M9.01052 18.3594H8.42035V19.7036H6.39648V20.2455H10.9157H11.0173V20.1329V19.7036H9.01052V18.3594Z"
        fill="#7D8488"
      />
      <path
        d="M19.5842 15.5547H18.998V20.9328H19.4806H19.5842V20.8191V18.024H20.2457V17.4871H19.5842V15.5547Z"
        fill="#7D8488"
      />
      <path
        d="M17.336 17.4539V16.364H18.4098V15.8281H15.7033V16.364H16.7459V17.4318C16.7459 17.9747 16.0672 18.9058 15.4258 19.3411L15.841 19.7533C16.2221 19.499 16.7861 18.8102 17.0575 18.3638C17.3039 18.7539 17.8438 19.4034 18.2238 19.6578L18.6139 19.2396C18.0338 18.8444 17.336 18.025 17.336 17.4549V17.4539Z"
        fill="#7D8488"
      />
      <path
        d="M20.8164 17.2498L21.1442 17.6902C21.6831 17.5263 22.4331 17.1593 22.788 16.6677C23.157 17.1362 23.8768 17.5263 24.4419 17.6902L24.7606 17.2498C23.8819 16.9954 23.3681 16.6224 23.168 16.2213L23.1429 16.165H24.462V15.6562H21.119V16.165H22.4492L22.424 16.2153C22.1928 16.6446 21.7152 16.9834 20.8164 17.2488V17.2498Z"
        fill="#7D8488"
      />
      <path
        d="M20.457 18.4812H22.4899V18.9558C21.5509 19.0181 21.0422 19.3911 21.0422 19.9954C21.0422 20.6731 21.6635 21.04 22.7785 21.04C23.8935 21.04 24.5088 20.6499 24.5088 19.9954C24.5088 19.3861 24.0061 19.0181 23.065 18.9558V18.4812H25.0839V17.9453H20.457V18.4812ZM23.9226 19.9944C23.9226 20.3051 23.5778 20.5142 22.7785 20.5142C21.9792 20.5142 21.6333 20.3111 21.6333 19.9944C21.6333 19.6948 21.9832 19.4575 22.7785 19.4575C23.5738 19.4575 23.9226 19.6948 23.9226 19.9944Z"
        fill="#7D8488"
      />
      <path
        d="M14.5 20.93H14.9896H15.0922V20.8164V15.5469H14.5V20.93Z"
        fill="#7D8488"
      />
      <path
        d="M13.2129 17.2027H11.8878V15.7901H11.3066V19.3654C11.3066 19.5514 11.4353 19.7042 11.6203 19.7042H13.798V15.7891H13.2129V17.2017V17.2027ZM13.2129 19.112V19.1683H11.939C11.9028 19.1683 11.8878 19.1512 11.8878 19.112V17.7446H13.2129V19.112Z"
        fill="#7D8488"
      />
      <path
        d="M28.8477 18.6223H29.3202H29.4217V18.5097V15.5547H28.8477V18.6223Z"
        fill="#7D8488"
      />
      <path
        d="M26.8106 17.4738C27.0418 17.8186 27.637 18.2419 28.0894 18.4058L28.4182 17.9825C27.828 17.694 27.083 17.2254 27.083 16.6443V15.6328H26.4818V16.6553C26.4818 17.3048 25.8404 17.8699 25.209 18.2027L25.593 18.6089C26.1319 18.3043 26.5693 17.8297 26.8106 17.4738Z"
        fill="#7D8488"
      />
      <path
        d="M26.0547 20.6095C26.0547 20.8065 26.1884 20.9483 26.3684 20.9483H29.3826V20.6095V18.9375H26.0547V20.6095ZM26.6207 19.4563H28.8175V20.4275H26.672C26.6358 20.4275 26.6207 20.4104 26.6207 20.3712V19.4563Z"
        fill="#7D8488"
      />
    </svg>
  ),
  icon_Graphic_Shield: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9996 37.4997C19.9996 37.4997 5.32227 32.2183 5.32227 21.3202V9.94513C5.32227 9.2805 5.71714 8.6794 6.32712 8.41549L19.9996 2.5V37.4997Z"
        fill="#69A7FF"
      />
      <path
        d="M20 37.4997C20 37.4997 34.6773 32.2183 34.6773 21.3202V9.94513C34.6773 9.2805 34.2824 8.6794 33.6724 8.41549L20 2.5V37.4997Z"
        fill="#4693FF"
      />
      <path
        d="M20.0005 31.467C20.0005 31.467 10.3691 28.009 10.3691 20.8623V12.6887L20.0005 8.53906V31.467Z"
        fill="#C6DDFF"
      />
      <path
        d="M20 31.467C20 31.467 29.6313 28.009 29.6313 20.8623V12.6887L20 8.53906V31.467Z"
        fill="#8CBCFF"
      />
    </svg>
  ),

  icon_Graphic_Promise: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma `Icon/Graphic/Promise`. 40px 박스 안에서 31.67x28.55 로 들어간다 */}
      <g transform="translate(4.172 5.7)">
        <path
          d="M20.1807 14.6353L25.1086 17.0066L31.4074 3.89026C32.0373 2.55639 31.4815 0.963166 30.1476 0.333287L30.018 0.259183C28.6841 -0.370697 27.0909 0.185079 26.461 1.51894L20.1622 14.6353H20.1807Z"
          fill="#FFCBC2"
        />
        <path
          d="M3.43336 12.9126L8.36124 15.2839L13.2336 5.13176C13.8634 3.7979 13.3077 2.20467 11.9738 1.57479L11.8441 1.50069C10.5102 0.870806 8.91702 1.42658 8.28714 2.76045L3.43336 12.8941V12.9126Z"
          fill="#FFCBC2"
        />
        <path
          d="M22.7188 21.9349C19.9399 27.7335 12.9556 30.1974 7.15703 27.4L6.61978 27.1406C0.821183 24.3618 -1.64276 17.3775 1.15465 11.5789L1.85863 10.0968C2.89608 7.91077 5.50823 7.003 7.69428 8.04045L25.3309 16.5068L22.7188 21.9349Z"
          fill="#FFCBC2"
        />
        <path
          d="M11.8253 13.9685L11.6956 13.913C10.3618 13.2831 9.80601 11.6713 10.4359 10.356L13.3445 4.29803C13.9743 2.96417 15.5861 2.40839 16.9014 3.03827L17.0311 3.09385C18.365 3.72373 18.9207 5.33548 18.2909 6.65082L15.3823 12.7088C14.7524 14.0426 13.1407 14.5984 11.8253 13.9685Z"
          fill="#FFCBC2"
        />
        <path
          d="M16.7903 16.0804L16.6606 16.0248C15.3268 15.3949 14.771 13.7832 15.4009 12.4678L18.2168 6.61367C18.8467 5.27981 20.4584 4.72403 21.7738 5.35391L21.9035 5.40949C23.2373 6.03937 23.7931 7.65112 23.1632 8.96646L20.3473 14.8206C19.7174 16.1545 18.1056 16.7103 16.7903 16.0804Z"
          fill="#FFCBC2"
        />
        <path
          d="M16.1046 12.1156C16.2713 12.0601 16.401 11.9489 16.4936 11.7822L17.4014 9.98517C17.5681 9.6517 17.4014 9.26266 17.105 9.09593C16.79 8.92919 16.3825 9.09593 16.2157 9.39234L15.308 11.1894C15.1412 11.5228 15.308 11.9119 15.6044 12.0786C15.7711 12.1527 15.9564 12.1712 16.1231 12.1156H16.1046Z"
          fill="#FF9C99"
        />
        <path
          d="M11.2325 9.78109C11.3993 9.72552 11.5289 9.61436 11.6216 9.44763L12.5293 7.65062C12.6961 7.31715 12.5293 6.92811 12.2329 6.76137C11.918 6.59464 11.5104 6.76137 11.3437 7.05779L10.4359 8.8548C10.2692 9.18827 10.4359 9.57731 10.7323 9.74404C10.8991 9.81815 11.0843 9.83667 11.2511 9.78109H11.2325Z"
          fill="#FF9C99"
        />
        <path
          d="M14.845 12.1345C14.456 12.9681 14.4004 13.8759 14.6968 14.7466C14.9932 15.5988 15.6046 16.3028 16.4382 16.6918C17.2719 17.0809 18.1797 17.1365 19.0504 16.8401C19.9026 16.5436 20.6066 15.9323 20.9956 15.0986L23.052 10.8191C23.2187 10.4857 23.052 10.0966 22.7556 9.9299C22.4406 9.76317 22.0331 9.9299 21.8663 10.2263L19.8099 14.5058C19.3283 15.5062 18.0315 15.9693 17.0311 15.4877C16.5309 15.2468 16.1418 14.8207 15.9751 14.302C15.8084 13.7648 15.8269 13.209 16.0677 12.7273L14.8635 12.153L14.845 12.1345Z"
          fill="#FF9C99"
        />
        <path
          d="M7.26798 10.9675L7.32356 10.8378C7.95344 9.50396 9.56519 8.94818 10.8805 9.57806L15.3082 11.7085C16.6421 12.3384 17.1979 13.9502 16.568 15.2655L16.5124 15.3952C15.8825 16.7291 14.2708 17.2848 12.9554 16.6549L8.52774 14.5245C7.19387 13.8946 6.6381 12.2828 7.26798 10.9675Z"
          fill="#FFCBC2"
        />
        <path
          d="M8.02732 8.5402C8.02732 8.5402 6.57236 7.76858 5.94248 7.62037L6.40656 6.69235C6.99938 6.80351 7.99027 7.28044 8.52752 7.5398L16.012 11.3191C17.6978 12.1157 18.4203 14.1721 17.6052 15.8579C17.1976 16.7101 16.4936 17.3215 15.66 17.5994C14.8263 17.8772 13.9 17.8587 13.0478 17.4512L11.0841 16.5249C10.8618 16.3952 10.5654 16.5249 10.4913 16.7657C10.1022 17.8217 9.56497 18.8406 8.87951 19.7854C8.6572 20.0818 8.2311 20.1559 7.93469 19.9336C7.63827 19.6928 7.56417 19.2852 7.78648 18.9888C8.63867 17.8217 9.25003 16.6545 9.58349 15.3021C9.62054 15.0984 9.75023 14.9316 9.93548 14.8575C10.1393 14.7649 10.3245 14.7649 10.5098 14.8575L13.6221 16.2284C14.6596 16.7101 15.9008 16.284 16.401 15.2466C16.8827 14.2091 16.4566 12.9679 15.4191 12.4677L8.02732 8.5402Z"
          fill="#FF9C99"
        />
      </g>
    </svg>
  ),
  icon_Graphic_RotateCoin: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9635 29.1615C25.0262 29.1615 29.1302 25.0574 29.1302 19.9948C29.1302 14.9322 25.0262 10.8281 19.9635 10.8281C14.9009 10.8281 10.7969 14.9322 10.7969 19.9948C10.7969 25.0574 14.9009 29.1615 19.9635 29.1615Z"
        fill="#FFBB42"
      />
      <path
        d="M25.0423 19.0456H24.2951L24.8624 17.3672C24.9316 17.1701 24.9178 16.9595 24.8209 16.7692C24.7241 16.5789 24.565 16.443 24.3712 16.3751C24.1706 16.3003 23.9492 16.3139 23.7624 16.4023C23.5687 16.4974 23.4234 16.6605 23.3543 16.8575L22.0813 20.5134L20.753 16.8507C20.6423 16.5585 20.3448 16.3683 19.9989 16.3683C19.653 16.3683 19.3555 16.5585 19.2379 16.8575L17.9165 20.5406L16.5951 16.8507C16.526 16.6537 16.3738 16.4974 16.187 16.4023C15.9933 16.3071 15.7788 16.2935 15.5782 16.3683C15.1561 16.5178 14.9417 16.9595 15.087 17.374L15.675 19.0388H14.8933C14.4643 19.0388 14.0977 19.399 14.0977 19.8203C14.0977 20.2416 14.4643 20.6017 14.8933 20.6017H16.2423L17.1624 23.1907C17.2662 23.4829 17.5637 23.6732 17.9165 23.6732C18.2694 23.6732 18.5599 23.4829 18.6775 23.1839L19.992 19.4941L21.3341 23.1907C21.4379 23.4829 21.7354 23.6732 22.0813 23.6732C22.4272 23.6732 22.7316 23.4761 22.8423 23.1704L23.7278 20.6085H25.0354C25.4643 20.6085 25.831 20.2484 25.831 19.8271C25.831 19.4058 25.4643 19.0456 25.0354 19.0456H25.0423Z"
        fill="white"
      />
      <path
        d="M6.4804 19.8956C6.51374 20.6289 5.9304 21.2456 5.19707 21.2789C4.46373 21.3122 3.84707 20.7289 3.81373 19.9956C3.54707 13.3789 7.41374 6.99556 13.9304 4.39556C17.8971 2.81223 22.1137 2.91223 25.7804 4.36223L25.5471 3.76223C25.3137 3.16223 25.5971 2.4789 26.1971 2.24556C26.7971 2.01223 27.4804 2.29556 27.7137 2.89556L29.1471 6.4789C29.3804 7.0789 29.0971 7.76223 28.4971 7.99556L24.9137 9.4289C24.3137 9.66223 23.6304 9.3789 23.3971 8.7789C23.1637 8.1789 23.4471 7.49556 24.0471 7.26223L24.9637 6.89556C21.8637 5.6289 18.2804 5.5289 14.9304 6.86223C9.4804 9.04556 6.24707 14.3622 6.4804 19.8956ZM26.0471 35.4289C22.0137 37.0456 17.7304 36.8956 14.0137 35.3956L14.3304 36.2122C14.5637 36.8122 14.2804 37.4956 13.6804 37.7289C13.0804 37.9622 12.3971 37.6789 12.1637 37.0789L10.7304 33.4956C10.4971 32.8956 10.7804 32.2122 11.3804 31.9789L14.9637 30.5456C15.5637 30.3122 16.2471 30.5956 16.4804 31.1956C16.7137 31.7956 16.4304 32.4789 15.8304 32.7122L15.1471 32.9956C18.2304 34.2122 21.7471 34.2956 25.0637 32.9789C30.4971 30.8122 33.7304 25.4956 33.5137 19.9622C33.4804 19.2289 34.0637 18.6122 34.7971 18.5789C35.5304 18.5456 36.1471 19.1289 36.1804 19.8622C36.4471 26.4956 32.5804 32.8622 26.0637 35.4622L26.0471 35.4289Z"
        fill="#FF8442"
      />
    </svg>
  ),

  icon_Graphic_Write: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 4.5C4.125 3.67157 4.79657 3 5.625 3H25.125C25.9535 3 26.625 3.67157 26.625 4.5V31.5C26.625 32.3284 25.9535 33 25.125 33H5.625C4.79657 33 4.125 32.3284 4.125 31.5V4.5Z"
        fill="#D1E6FF"
      />
      <rect
        x="8.25"
        y="8.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <rect
        x="8.25"
        y="14.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <rect
        x="8.25"
        y="20.25"
        width="14.25"
        height="1.5"
        rx="0.75"
        fill="#A0C9FF"
      />
      <path
        d="M29.7751 13.9852C30.0301 13.7752 30.4519 13.765 30.6619 14.02L33.7874 17.6646C33.9974 17.9196 33.9319 18.325 33.6769 18.535L20.3119 29.755C20.1469 29.89 19.9485 29.9786 19.7385 29.9786C19.7385 29.9786 16.581 30.0044 16.206 30.0044C15.831 30.0044 15.472 29.5935 15.532 29.2185L16.0951 25.7301C16.1251 25.5201 16.2377 25.3316 16.4027 25.1966L29.7751 13.9852Z"
        fill="#76A1DE"
      />
    </svg>
  ),
  icon_Graphic_PriceList: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.33398"
        y="2.66699"
        width="21.3333"
        height="26.6667"
        rx="1.33333"
        fill="#D1E6FF"
      />
      <path
        d="M16.3339 14.2663C18.8007 14.2663 20.8005 12.2665 20.8005 9.79967C20.8005 7.3328 18.8007 5.33301 16.3339 5.33301C13.867 5.33301 11.8672 7.3328 11.8672 9.79967C11.8672 12.2665 13.867 14.2663 16.3339 14.2663Z"
        fill="#69A7FF"
      />
      <path
        d="M18.8076 9.33676H18.4436L18.72 8.5189C18.7537 8.42288 18.747 8.32023 18.6998 8.22752C18.6526 8.13481 18.575 8.06858 18.4806 8.03547C18.3829 7.99905 18.275 8.00567 18.184 8.04872C18.0896 8.09507 18.0188 8.17454 17.9851 8.27056L17.3648 10.052L16.7176 8.26725C16.6636 8.12487 16.5187 8.03216 16.3501 8.03216C16.1816 8.03216 16.0366 8.12487 15.9793 8.27056L15.3354 10.0652L14.6916 8.26725C14.6579 8.17123 14.5837 8.09507 14.4927 8.04872C14.3983 8.00236 14.2938 7.99574 14.196 8.03216C13.9904 8.10501 13.8859 8.32023 13.9567 8.52221L14.2432 9.33344H13.8623C13.6533 9.33344 13.4746 9.50894 13.4746 9.71423C13.4746 9.91952 13.6533 10.095 13.8623 10.095H14.5196L14.968 11.3566C15.0186 11.4989 15.1635 11.5917 15.3354 11.5917C15.5074 11.5917 15.6489 11.4989 15.7063 11.3532L16.3468 9.55529L17.0007 11.3566C17.0513 11.4989 17.1963 11.5917 17.3648 11.5917C17.5334 11.5917 17.6817 11.4956 17.7356 11.3466L18.1671 10.0983H18.8043C19.0133 10.0983 19.1919 9.92283 19.1919 9.71754C19.1919 9.51225 19.0133 9.33676 18.8043 9.33676H18.8076Z"
        fill="white"
      />
      <rect
        x="15.334"
        y="17.8662"
        width="7.66667"
        height="1.06667"
        rx="0.533333"
        fill="#A0C9FF"
      />
      <path
        d="M12.8105 16.3693C12.9837 16.2429 13.2179 16.2325 13.4023 16.3419L13.4902 16.4074L13.5634 16.4884C13.7108 16.6906 13.7002 16.9758 13.5253 17.1681L11.2822 19.6349C11.2078 19.7167 11.1109 19.7736 11.0048 19.798L10.8964 19.8107C10.7492 19.814 10.6075 19.757 10.5038 19.6535L9.15716 18.3068C8.94761 18.0966 8.94761 17.7572 9.15716 17.547L9.24212 17.4777C9.42123 17.3594 9.65478 17.3594 9.83392 17.4777L9.91888 17.547L10.8642 18.4923L12.7304 16.4425L12.8105 16.3693Z"
        fill="#A0C9FF"
      />
      <rect
        x="15.334"
        y="22.4775"
        width="7.66667"
        height="1.06667"
        rx="0.533333"
        fill="#A0C9FF"
      />
      <path
        d="M12.8105 20.9806C12.9837 20.8542 13.2179 20.8438 13.4023 20.9533L13.4902 21.0187L13.5634 21.0997C13.7108 21.3019 13.7002 21.5871 13.5253 21.7794L11.2822 24.2462C11.2078 24.328 11.1109 24.3849 11.0048 24.4093L10.8964 24.422C10.7492 24.4253 10.6075 24.3683 10.5038 24.2648L9.15716 22.9181C8.94761 22.708 8.94761 22.3685 9.15716 22.1583L9.24212 22.089C9.42123 21.9707 9.65478 21.9708 9.83392 22.089L9.91888 22.1583L10.8642 23.1036L12.7304 21.0538L12.8105 20.9806Z"
        fill="#A0C9FF"
      />
    </svg>
  ),
  icon_Graphic_Building: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 5.85714C12.75 4.27919 14.0292 3 15.6071 3H26.0921C27.8362 3 29.25 4.41384 29.25 6.15789V33H12.75V5.85714Z"
        fill="#99A8B0"
      />
      <path
        d="M6.75 11.8571C6.75 10.2792 8.02919 9 9.60714 9H20.0921C21.8362 9 23.25 10.4138 23.25 12.1579V33H6.75V11.8571Z"
        fill="#C7D0D6"
      />
      <rect x="11.5508" y="12.8984" width="2.4" height="2.4" fill="#718189" />
      <rect x="16.0527" y="12.8984" width="2.4" height="2.4" fill="#718189" />
      <rect x="11.5508" y="17.4062" width="2.4" height="2.4" fill="#718189" />
      <rect x="16.0527" y="17.4062" width="2.4" height="2.4" fill="#718189" />
      <rect x="11.5508" y="21.9062" width="2.4" height="2.4" fill="#718189" />
      <rect x="16.0527" y="21.9062" width="2.4" height="2.4" fill="#718189" />
      <path
        d="M12.9004 29.3969C12.9004 28.2371 13.8406 27.2969 15.0004 27.2969C16.1602 27.2969 17.1004 28.2371 17.1004 29.3969V32.9969H12.9004V29.3969Z"
        fill="#718189"
      />
    </svg>
  ),
  black_ribbon_24: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.40234C9.23858 2.40234 7 4.64092 7 7.40234V9.80234C7 12.2916 8.85665 14.3434 11.25 14.6553V21.4023C11.25 21.8166 11.5858 22.1523 12 22.1523C12.4142 22.1523 12.75 21.8166 12.75 21.4023V14.6553C15.1434 14.3434 17 12.2916 17 9.80234V7.40234C17 4.64092 14.7614 2.40234 12 2.40234Z"
        fill="#3D3D3D"
      />
    </svg>
  ),
  icon_Graphic_Bankbook: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="4.5" width="20" height="15" rx="1" fill="#AFD0FF" />
      <rect x="2" y="4.5" width="20" height="13.5" rx="1" fill="#69A7FF" />
      <path
        d="M2 5.5C2 4.94772 2.44772 4.5 3 4.5H21C21.5523 4.5 22 4.94772 22 5.5V7.5H2V5.5Z"
        fill="#4E87D8"
      />
      <rect x="15" y="14" width="5" height="2" fill="#AFD0FF" />
    </svg>
  ),
  icon_Graphic_Card: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="19.35"
        y="1.5"
        width="21"
        height="14.7"
        rx="1.05"
        transform="rotate(90 19.35 1.5)"
        fill="#FF9860"
      />
      <rect
        x="13.25"
        y="4"
        width="3"
        height="2.5"
        rx="0.2"
        transform="rotate(90 13.25 4)"
        fill="#FFE6B9"
      />
    </svg>
  ),
  icon_Graphic_ChangePayment: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="13.707"
        y="16.6719"
        width="28.5848"
        height="21.4386"
        rx="1.42924"
        fill="#AFD0FF"
      />
      <rect
        x="13.707"
        y="16.6719"
        width="28.5848"
        height="19.2947"
        rx="1.42924"
        fill="#69A7FF"
      />
      <path
        d="M13.707 18.1011C13.707 17.3118 14.3469 16.6719 15.1363 16.6719H40.8626C41.6519 16.6719 42.2918 17.3118 42.2918 18.1011V20.9596H13.707V18.1011Z"
        fill="#4E87D8"
      />
      <rect
        x="32.2852"
        y="30.25"
        width="7.1462"
        height="2.85848"
        fill="#AFD0FF"
      />
      <path
        d="M7.01569 27.8597C7.06705 28.9938 6.16821 29.9475 5.03823 29.999C3.90825 30.0506 2.95804 29.1484 2.90668 28.0143C2.49578 17.7815 8.45384 7.90952 18.4952 3.88856C24.6074 1.43991 31.1048 1.59456 36.7547 3.83701L36.3951 2.9091C36.0356 1.98119 36.4722 0.924398 37.3967 0.563543C38.3212 0.202687 39.3742 0.640869 39.7337 1.56878L41.9423 7.11049C42.3018 8.0384 41.8652 9.09519 40.9407 9.45604L35.4192 11.6727C34.4947 12.0336 33.4418 11.5954 33.0822 10.6675C32.7227 9.73957 33.1593 8.68278 34.0838 8.32193L35.4963 7.75487C30.7195 5.79594 25.1981 5.64129 20.0361 7.70332C11.6383 11.0799 6.65615 19.3022 7.01569 27.8597ZM37.1656 51.8823C30.9507 54.3825 24.3506 54.1505 18.6236 51.8307L19.1116 53.0937C19.4711 54.0216 19.0345 55.0784 18.11 55.4393C17.1855 55.8001 16.1326 55.362 15.773 54.4341L13.5644 48.8923C13.2049 47.9644 13.6415 46.9076 14.566 46.5468L20.0875 44.3301C21.012 43.9693 22.0649 44.4074 22.4245 45.3354C22.784 46.2633 22.3474 47.3201 21.4229 47.6809L20.37 48.1191C25.121 50.0007 30.5398 50.1296 35.6504 48.0933C44.0225 44.7425 49.0046 36.5202 48.6708 27.9628C48.6194 26.8286 49.5183 25.875 50.6483 25.8234C51.7782 25.7719 52.7284 26.674 52.7798 27.8081C53.1907 38.0667 47.2326 47.9129 37.1912 51.9338L37.1656 51.8823Z"
        fill="#8CBCFF"
      />
    </svg>
  ),
  icon_Graphic_StopAutoPay: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.72656"
        y="13.1641"
        width="41.1569"
        height="30.8677"
        rx="2.05784"
        fill="#AFD0FF"
      />
      <rect
        x="9.72656"
        y="13.1641"
        width="41.1569"
        height="27.7809"
        rx="2.05784"
        fill="#69A7FF"
      />
      <path
        d="M9.72656 15.2219C9.72656 14.0854 10.6479 13.1641 11.7844 13.1641H48.8256C49.9621 13.1641 50.8834 14.0854 50.8834 15.2219V19.3376H9.72656V15.2219Z"
        fill="#4E87D8"
      />
      <rect
        x="36.4766"
        y="32.7109"
        width="10.2892"
        height="4.11569"
        fill="#AFD0FF"
      />
      <path
        d="M13.0158 5.5C18.2723 5.5 22.5276 9.75531 22.5276 15.0119C22.5276 20.2684 18.2723 24.5237 13.0158 24.5237C7.75921 24.5237 3.50391 20.2684 3.50391 15.0119C3.50391 9.75531 7.75921 5.5 13.0158 5.5Z"
        fill="#FF4242"
      />
      <path
        d="M9.53043 11.4203C9.84082 11.1099 10.3515 11.1099 10.6618 11.4203L13.0148 13.7732L15.3677 11.4203C15.6781 11.1099 16.1887 11.1099 16.4991 11.4203C16.8095 11.7307 16.8095 12.2413 16.4991 12.5517L14.1462 14.9046L16.6093 17.3677C16.9196 17.6781 16.9196 18.1887 16.6093 18.4991C16.2989 18.8095 15.7882 18.8095 15.4778 18.4991L13.0148 16.036L10.5517 18.4991C10.2413 18.8095 9.73068 18.8095 9.42029 18.4991C9.1099 18.1887 9.1099 17.6781 9.42029 17.3677L11.8834 14.9046L9.53043 12.5517C9.22004 12.2413 9.22004 11.7307 9.53043 11.4203Z"
        fill="white"
      />
    </svg>
  ),
  icon_Graphic_CS: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3521 14.0409H10.3065V17.1752H13.3521V14.0409Z"
        fill="#FFCBC2"
      />
      <path
        d="M21.1017 21.7665C20.7654 18.5434 18.1916 16.5535 15.0853 15.7734V15.764C14.5761 15.6239 14.0716 15.4884 13.3523 15.395L12.1705 16.7543C11.9883 16.9645 11.6613 16.9692 11.4745 16.7637L10.3067 15.4838C9.58735 15.5772 9.0922 15.7127 8.57838 15.8575V15.8668C5.62621 16.6983 3.22991 18.6602 2.89359 21.7618C2.85155 22.1588 3.17386 22.4998 3.57091 22.4998H20.4291C20.8261 22.4998 21.1484 22.1635 21.1064 21.7665H21.1017Z"
        fill="#767A7F"
      />
      <path
        d="M17.1825 8.76437C17.1825 13.4618 15.1552 14.7981 11.764 14.7981C8.37274 14.7981 6.34546 11.972 6.34546 8.39859C6.34546 4.82516 8.37741 1.93372 11.7687 1.93372C15.1599 1.93372 17.1872 4.48704 17.1872 8.0558L17.1825 8.76437Z"
        fill="#FFCBC2"
      />
      <path
        d="M10.2272 10.3599C10.4702 10.3599 10.6711 10.1357 10.6711 9.86472C10.6711 9.59376 10.4702 9.36951 10.2272 9.36951C9.9843 9.36951 9.78809 9.58908 9.78809 9.86472C9.78809 10.1404 9.98898 10.3599 10.2272 10.3599Z"
        fill="#36383A"
      />
      <path
        d="M13.4317 10.3599C13.6746 10.3599 13.8755 10.1357 13.8755 9.86472C13.8755 9.59376 13.6793 9.36951 13.4317 9.36951C13.1841 9.36951 12.9926 9.58908 12.9926 9.86472C12.9926 10.1404 13.1888 10.3599 13.4317 10.3599Z"
        fill="#36383A"
      />
      <path
        d="M12.4494 12.2027C12.5074 12.1239 12.6188 12.1067 12.6976 12.1647C12.776 12.2228 12.7922 12.3332 12.7345 12.4118C12.6602 12.5128 12.5338 12.6117 12.3848 12.6846C12.2331 12.7587 12.045 12.8127 11.8393 12.8128C11.6322 12.8128 11.4422 12.7603 11.2887 12.6866C11.1386 12.6146 11.0087 12.5152 10.9349 12.4067C10.8801 12.3258 10.9013 12.2156 10.9821 12.1606C11.063 12.1058 11.1732 12.127 11.2282 12.2078C11.2559 12.2484 11.3273 12.3129 11.4415 12.3678C11.5524 12.421 11.6908 12.459 11.8393 12.459C11.9837 12.459 12.1194 12.4198 12.23 12.3657C12.3429 12.3104 12.418 12.2452 12.4494 12.2027Z"
        fill="#36383A"
      />
      <path
        d="M17.2433 8.90228C16.9537 10.0234 12.9926 5.51103 12.9926 5.51103C12.9926 5.51103 6.71457 9.73842 6.4343 8.90228C5.20112 5.22141 7.91973 1.85352 11.8388 1.85352C15.7579 1.85352 18.1402 5.44096 17.2433 8.90228Z"
        fill="#36383A"
      />
      <path
        d="M16.8182 7.54878C16.8182 4.515 14.646 2.67807 12 2.678C9.35389 2.67812 6.978 4.51507 6.978 7.54878V10.815H5.79968V7.54878C5.79968 3.96739 8.60496 1.4998 12 1.49968C15.395 1.49977 17.9519 3.96741 17.9519 7.54878L17.9165 10.815H16.7382L16.8182 7.54878Z"
        fill="#767A7F"
      />
      <path
        d="M16.7653 11.0955C16.7653 10.8104 17.1013 10.5792 17.3864 10.5791C17.6715 10.5791 17.9304 10.8104 17.9304 11.0955C17.9304 12.8933 16.3546 14.3708 14.6022 14.5445C14.3186 14.5726 14.0659 14.3657 14.0376 14.0821C14.0095 13.7985 14.2164 13.5457 14.5 13.5175C15.7295 13.3957 16.7653 12.3573 16.7653 11.0955Z"
        fill="#767A7F"
      />
      <rect
        x="12.2834"
        y="13.1577"
        width="2.5587"
        height="1.84227"
        rx="0.921133"
        fill="#69A7FF"
      />
      <path
        d="M7.04021 6.63879C5.63042 6.63879 4.48938 7.77984 4.48938 9.18962C4.48938 10.5994 5.63042 11.7405 7.04021 11.7405V6.6432V6.63879Z"
        fill="#69A7FF"
      />
      <path
        d="M16.7334 6.63879C18.1431 6.63879 19.2842 7.77984 19.2842 9.18962C19.2842 10.5994 18.1431 11.7405 16.7334 11.7405V6.6432V6.63879Z"
        fill="#69A7FF"
      />
    </svg>
  ),
  icon_Graphic_Scale: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.87451 13.0872H4.43542V15.2681H5.87451V13.0872Z"
        fill="#CBCDCF"
      />
      <path
        d="M4.47095 6.18676L1.98957 10.288C1.66385 10.8213 2.04879 11.5029 2.67654 11.5029H7.63931C8.26114 11.5029 8.64608 10.8213 8.32628 10.288L5.84489 6.18676C5.53102 5.67115 4.78483 5.67115 4.47688 6.18676H4.47095Z"
        fill="#69A7FF"
      />
      <path
        d="M2.09023 12.0559H8.21967C8.37957 12.0559 8.50986 12.1863 8.50986 12.3463C8.50986 12.8382 8.10715 13.2412 7.61561 13.2412H2.6943C2.20276 13.2412 1.80005 12.8382 1.80005 12.3463C1.80005 12.1863 1.93034 12.0559 2.09023 12.0559Z"
        fill="#989CA0"
      />
      <path
        d="M19.5747 9.86877H18.1356V11.9786H19.5747V9.86877Z"
        fill="#CBCDCF"
      />
      <path
        d="M18.8521 8.81659C20.4874 8.81659 21.8132 7.48988 21.8132 5.8533C21.8132 4.21672 20.4874 2.89001 18.8521 2.89001C17.2167 2.89001 15.891 4.21672 15.891 5.8533C15.891 7.48988 17.2167 8.81659 18.8521 8.81659Z"
        fill="#FF9860"
      />
      <path
        d="M15.7843 9.37085H21.9137C22.0736 9.37085 22.2039 9.50123 22.2039 9.66125C22.2039 10.1532 21.8012 10.5562 21.3096 10.5562H16.3942C15.9027 10.5562 15.5 10.1532 15.5 9.66125C15.5 9.50123 15.6303 9.37085 15.7902 9.37085H15.7843Z"
        fill="#989CA0"
      />
      <path
        d="M13.137 13.6263H11.6565V16.3184H13.137V13.6263Z"
        fill="#989CA0"
      />
      <path
        d="M15.7724 20.0846H9.0271L10.0102 16.2867C10.1286 15.7541 10.6083 15.3778 11.165 15.3778H13.6345C14.1912 15.3778 14.6709 15.7541 14.7894 16.2867L15.7724 20.0846Z"
        fill="#CBCDCF"
      />
      <path
        d="M15.8198 19.6603H8.97377C8.71212 19.6603 8.5 19.8676 8.5 20.1234V20.6445C8.5 20.9003 8.71212 21.1076 8.97377 21.1076H15.8198C16.0815 21.1076 16.2936 20.9003 16.2936 20.6445V20.1234C16.2936 19.8676 16.0815 19.6603 15.8198 19.6603Z"
        fill="#989CA0"
      />
      <path
        d="M20.0148 11.0561L3.69834 14.3604C3.29762 14.4415 3.03851 14.8324 3.1196 15.2334C3.20069 15.6344 3.59128 15.8937 3.99199 15.8126L20.3085 12.5083C20.7092 12.4272 20.9683 12.0363 20.8872 11.6353C20.8061 11.2342 20.4155 10.9749 20.0148 11.0561Z"
        fill="#CBCDCF"
      />
    </svg>
  ),
  icon_graphic_clap: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip_clap)">
        <path
          d="M29.0137 8.11103C27.4677 8.11103 26.2147 9.36403 26.2147 10.91L25.4727 15.316L22.2487 12.092L16.1787 6.02203C16.1787 6.02203 16.1777 6.02103 16.1767 6.02003C15.1047 4.94703 13.3847 4.92903 12.3357 5.97803C11.2867 7.02703 11.3057 8.74703 12.3777 9.81903L18.4497 15.891L18.4417 15.9L10.7017 8.16003C9.63069 7.08803 7.91169 7.07003 6.86369 8.11803C5.81569 9.16603 5.83469 10.884 6.90569 11.956L14.6457 19.696L14.6337 19.708L8.02469 13.099C6.96069 12.035 5.23669 12.033 4.17369 13.096C3.11169 14.158 3.11269 15.883 4.17669 16.947L6.19669 18.967C5.25369 18.352 3.99469 18.443 3.18669 19.251C2.25469 20.183 2.27369 21.713 3.22969 22.668L11.9497 31.388C16.4937 35.932 23.8617 35.932 28.4057 31.388C30.6777 29.116 31.8137 26.138 31.8137 23.16V10.91C31.8137 9.36403 30.5597 8.11103 29.0137 8.11103Z"
          fill="#F78700"
        />
        <path
          d="M32.8775 9.05646C31.4285 9.05646 30.2545 10.2315 30.2545 11.6805L29.5725 15.7285L25.9365 12.0925L19.8495 6.00546L19.8485 6.00346C18.9305 5.08646 17.4595 5.06946 16.5615 5.96746C15.6635 6.86546 15.6805 8.33646 16.5975 9.25446L22.6865 15.3435L22.0915 15.9375L14.3285 8.17446C13.4065 7.25246 11.9275 7.23646 11.0255 8.13846C10.1235 9.04046 10.1395 10.5195 11.0615 11.4415L18.8245 19.2045L18.2325 19.7965L11.5855 13.1495C10.6845 12.2485 9.22554 12.2475 8.32654 13.1465C7.42754 14.0455 7.42854 15.5045 8.32954 16.4055L14.9765 23.0525L14.3635 23.6665L10.3485 19.6515C9.43554 18.7375 7.97354 18.7195 7.08354 19.6095C6.19354 20.4995 6.21154 21.9615 7.12454 22.8745L11.1405 26.8905L12.6535 28.4035L15.4555 31.2055L15.6385 31.3885C20.1825 35.9325 27.5505 35.9325 32.0945 31.3885C34.3665 29.1165 35.5025 26.1385 35.5025 23.1605V11.6805C35.5025 10.2315 34.3275 9.05646 32.8795 9.05646H32.8775Z"
          fill="#FFC84D"
        />
        <path
          d="M25.877 5.95917C26.7077 5.95917 27.381 5.28581 27.381 4.45517C27.381 3.62454 26.7077 2.95117 25.877 2.95117C25.0464 2.95117 24.373 3.62454 24.373 4.45517C24.373 5.28581 25.0464 5.95917 25.877 5.95917Z"
          fill="#EDCCF8"
        />
        <path
          d="M10.7852 36.2619C11.6159 36.2619 12.2892 35.5885 12.2892 34.7579C12.2892 33.9273 11.6159 33.2539 10.7852 33.2539C9.95461 33.2539 9.28125 33.9273 9.28125 34.7579C9.28125 35.5885 9.95461 36.2619 10.7852 36.2619Z"
          fill="#F66570"
        />
        <path
          d="M33.6187 1.55569L31.4893 2.62977C31.0465 2.85312 30.8686 3.39315 31.0919 3.83596L32.166 5.96542C32.3893 6.40823 32.9294 6.58614 33.3722 6.36279L35.5016 5.28871C35.9445 5.06536 36.1224 4.52532 35.899 4.08251L34.8249 1.95306C34.6016 1.51025 34.0615 1.33234 33.6187 1.55569Z"
          fill="#B44BD7"
        />
        <path
          d="M6.57028 32.1093L5.96744 30.2128C5.84196 29.8181 5.42023 29.5998 5.02548 29.7252L3.12899 30.3281C2.73424 30.4536 2.51595 30.8753 2.64143 31.27L3.24427 33.1665C3.36975 33.5613 3.79148 33.7796 4.18623 33.6541L6.08272 33.0513C6.47747 32.9258 6.69576 32.504 6.57028 32.1093Z"
          fill="#6376FF"
        />
        <path
          d="M37.586 9.97675C38.4167 9.97675 39.09 9.30339 39.09 8.47275C39.09 7.64211 38.4167 6.96875 37.586 6.96875C36.7554 6.96875 36.082 7.64211 36.082 8.47275C36.082 9.30339 36.7554 9.97675 37.586 9.97675Z"
          fill="#7896FF"
        />
      </g>
      <defs>
        <clipPath id="clip_clap">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  icon_normal_O: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20.0007"
        cy="19.9997"
        r="12.9167"
        stroke="#237EFF"
        strokeWidth="2.5"
      />
    </svg>
  ),
  icon_quiz_correct: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_20098_10689)">
        <path
          d="M29.0137 8.11103C27.4677 8.11103 26.2147 9.36403 26.2147 10.91L25.4727 15.316L22.2487 12.092L16.1787 6.02203C16.1787 6.02203 16.1777 6.02103 16.1767 6.02003C15.1047 4.94703 13.3847 4.92903 12.3357 5.97803C11.2867 7.02703 11.3057 8.74703 12.3777 9.81903L18.4497 15.891L18.4417 15.9L10.7017 8.16003C9.63069 7.08803 7.91169 7.07003 6.86369 8.11803C5.81569 9.16603 5.83469 10.884 6.90569 11.956L14.6457 19.696L14.6337 19.708L8.02469 13.099C6.96069 12.035 5.23669 12.033 4.17369 13.096C3.11169 14.158 3.11269 15.883 4.17669 16.947L6.19669 18.967C5.25369 18.352 3.99469 18.443 3.18669 19.251C2.25469 20.183 2.27369 21.713 3.22969 22.668L11.9497 31.388C16.4937 35.932 23.8617 35.932 28.4057 31.388C30.6777 29.116 31.8137 26.138 31.8137 23.16V10.91C31.8137 9.36403 30.5597 8.11103 29.0137 8.11103Z"
          fill="#F78700"
        />
        <path
          d="M32.8775 9.05646C31.4285 9.05646 30.2545 10.2315 30.2545 11.6805L29.5725 15.7285L25.9365 12.0925L19.8495 6.00546L19.8485 6.00346C18.9305 5.08646 17.4595 5.06946 16.5615 5.96746C15.6635 6.86546 15.6805 8.33646 16.5975 9.25446L22.6865 15.3435L22.0915 15.9375L14.3285 8.17446C13.4065 7.25246 11.9275 7.23646 11.0255 8.13846C10.1235 9.04046 10.1395 10.5195 11.0615 11.4415L18.8245 19.2045L18.2325 19.7965L11.5855 13.1495C10.6845 12.2485 9.22554 12.2475 8.32654 13.1465C7.42754 14.0455 7.42854 15.5045 8.32954 16.4055L14.9765 23.0525L14.3635 23.6665L10.3485 19.6515C9.43554 18.7375 7.97354 18.7195 7.08354 19.6095C6.19354 20.4995 6.21154 21.9615 7.12454 22.8745L11.1405 26.8905L12.6535 28.4035L15.4555 31.2055L15.6385 31.3885C20.1825 35.9325 27.5505 35.9325 32.0945 31.3885C34.3665 29.1165 35.5025 26.1385 35.5025 23.1605V11.6805C35.5025 10.2315 34.3275 9.05646 32.8795 9.05646H32.8775Z"
          fill="#FFC84D"
        />
        <path
          d="M25.877 5.96113C26.7077 5.96113 27.381 5.28776 27.381 4.45712C27.381 3.62649 26.7077 2.95312 25.877 2.95312C25.0464 2.95312 24.373 3.62649 24.373 4.45712C24.373 5.28776 25.0464 5.96113 25.877 5.96113Z"
          fill="#EDCCF8"
        />
        <path
          d="M10.7852 36.2619C11.6159 36.2619 12.2892 35.5885 12.2892 34.7579C12.2892 33.9273 11.6159 33.2539 10.7852 33.2539C9.95461 33.2539 9.28125 33.9273 9.28125 34.7579C9.28125 35.5885 9.95461 36.2619 10.7852 36.2619Z"
          fill="#F66570"
        />
        <path
          d="M33.6187 1.55666L31.4893 2.63074C31.0465 2.8541 30.8686 3.39413 31.0919 3.83694L32.166 5.96639C32.3893 6.40921 32.9294 6.58711 33.3722 6.36376L35.5016 5.28968C35.9445 5.06633 36.1224 4.5263 35.899 4.08349L34.8249 1.95403C34.6016 1.51122 34.0615 1.33331 33.6187 1.55666Z"
          fill="#B44BD7"
        />
        <path
          d="M6.57028 32.1113L5.96744 30.2148C5.84196 29.82 5.42023 29.6017 5.02548 29.7272L3.12899 30.33C2.73424 30.4555 2.51595 30.8773 2.64143 31.272L3.24427 33.1685C3.36975 33.5632 3.79148 33.7815 4.18623 33.6561L6.08272 33.0532C6.47747 32.9277 6.69576 32.506 6.57028 32.1113Z"
          fill="#6376FF"
        />
        <path
          d="M37.586 9.97675C38.4167 9.97675 39.09 9.30339 39.09 8.47275C39.09 7.64211 38.4167 6.96875 37.586 6.96875C36.7554 6.96875 36.082 7.64211 36.082 8.47275C36.082 9.30339 36.7554 9.97675 37.586 9.97675Z"
          fill="#7896FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_20098_10689">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  icon_quiz_wrong: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_20105_11315)">
        <path
          d="M28.5 3.5H11.5C7.08172 3.5 3.5 7.08172 3.5 11.5V28.5C3.5 32.9183 7.08172 36.5 11.5 36.5H28.5C32.9183 36.5 36.5 32.9183 36.5 28.5V11.5C36.5 7.08172 32.9183 3.5 28.5 3.5Z"
          fill="#EF4452"
        />
        <path
          d="M26.4997 28.4998C25.9877 28.4998 25.4767 28.3048 25.0857 27.9137L12.0857 14.9137C11.3047 14.1327 11.3047 12.8668 12.0857 12.0857C12.8668 11.3047 14.1327 11.3047 14.9137 12.0857L27.9137 25.0857C28.6947 25.8667 28.6947 27.1327 27.9137 27.9137C27.5227 28.3048 27.0117 28.4998 26.4997 28.4998Z"
          fill="white"
        />
        <path
          d="M13.4997 28.4998C12.9877 28.4998 12.4768 28.3048 12.0857 27.9137C11.3047 27.1327 11.3047 25.8667 12.0857 25.0857L25.0857 12.0857C25.8667 11.3047 27.1327 11.3047 27.9137 12.0857C28.6947 12.8668 28.6947 14.1327 27.9137 14.9137L14.9137 27.9137C14.5227 28.3048 14.0117 28.4998 13.4997 28.4998Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20105_11315">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  icon_Graphic_MarketingMail: (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67969 21.26L32.1102 8.98828L56.5408 21.26C57.2722 21.6257 57.7508 22.5023 57.7508 23.4702V41.3401H6.46973V23.4702C6.46973 22.5023 6.94834 21.6257 7.67969 21.26Z"
        fill="#96BDFB"
      />
      <path
        d="M13.8851 7.99902H50.34C50.9316 7.99902 51.4155 8.48301 51.4155 9.07455V49.4928H12.8096V9.07455C12.8096 8.48301 13.2936 7.99902 13.8851 7.99902Z"
        fill="#D9E0EC"
      />
      <path
        d="M55.8041 55.999H8.41643C7.3409 55.999 6.46973 55.101 6.46973 53.9932V30.2725L32.1748 49.2555L57.7508 30.2725V53.9932C57.7508 55.101 56.8796 55.999 55.8041 55.999Z"
        fill="#B4D1FF"
      />
      <path
        d="M33.4822 16.84H32.111V18.2113H34.8535V12.7261H27.9971V14.0974H33.4822V16.84Z"
        fill="#666F75"
      />
      <path
        d="M33.4809 19.5825C32.9324 19.5825 32.4054 19.7385 31.9536 20.0342C31.5019 20.3408 31.1524 20.771 30.9426 21.2711C30.7437 21.7766 30.6791 22.3251 30.7975 22.8521C30.905 23.3899 31.1578 23.8739 31.5449 24.2557C31.9268 24.6482 32.4107 24.9117 32.9485 25.0139C33.4755 25.1215 34.0348 25.0677 34.5295 24.858C35.035 24.6482 35.4599 24.2987 35.7664 23.847C36.0621 23.3953 36.2289 22.8682 36.2289 22.3251C36.2289 21.5991 35.9331 20.9 35.4168 20.3838C34.9113 19.8675 34.2015 19.5825 33.4863 19.5825H33.4809ZM33.4809 23.8362C33.1744 23.8362 32.8893 23.7394 32.6366 23.5727C32.3946 23.4168 32.1956 23.1694 32.0881 22.8951C31.9698 22.6209 31.9429 22.3144 31.9913 22.0293C32.0558 21.7336 32.201 21.4701 32.4054 21.2603C32.6151 21.0506 32.8893 20.9 33.1851 20.8463C33.4701 20.7817 33.7767 20.814 34.0509 20.9323C34.3252 21.0399 34.5672 21.2388 34.7285 21.4808C34.8952 21.7336 34.9812 22.0186 34.9812 22.3251C34.9812 22.7284 34.8253 23.1049 34.551 23.3899C34.266 23.6641 33.8735 23.8308 33.4863 23.8308L33.4809 23.8362Z"
        fill="#666F75"
      />
      <path
        d="M37.5304 16.8403H36.2236V18.2762H37.3099C37.3637 18.2762 37.4175 18.2977 37.4551 18.3407C37.4981 18.3837 37.5196 18.4375 37.5196 18.4859V26.4394H38.9662V18.26C38.9662 18.174 38.9447 18.1041 38.9124 18.0288C38.8802 17.9428 38.8372 17.8836 38.7726 17.8191L37.9714 17.0178C37.9068 16.9533 37.8423 16.9102 37.7724 16.878C37.6863 16.8457 37.6164 16.835 37.5304 16.835V16.8403Z"
        fill="#666F75"
      />
      <path
        d="M30.7386 18.2216V15.4683H29.3673V18.0119C29.3673 18.0657 29.3458 18.1194 29.3028 18.1517C29.2705 18.1947 29.2167 18.2162 29.163 18.2162H25.248V19.5875H29.3727C29.5286 19.5875 29.6792 19.523 29.7921 19.4101L30.5504 18.6518C30.6687 18.5335 30.7278 18.3883 30.7278 18.2324L30.7386 18.2216Z"
        fill="#666F75"
      />
      <path
        d="M43.4404 30.5537H20.7737C20.4381 30.5537 20.166 30.8258 20.166 31.1614C20.166 31.497 20.4381 31.7691 20.7737 31.7691H43.4404C43.776 31.7691 44.0481 31.497 44.0481 31.1614C44.0481 30.8258 43.776 30.5537 43.4404 30.5537Z"
        fill="#B5C0C6"
      />
      <path
        d="M43.4404 34.9575H20.7737C20.4381 34.9575 20.166 35.2296 20.166 35.5652C20.166 35.9008 20.4381 36.1729 20.7737 36.1729H43.4404C43.776 36.1729 44.0481 35.9008 44.0481 35.5652C44.0481 35.2296 43.776 34.9575 43.4404 34.9575Z"
        fill="#B5C0C6"
      />
    </svg>
  ),
  icon_normal_close: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.8996 8.2166C30.4165 7.69993 31.2667 7.69993 31.7836 8.2166C32.3004 8.73327 32.3004 9.58327 31.7836 10.0999L21.8969 19.9833L31.7836 29.8666C32.3004 30.3833 32.3004 31.2333 31.7836 31.7499C31.2667 32.2666 30.4165 32.2666 29.8996 31.7499L20.0129 21.8666L10.1262 31.7833C9.60933 32.2999 8.75904 32.2999 8.2422 31.7833C7.72535 31.2666 7.72535 30.4166 8.2422 29.8999L18.1289 20.0166L8.22552 10.1166C7.70868 9.58327 7.70868 8.74993 8.22552 8.2166C8.75904 7.69993 9.59266 7.69993 10.1262 8.2166L20.0129 18.0999L29.8996 8.2166Z"
        fill="#FF4242"
      />
    </svg>
  ),
  // 고이 디자인 시스템에 없어 같은 Graphic 결로 새로 그림(E5 비용 구성, 2026-11-04)
  icon_Graphic_RiceBowl: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.6 2.4L19.4 9.2"
        stroke="#8B8685"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M17.4 1.9L20.6 8.9"
        stroke="#8B8685"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M4.2 11.2C4.2 8.1 7.7 6.2 12 6.2C16.3 6.2 19.8 8.1 19.8 11.2Z"
        fill="#FFFFFF"
      />
      <path
        d="M4.2 11.2C4.2 8.1 7.7 6.2 12 6.2C16.3 6.2 19.8 8.1 19.8 11.2Z"
        fill="#E8E9EA"
        fillOpacity="0.55"
      />
      <path
        d="M6.4 9.4C7.4 8.2 9.5 7.5 12 7.5C14.5 7.5 16.6 8.2 17.6 9.4"
        stroke="#FFFFFF"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M2.6 11.4H21.4C21.4 16.7 17.2 20.2 12 20.2C6.8 20.2 2.6 16.7 2.6 11.4Z"
        fill="#FF7225"
      />
      <path
        d="M2.6 11.4H21.4C21.3 12.6 21.1 13.6 20.7 14.4H3.3C2.9 13.6 2.7 12.6 2.6 11.4Z"
        fill="#FF8442"
      />
      <path d="M8.6 20.2H15.4L14.8 21.8H9.2Z" fill="#E45E15" />
    </svg>
  ),
  icon_Graphic_Chrysanthemum: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 13.6V22"
        stroke="#81C39B"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M12 18.4C10.2 17 7.9 16.9 6.6 17.8C8 19.3 10.4 19.5 12 18.4Z"
        fill="#81C39B"
      />
      <path
        d="M12 16.6C13.6 15.3 15.8 15.2 17.1 16C15.8 17.5 13.5 17.7 12 16.6Z"
        fill="#C6E3CF"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(0 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(30 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(60 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(90 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(120 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(150 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(180 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(210 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(240 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(270 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(300 12 9.4)"
        fill="#FFFFFF"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <ellipse
        cx="12"
        cy="5.6"
        rx="1.5"
        ry="3.6"
        transform="rotate(330 12 9.4)"
        fill="#F4F5F6"
        stroke="#DDDEDF"
        strokeWidth="0.4"
      />
      <circle cx="12" cy="9.4" r="2.6" fill="#FFBB42" />
      <circle cx="12" cy="9.4" r="1.4" fill="#FFE281" />
    </svg>
  ),
  // 고이 디자인 시스템 Graphic 「Savings」(goi-agent design-system/assets/icons/graphic/savings.svg). PriceDrop 과 화살표가 같고 동전·주황 버전
  icon_Graphic_Savings: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <defs>
        <linearGradient
          id="paint0_linear_icon_Graphic_Savings"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientTransform="matrix(0 18.375 -19.8069 0 18.5659 -4.0833)"
        >
          <stop offset="0" stopColor="#FFEC9F" stopOpacity="1" />
          <stop offset="1" stopColor="#FF7225" stopOpacity="1" />
        </linearGradient>
        <clipPath id="clip0_icon_Graphic_Savings">
          <path d="M0 0H21V21.000259399414062H0Z" />
        </clipPath>
      </defs>
      <g>
        <g transform="matrix(1 0 0 1 1.5001 1.5)">
          <g clipPath="url(#clip0_icon_Graphic_Savings)">
            <g transform="matrix(1 0 0 1 0 0)">
              <path
                d="M 13.055 5.885 L 13.055 0.082 C 13.055 0.037 13.022 0 12.979 0 L 4.348 0 C 4.305 0 4.272 0.035 4.272 0.082 L 4.272 5.887 C 4.272 5.932 4.238 5.969 4.196 5.969 L 0.076 5.969 C 0.009 5.969 -0.024 6.052 0.02 6.104 L 8.607 16.046 C 8.637 16.081 8.688 16.081 8.718 16.046 L 17.305 6.104 C 17.349 6.052 17.316 5.969 17.249 5.969 L 13.129 5.969 C 13.086 5.969 13.053 5.933 13.053 5.887 L 13.055 5.885 Z"
                fill="url(#paint0_linear_icon_Graphic_Savings)"
              />
            </g>
            <g transform="matrix(1 0 0 1 10.9486 8.9436)">
              <path
                d="M 10.051 0 L 0 0 L 0 12.057 L 10.051 12.057 L 10.051 0 Z"
                fill="#FFE281"
              />
            </g>
            <g transform="matrix(1 0 0 1 10.9486 11.5812)">
              <path
                d="M 10.051 0 L 0 0 L 0 0.5 L 10.051 0.5 L 10.051 0 Z"
                fill="#FFBB42"
              />
            </g>
            <g transform="matrix(1 0 0 1 10.9486 14.7212)">
              <path
                d="M 10.051 0 L 0 0 L 0 0.5 L 10.051 0.5 L 10.051 0 Z"
                fill="#FFBB42"
              />
            </g>
            <g transform="matrix(1 0 0 1 10.9486 17.86)">
              <path
                d="M 10.051 0 L 0 0 L 0 0.5 L 10.051 0.5 L 10.051 0 Z"
                fill="#FFBB42"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  icon_Graphic_PriceDrop: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.4642 26.7457V7.16599C30.4642 7.07578 30.3958 7 30.3095 7H12.8131C12.7267 7 12.6583 7.07217 12.6583 7.16599V26.7493C12.6583 26.8395 12.59 26.9153 12.5036 26.9153H4.15313C4.01636 26.9153 3.95157 27.0849 4.04155 27.1895L21.4515 47.3975C21.5127 47.4697 21.6171 47.4697 21.6783 47.3975L39.0882 27.1895C39.1782 27.0849 39.1098 26.9153 38.9766 26.9153H30.6226C30.5362 26.9153 30.4678 26.8431 30.4678 26.7493H30.4714L30.4642 26.7457Z"
        fill="url(#paint0_linear_icon_Graphic_PriceDrop)"
      />
      <path
        d="M75.4216 32.2634H25.2188V72.9999H75.4216V32.2634Z"
        fill="#81C39B"
      />
      <path
        d="M75.4216 32.2634H25.2188V58.3772H75.4216V32.2634Z"
        fill="#C6E3CF"
      />
      <path
        d="M75.4216 67.7764H25.2188V68.8202H75.4216V67.7764Z"
        fill="#579A70"
      />
      <path
        d="M75.4216 62.5527H25.2188V63.5965H75.4216V62.5527Z"
        fill="#579A70"
      />
      <path
        d="M72.2814 34.773V55.872H28.3589V34.773H72.2814ZM75.4216 32.2634H25.2188V58.3772H75.4216V32.2634Z"
        fill="#58A573"
      />
      <path
        d="M25.2188 50.0222V58.3774H33.5852C33.5852 53.7622 29.8401 50.0222 25.2188 50.0222Z"
        fill="#58A573"
      />
      <path
        d="M75.4172 50.0222C70.7959 50.0222 67.0508 53.7622 67.0508 58.3774H75.4172V50.0222Z"
        fill="#58A573"
      />
      <path
        d="M67.0508 32.2634C67.0508 36.8786 70.7959 40.6186 75.4172 40.6186V32.2634H67.0508Z"
        fill="#58A573"
      />
      <path
        d="M25.2188 40.6186C29.8401 40.6186 33.5852 36.8785 33.5852 32.2634H25.2188V40.6186Z"
        fill="#58A573"
      />
      <path
        d="M50.3229 54.1975C55.2333 54.1975 59.2141 50.222 59.2141 45.3182C59.2141 40.4143 55.2333 36.4388 50.3229 36.4388C45.4125 36.4388 41.4316 40.4143 41.4316 45.3182C41.4316 50.222 45.4125 54.1975 50.3229 54.1975Z"
        fill="#81C39B"
      />
      <path d="M54.507 32.2634H46.1406V73H54.507V32.2634Z" fill="#579A70" />
      <defs>
        <linearGradient
          id="paint0_linear_icon_Graphic_PriceDrop"
          x1="21.5631"
          y1="8.87375"
          x2="21.5631"
          y2="43.8286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4E7FF" stopOpacity="0" />
          <stop offset="0.125" stopColor="#94D8FC" stopOpacity="0.394231" />
          <stop offset="1" stopColor="#62C0F7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  icon_gift_fomo: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1582 31.5261H56.8419V58.8941C56.8419 60.0568 55.8994 60.9993 54.7367 60.9993H25.2634C24.1007 60.9993 23.1582 60.0568 23.1582 58.8941V31.5261Z"
        fill="#FFD07E"
      />
      <rect
        x="23.1582"
        y="31.5261"
        width="33.6837"
        height="7.36831"
        fill="#FFBB42"
      />
      <rect
        x="20"
        y="25.2103"
        width="39.9994"
        height="10.5262"
        rx="1.05262"
        fill="#FFD07E"
      />
      <rect
        x="36.8418"
        y="25.2103"
        width="6.3157"
        height="35.7889"
        fill="#FF8442"
      />
      <path
        d="M42.1052 25.2103H31.0527V21.1606C31.0527 20.3694 31.8929 19.861 32.5938 20.2282L42.1052 25.2103Z"
        fill="#FF8442"
      />
      <path
        d="M37.8948 25.2103H48.9473V21.1606C48.9473 20.3694 48.1071 19.861 47.4062 20.2282L37.8948 25.2103Z"
        fill="#FF8442"
      />
      <path
        d="M15.8443 49.6801C13.8885 50.503 10.2298 51.9461 5.98581 49.1284C4.56006 48.1813 4.20968 46.3436 4.95355 45.4466C3.70927 45.0018 2.33922 44.0037 2.33922 42.7079C2.33922 41.9942 2.60694 41.3389 3.05524 40.8185C1.846 40.358 1.50188e-09 39.8893 0 36.9182C0 36.9182 0 33.9471 2.98836 33.9471C8.35614 33.9471 18.0166 34.5796 18.9258 45.26C19.1236 47.5839 17.9301 48.8026 15.8443 49.6801Z"
        fill="#BDE4FA"
      />
      <path
        d="M3.76716 40.4228C4.90711 39.8637 6.29032 39.8808 7.49872 40.2603C8.70515 40.6393 9.8255 41.4072 10.4015 42.4557C10.5329 42.6955 10.4438 42.9957 10.203 43.127C9.96161 43.258 9.65782 43.1697 9.52598 42.9297C9.10573 42.1653 8.2334 41.5312 7.1991 41.2062C6.16647 40.8817 5.05893 40.8926 4.20686 41.3106C3.96029 41.4313 3.66121 41.3313 3.53953 41.0863C3.41781 40.841 3.52049 40.5438 3.76716 40.4228Z"
        fill="#97CEEE"
      />
      <path
        d="M7.34262 44.9537C7.84244 44.9943 8.39413 45.1357 8.73757 45.4198C8.94895 45.5948 8.97779 45.908 8.80177 46.1181C8.62595 46.3275 8.31259 46.3559 8.10138 46.182C7.99281 46.0921 7.68708 45.9748 7.2609 45.9402C6.95242 45.9152 6.65175 45.9394 6.41264 46.0059L6.10136 46.122C5.87715 46.1807 5.634 46.0756 5.52742 45.8609C5.40647 45.6158 5.50871 45.3202 5.75505 45.1993C6.23063 44.966 6.82835 44.9119 7.34262 44.9537Z"
        fill="#97CEEE"
      />
      <path
        d="M64.1557 49.6801C66.1115 50.503 69.7702 51.9461 74.0142 49.1284C75.4399 48.1813 75.7903 46.3436 75.0464 45.4466C76.2907 45.0018 77.6608 44.0037 77.6608 42.7079C77.6608 41.9942 77.3931 41.3389 76.9448 40.8185C78.154 40.358 80 39.8893 80 36.9182C80 36.9182 80 33.9471 77.0116 33.9471C71.6439 33.9471 61.9834 34.5796 61.0742 45.26C60.8764 47.5839 62.0699 48.8026 64.1557 49.6801Z"
        fill="#BDE4FA"
      />
      <path
        d="M76.2328 40.4228C75.0929 39.8637 73.7097 39.8808 72.5013 40.2603C71.2949 40.6393 70.1745 41.4072 69.5985 42.4557C69.4671 42.6955 69.5562 42.9957 69.797 43.127C70.0384 43.258 70.3422 43.1697 70.474 42.9297C70.8943 42.1653 71.7666 41.5312 72.8009 41.2062C73.8335 40.8817 74.9411 40.8926 75.7931 41.3106C76.0397 41.4313 76.3388 41.3313 76.4605 41.0863C76.5822 40.841 76.4795 40.5438 76.2328 40.4228Z"
        fill="#97CEEE"
      />
      <path
        d="M72.6574 44.9537C72.1576 44.9943 71.6059 45.1357 71.2624 45.4198C71.0511 45.5948 71.0222 45.908 71.1982 46.1181C71.3741 46.3275 71.6874 46.3559 71.8986 46.182C72.0072 46.0921 72.3129 45.9748 72.7391 45.9402C73.0476 45.9152 73.3483 45.9394 73.5874 46.0059L73.8986 46.122C74.1229 46.1807 74.366 46.0756 74.4726 45.8609C74.5935 45.6158 74.4913 45.3202 74.2449 45.1993C73.7694 44.966 73.1716 44.9119 72.6574 44.9537Z"
        fill="#97CEEE"
      />
    </svg>
  ),
  // E5 조문객 질문용 여성 상주(흰 리본 핀 + 완장). 디자인 시스템 Graphic 「Suit」 를 바탕으로 그린 자체 그래픽(디자인 시스템 원본 아님)
  icon_Graphic_MournerFemale: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <defs>
        <clipPath id="c35_MournerFemale">
          <path d="M0 0H13.53709888458252V12.8693208694458H0Z" />
        </clipPath>
        <clipPath id="c36_MournerFemale">
          <path d="M0 0H18.220205307006836V20.570068359375H0Z" />
        </clipPath>
      </defs>
      <path
        d="M6.4 8.6C6.1 4.6 8.6 1.9 12 1.9C15.4 1.9 17.9 4.6 17.6 8.6L18.2 15.1C16.9 15.9 15.6 15.8 14.9 15.3L9.1 15.3C8.4 15.8 7.1 15.9 5.8 15.1Z"
        fill="#36383A"
      />
      <g>
        <g transform="matrix(1 0 0 1 2.89 1.93)">
          <g clipPath="url(#c36_MournerFemale)">
            <g transform="matrix(1 0 0 1 0 13.4651)">
              <path
                d="M 12.34 0.405 C 15.446 1.185 17.876 3.148 18.212 6.371 L 18.217 6.371 C 18.259 6.768 17.936 7.105 17.539 7.105 L 0.681 7.105 C 0.284 7.105 -0.038 6.764 0.004 6.367 C 0.34 3.265 2.888 1.236 5.84 0.405 L 7.84 0.089 L 8.585 1.369 C 8.771 1.574 9.098 1.57 9.281 1.359 L 10.462 0 L 12.34 0.405 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 7.59 12.1111)">
              <path
                d="M 3.04 0 L 0 0 L 0 3.134 L 3.04 3.134 L 3.04 0 Z"
                fill="#FFCBC2"
              />
            </g>
            <g transform="matrix(1 0 0 1 5.9102 12.8701)">
              <path
                d="M 6.42 0.989 L 3.72 6.1 L 2.7 6.1 L 0 0.989 L 1.68 0 L 3.21 2.1 L 4.74 0 L 6.42 0.989 Z"
                fill="#FFFFFF"
              />
            </g>
            <g transform="matrix(1 0 0 1 2.34 0)">
              <g clipPath="url(#c35_MournerFemale)">
                <g transform="matrix(1 0 0 1 1.3487 0.0027)">
                  <path
                    d="M 10.835 6.467 C 10.835 10.039 8.807 12.867 5.418 12.867 C 2.028 12.867 0 10.039 0 6.467 C 0 2.895 2.028 0 5.418 0 C 8.807 0 10.835 2.895 10.835 6.467 Z"
                    fill="#FFCBC2"
                  />
                </g>
                <g transform="matrix(1 0 0 1 4.7881 7.4395)">
                  <path
                    d="M 0.439 0.99 C 0.682 0.99 0.883 0.766 0.883 0.495 C 0.883 0.224 0.682 0 0.439 0 C 0.196 0 0 0.22 0 0.495 C 0 0.771 0.201 0.99 0.439 0.99 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 7.9925 7.4395)">
                  <path
                    d="M 0.439 0.99 C 0.682 0.99 0.883 0.766 0.883 0.495 C 0.883 0.224 0.687 0 0.439 0 C 0.192 0 0 0.22 0 0.495 C 0 0.771 0.196 0.99 0.439 0.99 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 5.9044 10.2002)">
                  <path
                    d="M 1.545 0.073 C 1.603 -0.006 1.714 -0.023 1.793 0.035 C 1.872 0.093 1.888 0.203 1.83 0.282 C 1.756 0.383 1.629 0.482 1.48 0.554 C 1.329 0.629 1.141 0.683 0.935 0.683 C 0.728 0.683 0.538 0.63 0.384 0.557 C 0.234 0.485 0.104 0.385 0.03 0.277 C -0.024 0.196 -0.003 0.085 0.078 0.03 C 0.159 -0.024 0.269 -0.003 0.324 0.078 C 0.352 0.118 0.423 0.183 0.537 0.238 C 0.648 0.291 0.786 0.329 0.935 0.329 C 1.079 0.329 1.215 0.29 1.326 0.236 C 1.438 0.18 1.514 0.115 1.545 0.073 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 1.0651 0)">
                  <path
                    d="M 11.105 7.03 C 9.405 6.551 6.793 3.657 6.793 3.657 C 6.793 3.657 3.005 6.551 0.305 7.03 C -0.928 3.35 1.721 0 5.642 0 C 9.563 0 12.002 3.57 11.105 7.03 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(0.9988 0.0494 -0.0494 0.9988 0.1453 6.97)">
                  <path
                    d="M 2.634 2.62 C 3.142 2.115 3.037 1.191 2.397 0.554 C 1.757 -0.079 0.829 -0.187 0.321 0.321 C -0.186 0.825 -0.081 1.75 0.558 2.386 C 1.198 3.019 2.126 3.128 2.634 2.62 Z"
                    fill="#FFCBC2"
                  />
                </g>
                <g transform="matrix(-0.9988 0.0494 0.0494 0.9988 13.3918 6.97)">
                  <path
                    d="M 2.634 2.62 C 3.142 2.115 3.037 1.191 2.397 0.554 C 1.757 -0.079 0.829 -0.187 0.321 0.321 C -0.186 0.825 -0.081 1.75 0.558 2.386 C 1.198 3.019 2.126 3.128 2.634 2.62 Z"
                    fill="#FFCBC2"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g transform="translate(15.9 4.6) rotate(20)">
        <ellipse cx="-1.05" cy="0" rx="1.15" ry="0.75" fill="#FFFFFF" />
        <ellipse cx="1.05" cy="0" rx="1.15" ry="0.75" fill="#FFFFFF" />
        <circle cx="0" cy="0" r="0.5" fill="#E8E9EA" />
      </g>
      <g transform="rotate(-24 5.6 19.3)">
        <rect
          x="3.7"
          y="18.5"
          width="3.8"
          height="1.7"
          rx="0.3"
          fill="#171819"
        />
        <rect x="3.7" y="18.95" width="3.8" height="0.25" fill="#FFFFFF" />
        <rect x="3.7" y="19.5" width="3.8" height="0.25" fill="#FFFFFF" />
      </g>
    </svg>
  ),
  // E5 조문객 질문용 남성 상주(정장 + 완장). 디자인 시스템 Graphic 「Suit」 를 바탕으로 그린 자체 그래픽(디자인 시스템 원본 아님)
  icon_Graphic_MournerMale: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <defs>
        <clipPath id="c35_MournerMale">
          <path d="M0 0H13.53709888458252V12.8693208694458H0Z" />
        </clipPath>
        <clipPath id="c36_MournerMale">
          <path d="M0 0H18.220205307006836V20.570068359375H0Z" />
        </clipPath>
      </defs>
      <g>
        <g transform="matrix(1 0 0 1 2.89 1.93)">
          <g clipPath="url(#c36_MournerMale)">
            <g transform="matrix(1 0 0 1 0 13.4651)">
              <path
                d="M 12.34 0.405 C 15.446 1.185 17.876 3.148 18.212 6.371 L 18.217 6.371 C 18.259 6.768 17.936 7.105 17.539 7.105 L 0.681 7.105 C 0.284 7.105 -0.038 6.764 0.004 6.367 C 0.34 3.265 2.888 1.236 5.84 0.405 L 7.84 0.089 L 8.585 1.369 C 8.771 1.574 9.098 1.57 9.281 1.359 L 10.462 0 L 12.34 0.405 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 7.59 12.1111)">
              <path
                d="M 3.04 0 L 0 0 L 0 3.134 L 3.04 3.134 L 3.04 0 Z"
                fill="#FFCBC2"
              />
            </g>
            <g transform="matrix(1 0 0 1 5.9102 12.8701)">
              <path
                d="M 6.42 0.989 L 3.72 6.1 L 2.7 6.1 L 0 0.989 L 1.68 0 L 3.21 2.1 L 4.74 0 L 6.42 0.989 Z"
                fill="#FFFFFF"
              />
            </g>
            <g transform="matrix(1 0 0 1 8 15.5)">
              <path
                d="M 0.09 0.9 L 1.11 0 L 2.13 0.9 L 1.66 2.1 L 2.22 5.024 L 0 5.024 L 0.56 2.1 L 0.09 0.9 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 2.34 0)">
              <g clipPath="url(#c35_MournerMale)">
                <g transform="matrix(1 0 0 1 1.3487 0.0027)">
                  <path
                    d="M 10.835 6.467 C 10.835 10.039 8.807 12.867 5.418 12.867 C 2.028 12.867 0 10.039 0 6.467 C 0 2.895 2.028 0 5.418 0 C 8.807 0 10.835 2.895 10.835 6.467 Z"
                    fill="#FFCBC2"
                  />
                </g>
                <g transform="matrix(1 0 0 1 4.7881 7.4395)">
                  <path
                    d="M 0.439 0.99 C 0.682 0.99 0.883 0.766 0.883 0.495 C 0.883 0.224 0.682 0 0.439 0 C 0.196 0 0 0.22 0 0.495 C 0 0.771 0.201 0.99 0.439 0.99 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 7.9925 7.4395)">
                  <path
                    d="M 0.439 0.99 C 0.682 0.99 0.883 0.766 0.883 0.495 C 0.883 0.224 0.687 0 0.439 0 C 0.192 0 0 0.22 0 0.495 C 0 0.771 0.196 0.99 0.439 0.99 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 5.9044 10.2002)">
                  <path
                    d="M 1.545 0.073 C 1.603 -0.006 1.714 -0.023 1.793 0.035 C 1.872 0.093 1.888 0.203 1.83 0.282 C 1.756 0.383 1.629 0.482 1.48 0.554 C 1.329 0.629 1.141 0.683 0.935 0.683 C 0.728 0.683 0.538 0.63 0.384 0.557 C 0.234 0.485 0.104 0.385 0.03 0.277 C -0.024 0.196 -0.003 0.085 0.078 0.03 C 0.159 -0.024 0.269 -0.003 0.324 0.078 C 0.352 0.118 0.423 0.183 0.537 0.238 C 0.648 0.291 0.786 0.329 0.935 0.329 C 1.079 0.329 1.215 0.29 1.326 0.236 C 1.438 0.18 1.514 0.115 1.545 0.073 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(1 0 0 1 1.0651 0)">
                  <path
                    d="M 11.105 7.03 C 9.405 6.551 6.793 3.657 6.793 3.657 C 6.793 3.657 3.005 6.551 0.305 7.03 C -0.928 3.35 1.721 0 5.642 0 C 9.563 0 12.002 3.57 11.105 7.03 Z"
                    fill="#36383A"
                  />
                </g>
                <g transform="matrix(0.9988 0.0494 -0.0494 0.9988 0.1453 6.97)">
                  <path
                    d="M 2.634 2.62 C 3.142 2.115 3.037 1.191 2.397 0.554 C 1.757 -0.079 0.829 -0.187 0.321 0.321 C -0.186 0.825 -0.081 1.75 0.558 2.386 C 1.198 3.019 2.126 3.128 2.634 2.62 Z"
                    fill="#FFCBC2"
                  />
                </g>
                <g transform="matrix(-0.9988 0.0494 0.0494 0.9988 13.3918 6.97)">
                  <path
                    d="M 2.634 2.62 C 3.142 2.115 3.037 1.191 2.397 0.554 C 1.757 -0.079 0.829 -0.187 0.321 0.321 C -0.186 0.825 -0.081 1.75 0.558 2.386 C 1.198 3.019 2.126 3.128 2.634 2.62 Z"
                    fill="#FFCBC2"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g transform="rotate(-24 5.6 19.3)">
        <rect
          x="3.7"
          y="18.5"
          width="3.8"
          height="1.7"
          rx="0.3"
          fill="#171819"
        />
        <rect x="3.7" y="18.95" width="3.8" height="0.25" fill="#FFFFFF" />
        <rect x="3.7" y="19.5" width="3.8" height="0.25" fill="#FFFFFF" />
      </g>
    </svg>
  ),
  icon_Graphic_Suit: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M25.383 26.3312C30.5602 27.6314 34.6089 30.9035 35.1695 36.2753H35.1773C35.2473 36.9371 34.7101 37.4976 34.0484 37.4976H5.95143C5.28968 37.4976 4.7525 36.9293 4.82257 36.2675C5.3831 31.0981 9.6294 27.717 14.5497 26.3312L17.883 25.8042L19.1241 27.9373C19.4355 28.2799 19.9804 28.2721 20.2841 27.9218L22.2537 25.6562L25.383 26.3312Z"
        fill="#36383A"
      />
      <path
        d="M22.5335 23.3984H17.4668V28.6223H22.5335V23.3984Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.3662 26.3125L20.8662 34.8301L19.166 34.8311L14.666 26.3125L17.4658 24.6641L20.0156 28.1641L22.5654 24.6641L25.3662 26.3125Z"
        fill="white"
      />
      <path
        d="M18.3004 30.5469L20.0004 29.0469L21.7004 30.5469L20.917 32.5469L21.8504 37.4198H18.1504L19.0837 32.5469L18.3004 30.5469Z"
        fill="#36383A"
      />
      <path
        d="M29.0233 13.9974C29.0233 19.951 25.643 24.6631 19.9941 24.6631C14.3452 24.6631 10.9648 19.951 10.9648 13.9974C10.9648 8.04374 14.3452 3.21875 19.9941 3.21875C25.643 3.21875 29.0233 8.04374 29.0233 13.9974Z"
        fill="#FFCBC2"
      />
      <path
        d="M17.4292 17.264C17.8341 17.264 18.1689 16.8903 18.1689 16.4386C18.1689 15.987 17.8341 15.6133 17.4292 15.6133C17.0243 15.6133 16.6973 15.9792 16.6973 16.4386C16.6973 16.898 17.0321 17.264 17.4292 17.264Z"
        fill="#36383A"
      />
      <path
        d="M22.769 17.264C23.1739 17.264 23.5087 16.8903 23.5087 16.4386C23.5087 15.987 23.1817 15.6133 22.769 15.6133C22.3564 15.6133 22.0371 15.9792 22.0371 16.4386C22.0371 16.898 22.3641 17.264 22.769 17.264Z"
        fill="#36383A"
      />
      <path
        d="M21.1316 20.3357C21.2283 20.2044 21.4139 20.1759 21.5452 20.2725C21.6759 20.3692 21.703 20.5533 21.6067 20.6844C21.4829 20.8526 21.2723 21.0175 21.024 21.139C20.7712 21.2625 20.4577 21.3525 20.1148 21.3526C19.7697 21.3526 19.4529 21.2651 19.1971 21.1424C18.947 21.0224 18.7305 20.8566 18.6075 20.6758C18.516 20.541 18.5514 20.3573 18.6861 20.2657C18.8209 20.1742 19.0046 20.2096 19.0962 20.3443C19.1425 20.412 19.2614 20.5195 19.4517 20.6109C19.6367 20.6996 19.8673 20.763 20.1148 20.763C20.3554 20.7629 20.5816 20.6976 20.7659 20.6075C20.9541 20.5153 21.0793 20.4066 21.1316 20.3357Z"
        fill="#36383A"
      />
      <path
        d="M29.0004 14.9316C26.1671 14.1325 21.8143 9.30956 21.8143 9.30956C21.8143 9.30956 15.5009 14.1325 11.0004 14.9316C8.94624 8.7974 13.3607 3.21484 19.8956 3.21484C26.4305 3.21484 30.4959 9.16421 29.0004 14.9316Z"
        fill="#36383A"
      />
      <path
        d="M13.128 19.4098C14.015 18.6118 13.9164 17.0644 12.9035 15.9521C11.8904 14.8454 10.355 14.5886 9.46768 15.3923C8.58069 16.1903 8.67931 17.7376 9.69217 18.85C10.7053 19.9567 12.2408 20.2134 13.128 19.4098Z"
        fill="#FFCBC2"
      />
      <path
        d="M26.8681 19.4098C25.9811 18.6118 26.0797 17.0644 27.0926 15.9521C28.1057 14.8454 29.6411 14.5886 30.5284 15.3923C31.4154 16.1903 31.3168 17.7376 30.3039 18.85C29.2908 19.9567 27.7553 20.2134 26.8681 19.4098Z"
        fill="#FFCBC2"
      />
    </svg>
  ),
  // E5 「왜 조문객 수」 조문객 무리용. 디자인 시스템 Graphic 「Suit」 를 바탕으로 단발 여성(넥타이 없음). 자체 그래픽
  icon_Graphic_GuestFemale: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M10.6 14.3C10.1 7.6 14.3 3.2 20 3.2C25.7 3.2 29.9 7.6 29.4 14.3L30.3 24.6C28.2 25.9 26 25.8 24.8 25L15.2 25C14 25.8 11.8 25.9 9.7 24.6Z"
        fill="#36383A"
      />
      <path
        d="M25.383 26.3312C30.5602 27.6314 34.6089 30.9035 35.1695 36.2753H35.1773C35.2473 36.9371 34.7101 37.4976 34.0484 37.4976H5.95143C5.28968 37.4976 4.7525 36.9293 4.82257 36.2675C5.3831 31.0981 9.6294 27.717 14.5497 26.3312L17.883 25.8042L19.1241 27.9373C19.4355 28.2799 19.9804 28.2721 20.2841 27.9218L22.2537 25.6562L25.383 26.3312Z"
        fill="#36383A"
      />
      <path
        d="M22.5335 23.3984H17.4668V28.6223H22.5335V23.3984Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.3662 26.3125L20.8662 34.8301L19.166 34.8311L14.666 26.3125L17.4658 24.6641L20.0156 28.1641L22.5654 24.6641L25.3662 26.3125Z"
        fill="white"
      />
      <path
        d="M29.0233 13.9974C29.0233 19.951 25.643 24.6631 19.9941 24.6631C14.3452 24.6631 10.9648 19.951 10.9648 13.9974C10.9648 8.04374 14.3452 3.21875 19.9941 3.21875C25.643 3.21875 29.0233 8.04374 29.0233 13.9974Z"
        fill="#FFCBC2"
      />
      <path
        d="M17.4292 17.264C17.8341 17.264 18.1689 16.8903 18.1689 16.4386C18.1689 15.987 17.8341 15.6133 17.4292 15.6133C17.0243 15.6133 16.6973 15.9792 16.6973 16.4386C16.6973 16.898 17.0321 17.264 17.4292 17.264Z"
        fill="#36383A"
      />
      <path
        d="M22.769 17.264C23.1739 17.264 23.5087 16.8903 23.5087 16.4386C23.5087 15.987 23.1817 15.6133 22.769 15.6133C22.3564 15.6133 22.0371 15.9792 22.0371 16.4386C22.0371 16.898 22.3641 17.264 22.769 17.264Z"
        fill="#36383A"
      />
      <path
        d="M21.1316 20.3357C21.2283 20.2044 21.4139 20.1759 21.5452 20.2725C21.6759 20.3692 21.703 20.5533 21.6067 20.6844C21.4829 20.8526 21.2723 21.0175 21.024 21.139C20.7712 21.2625 20.4577 21.3525 20.1148 21.3526C19.7697 21.3526 19.4529 21.2651 19.1971 21.1424C18.947 21.0224 18.7305 20.8566 18.6075 20.6758C18.516 20.541 18.5514 20.3573 18.6861 20.2657C18.8209 20.1742 19.0046 20.2096 19.0962 20.3443C19.1425 20.412 19.2614 20.5195 19.4517 20.6109C19.6367 20.6996 19.8673 20.763 20.1148 20.763C20.3554 20.7629 20.5816 20.6976 20.7659 20.6075C20.9541 20.5153 21.0793 20.4066 21.1316 20.3357Z"
        fill="#36383A"
      />
      <path
        d="M29.0004 14.9316C26.1671 14.1325 21.8143 9.30956 21.8143 9.30956C21.8143 9.30956 15.5009 14.1325 11.0004 14.9316C8.94624 8.7974 13.3607 3.21484 19.8956 3.21484C26.4305 3.21484 30.4959 9.16421 29.0004 14.9316Z"
        fill="#36383A"
      />
      <path
        d="M13.128 19.4098C14.015 18.6118 13.9164 17.0644 12.9035 15.9521C11.8904 14.8454 10.355 14.5886 9.46768 15.3923C8.58069 16.1903 8.67931 17.7376 9.69217 18.85C10.7053 19.9567 12.2408 20.2134 13.128 19.4098Z"
        fill="#FFCBC2"
      />
      <path
        d="M26.8681 19.4098C25.9811 18.6118 26.0797 17.0644 27.0926 15.9521C28.1057 14.8454 29.6411 14.5886 30.5284 15.3923C31.4154 16.1903 31.3168 17.7376 30.3039 18.85C29.2908 19.9567 27.7553 20.2134 26.8681 19.4098Z"
        fill="#FFCBC2"
      />
    </svg>
  ),
  // E5 「왜 조문객 수」 조문객 무리용. 디자인 시스템 Graphic 「Suit」 를 바탕으로 갈색 긴 머리 여성(넥타이 없음). 자체 그래픽
  icon_Graphic_GuestFemaleLong: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M10.4 14.3C9.9 7.6 14.2 3.2 20 3.2C25.8 3.2 30.1 7.6 29.6 14.3L30.9 29.2C28.6 30.6 26.2 30.3 25 29.4L15 29.4C13.8 30.3 11.4 30.6 9.1 29.2Z"
        fill="#5B4636"
      />
      <path
        d="M25.383 26.3312C30.5602 27.6314 34.6089 30.9035 35.1695 36.2753H35.1773C35.2473 36.9371 34.7101 37.4976 34.0484 37.4976H5.95143C5.28968 37.4976 4.7525 36.9293 4.82257 36.2675C5.3831 31.0981 9.6294 27.717 14.5497 26.3312L17.883 25.8042L19.1241 27.9373C19.4355 28.2799 19.9804 28.2721 20.2841 27.9218L22.2537 25.6562L25.383 26.3312Z"
        fill="#36383A"
      />
      <path
        d="M22.5335 23.3984H17.4668V28.6223H22.5335V23.3984Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.3662 26.3125L20.8662 34.8301L19.166 34.8311L14.666 26.3125L17.4658 24.6641L20.0156 28.1641L22.5654 24.6641L25.3662 26.3125Z"
        fill="white"
      />
      <path
        d="M29.0233 13.9974C29.0233 19.951 25.643 24.6631 19.9941 24.6631C14.3452 24.6631 10.9648 19.951 10.9648 13.9974C10.9648 8.04374 14.3452 3.21875 19.9941 3.21875C25.643 3.21875 29.0233 8.04374 29.0233 13.9974Z"
        fill="#FFCBC2"
      />
      <path
        d="M17.4292 17.264C17.8341 17.264 18.1689 16.8903 18.1689 16.4386C18.1689 15.987 17.8341 15.6133 17.4292 15.6133C17.0243 15.6133 16.6973 15.9792 16.6973 16.4386C16.6973 16.898 17.0321 17.264 17.4292 17.264Z"
        fill="#36383A"
      />
      <path
        d="M22.769 17.264C23.1739 17.264 23.5087 16.8903 23.5087 16.4386C23.5087 15.987 23.1817 15.6133 22.769 15.6133C22.3564 15.6133 22.0371 15.9792 22.0371 16.4386C22.0371 16.898 22.3641 17.264 22.769 17.264Z"
        fill="#36383A"
      />
      <path
        d="M21.1316 20.3357C21.2283 20.2044 21.4139 20.1759 21.5452 20.2725C21.6759 20.3692 21.703 20.5533 21.6067 20.6844C21.4829 20.8526 21.2723 21.0175 21.024 21.139C20.7712 21.2625 20.4577 21.3525 20.1148 21.3526C19.7697 21.3526 19.4529 21.2651 19.1971 21.1424C18.947 21.0224 18.7305 20.8566 18.6075 20.6758C18.516 20.541 18.5514 20.3573 18.6861 20.2657C18.8209 20.1742 19.0046 20.2096 19.0962 20.3443C19.1425 20.412 19.2614 20.5195 19.4517 20.6109C19.6367 20.6996 19.8673 20.763 20.1148 20.763C20.3554 20.7629 20.5816 20.6976 20.7659 20.6075C20.9541 20.5153 21.0793 20.4066 21.1316 20.3357Z"
        fill="#36383A"
      />
      <path
        d="M29.0004 14.9316C26.1671 14.1325 21.8143 9.30956 21.8143 9.30956C21.8143 9.30956 15.5009 14.1325 11.0004 14.9316C8.94624 8.7974 13.3607 3.21484 19.8956 3.21484C26.4305 3.21484 30.4959 9.16421 29.0004 14.9316Z"
        fill="#5B4636"
      />
      <path
        d="M13.128 19.4098C14.015 18.6118 13.9164 17.0644 12.9035 15.9521C11.8904 14.8454 10.355 14.5886 9.46768 15.3923C8.58069 16.1903 8.67931 17.7376 9.69217 18.85C10.7053 19.9567 12.2408 20.2134 13.128 19.4098Z"
        fill="#FFCBC2"
      />
      <path
        d="M26.8681 19.4098C25.9811 18.6118 26.0797 17.0644 27.0926 15.9521C28.1057 14.8454 29.6411 14.5886 30.5284 15.3923C31.4154 16.1903 31.3168 17.7376 30.3039 18.85C29.2908 19.9567 27.7553 20.2134 26.8681 19.4098Z"
        fill="#FFCBC2"
      />
    </svg>
  ),
  // E5 「왜 조문객 수」 조문객 무리용. 디자인 시스템 Graphic 「Suit」 를 바탕으로 흰머리 · 안경 어르신. 자체 그래픽
  icon_Graphic_GuestSenior: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M25.383 26.3312C30.5602 27.6314 34.6089 30.9035 35.1695 36.2753H35.1773C35.2473 36.9371 34.7101 37.4976 34.0484 37.4976H5.95143C5.28968 37.4976 4.7525 36.9293 4.82257 36.2675C5.3831 31.0981 9.6294 27.717 14.5497 26.3312L17.883 25.8042L19.1241 27.9373C19.4355 28.2799 19.9804 28.2721 20.2841 27.9218L22.2537 25.6562L25.383 26.3312Z"
        fill="#36383A"
      />
      <path
        d="M22.5335 23.3984H17.4668V28.6223H22.5335V23.3984Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.3662 26.3125L20.8662 34.8301L19.166 34.8311L14.666 26.3125L17.4658 24.6641L20.0156 28.1641L22.5654 24.6641L25.3662 26.3125Z"
        fill="white"
      />
      <path
        d="M18.3004 30.5469L20.0004 29.0469L21.7004 30.5469L20.917 32.5469L21.8504 37.4198H18.1504L19.0837 32.5469L18.3004 30.5469Z"
        fill="#36383A"
      />
      <path
        d="M29.0233 13.9974C29.0233 19.951 25.643 24.6631 19.9941 24.6631C14.3452 24.6631 10.9648 19.951 10.9648 13.9974C10.9648 8.04374 14.3452 3.21875 19.9941 3.21875C25.643 3.21875 29.0233 8.04374 29.0233 13.9974Z"
        fill="#FFCBC2"
      />
      <path
        d="M17.4292 17.264C17.8341 17.264 18.1689 16.8903 18.1689 16.4386C18.1689 15.987 17.8341 15.6133 17.4292 15.6133C17.0243 15.6133 16.6973 15.9792 16.6973 16.4386C16.6973 16.898 17.0321 17.264 17.4292 17.264Z"
        fill="#36383A"
      />
      <path
        d="M22.769 17.264C23.1739 17.264 23.5087 16.8903 23.5087 16.4386C23.5087 15.987 23.1817 15.6133 22.769 15.6133C22.3564 15.6133 22.0371 15.9792 22.0371 16.4386C22.0371 16.898 22.3641 17.264 22.769 17.264Z"
        fill="#36383A"
      />
      <path
        d="M21.1316 20.3357C21.2283 20.2044 21.4139 20.1759 21.5452 20.2725C21.6759 20.3692 21.703 20.5533 21.6067 20.6844C21.4829 20.8526 21.2723 21.0175 21.024 21.139C20.7712 21.2625 20.4577 21.3525 20.1148 21.3526C19.7697 21.3526 19.4529 21.2651 19.1971 21.1424C18.947 21.0224 18.7305 20.8566 18.6075 20.6758C18.516 20.541 18.5514 20.3573 18.6861 20.2657C18.8209 20.1742 19.0046 20.2096 19.0962 20.3443C19.1425 20.412 19.2614 20.5195 19.4517 20.6109C19.6367 20.6996 19.8673 20.763 20.1148 20.763C20.3554 20.7629 20.5816 20.6976 20.7659 20.6075C20.9541 20.5153 21.0793 20.4066 21.1316 20.3357Z"
        fill="#36383A"
      />
      <path
        d="M29.0004 14.9316C26.1671 14.1325 21.8143 9.30956 21.8143 9.30956C21.8143 9.30956 15.5009 14.1325 11.0004 14.9316C8.94624 8.7974 13.3607 3.21484 19.8956 3.21484C26.4305 3.21484 30.4959 9.16421 29.0004 14.9316Z"
        fill="#C4C7CA"
      />
      <path
        d="M13.128 19.4098C14.015 18.6118 13.9164 17.0644 12.9035 15.9521C11.8904 14.8454 10.355 14.5886 9.46768 15.3923C8.58069 16.1903 8.67931 17.7376 9.69217 18.85C10.7053 19.9567 12.2408 20.2134 13.128 19.4098Z"
        fill="#FFCBC2"
      />
      <path
        d="M26.8681 19.4098C25.9811 18.6118 26.0797 17.0644 27.0926 15.9521C28.1057 14.8454 29.6411 14.5886 30.5284 15.3923C31.4154 16.1903 31.3168 17.7376 30.3039 18.85C29.2908 19.9567 27.7553 20.2134 26.8681 19.4098Z"
        fill="#FFCBC2"
      />
      <circle
        cx="17.43"
        cy="16.44"
        r="2.35"
        stroke="#36383A"
        strokeWidth="0.8"
      />
      <circle
        cx="22.77"
        cy="16.44"
        r="2.35"
        stroke="#36383A"
        strokeWidth="0.8"
      />
      <path d="M19.78 16.3H20.42" stroke="#36383A" strokeWidth="0.8" />
    </svg>
  ),
  // E5 「왜 조문객 수」 조문객 무리용. 디자인 시스템 Graphic 「Suit」 를 바탕으로 갈색 머리 · 안경 남성. 자체 그래픽
  icon_Graphic_GuestGlasses: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M25.383 26.3312C30.5602 27.6314 34.6089 30.9035 35.1695 36.2753H35.1773C35.2473 36.9371 34.7101 37.4976 34.0484 37.4976H5.95143C5.28968 37.4976 4.7525 36.9293 4.82257 36.2675C5.3831 31.0981 9.6294 27.717 14.5497 26.3312L17.883 25.8042L19.1241 27.9373C19.4355 28.2799 19.9804 28.2721 20.2841 27.9218L22.2537 25.6562L25.383 26.3312Z"
        fill="#36383A"
      />
      <path
        d="M22.5335 23.3984H17.4668V28.6223H22.5335V23.3984Z"
        fill="#FFCBC2"
      />
      <path
        d="M25.3662 26.3125L20.8662 34.8301L19.166 34.8311L14.666 26.3125L17.4658 24.6641L20.0156 28.1641L22.5654 24.6641L25.3662 26.3125Z"
        fill="white"
      />
      <path
        d="M18.3004 30.5469L20.0004 29.0469L21.7004 30.5469L20.917 32.5469L21.8504 37.4198H18.1504L19.0837 32.5469L18.3004 30.5469Z"
        fill="#36383A"
      />
      <path
        d="M29.0233 13.9974C29.0233 19.951 25.643 24.6631 19.9941 24.6631C14.3452 24.6631 10.9648 19.951 10.9648 13.9974C10.9648 8.04374 14.3452 3.21875 19.9941 3.21875C25.643 3.21875 29.0233 8.04374 29.0233 13.9974Z"
        fill="#FFCBC2"
      />
      <path
        d="M17.4292 17.264C17.8341 17.264 18.1689 16.8903 18.1689 16.4386C18.1689 15.987 17.8341 15.6133 17.4292 15.6133C17.0243 15.6133 16.6973 15.9792 16.6973 16.4386C16.6973 16.898 17.0321 17.264 17.4292 17.264Z"
        fill="#36383A"
      />
      <path
        d="M22.769 17.264C23.1739 17.264 23.5087 16.8903 23.5087 16.4386C23.5087 15.987 23.1817 15.6133 22.769 15.6133C22.3564 15.6133 22.0371 15.9792 22.0371 16.4386C22.0371 16.898 22.3641 17.264 22.769 17.264Z"
        fill="#36383A"
      />
      <path
        d="M21.1316 20.3357C21.2283 20.2044 21.4139 20.1759 21.5452 20.2725C21.6759 20.3692 21.703 20.5533 21.6067 20.6844C21.4829 20.8526 21.2723 21.0175 21.024 21.139C20.7712 21.2625 20.4577 21.3525 20.1148 21.3526C19.7697 21.3526 19.4529 21.2651 19.1971 21.1424C18.947 21.0224 18.7305 20.8566 18.6075 20.6758C18.516 20.541 18.5514 20.3573 18.6861 20.2657C18.8209 20.1742 19.0046 20.2096 19.0962 20.3443C19.1425 20.412 19.2614 20.5195 19.4517 20.6109C19.6367 20.6996 19.8673 20.763 20.1148 20.763C20.3554 20.7629 20.5816 20.6976 20.7659 20.6075C20.9541 20.5153 21.0793 20.4066 21.1316 20.3357Z"
        fill="#36383A"
      />
      <path
        d="M29.0004 14.9316C26.1671 14.1325 21.8143 9.30956 21.8143 9.30956C21.8143 9.30956 15.5009 14.1325 11.0004 14.9316C8.94624 8.7974 13.3607 3.21484 19.8956 3.21484C26.4305 3.21484 30.4959 9.16421 29.0004 14.9316Z"
        fill="#6B5444"
      />
      <path
        d="M13.128 19.4098C14.015 18.6118 13.9164 17.0644 12.9035 15.9521C11.8904 14.8454 10.355 14.5886 9.46768 15.3923C8.58069 16.1903 8.67931 17.7376 9.69217 18.85C10.7053 19.9567 12.2408 20.2134 13.128 19.4098Z"
        fill="#FFCBC2"
      />
      <path
        d="M26.8681 19.4098C25.9811 18.6118 26.0797 17.0644 27.0926 15.9521C28.1057 14.8454 29.6411 14.5886 30.5284 15.3923C31.4154 16.1903 31.3168 17.7376 30.3039 18.85C29.2908 19.9567 27.7553 20.2134 26.8681 19.4098Z"
        fill="#FFCBC2"
      />
      <circle
        cx="17.43"
        cy="16.44"
        r="2.35"
        stroke="#36383A"
        strokeWidth="0.8"
      />
      <circle
        cx="22.77"
        cy="16.44"
        r="2.35"
        stroke="#36383A"
        strokeWidth="0.8"
      />
      <path d="M19.78 16.3H20.42" stroke="#36383A" strokeWidth="0.8" />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic 스타일로 새로 그림(낮고 넓은 건물, E4 B-3 지도 핀 장례식장). icon_Graphic_Building 과 같은 색 계열
  icon_Graphic_BuildingLow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect x="4" y="16" width="32" height="18" rx="1.5" fill="#D9D3CF" />
      <rect x="3" y="13" width="34" height="4" rx="1" fill="#B9B3B2" />
      <rect x="7.5" y="20" width="5" height="4" rx="0.8" fill="#8A8A8A" />
      <rect x="17.5" y="20" width="5" height="4" rx="0.8" fill="#8A8A8A" />
      <rect x="27.5" y="20" width="5" height="4" rx="0.8" fill="#8A8A8A" />
      <rect x="7.5" y="27" width="5" height="4" rx="0.8" fill="#8A8A8A" />
      <rect x="27.5" y="27" width="5" height="4" rx="0.8" fill="#8A8A8A" />
      <path
        d="M17 34V28.5C17 27.67 17.67 27 18.5 27H21.5C22.33 27 23 27.67 23 28.5V34H17Z"
        fill="#686868"
      />
      <rect x="2" y="33.5" width="36" height="2.5" rx="1.25" fill="#B9B3B2" />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic 스타일로 새로 그림(지붕이 있는 건물, E4 B-3 지도 핀 장례식장). icon_Graphic_Building 과 같은 색 계열
  icon_Graphic_BuildingRoof: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path d="M20 5L35 15.5H5L20 5Z" fill="#99A8B0" />
      <rect x="7" y="15" width="26" height="19" fill="#E8E9EA" />
      <rect x="5" y="14.5" width="30" height="2.5" rx="1" fill="#718189" />
      <rect x="10" y="20" width="4" height="9" rx="2" fill="#718189" />
      <rect x="26" y="20" width="4" height="9" rx="2" fill="#718189" />
      <path
        d="M16.5 34V23.5C16.5 22.67 17.17 22 18 22H22C22.83 22 23.5 22.67 23.5 23.5V34H16.5Z"
        fill="#99A8B0"
      />
      <circle cx="20" cy="11" r="1.6" fill="#E8E9EA" />
      <rect x="3" y="33.5" width="34" height="2.5" rx="1.25" fill="#99A8B0" />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic 스타일로 새로 그림(본관 + 양옆 별관 건물, E4 B-3 지도 핀 장례식장). icon_Graphic_Building 과 같은 색 계열
  icon_Graphic_BuildingAnnex: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect x="9" y="6" width="22" height="28" rx="1.5" fill="#F2F4F5" />
      <rect x="9" y="6" width="22" height="5" rx="1.5" fill="#C7D0D6" />
      <rect x="3" y="20" width="8" height="14" rx="1" fill="#C7D0D6" />
      <rect x="29" y="20" width="8" height="14" rx="1" fill="#C7D0D6" />
      <g fill="#99A8B0">
        <rect x="12.5" y="14" width="4" height="3" rx="0.6" />
        <rect x="18" y="14" width="4" height="3" rx="0.6" />
        <rect x="23.5" y="14" width="4" height="3" rx="0.6" />
        <rect x="12.5" y="20" width="4" height="3" rx="0.6" />
        <rect x="18" y="20" width="4" height="3" rx="0.6" />
        <rect x="23.5" y="20" width="4" height="3" rx="0.6" />
        <rect x="5" y="24" width="4" height="2.5" rx="0.5" />
        <rect x="31" y="24" width="4" height="2.5" rx="0.5" />
      </g>
      <path
        d="M16.5 34V28C16.5 27.17 17.17 26.5 18 26.5H22C22.83 26.5 23.5 27.17 23.5 28V34H16.5Z"
        fill="#718189"
      />
      <rect x="2" y="33.5" width="36" height="2.5" rx="1.25" fill="#C7D0D6" />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic 스타일로 새로 그림(가족 셋, 무빈소 "가족 중심"). 인물은 icon_Graphic_Suit 를 따름
  icon_Graphic_Family: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M3.5 33C3.5 26.5 7.0 22.5 10.5 22.5C14.0 22.5 17.5 26.5 17.5 33Z"
        fill="#B9B3B2"
      />
      <circle cx="10.5" cy="16" r="4.2" fill="#FFCBC2" />
      <path
        d="M6.2 16.4C5.7 9.7 15.299999999999999 9.7 14.799999999999999 16.4C11.97 14.11 9.03 14.11 6.2 16.4Z"
        fill="#36383A"
      />
      <circle cx="8.99" cy="17.18" r="0.46" fill="#36383A" />
      <circle cx="12.01" cy="17.18" r="0.46" fill="#36383A" />
      <path
        d="M22.5 33C22.5 26.5 26.0 22.5 29.5 22.5C33.0 22.5 36.5 26.5 36.5 33Z"
        fill="#B9B3B2"
      />
      <circle cx="29.5" cy="16" r="4.2" fill="#FFCBC2" />
      <path
        d="M25.2 16.4C24.7 9.7 34.300000000000004 9.7 33.800000000000004 16.4C30.97 14.11 28.03 14.11 25.2 16.4Z"
        fill="#36383A"
      />
      <circle cx="27.99" cy="17.18" r="0.46" fill="#36383A" />
      <circle cx="31.01" cy="17.18" r="0.46" fill="#36383A" />
      <path
        d="M11.5 36C11.5 27.5 15.75 23.5 20 23.5C24.25 23.5 28.5 27.5 28.5 36Z"
        fill="#36383A"
      />
      <path d="M17 23.9L20 27.6L23 23.9Z" fill="white" />
      <circle cx="20" cy="14.6" r="5.2" fill="#FFCBC2" />
      <path
        d="M14.700000000000001 15.0C14.200000000000001 6.799999999999999 25.8 6.799999999999999 25.3 15.0C21.82 12.26 18.18 12.26 14.700000000000001 15.0Z"
        fill="#36383A"
      />
      <circle cx="18.13" cy="16.06" r="0.57" fill="#36383A" />
      <circle cx="21.87" cy="16.06" r="0.57" fill="#36383A" />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic 스타일로 새로 그림(집). DS 에 아직 없음 — Figma 디자인 시스템 반영 필요
  icon_Graphic_Home: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.4 4.3C15.4 3.97 15.67 3.7 16 3.7H17.6C17.93 3.7 18.2 3.97 18.2 4.3V9H15.4V4.3Z"
        fill="#5D5959"
      />
      <path
        d="M4.5 11C4.5 10.45 4.95 10 5.5 10H18.5C19.05 10 19.5 10.45 19.5 11V20.3C19.5 20.69 19.19 21 18.8 21H5.2C4.81 21 4.5 20.69 4.5 20.3V11Z"
        fill="#FFD07E"
      />
      <path d="M4.5 11.4H19.5V13.2H4.5V11.4Z" fill="#FFBB42" />
      <path
        d="M3.08 11.8C2.42 11.8 2.13 10.97 2.65 10.56L11.38 3.62C11.74 3.33 12.26 3.33 12.62 3.62L21.35 10.56C21.87 10.97 21.58 11.8 20.92 11.8H3.08Z"
        fill="#FF8442"
      />
      <path
        d="M10 21V16.6C10 15.5 10.9 14.6 12 14.6C13.1 14.6 14 15.5 14 16.6V21H10Z"
        fill="#FF8442"
      />
      <path
        d="M6.4 14.9C6.4 14.62 6.62 14.4 6.9 14.4H8.6C8.88 14.4 9.1 14.62 9.1 14.9V16.6C9.1 16.88 8.88 17.1 8.6 17.1H6.9C6.62 17.1 6.4 16.88 6.4 16.6V14.9Z"
        fill="#FFFFFF"
      />
      <path
        d="M14.9 14.9C14.9 14.62 15.12 14.4 15.4 14.4H17.1C17.38 14.4 17.6 14.62 17.6 14.9V16.6C17.6 16.88 17.38 17.1 17.1 17.1H15.4C15.12 17.1 14.9 16.88 14.9 16.6V14.9Z"
        fill="#FFFFFF"
      />
    </svg>
  ),
  // 디자인 시스템 Icon/Graphic/Bus 원본(goi-agent design-system assets/icons/graphic/bus.svg)
  // 고인 이송 앰뷸런스(E4 C-3). 디자인 시스템 그래픽 아이콘에 차가 버스뿐이라 같은 색(#36383A · #767A7F)으로 새로 그렸다
  icon_Graphic_Ambulance: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="7.4" y="4.4" width="2.8" height="1.6" rx="0.6" fill="#F26B5B" />
      <rect
        x="1.8"
        y="5.8"
        width="13.6"
        height="12.4"
        rx="1.6"
        fill="#E3E5E8"
      />
      <path
        d="M15.4 8.8H18.6C19 8.8 19.4 9 19.6 9.3L22 12.6C22.1 12.8 22.2 13 22.2 13.2V17.4C22.2 17.8 21.8 18.2 21.4 18.2H15.4V8.8Z"
        fill="#E3E5E8"
      />
      <path d="M16.6 10.2H18.4L20.3 12.9H16.6V10.2Z" fill="#767A7F" />
      <rect x="1.8" y="14.2" width="20.4" height="1.4" fill="#C9CDD2" />
      <rect x="7.6" y="8.2" width="1.6" height="5" rx="0.4" fill="#F26B5B" />
      <rect x="5.9" y="9.9" width="5" height="1.6" rx="0.4" fill="#F26B5B" />
      <circle cx="6.4" cy="18.4" r="2.2" fill="#36383A" />
      <circle cx="6.4" cy="18.4" r="0.9" fill="#C9CDD2" />
      <circle cx="17.6" cy="18.4" r="2.2" fill="#36383A" />
      <circle cx="17.6" cy="18.4" r="0.9" fill="#C9CDD2" />
    </svg>
  ),
  icon_Graphic_Bus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <defs>
        <clipPath id="graphic_bus_c29">
          <path d="M0 0H19.399999618530273V18.876598358154297H0Z" />
        </clipPath>
      </defs>
      <g>
        <g transform="matrix(1 0 0 1 2.3 2.5601)">
          <g clipPath="url(#graphic_bus_c29)">
            <g transform="matrix(1 0 0 1 2.948 16.017)">
              <path
                d="M 1.993 2.86 C 3.094 2.86 3.986 1.967 3.986 0.867 L 3.986 0 L 0 0 L 0 0.867 C 0 1.967 0.892 2.86 1.993 2.86 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 12.4663 16.017)">
              <path
                d="M 1.993 2.86 C 3.094 2.86 3.986 1.967 3.986 0.867 L 3.986 0 L 0 0 L 0 0.867 C 0 1.967 0.892 2.86 1.993 2.86 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 1.5254 0)">
              <path
                d="M 1.777 0 L 14.569 0 C 15.549 0 16.345 0.806 16.345 1.799 L 16.345 15.915 C 16.345 16.31 16.025 16.634 15.634 16.634 L 0.711 16.634 C 0.32 16.634 0 16.31 0 15.915 L 0 1.799 C 0 0.806 0.796 0 1.777 0 Z"
                fill="#767A7F"
              />
            </g>
            <g transform="matrix(1 0 0 1 1.5254 2.2586)">
              <path
                d="M 16.345 0 L 0 0 L 0 7.324 L 16.345 7.324 L 16.345 0 Z"
                fill="#36383A"
              />
            </g>
            <g transform="matrix(1 0 0 1 1.5254 11.684)">
              <path
                d="M 0 0 L 16.345 0 L 16.345 4.23 C 16.345 4.626 16.025 4.95 15.634 4.95 L 0.711 4.95 C 0.32 4.95 0 4.626 0 4.23 L 0 0 Z"
                fill="#BABDBF"
              />
            </g>
            <g transform="matrix(1 0 0 1 0 3.5619)">
              <path
                d="M 1.079 0 L 1.525 0 L 1.525 4.856 L 1.079 4.856 C 0.482 4.856 0 4.374 0 3.777 L 0 1.079 C 0 0.482 0.482 0 1.079 0 Z"
                fill="#767A7F"
              />
            </g>
            <g transform="matrix(-1 0 0 -1 19.4 8.4177)">
              <path
                d="M 1.079 0 L 1.525 0 L 1.525 4.856 L 1.079 4.856 C 0.482 4.856 0 4.374 0 3.777 L 0 1.079 C 0 0.482 0.482 0 1.079 0 Z"
                fill="#767A7F"
              />
            </g>
            <g transform="matrix(1 0 0 1 1.5247 12.9661)">
              <path
                d="M 0 0 L 2.991 0 C 3.535 0 3.986 0.444 3.986 0.997 C 3.986 1.541 3.542 1.993 2.991 1.993 L 0 1.993 L 0 0.007 L 0 0 Z"
                fill="#E8E9EA"
              />
            </g>
            <g transform="matrix(-1 0 0 1 17.872 12.9661)">
              <path
                d="M 0 0 L 2.991 0 C 3.535 0 3.986 0.444 3.986 0.997 C 3.986 1.541 3.542 1.993 2.991 1.993 L 0 1.993 L 0 0.007 L 0 0 Z"
                fill="#E8E9EA"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  icon_Graphic_Urn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M8.39258 5.65281C8.39258 4.37108 9.43163 3.33203 10.7134 3.33203H29.2786C30.5603 3.33203 31.5994 4.37108 31.5994 5.65281H8.39258Z"
        fill="#D1CAC9"
      />
      <path
        d="M8.39258 34.5547H31.5994V35.7502C31.5994 36.2551 31.19 36.6644 30.6851 36.6644H9.30678C8.80188 36.6644 8.39258 36.2551 8.39258 35.7502V34.5547Z"
        fill="#B9B3B2"
      />
      <path
        d="M6.2832 10.5425C6.2832 9.0969 7.09994 7.77539 8.39291 7.12891H31.5997C32.8927 7.77539 33.7094 9.0969 33.7094 10.5425V31.1415C33.7094 32.5871 32.8927 33.9086 31.5997 34.5551H8.39291C7.09994 33.9086 6.2832 32.5871 6.2832 31.1415V10.5425Z"
        fill="#DDD7D7"
      />
      <rect
        x="15.7773"
        y="14.5117"
        width="8.43883"
        height="12.6582"
        rx="1.09705"
        fill="white"
      />
      <rect
        x="6.2832"
        y="10.293"
        width="27.4262"
        height="1.26582"
        fill="#CAC4C3"
      />
      <path
        d="M8.39258 5.65234H31.5994V7.12914H8.39258V5.65234Z"
        fill="#B9B3B2"
      />
      <rect
        x="6.2832"
        y="30.125"
        width="27.4262"
        height="1.26582"
        fill="#CAC4C3"
      />
    </svg>
  ),
  "icon-circle-info-mono": (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0C14.75 0 19 4.25 19 9.5C19 14.75 14.75 19 9.5 19C4.25 19 0 14.75 0 9.5C0 4.25 4.25 0 9.5 0Z"
        fill="#0CCF50"
      />
      <path
        d="M9.5 7.9C10 7.9 10.4 8.3 10.4 8.8V13.5C10.4 14 10 14.4 9.5 14.4C9 14.4 8.6 14 8.6 13.5V8.8C8.6 8.3 9 7.9 9.5 7.9ZM9.5 4.5C10.05 4.5 10.5 4.95 10.5 5.5C10.5 6.05 10.05 6.5 9.5 6.5C8.95 6.5 8.5 6.05 8.5 5.5C8.5 4.95 8.95 4.5 9.5 4.5Z"
        fill="white"
      />
    </svg>
  ),
  "icon-circle-check-green-mono": (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma 는 62px 박스 안에 49.0833 아트를 10.42% 인셋으로 둔다 */}
      <g transform="translate(6.4583 6.4583)">
        <path
          d="M24.5417 0C38.1042 0 49.0833 10.9792 49.0833 24.5417C49.0833 38.1042 38.1042 49.0833 24.5417 49.0833C10.9792 49.0833 0 38.1042 0 24.5417C0 10.9792 10.9792 0 24.5417 0Z"
          fill="#EBFBEE"
        />
        <path
          d="M33.3509 16.6883C34.1259 15.8358 35.4175 15.7841 36.27 16.5591C37.1225 17.3341 37.1742 18.6258 36.3992 19.4783L23.4826 33.6866C23.0951 34.0999 22.5784 34.3583 22.0101 34.3583C21.4417 34.3583 20.8992 34.1516 20.5117 33.7641L12.7617 26.0141C11.9609 25.2133 11.9609 23.8958 12.7617 23.0949C13.5626 22.2941 14.8801 22.2941 15.6809 23.0949L21.9067 29.3208L33.3767 16.7141L33.3509 16.6883Z"
          fill="#37B24D"
        />
      </g>
    </svg>
  ),
  "icon-circle-exclamation-red-mono": (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma 는 62px 박스 안에 49.0833 아트를 10.42% 인셋으로 둔다 */}
      <g transform="translate(6.4583 6.4583)">
        <path
          d="M24.5417 0C38.1042 0 49.0833 10.9792 49.0833 24.5417C49.0833 38.1042 38.1042 49.0833 24.5417 49.0833C10.9792 49.0833 0 38.1042 0 24.5417C0 10.9792 10.9792 0 24.5417 0Z"
          fill="#FFEDED"
        />
        <path
          d="M24.5417 32.0333C25.9625 32.0333 27.125 33.1958 27.125 34.6167C27.125 36.0375 25.9625 37.2 24.5417 37.2C23.1208 37.2 21.9583 36.0375 21.9583 34.6167C21.9583 33.1958 23.1208 32.0333 24.5417 32.0333ZM24.5417 11.625C25.8333 11.625 26.8667 12.6583 26.8667 13.95V26.0917C26.8667 27.3833 25.8333 28.4167 24.5417 28.4167C23.25 28.4167 22.2167 27.3833 22.2167 26.0917V13.95C22.2167 12.6583 23.25 11.625 24.5417 11.625Z"
          fill="#CB3232"
        />
      </g>
    </svg>
  ),
  "icon-circle-exclamation-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma 는 20px 박스 안에 15.8333 아트를 10.42% 인셋으로 둔다 */}
      <g transform="translate(2.0833 2.0833)">
        <path
          d="M7.91667 0C12.2917 0 15.8333 3.54167 15.8333 7.91667C15.8333 12.2917 12.2917 15.8333 7.91667 15.8333C3.54167 15.8333 0 12.2917 0 7.91667C0 3.54167 3.54167 0 7.91667 0Z"
          fill="#FF4242"
        />
        <path
          d="M7.91663 10.3334C8.37496 10.3334 8.74996 10.7084 8.74996 11.1667C8.74996 11.625 8.37496 12 7.91663 12C7.45829 12 7.08329 11.625 7.08329 11.1667C7.08329 10.7084 7.45829 10.3334 7.91663 10.3334ZM7.91663 3.75002C8.33329 3.75002 8.66663 4.08335 8.66663 4.50002V8.41669C8.66663 8.83335 8.33329 9.16669 7.91663 9.16669C7.49996 9.16669 7.16663 8.83335 7.16663 8.41669V4.50002C7.16663 4.08335 7.49996 3.75002 7.91663 3.75002Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  "icon-circle-close-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.0833 2.0833)">
        <path
          d="M7.91667 0C12.2917 0 15.8333 3.54167 15.8333 7.91667C15.8333 12.2917 12.2917 15.8333 7.91667 15.8333C3.54167 15.8333 0 12.2917 0 7.91667C0 3.54167 3.54167 0 7.91667 0Z"
          fill="#E2452B"
        />
        <path
          d="M5.01666 4.92499C5.27499 4.66666 5.69999 4.66666 5.95833 4.92499L7.91666 6.88333L9.87499 4.92499C10.1333 4.66666 10.5583 4.66666 10.8167 4.92499C11.075 5.18333 11.075 5.60833 10.8167 5.86666L8.85833 7.82499L10.9083 9.87499C11.1667 10.1333 11.1667 10.5583 10.9083 10.8167C10.65 11.075 10.225 11.075 9.96666 10.8167L7.91666 8.76666L5.86666 10.8167C5.60833 11.075 5.18333 11.075 4.92499 10.8167C4.66666 10.5583 4.66666 10.1333 4.92499 9.87499L6.97499 7.82499L5.01666 5.86666C4.75833 5.60833 4.75833 5.18333 5.01666 4.92499Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  "icon-circle-info-line-mono": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(2.08333 2.08333)"
        d="M7.91667 0C12.2917 0 15.8333 3.54167 15.8333 7.91667C15.8333 12.2917 12.2917 15.8333 7.91667 15.8333C3.54167 15.8333 0 12.2917 0 7.91667C0 3.54167 3.54167 0 7.91667 0ZM7.91667 1.33333C4.28333 1.33333 1.33333 4.28333 1.33333 7.91667C1.33333 11.55 4.28333 14.5 7.91667 14.5C11.55 14.5 14.5 11.55 14.5 7.91667C14.5 4.28333 11.55 1.33333 7.91667 1.33333ZM7.91667 6.58333C8.33333 6.58333 8.66667 6.91667 8.66667 7.33333V11.25C8.66667 11.6667 8.33333 12 7.91667 12C7.5 12 7.16667 11.6667 7.16667 11.25V7.33333C7.16667 6.91667 7.5 6.58333 7.91667 6.58333ZM7.91667 3.75C8.375 3.75 8.75 4.125 8.75 4.58333C8.75 5.04167 8.375 5.41667 7.91667 5.41667C7.45833 5.41667 7.08333 5.04167 7.08333 4.58333C7.08333 4.125 7.45833 3.75 7.91667 3.75Z"
        fill="#4693FF"
      />
    </svg>
  ),
  // 카카오 심볼(말풍선). 기존 CDN kakao.svg 는 24px PNG 라 선명한 화면에서 흐리고 깨져 보여 벡터로 다시 그림(2026-11-04).
  // 카카오 로그인 버튼 가이드: 노란 바탕(#FEE500) 위 검정 심볼
  icon_kakao_symbol: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="#000000"
        d="M12 3.5C6.75 3.5 2.5 6.86 2.5 11c0 2.66 1.76 5 4.41 6.33l-1.12 4.1c-.1.36.31.65.62.44l4.89-3.24c.23.02.46.03.7.03 5.25 0 9.5-3.36 9.5-7.5S17.25 3.5 12 3.5z"
      />
    </svg>
  ),
  // 고이 디자인 시스템 Normal 「Call」 Fill(goi-agent design-system/assets/icons/normal/call-fill.svg). 색은 color 로
  icon_normal_call_fill: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g>
        <g transform="matrix(1 0 0 1 4.14 2.9415)">
          <path
            d="M 1.692 1.454 C -0.671 3.706 -0.822 8.029 2.934 13.012 C 6.7 17.996 10.886 19.046 13.711 17.395 C 13.981 17.235 14.862 16.685 15.303 16.304 C 15.884 15.814 15.804 15.224 15.393 14.683 L 12.609 11.721 C 12.248 11.351 11.678 11.311 11.267 11.621 L 9.875 12.672 C 9.464 12.982 8.873 12.912 8.483 12.652 C 7.752 12.142 7.111 11.461 6.359 10.45 C 5.608 9.44 5.117 8.649 4.827 7.809 C 4.677 7.368 4.777 6.778 5.188 6.468 L 6.58 5.417 C 6.99 5.107 7.111 4.546 6.86 4.096 L 4.767 0.584 C 4.356 0.023 3.815 -0.207 3.185 0.223 C 2.694 0.544 1.933 1.244 1.692 1.454 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  ),
  // Figma Icon/Normal/Location (26). 기존 location 과 모양이 달라 따로 둔다. 색은 color 로 준다
  icon_normal_location: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.16729C17.9292 2.16729 21.9375 6.14313 21.9375 11.0506C21.71 17.2581 15.73 22.079 13.8558 23.444C13.52 23.6931 13.0758 23.6931 12.7292 23.4656C10.7575 22.1331 4.29 17.2906 4.0625 11.0506C4.0625 6.14313 8.06 2.16729 13 2.16729ZM13 7.31313C11.0608 7.31313 9.47917 8.8948 9.47917 10.834C9.47917 12.7731 11.0608 14.3548 13 14.3548C14.9392 14.3548 16.5208 12.7731 16.5208 10.834C16.5208 8.8948 14.9392 7.31313 13 7.31313Z"
        fill="#46494C"
      />
    </svg>
  ),
  // Figma Icon/Normal/People (26). 기존 icon-people 과 모양이 달라 따로 둔다. 색은 color 로 준다
  icon_normal_people: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.18135 14.1917C13.3413 14.1917 16.7972 17.4958 17.3063 21.775H2.91968C1.90135 21.775 1.18635 20.7675 1.52218 19.8142C2.69218 16.5208 5.68218 14.1917 9.18135 14.1917ZM18.498 15.7083C21.1088 15.7083 23.373 17.3442 24.4238 19.695C24.868 20.67 24.153 21.775 23.0805 21.775H19.0613L19.0397 21.5692C18.7797 19.435 17.913 17.5175 16.6347 16.0008C17.2305 15.8167 17.8588 15.7083 18.5088 15.7083H18.498ZM18.6063 6.825C20.578 6.825 22.1813 8.42834 22.1813 10.4C22.1813 12.3717 20.578 13.975 18.6063 13.975C16.6347 13.975 15.0313 12.3717 15.0313 10.4C15.0313 8.42834 16.6347 6.825 18.6063 6.825ZM9.18135 4.225C11.4563 4.225 13.298 6.06667 13.298 8.34167C13.298 10.6167 11.4563 12.4583 9.18135 12.4583C6.90635 12.4583 5.06468 10.6167 5.06468 8.34167C5.06468 6.06667 6.90635 4.225 9.18135 4.225Z"
        fill="#4693FF"
      />
    </svg>
  ),
  // Figma Icon/Normal/Plus (16). 색은 color 로 준다
  icon_normal_plus: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.16667C8.29333 2.16667 8.53333 2.40667 8.53333 2.7V7.46667H13.3C13.5933 7.46667 13.8333 7.70667 13.8333 8C13.8333 8.29333 13.5933 8.53333 13.3 8.53333H8.53333V13.3C8.53333 13.5933 8.29333 13.8333 8 13.8333C7.70667 13.8333 7.46667 13.5933 7.46667 13.3V8.53333H2.7C2.40667 8.53333 2.16667 8.29333 2.16667 8C2.16667 7.70667 2.40667 7.46667 2.7 7.46667H7.46667V2.7C7.46667 2.40667 7.70667 2.16667 8 2.16667Z"
        fill="#171819"
      />
    </svg>
  ),
  // Figma Icon/Normal/ChevronRight (20). 기존 chevron_right_24 는 선(stroke) 아이콘이라 모양이 다르다
  icon_normal_chevron_right: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22268 4.11557C7.48102 3.85327 7.90354 3.84996 8.16588 4.10825L13.6656 9.52492C13.7928 9.65022 13.8649 9.8216 13.8649 10.0002C13.8649 10.1788 13.7928 10.3501 13.6656 10.4754L8.16588 15.8921C7.90354 16.1504 7.48102 16.1471 7.22268 15.8848C6.96439 15.6224 6.9677 15.1999 7.23001 14.9416L12.2471 10.0002L7.23001 5.05877C6.9677 4.80044 6.96439 4.37791 7.22268 4.11557Z"
        fill="white"
      />
    </svg>
  ),
  // Figma Icon/Normal/CircleExclamation(Fill, 회색). 원·느낌표 두 색이라 color="" 로 원본 색을 쓴다
  icon_normal_circle_exclamation_gray: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Figma 는 32px 박스 안에 25.3333 아트를 10.42% 인셋으로 둔다 */}
      <g transform="translate(3.3333 3.3333)">
        <path
          d="M12.6667 0C19.6667 0 25.3333 5.66667 25.3333 12.6667C25.3333 19.6667 19.6667 25.3333 12.6667 25.3333C5.66667 25.3333 0 19.6667 0 12.6667C0 5.66667 5.66667 0 12.6667 0Z"
          fill="#CBCDCF"
        />
        <path
          d="M12.6667 16.5333C13.4 16.5333 14 17.1333 14 17.8667C14 18.6 13.4 19.2 12.6667 19.2C11.9333 19.2 11.3333 18.6 11.3333 17.8667C11.3333 17.1333 11.9333 16.5333 12.6667 16.5333ZM12.6667 6C13.3333 6 13.8667 6.53333 13.8667 7.2V13.4667C13.8667 14.1333 13.3333 14.6667 12.6667 14.6667C12 14.6667 11.4667 14.1333 11.4667 13.4667V7.2C11.4667 6.53333 12 6 12.6667 6Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  // Figma Icon/Normal/CircleExclamation(Fill=False, 20). 선 아이콘이라 color 로 색을 준다
  icon_normal_circle_exclamation_line: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.08333C14.375 2.08333 17.9167 5.625 17.9167 10C17.9167 14.375 14.375 17.9167 10 17.9167C5.625 17.9167 2.08333 14.375 2.08333 10C2.08333 5.625 5.625 2.08333 10 2.08333ZM10 3.41667C6.36667 3.41667 3.41667 6.36667 3.41667 10C3.41667 13.6333 6.36667 16.5833 10 16.5833C13.6333 16.5833 16.5833 13.6333 16.5833 10C16.5833 6.36667 13.6333 3.41667 10 3.41667ZM10 12.4167C10.4583 12.4167 10.8333 12.7917 10.8333 13.25C10.8333 13.7083 10.4583 14.0833 10 14.0833C9.54167 14.0833 9.16667 13.7083 9.16667 13.25C9.16667 12.7917 9.54167 12.4167 10 12.4167ZM10 5.83333C10.4167 5.83333 10.75 6.16667 10.75 6.58333V10.5C10.75 10.9167 10.4167 11.25 10 11.25C9.58333 11.25 9.25 10.9167 9.25 10.5V6.58333C9.25 6.16667 9.58333 5.83333 10 5.83333Z"
        fill="#767A7F"
      />
    </svg>
  ),
  "icon-dollar-stroke": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11"
        cy="11"
        r="9.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11 5.5V6.5M11 15.5V16.5M13.5 8.5C13.5 7.39543 12.3807 6.5 11 6.5C9.61929 6.5 8.5 7.39543 8.5 8.5C8.5 9.60457 9.61929 10.5 11 10.5V6.5ZM11 10.5C12.3807 10.5 13.5 11.3954 13.5 12.5C13.5 13.6046 12.3807 14.5 11 14.5V10.5ZM11 14.5C9.61929 14.5 8.5 13.6046 8.5 12.5M11 14.5V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  "icon-calendar-stroke": (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.25"
        y="4.25"
        width="15.5"
        height="14.5"
        rx="1.75"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M3.25 8.5H18.75" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M7.5 3V5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5 3V5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="11" cy="13" r="1" fill="currentColor" />
    </svg>
  ),
  icon_Graphic_Receipt: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g transform="translate(5.5 4)">
        <g>
          <path
            d="M28 0C29.1046 0 30 0.895431 30 2V39H28.0635L25.4951 36.3682C25.2989 36.1671 24.9755 36.1671 24.7793 36.3682L22.2402 38.9697L19.3438 36.001L16.4463 38.9697L13.5498 36.001L10.6885 38.9316L8.23828 36.001L5.78711 38.9316L2.92773 36.001L0.000976562 39H0V2C0 0.895431 0.895431 5.63724e-08 2 0H28Z"
            fill="#D1E6FF"
          />
          <rect x="5.5" y="7" width="19" height="2" rx="1" fill="#A0C9FF" />
          <rect x="5.5" y="15" width="19" height="2" rx="1" fill="#A0C9FF" />
          <rect x="5.5" y="23" width="19" height="2" rx="1" fill="#A0C9FF" />
        </g>
      </g>
      <g transform="translate(23.6 25.2)">
        <g>
          <path
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
            fill="#FFC560"
          />
          <path
            d="M15.5396 8.96238H14.7245L15.3434 7.13136C15.4189 6.91639 15.4038 6.68658 15.2981 6.47902C15.1925 6.27145 15.0189 6.12319 14.8075 6.04906C14.5887 5.96752 14.3472 5.98234 14.1434 6.07871C13.9321 6.1825 13.7736 6.36041 13.6981 6.57539L12.3094 10.5636L10.8604 6.56797C10.7396 6.24921 10.4151 6.04165 10.0377 6.04165C9.66038 6.04165 9.33585 6.24921 9.20755 6.57539L7.76604 10.5932L6.32453 6.56797C6.24906 6.353 6.08302 6.1825 5.87925 6.07871C5.66793 5.97493 5.43396 5.9601 5.21509 6.04165C4.75472 6.20473 4.52075 6.68658 4.67925 7.13878L5.32075 8.95497H4.46792C4 8.95497 3.6 9.34786 3.6 9.80747C3.6 10.2671 4 10.66 4.46792 10.66H5.93962L6.9434 13.4843C7.0566 13.8031 7.38113 14.0107 7.76604 14.0107C8.15094 14.0107 8.46792 13.8031 8.59623 13.4769L10.0302 9.45164L11.4943 13.4843C11.6075 13.8031 11.9321 14.0107 12.3094 14.0107C12.6868 14.0107 13.0189 13.7957 13.1396 13.4621L14.1057 10.6674H15.5321C16 10.6674 16.4 10.2745 16.4 9.81488C16.4 9.35527 16 8.96238 15.5321 8.96238H15.5396Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  ),
  // 후기 상세 지역 비용 블록(장례식장 / 장지·화장장 / 인력·차량·용품). 다색 그래픽이라 color 없이 쓴다. 원본: platform public funeral-facilities/parlor.svg, mypage/urn.svg, mypage/ribbon.svg
  graphic_building: (
    <svg
      width="40"
      height="40"
      viewBox="8 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.166 6.50663C22.166 4.75335 23.5873 3.33203 25.3406 3.33203H36.9906C38.9284 3.33203 40.4993 4.90296 40.4993 6.8408V36.6654H22.166V6.50663Z"
        fill="#99A8B0"
      />
      <path
        d="M15.5 13.1746C15.5 11.4213 16.9213 10 18.6746 10H30.3246C32.2624 10 33.8333 11.5709 33.8333 13.5088V36.6667H15.5V13.1746Z"
        fill="#C7D0D6"
      />
      <rect
        x="20.834"
        y="14.332"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="25.8359"
        y="14.332"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="20.834"
        y="19.3359"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="25.8359"
        y="19.3359"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="20.834"
        y="24.3359"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <rect
        x="25.8359"
        y="24.3359"
        width="2.66667"
        height="2.66667"
        fill="#718189"
      />
      <path
        d="M22.334 32.6654C22.334 31.3767 23.3787 30.332 24.6673 30.332C25.956 30.332 27.0007 31.3767 27.0007 32.6654V36.6654H22.334V32.6654Z"
        fill="#718189"
      />
    </svg>
  ),
  graphic_urn: (
    <svg
      width="15.0844"
      height="18.3334"
      viewBox="0 0 15.0844 18.3334"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.16035 1.27643C1.16035 0.571477 1.73182 0 2.43678 0H12.6476C13.3526 0 13.9241 0.571477 13.9241 1.27643H1.16035Z"
        fill="#D1CAC9"
      />
      <path
        d="M1.16035 17.173H13.9241V17.8305C13.9241 18.1082 13.699 18.3333 13.4213 18.3333H1.66316C1.38546 18.3333 1.16035 18.1082 1.16035 17.8305V17.173Z"
        fill="#B9B3B2"
      />
      <path
        d="M4.48812e-05 3.96606C4.48812e-05 3.17099 0.449251 2.44416 1.16038 2.08859H13.9241C14.6352 2.44416 15.0844 3.17099 15.0844 3.96606V15.2955C15.0844 16.0906 14.6352 16.8174 13.9241 17.173H1.16038C0.449251 16.8174 4.48812e-05 16.0906 4.48812e-05 15.2955V3.96606Z"
        fill="#DDD7D7"
      />
      <rect
        x="5.22152"
        y="6.14964"
        width="4.64136"
        height="6.96203"
        rx="0.603376"
        fill="white"
      />
      <rect
        x="4.48812e-05"
        y="3.82904"
        width="15.0844"
        height="0.696203"
        fill="#CAC4C3"
      />
      <path
        d="M1.16035 1.27643H13.9241V2.08867H1.16035V1.27643Z"
        fill="#B9B3B2"
      />
      <rect
        x="4.48812e-05"
        y="14.736"
        width="15.0844"
        height="0.696203"
        fill="#CAC4C3"
      />
    </svg>
  ),
  graphic_black_ribbon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24676 7.62C6.24676 7.62 5.91863 8.67941 8.59059 12.4483C6.93116 14.3233 5.36548 15.8328 4.75609 16.4047C4.60608 16.5453 4.58733 16.7797 4.70921 16.9484L6.75303 19.6391C6.90303 19.836 7.19367 19.8548 7.36243 19.6673C8.80622 18.111 10.0063 16.7516 11 15.5609C11.9938 16.7516 13.1845 18.1203 14.6377 19.6673C14.8064 19.8454 15.0971 19.836 15.2471 19.6391L17.2909 16.9484C17.4128 16.7797 17.394 16.5453 17.244 16.4047C16.6346 15.8328 15.0689 14.3327 13.4095 12.4483C16.0721 8.68879 15.7533 7.62 15.7533 7.62L13.7751 2.77297C10.7657 1.48855 8.2437 2.77297 8.2437 2.77297L6.23739 7.62H6.24676ZM8.76872 5.60431C10.4282 5.28555 12.1063 5.4543 13.222 5.65119C12.7251 6.87935 11.9188 8.18252 11.0094 9.44819C9.59375 7.61063 8.7781 5.60431 8.7781 5.60431H8.76872Z"
        fill="#46494C"
      />
    </svg>
  ),
} as const;
